
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("eWtDJ", function(module, exports) {
/**
 * The enum that describes Smart Link action types
 */ var $ef78d43ddf94efaf$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $ef78d43ddf94efaf$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = void 0;
        this.errorCode = errorCode;
    }
}
module.exports["SmartLinkActionType"] = $ef78d43ddf94efaf$export$6324b7946ad663e9;
module.exports["InvokeError"] = $ef78d43ddf94efaf$export$d4d72202bff63658;

});

parcelRegister("l8wPz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $gTPfK = parcelRequire("gTPfK");


var $lzgC6 = parcelRequire("lzgC6");


var $6GOAK = parcelRequire("6GOAK");





var $9EOlJ = parcelRequire("9EOlJ");


var $6cFsl = parcelRequire("6cFsl");


var $03RpJ = parcelRequire("03RpJ");


var $iDrrr = parcelRequire("iDrrr");


var $6Vsq4 = parcelRequire("6Vsq4");


var $12fG9 = parcelRequire("12fG9");


var $kSkO7 = parcelRequire("kSkO7");


var $1dET2 = parcelRequire("1dET2");


var $6gRyu = parcelRequire("6gRyu");

const $1acda79e406deb0e$export$1a717feb4df1a945 = (id)=>{
    if (0, $6gRyu.hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};





const $ca4ef11d154bd413$export$de42547d395c8271 = (id)=>{
    if (0, $6gRyu.hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};


const $8df9bbc8b94789f9$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};


const $7ccfc786e0b61069$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await (0, $8df9bbc8b94789f9$export$e772c8ff12451969)(interval);
            return $7ccfc786e0b61069$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};



var $h61mR = parcelRequire("h61mR");


var $1384B = parcelRequire("1384B");


const $6108acbd43407f01$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(0, $7ccfc786e0b61069$export$aacbf48ace518c5a)(()=>(parcelRequire("dZcIT"))));
function $6108acbd43407f01$export$e00a7788e30dc998(props) {
    (0, $6cFsl.di)($6108acbd43407f01$export$a7690c318cd6a95e);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $cozmU.useState)(()=>props.id ? props.id : (0, $03RpJ.default)());
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $1acda79e406deb0e$export$1a717feb4df1a945)(id);
            (0, $ca4ef11d154bd413$export$de42547d395c8271)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, disablePreviewPanel: disablePreviewPanel } = props;
    const isFlexibleUi = (0, $h61mR.isFlexibleUiCard)(children, ui);
    const analyticsContext = (0, $1dET2.useSmartLinkAnalyticsContext)({
        display: isFlexibleUi ? 'flexible' : appearance,
        id: id,
        url: url ?? ''
    });
    const errorHandler = (0, $cozmU.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') fireEvent('operational.smartLink.chunkLoadFailed', {
            ...analyticsContext?.attributes,
            display: appearance,
            error: error,
            errorInfo: errorInfo,
            definitionId: null
        });
        else if (error.name !== 'APIError') {
            (0, $kSkO7.startUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $12fG9.failUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $12fG9.failUfoExperience)('smart-link-authenticated', id || 'NULL');
            fireEvent('ui.smartLink.renderFailed', {
                ...analyticsContext?.attributes,
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id ?? null,
                error: error,
                errorInfo: errorInfo
            });
        }
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analyticsContext?.attributes,
        appearance,
        fireEvent,
        id,
        isFlexibleUi,
        onError,
        url
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FallbackComponent, null);
    // FlexibleCards always need full ORS data regardless of appearance prop,
    // because they render custom blocks (TitleBlock etc.) requiring complete response.
    // Override appearance to 'block' for all FlexibleCards when FG is enabled.
    const effectiveAppearance = isFlexibleUi && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization') ? 'block' : appearance;
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: effectiveAppearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        placeholder: placeholder,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline,
        CompetitorPrompt: CompetitorPrompt,
        disablePreviewPanel: disablePreviewPanel
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1384B.LoadingCardLink), cardWithUrlProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6108acbd43407f01$export$a7690c318cd6a95e, cardWithUrlProps, children)));
}


class $d596ea86ef004430$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6108acbd43407f01$export$e00a7788e30dc998), this.props);
        return this.props.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: "en"
        }, content);
    }
}
const $d596ea86ef004430$export$60332b2344f7fe41 = (0, $gTPfK.default)((0, $6GOAK.context))((0, $lzgC6.default)()((0, $kSwu1.injectIntl)($d596ea86ef004430$var$PlainCard, {
    enforceContext: false
})));
module.exports["Card"] = $d596ea86ef004430$export$60332b2344f7fe41;

});

parcelRegister("1dET2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bI14T = parcelRequire("bI14T");


var $de3yk = parcelRequire("de3yk");


var $3KHpl = parcelRequire("3KHpl");

const $affd5785563fbfc5$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $bI14T.useSmartLinkContext)();
    const state = store ? (0, $de3yk.getUrl)(store, url) : undefined;
    return (0, $cozmU.useMemo)(()=>{
        return (0, $3KHpl.getSmartLinkAnalyticsContext)({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
module.exports["useSmartLinkAnalyticsContext"] = $affd5785563fbfc5$export$ac28ada90c4970b7;

});

parcelRegister("h61mR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");





var $jdA6O = parcelRequire("jdA6O");


var $lkhb1 = parcelRequire("lkhb1");

const $ecd1a4a452dfbd01$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node)) return false;
    if (node.type === (0, $jdA6O.default)) return true;
    if ((0, $lkhb1.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ecd1a4a452dfbd01$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};


const $9f09dcea9ffde02a$export$3c94e0f4719f5c2a = (children, ui)=>{
    if (ui?.removeBlockRestriction) return children && (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children)?.length > 0 ? true : false;
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children).some((child)=>(0, $ecd1a4a452dfbd01$export$df0092b19156b140)(child))) return true;
    return false;
};
module.exports["isFlexibleUiCard"] = $9f09dcea9ffde02a$export$3c94e0f4719f5c2a;

});

parcelRegister("jdA6O", function(module, exports) {
$parcel$export(module.exports, "default", () => $62d1ba92b0d6cb12$export$2e2bcd8739ae039);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("7n0A2")).TitleBlock);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $7n0A2 = parcelRequire("7n0A2");

var $62d1ba92b0d6cb12$export$2e2bcd8739ae039 = (0, $7n0A2.TitleBlock);

});

parcelRegister("7n0A2", function(module, exports) {
/* TitleBlock.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");


var $eTTRx = parcelRequire("eTTRx");


var $3ec5J = parcelRequire("3ec5J");


var $fIakH = parcelRequire("fIakH");


var $3M4EV = parcelRequire("3M4EV");

/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $iMnC5 = parcelRequire("iMnC5");





var $kjaz0 = parcelRequire("kjaz0");


var $8Mb1e = parcelRequire("8Mb1e");


var $hsIfr = parcelRequire("hsIfr");


var $3qg1D = parcelRequire("3qg1D");


var $knKT4 = parcelRequire("knKT4");

const $035d7ae6638db71e$var$styles = {
    titleBoxCard: "_3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _39xV02N91d"
};
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $035d7ae6638db71e$var$TitleBlockErroredView = ({ actionGroup: actionGroup, hideRetry: hideRetry, retry: _retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, ...blockProps })=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const showRetry = !hideRetry && Boolean(context?.actions?.[(0, $4yYAm.InternalActionName).UnresolvedAction]);
    const competitorPrompt = CompetitorPrompt && context?.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CompetitorPrompt, {
        sourceUrl: context?.url,
        linkType: 'card'
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3qg1D.default), {
        ...blockProps,
        testId: `${testId}-errored-view`
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hsIfr.default), {
        overrideIcon: icon,
        position: position
    }), competitorPrompt ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $035d7ae6638db71e$var$styles.titleBoxCard
    }, title, competitorPrompt) : title, showRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $knKT4.default), {
        align: (0, $4yYAm.SmartLinkAlignment).Right
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Mb1e.default), {
        testId: testId
    })), actionGroup);
};
var $035d7ae6638db71e$export$2e2bcd8739ae039 = $035d7ae6638db71e$var$TitleBlockErroredView;


/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 





















var $1NMtH = parcelRequire("1NMtH");

const $656aa9cb921f908d$var$style = null;
const $656aa9cb921f908d$var$styles = {
    titleBox: "_3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _39xV02N91d"
}; /**
    * This renders a fully resolved TitleBlock.
    * This should render when a Smart Link returns a valid response.
    * @see TitleBlock
    */ 
const $656aa9cb921f908d$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: _text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $1NMtH.renderElementItems)(metadata);
    const subtitleElements = (0, $1NMtH.renderElementItems)(subtitle);
    return /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`
    }, !hideIcon && /*#__PURE__*/ $cozmU.createElement((0, $hsIfr.default), {
        overrideIcon: icon,
        position: position,
        size: size,
        hideLoadingSkeleton: hideIconLoadingSkeleton
    }), /*#__PURE__*/ $cozmU.createElement((0, $knKT4.default), {
        direction: (0, $4yYAm.SmartLinkDirection).Vertical,
        width: (0, $4yYAm.SmartLinkWidth).Flexible,
        size: blockProps.size,
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M"
        ])
    }, CompetitorPrompt && url ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $656aa9cb921f908d$var$styles.titleBox
    }, title, /*#__PURE__*/ $cozmU.createElement(CompetitorPrompt, {
        sourceUrl: url,
        linkType: 'card'
    })) : title, subtitleElements && /*#__PURE__*/ $cozmU.createElement((0, $knKT4.default), {
        direction: (0, $4yYAm.SmartLinkDirection).Horizontal
    }, subtitleElements)), metadataElements && /*#__PURE__*/ $cozmU.createElement((0, $knKT4.default), {
        direction: (0, $4yYAm.SmartLinkDirection).Horizontal,
        align: (0, $4yYAm.SmartLinkAlignment).Right,
        position: metadataPosition ?? (0, $4yYAm.SmartLinkPosition).Center,
        size: blockProps.size
    }, metadataElements), actionGroup);
};
var $656aa9cb921f908d$export$2e2bcd8739ae039 = $656aa9cb921f908d$var$TitleBlockResolvedView;


/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 






var $htZ7r = parcelRequire("htZ7r");





var $f3cl5 = parcelRequire("f3cl5");




/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $7b9919bccb7f62e8$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, icon: icon, position: position, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $4yYAm.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $f3cl5.getIconWidth)(size);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3qg1D.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`
    }, !hideIcon && icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hsIfr.default), {
        overrideIcon: icon,
        position: position,
        size: size,
        hideLoadingSkeleton: true
    }), !hideIcon && !icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            width: iconWidth,
            height: iconWidth
        },
        "data-testid": `${testId}-icon`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $htZ7r.LoadingSkeleton), {
        width: iconWidth,
        height: iconWidth,
        testId: `${testId}-icon-loading`
    })), title, actionGroup);
};
var $7b9919bccb7f62e8$export$2e2bcd8739ae039 = $7b9919bccb7f62e8$var$TitleBlockResolvingView;


const $6eea6b83cd94b3e0$var$actionStyles = null;
const $6eea6b83cd94b3e0$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $4yYAm.SmartLinkStatus).Pending:
        case (0, $4yYAm.SmartLinkStatus).Resolving:
            return 0, $7b9919bccb7f62e8$export$2e2bcd8739ae039;
        case (0, $4yYAm.SmartLinkStatus).Resolved:
            return 0, $656aa9cb921f908d$export$2e2bcd8739ae039;
        case (0, $4yYAm.SmartLinkStatus).Unauthorized:
        case (0, $4yYAm.SmartLinkStatus).Forbidden:
        case (0, $4yYAm.SmartLinkStatus).NotFound:
        case (0, $4yYAm.SmartLinkStatus).Errored:
        case (0, $4yYAm.SmartLinkStatus).Fallback:
        default:
            return 0, $035d7ae6638db71e$export$2e2bcd8739ae039;
    }
}; /**
    * Represents a TitleBlock, which is the foundation of Flexible UI.
    * This contains an icon, the link, and any associated metadata and actions in one block.
    * The TitleBlock will also render differently given the state of the smart link.
    * This can be found in the corresponding Resolving, Resolved and Errored views.
    * @public
    * @param {TitleBlockProps} TitleBlockProps
    * @see Block
    * @see TitleBlockResolvingViewNew
    * @see TitleBlockResolvedViewNew
    * @see TitleBlockErroredViewNew
    */ 
const $6eea6b83cd94b3e0$export$ccf187e9bb6e68c = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, anchorRef: anchorRef, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...props })=>{
    const cardContext = (0, $3ec5J.useFlexibleCardContext)();
    const { status: status = (0, $4yYAm.SmartLinkStatus).Fallback, ui: ui } = cardContext || {};
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $cozmU.useState)(false);
    const onDropdownOpenChange = (0, $cozmU.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ $cozmU.createElement((0, $3M4EV.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $eTTRx.useMouseDownEvent)();
    const title = /*#__PURE__*/ $cozmU.createElement((0, $fIakH.default), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onMouseDown: onMouseDown,
        target: (0, $iDrrr.fg)('confluence_ep_shim_macro_links_v2') ? anchorTarget ?? cardContext?.navigation?.target : anchorTarget,
        theme: ui?.theme,
        anchorRef: anchorRef,
        ...overrideText
    });
    const Component = $6eea6b83cd94b3e0$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ $cozmU.createElement(Component, {
        ...props,
        actionGroup: actionGroup,
        className: (0, $hekY6.default)([
            showActionOnHover && !actionDropdownOpen && "_385uQ8dnbC _29zYll7dHp _17H8r87dHp",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        hideRetry: hideRetry,
        icon: icon,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton,
        size: props.size ?? ui?.size,
        CompetitorPrompt: CompetitorPrompt,
        url: url
    });
};
module.exports["TitleBlock"] = $6eea6b83cd94b3e0$export$ccf187e9bb6e68c;

});

parcelRegister("3ec5J", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9PA4G = parcelRequire("9PA4G");

const $e35cd7b1097e6be9$export$a8c4167e4e9f26ab = ()=>(0, $cozmU.useContext)((0, $9PA4G.FlexibleCardContext));
module.exports["useFlexibleCardContext"] = $e35cd7b1097e6be9$export$a8c4167e4e9f26ab;

});

parcelRegister("9PA4G", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $e8448976eac6bdb2$export$13dde4423ab71d62 = (0, $cozmU.createContext)(undefined);
module.exports["FlexibleCardContext"] = $e8448976eac6bdb2$export$13dde4423ab71d62;

});

parcelRegister("fIakH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");


var $3ec5J = parcelRequire("3ec5J");


var $jdGU5 = parcelRequire("jdGU5");

const $28a8d06450508f14$var$TitleElement = (props)=>{
    const context = (0, $3ec5J.useFlexibleCardContext)();
    const data = context?.data?.linkTitle;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdGU5.default), {
        ...data,
        url: (0, $iDrrr.fg)('confluence_ep_shim_macro_links_v2') ? context?.navigation?.url ?? data.url : data.url,
        ...props,
        name: (0, $4yYAm.ElementName).Title
    }) : null;
};
var $28a8d06450508f14$export$2e2bcd8739ae039 = $28a8d06450508f14$var$TitleElement;
module.exports["default"] = $28a8d06450508f14$export$2e2bcd8739ae039;

});

parcelRegister("3M4EV", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $7joZr = parcelRequire("7joZr");


var $1sCHt = parcelRequire("1sCHt");


var $3vgx3 = parcelRequire("3vgx3");


var $6TaGl = parcelRequire("6TaGl");


var $lpNn5 = parcelRequire("lpNn5");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $kjaz0 = parcelRequire("kjaz0");


var $it2N0 = parcelRequire("it2N0");


var $8QLAc = parcelRequire("8QLAc");


var $edVsK = parcelRequire("edVsK");


var $lOv7Z = parcelRequire("lOv7Z");








var $cOVCp = parcelRequire("cOVCp");


var $5Nciw = parcelRequire("5Nciw");


var $5IFQc = parcelRequire("5IFQc");


var $1FScK = parcelRequire("1FScK");


var $bHsBU = parcelRequire("bHsBU");


var $fhinp = parcelRequire("fhinp");


var $kD7T6 = parcelRequire("kD7T6");


var $78OZj = parcelRequire("78OZj");


var $1fKLY = parcelRequire("1fKLY");


var $e8Ej5 = parcelRequire("e8Ej5");


var $kI1Tj = parcelRequire("kI1Tj");


var $cpdvP = parcelRequire("cpdvP");

const $1a85ac9775b31ba0$var$Actions = {
    [(0, $4yYAm.ActionName).AutomationAction]: (0, $5IFQc.default),
    [(0, $4yYAm.ActionName).CopyLinkAction]: (0, $1FScK.default),
    [(0, $4yYAm.ActionName).CustomAction]: (0, $cOVCp.default),
    [(0, $4yYAm.ActionName).DeleteAction]: (0, $fhinp.default),
    [(0, $4yYAm.ActionName).DownloadAction]: (0, $kD7T6.default),
    [(0, $4yYAm.ActionName).EditAction]: (0, $78OZj.default),
    [(0, $4yYAm.ActionName).FollowAction]: (0, $1fKLY.default),
    [(0, $4yYAm.ActionName).PreviewAction]: (0, $e8Ej5.default),
    [(0, $4yYAm.ActionName).RovoChatAction]: (0, $kI1Tj.default),
    [(0, $4yYAm.InternalActionName).AISummaryAction]: (0, $5Nciw.default),
    [(0, $4yYAm.InternalActionName).UnresolvedAction]: (0, $bHsBU.default),
    [(0, $4yYAm.InternalActionName).ViewRelatedLinksAction]: (0, $cpdvP.default)
};
const $1a85ac9775b31ba0$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $cozmU.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $1a85ac9775b31ba0$var$Actions ? $1a85ac9775b31ba0$var$Actions[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $1a85ac9775b31ba0$export$2e2bcd8739ae039 = $1a85ac9775b31ba0$var$ActionGroupItem;


const $1f94c9c7d09c94b8$var$styles = null;
const $1f94c9c7d09c94b8$var$FULL_ACTIONS_SIZE = 450;
const $1f94c9c7d09c94b8$var$REDUCED_ACTIONS_SIZE = 360;
const $1f94c9c7d09c94b8$var$ICON_ONLY_ACTIONS_SIZE = 200;
const $1f94c9c7d09c94b8$var$OVERFLOW_ONLY_ACTIONS_SIZE = 100;
const $1f94c9c7d09c94b8$var$renderActionItems = (items = [], size = (0, $4yYAm.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ $cozmU.createElement((0, $1a85ac9775b31ba0$export$2e2bcd8739ae039), {
            item: item,
            key: idx,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        })); /**
                                                                                                                                                                                                                                                                                                                                                                                                            * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
                                                                                                                                                                                                                                                                                                                                                                                                            * preferences.
                                                                                                                                                                                                                                                                                                                                                                                                            * @internal
                                                                                                                                                                                                                                                                                                                                                                                                            * @param {ActionGroupProps} ActionGroupProps
                                                                                                                                                                                                                                                                                                                                                                                                            * @see Action
                                                                                                                                                                                                                                                                                                                                                                                                            */ 
const $1f94c9c7d09c94b8$var$ActionGroup = ({ items: items = [], size: size = (0, $4yYAm.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange, containerWidth: containerWidth = Infinity })=>{
    (0, $6cFsl.di)((0, $3vgx3.default));
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const ui = (0, $it2N0.useFlexibleUiOptionContext)();
    const { product: product } = (0, $8QLAc.default)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const renderableActionItems = (0, $cozmU.useMemo)(()=>(0, $lOv7Z.filterActionItems)(items, context, product), [
        context,
        items,
        product
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const rovoChatAction = context?.actions?.[(0, $4yYAm.ActionName).RovoChatAction];
    const isRovoActionsEnabled = (0, $cozmU.useMemo)(()=>{
        return !!rovoChatAction && rovoChatAction.product === 'CONFLUENCE' && items.some((action)=>action.name === 'RovoChatAction');
    }, [
        rovoChatAction,
        items
    ]);
    const onOpenChange = (0, $cozmU.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $cozmU.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $cozmU.useMemo)(()=>{
        if (isRovoActionsEnabled) {
            const rovoActions = [
                ...containerWidth >= $1f94c9c7d09c94b8$var$REDUCED_ACTIONS_SIZE ? renderableActionItems.slice(0, visibleButtonsNum - 1) : [],
                ...containerWidth >= $1f94c9c7d09c94b8$var$OVERFLOW_ONLY_ACTIONS_SIZE ? [
                    {
                        name: (0, $4yYAm.ActionName).RovoChatAction,
                        prompts: [
                            (0, $edVsK.RovoChatPromptKey).ASK_ROVO_ANYTHING
                        ],
                        iconSize: 'small',
                        cardAppearance: (0, $4yYAm.CardDisplay).Block,
                        hideContent: containerWidth < $1f94c9c7d09c94b8$var$FULL_ACTIONS_SIZE && containerWidth >= $1f94c9c7d09c94b8$var$REDUCED_ACTIONS_SIZE || containerWidth < $1f94c9c7d09c94b8$var$ICON_ONLY_ACTIONS_SIZE && containerWidth >= $1f94c9c7d09c94b8$var$OVERFLOW_ONLY_ACTIONS_SIZE
                    },
                    {
                        name: (0, $4yYAm.ActionName).CopyLinkAction,
                        hideContent: true,
                        iconSize: 'small'
                    },
                    {
                        name: (0, $4yYAm.ActionName).PreviewAction,
                        hideContent: true,
                        iconSize: 'small'
                    }
                ] : []
            ];
            return $1f94c9c7d09c94b8$var$renderActionItems(rovoActions, size, appearance, false, onActionItemClick);
        }
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $1f94c9c7d09c94b8$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum,
        isRovoActionsEnabled,
        containerWidth
    ]);
    const moreActionDropdown = (0, $cozmU.useMemo)(()=>{
        let actionItems;
        if (isRovoActionsEnabled && containerWidth < $1f94c9c7d09c94b8$var$OVERFLOW_ONLY_ACTIONS_SIZE) actionItems = [
            ...renderableActionItems,
            {
                name: (0, $4yYAm.ActionName).RovoChatAction,
                prompts: [
                    (0, $edVsK.RovoChatPromptKey).ASK_ROVO_ANYTHING
                ],
                iconSize: 'small',
                cardAppearance: (0, $4yYAm.CardDisplay).Block
            },
            {
                name: (0, $4yYAm.ActionName).CopyLinkAction,
                iconSize: 'small'
            },
            {
                name: (0, $4yYAm.ActionName).PreviewAction,
                iconSize: 'small'
            }
        ];
        else if (isRovoActionsEnabled && containerWidth < $1f94c9c7d09c94b8$var$REDUCED_ACTIONS_SIZE) actionItems = renderableActionItems;
        else actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const formatMessage = /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).more_actions);
            const moreIconAppearance = appearance !== 'subtle' ? 'default' : appearance;
            return /*#__PURE__*/ $cozmU.createElement((0, $3vgx3.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span"
                    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                        ...props,
                        spacing: size === (0, $4yYAm.SmartLinkSize).XLarge ? 'default' : 'compact',
                        testId: "action-group-more-button",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                        ref: triggerRef,
                        label: "more",
                        color: "currentColor",
                        ...isRovoActionsEnabled ? {
                            appearance: moreIconAppearance
                        } : {}
                    })),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex
            }, $1f94c9c7d09c94b8$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick));
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum,
        isRovoActionsEnabled,
        containerWidth
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_3iDTPbccYA _0VdfO7DIqT _3BruOXLl21",
            "actions-button-group"
        ]),
        "data-action-open": isOpen
    }, /*#__PURE__*/ $cozmU.createElement((0, $7joZr.default), null, actionButtons, moreActionDropdown)) : null;
};
var $1f94c9c7d09c94b8$export$2e2bcd8739ae039 = $1f94c9c7d09c94b8$var$ActionGroup;
module.exports["default"] = $1f94c9c7d09c94b8$export$2e2bcd8739ae039;

});

parcelRegister("kjaz0", function(module, exports) {

var $3ec5J = parcelRequire("3ec5J");

const $bb892c38bd00b89d$export$61d7957a243df7aa = ()=>(0, $3ec5J.useFlexibleCardContext)()?.data;
module.exports["useFlexibleUiContext"] = $bb892c38bd00b89d$export$61d7957a243df7aa;

});

parcelRegister("it2N0", function(module, exports) {

var $3ec5J = parcelRequire("3ec5J");

const $7c8aee16213bbfa4$export$e6b5ad18b56e8f51 = ()=>(0, $3ec5J.useFlexibleCardContext)()?.ui;
module.exports["useFlexibleUiOptionContext"] = $7c8aee16213bbfa4$export$e6b5ad18b56e8f51;

});

parcelRegister("8QLAc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bI14T = parcelRequire("bI14T");

const $e955061c8afbfdff$var$useRovoConfig = ()=>{
    const { rovoOptions: rovoOptions, product: product } = (0, $bI14T.useSmartLinkContext)();
    return (0, $cozmU.useMemo)(()=>({
            rovoOptions: rovoOptions,
            product: product
        }), [
        rovoOptions,
        product
    ]);
};
var $e955061c8afbfdff$export$2e2bcd8739ae039 = $e955061c8afbfdff$var$useRovoConfig;
module.exports["default"] = $e955061c8afbfdff$export$2e2bcd8739ae039;

});

parcelRegister("edVsK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9UcmI = parcelRequire("9UcmI");


var $mfdwv = parcelRequire("mfdwv");


var $f0b2F = parcelRequire("f0b2F");


var $bLfHG = parcelRequire("bLfHG");


var $etoPX = parcelRequire("etoPX");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");

/* ai-chapter-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $hekY6 = parcelRequire("hekY6");

const $5d1eb2b6c0e657fd$var$style = {
    foreignObject: "_2uo31fdOom _0jFU0VN91d _39xV02N91d _1YKVNs7dHp"
};
const $5d1eb2b6c0e657fd$var$AiChapterIcon = (props)=>/*#__PURE__*/ $cozmU.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $cozmU.createElement("g", {
        clipPath: "url(#paint0_angular_1804_15128_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $cozmU.createElement("g", {
        transform: "matrix(0.008 -0.00939228 0.0100184 0.0075 12 12.5)"
    }, /*#__PURE__*/ $cozmU.createElement("foreignObject", {
        x: "-1047.5",
        y: "-1047.5",
        width: "2095.01",
        height: "2095.01"
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $5d1eb2b6c0e657fd$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 6.5V16.5H11.2495V18H5.375C4.61561 18 4 17.3844 4 16.625V6.375C4 5.6175 4.61251 5 5.37379 5L8.8749 5.00001C10.1576 5.00001 11.2947 5.6232 11.9999 6.58333C12.7053 5.62319 13.8425 5.00001 15.1251 5.00001L18.6253 5C19.3874 5 20 5.61967 20 6.37637V12.25H18.5V6.50082L15.1251 6.50001C13.8134 6.50001 12.7499 7.56337 12.7499 8.87496V14H11.2499V8.87498C11.2499 7.56332 10.1866 6.50001 8.8749 6.50001L5.5 6.5ZM17.2495 10H14.4995V8.5H17.2495V10ZM6.75049 8.50001H9.50049V10H6.75049V8.50001ZM6.75049 11H9.50049V12.5H6.75049V11ZM15.7945 13.4943C15.9025 13.1982 16.184 13.0013 16.4991 13.0013C16.8142 13.0013 17.0962 13.1982 17.2042 13.4943L17.8193 15.1807L19.5057 15.7958C19.8017 15.9038 19.9987 16.1853 19.9987 16.5004C19.9987 16.8155 19.8017 17.0975 19.5057 17.2055L17.8193 17.8206L17.2042 19.507C17.0962 19.803 16.8147 20 16.4996 20C16.1845 20 15.9025 19.803 15.7945 19.507L15.1794 17.8206L13.493 17.2055C13.197 17.0975 13 16.816 13 16.5009C13 16.1858 13.197 15.9038 13.493 15.7958L15.1794 15.1807L15.7945 13.4943Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":16.000001907348633,"m01":20.036861419677734,"m02":-6.0184345245361328,"m10":-18.784559249877930,"m11":15.000002861022949,"m12":14.392276763916016},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $cozmU.createElement("defs", null, /*#__PURE__*/ $cozmU.createElement("clipPath", {
        id: "paint0_angular_1804_15128_clip_path"
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 6.5V16.5H11.2495V18H5.375C4.61561 18 4 17.3844 4 16.625V6.375C4 5.6175 4.61251 5 5.37379 5L8.8749 5.00001C10.1576 5.00001 11.2947 5.6232 11.9999 6.58333C12.7053 5.62319 13.8425 5.00001 15.1251 5.00001L18.6253 5C19.3874 5 20 5.61967 20 6.37637V12.25H18.5V6.50082L15.1251 6.50001C13.8134 6.50001 12.7499 7.56337 12.7499 8.87496V14H11.2499V8.87498C11.2499 7.56332 10.1866 6.50001 8.8749 6.50001L5.5 6.5ZM17.2495 10H14.4995V8.5H17.2495V10ZM6.75049 8.50001H9.50049V10H6.75049V8.50001ZM6.75049 11H9.50049V12.5H6.75049V11ZM15.7945 13.4943C15.9025 13.1982 16.184 13.0013 16.4991 13.0013C16.8142 13.0013 17.0962 13.1982 17.2042 13.4943L17.8193 15.1807L19.5057 15.7958C19.8017 15.9038 19.9987 16.1853 19.9987 16.5004C19.9987 16.8155 19.8017 17.0975 19.5057 17.2055L17.8193 17.8206L17.2042 19.507C17.0962 19.803 16.8147 20 16.4996 20C16.1845 20 15.9025 19.803 15.7945 19.507L15.1794 17.8206L13.493 17.2055C13.197 17.0975 13 16.816 13 16.5009C13 16.1858 13.197 15.9038 13.493 15.7958L15.1794 15.1807L15.7945 13.4943Z"
    }))));
$5d1eb2b6c0e657fd$var$AiChapterIcon.displayName = 'AiChapterIcon';
var $5d1eb2b6c0e657fd$export$2e2bcd8739ae039 = $5d1eb2b6c0e657fd$var$AiChapterIcon;


/* ai-search-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 





const $11b5a217c0474393$var$style = {
    foreignObject: "_2uo31fdOom _0jFU0VN91d _39xV02N91d _1YKVNs7dHp"
};
const $11b5a217c0474393$var$AiSearchIcon = (props)=>/*#__PURE__*/ $cozmU.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $cozmU.createElement("g", {
        clipPath: "url(#paint0_angular_1804_8080_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $cozmU.createElement("g", {
        transform: "matrix(0.00701514 -0.00941124 0.00878508 0.00751514 12.0151 11.5151)"
    }, /*#__PURE__*/ $cozmU.createElement("foreignObject", {
        x: "-1058.95",
        y: "-1058.95",
        width: "2117.91",
        height: "2117.91"
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $11b5a217c0474393$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M10 6.6123C7.9961 7.0671 6.5 8.85847 6.5 11C6.5 13.4853 8.51472 15.5 11 15.5C12.2428 15.5 13.3665 14.9968 14.1816 14.1816C14.7712 13.5921 15.1959 12.8407 15.3867 12H16.917C16.7489 12.9977 16.3336 13.9117 15.7383 14.6777L19.0303 17.9697L17.9697 19.0303L14.6777 15.7383C13.662 16.5276 12.3862 17 11 17C7.68629 17 5 14.3137 5 11C5 8.02706 7.16237 5.56013 10 5.08398V6.6123Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":14.030276298522949,"m01":17.570167541503906,"m02":-3.7850868701934814,"m10":-18.822471618652344,"m11":15.030277252197266,"m12":13.411232948303223},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $cozmU.createElement("g", {
        clipPath: "url(#paint1_angular_1804_8080_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $cozmU.createElement("g", {
        transform: "matrix(0.00701514 -0.00941124 0.00878508 0.00751514 12.0151 11.5151)"
    }, /*#__PURE__*/ $cozmU.createElement("foreignObject", {
        x: "-1058.95",
        y: "-1058.95",
        width: "2117.91",
        height: "2117.91"
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $11b5a217c0474393$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M18 7.25C18 7.56523 17.803 7.84705 17.5068 7.95508L16.2217 8.42383C16.0833 8.4744 15.9744 8.58332 15.9238 8.72168L15.4551 10.0068C15.3471 10.3029 15.0653 10.5 14.75 10.5C14.4348 10.5 14.1529 10.303 14.0449 10.0068L13.5762 8.72168C13.5256 8.58332 13.4167 8.4744 13.2783 8.42383L11.9932 7.95508C11.7338 7.86049 11.5505 7.63274 11.5088 7.36621L11.5 7.25L11.5088 7.13379C11.5505 6.86715 11.734 6.63947 11.9932 6.54492L13.2783 6.07617C13.4167 6.0256 13.5256 5.91668 13.5762 5.77832L14.0449 4.49316L14.0938 4.38672C14.2242 4.15114 14.4736 4.00036 14.749 4L14.8652 4.00879C15.0941 4.04428 15.2941 4.18415 15.4062 4.38672L15.4551 4.49316L15.9238 5.77832C15.9744 5.91668 16.0833 6.0256 16.2217 6.07617L17.5068 6.54492C17.8031 6.65301 18 6.93494 18 7.25Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":14.030276298522949,"m01":17.570167541503906,"m02":-3.7850868701934814,"m10":-18.822471618652344,"m11":15.030277252197266,"m12":13.411232948303223},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $cozmU.createElement("defs", null, /*#__PURE__*/ $cozmU.createElement("clipPath", {
        id: "paint0_angular_1804_8080_clip_path"
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M10 6.6123C7.9961 7.0671 6.5 8.85847 6.5 11C6.5 13.4853 8.51472 15.5 11 15.5C12.2428 15.5 13.3665 14.9968 14.1816 14.1816C14.7712 13.5921 15.1959 12.8407 15.3867 12H16.917C16.7489 12.9977 16.3336 13.9117 15.7383 14.6777L19.0303 17.9697L17.9697 19.0303L14.6777 15.7383C13.662 16.5276 12.3862 17 11 17C7.68629 17 5 14.3137 5 11C5 8.02706 7.16237 5.56013 10 5.08398V6.6123Z"
    })), /*#__PURE__*/ $cozmU.createElement("clipPath", {
        id: "paint1_angular_1804_8080_clip_path"
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M18 7.25C18 7.56523 17.803 7.84705 17.5068 7.95508L16.2217 8.42383C16.0833 8.4744 15.9744 8.58332 15.9238 8.72168L15.4551 10.0068C15.3471 10.3029 15.0653 10.5 14.75 10.5C14.4348 10.5 14.1529 10.303 14.0449 10.0068L13.5762 8.72168C13.5256 8.58332 13.4167 8.4744 13.2783 8.42383L11.9932 7.95508C11.7338 7.86049 11.5505 7.63274 11.5088 7.36621L11.5 7.25L11.5088 7.13379C11.5505 6.86715 11.734 6.63947 11.9932 6.54492L13.2783 6.07617C13.4167 6.0256 13.5256 5.91668 13.5762 5.77832L14.0449 4.49316L14.0938 4.38672C14.2242 4.15114 14.4736 4.00036 14.749 4L14.8652 4.00879C15.0941 4.04428 15.2941 4.18415 15.4062 4.38672L15.4551 4.49316L15.9238 5.77832C15.9744 5.91668 16.0833 6.0256 16.2217 6.07617L17.5068 6.54492C17.8031 6.65301 18 6.93494 18 7.25Z"
    }))));
$11b5a217c0474393$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $11b5a217c0474393$export$2e2bcd8739ae039 = $11b5a217c0474393$var$AiSearchIcon;


/**
 * This is a simplified version of html to adf conversion,
 * used specifically for SL RovoChatAction prompt message,
 * and does not support all ADF offered via @atlaskit/adf-utils
 *
 * Support: p, ul, li, text, b, strong, code, inlineCard (replace a hyperlink)
 */ 
var $751cc = parcelRequire("751cc");

var $gxFDR = parcelRequire("gxFDR");

var $4AavA = parcelRequire("4AavA");

var $fGQsh = parcelRequire("fGQsh");

var $gHMgs = parcelRequire("gHMgs");

var $c8cGy = parcelRequire("c8cGy");

var $iO4QI = parcelRequire("iO4QI");

var $bWF3R = parcelRequire("bWF3R");

const $018fcbc360e870ab$var$INLINE_TAG_NAMES = [
    'b',
    'strong',
    'code',
    'a',
    'inlineCard'
];
const $018fcbc360e870ab$var$BLOCK_TAG_NAMES = [
    'p',
    'ul',
    'ol',
    'li'
];
/**
 *   Group      Captures                Example
 *  ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *   match[1]   Self-closing tag name   br from <br/> or <img src="x"/>
 *   match[2]   Opening tag name        div from <div> or <div class="x">
 *   match[3]   Closing tag name        div from </div>
 *   match[4]   Text content            Hello world
 */ const $018fcbc360e870ab$var$htmlRegex = /<\s*(\w+)[^>]*?\s*\/\s*>|<\s*(\w+)[^>]*>|<\s*\/\s*(\w+)\s*>|([^<]+)/g;
const $018fcbc360e870ab$var$decodeHtmlEntities = (text = '')=>{
    return text.replace(/&nbsp;/g, ' ').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#39;/g, "'");
};
const $018fcbc360e870ab$var$tokenizeHtml = (html)=>{
    const tokens = [];
    let match;
    while((match = $018fcbc360e870ab$var$htmlRegex.exec(html)) !== null){
        const selfClosingTag = match[1];
        const openingTag = match[2];
        const closingTag = match[3];
        const textContent = match[4];
        if (selfClosingTag) tokens.push({
            type: 'selfClosing',
            tagName: selfClosingTag.toLowerCase()
        });
        else if (openingTag) tokens.push({
            type: 'open',
            tagName: openingTag.toLowerCase()
        });
        else if (closingTag) tokens.push({
            type: 'close',
            tagName: closingTag.toLowerCase()
        });
        else if (textContent) {
            if (textContent?.trim()) tokens.push({
                type: 'text',
                content: $018fcbc360e870ab$var$decodeHtmlEntities(textContent)
            });
        }
    }
    return tokens;
};
const $018fcbc360e870ab$var$buildListItem = (content = [])=>{
    // Check if content has only text/inline elements
    const hasOnlyInlineContent = content.every((node)=>node.type === 'text' || node.type === 'hardBreak' || !node.type);
    if (hasOnlyInlineContent) // Wrap text content in a paragraph
    return (0, $gHMgs.listItem)([
        (0, $c8cGy.paragraph)(...content)
    ]);
    // Content has block elements (like nested lists), use as-is
    return (0, $gHMgs.listItem)(content);
};
const $018fcbc360e870ab$var$blockToAdf = (tagName, content = [])=>{
    switch(tagName){
        case 'p':
            return (0, $c8cGy.paragraph)(...content);
        case 'ul':
            return (0, $bWF3R.bulletList)(...content);
        case 'li':
            return $018fcbc360e870ab$var$buildListItem(content);
    }
};
const $018fcbc360e870ab$var$inlineToAdf = (tagName, content)=>{
    switch(tagName){
        case 'b':
        case 'strong':
            return (0, $751cc.strong)(content);
        case 'code':
            return (0, $gxFDR.code)(content);
        case 'a':
        case 'inlineCard':
            return (0, $fGQsh.inlineCard)({
                url: content
            });
        default:
            return (0, $iO4QI.text)(content);
    }
};
const $018fcbc360e870ab$var$parseTokensToAdf = (tokens)=>{
    const stack = [
        {
            type: 'root',
            content: []
        }
    ];
    let currentMarks = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        const current = stack[stack.length - 1];
        switch(token.type){
            case 'text':
                if (token.content) {
                    const inlineAdfNode = $018fcbc360e870ab$var$inlineToAdf(currentMarks?.[0]?.type, token.content);
                    current.content.push(inlineAdfNode);
                }
                break;
            case 'open':
                if ($018fcbc360e870ab$var$INLINE_TAG_NAMES.includes(token.tagName)) currentMarks.push({
                    type: token.tagName
                });
                else if ($018fcbc360e870ab$var$BLOCK_TAG_NAMES.includes(token.tagName)) stack.push({
                    type: token.tagName,
                    content: []
                });
                break;
            case 'close':
                // Inline formatting
                if (token.tagName && $018fcbc360e870ab$var$INLINE_TAG_NAMES.includes(token.tagName)) currentMarks = currentMarks.filter((m)=>m.type !== token.tagName);
                else if (stack.length > 1) {
                    const closed = stack.pop();
                    const parent = stack[stack.length - 1];
                    const adfNode = $018fcbc360e870ab$var$blockToAdf(closed?.type, closed?.content);
                    if (adfNode) parent.content.push(adfNode);
                }
                break;
        }
    }
    // Return root content
    return stack[0].content;
};
/**
 * Convert HTML string to ADF format
 *
 * This is a simplified version specific for RovoChatAction prompt message
 * and does not support all ADF offered via @atlaskit/adf-utils
 */ const $018fcbc360e870ab$var$htmlToAdf = (html)=>{
    try {
        const tokens = $018fcbc360e870ab$var$tokenizeHtml(html);
        const adfContent = $018fcbc360e870ab$var$parseTokensToAdf(tokens);
        return (0, $4AavA.doc)(...adfContent);
    } catch  {
        return html;
    }
};
var $018fcbc360e870ab$export$2e2bcd8739ae039 = $018fcbc360e870ab$var$htmlToAdf;


var $77626c1968cfb017$export$a9f8723a23072cb8 = /*#__PURE__*/ function(RovoChatPromptKey) {
    RovoChatPromptKey["SUMMARIZE_LINK"] = "summarize-link";
    RovoChatPromptKey["KEY_HIGHLIGHTS"] = "key-highlights";
    RovoChatPromptKey["ASK_ROVO_ANYTHING"] = "ask-rovo-anything";
    RovoChatPromptKey["IDENTIFY_KEY_POINTS"] = "identify-key-points";
    RovoChatPromptKey["IDENTIFY_KEY_TRENDS"] = "identify-key-trends";
    RovoChatPromptKey["FIND_OPEN_QUESTIONS"] = "find-open-questions";
    RovoChatPromptKey["HIGHLIGHT_RELEVANT_CONTENT"] = "highlight-relevant-content";
    RovoChatPromptKey["SUMMARIZE_THIS_FOR_ME"] = "summarize-this-for-me";
    RovoChatPromptKey["ASK_A_SPECIFIC_QUESTION"] = "ask-a-specific-question";
    RovoChatPromptKey["SHOW_ME_WHATS_RELEVANT"] = "show-me-whats-relevant";
    RovoChatPromptKey["SUMMARIZE_DOCUMENT"] = "summarize-document";
    RovoChatPromptKey["SUMMARIZE_PRESENTATION"] = "summarize-presentation";
    RovoChatPromptKey["EXPLAIN_CODE"] = "explain-code";
    RovoChatPromptKey["CATCH_UP"] = "catch-up";
    RovoChatPromptKey["SALESFORCE_PREP"] = "salesforce-prep";
    return RovoChatPromptKey;
}({});
const $77626c1968cfb017$var$getContext = (intl, product)=>{
    switch(product){
        case 'CONFLUENCE':
            return {
                contextLong: intl.formatMessage((0, $dM7c5.messages).rovo_prompt_context_confluence_page)
            };
        case 'JSW':
        case 'JWM':
        case 'JSM':
        case 'JPD':
            return {
                contextLong: intl.formatMessage((0, $dM7c5.messages).rovo_prompt_context_jira_work_item)
            };
    }
};
const $77626c1968cfb017$export$35d7b8e732470f9f = ({ promptKey: promptKey, intl: intl, url: url = '', product: product, iconSize: iconSize, cardAppearance: cardAppearance, provider: provider })=>{
    const { contextLong: contextLong } = $77626c1968cfb017$var$getContext(intl, product) ?? {
        contextLong: intl.formatMessage((0, $dM7c5.messages).rovo_prompt_context_generic)
    };
    switch(promptKey){
        case "summarize-link":
            const label_summarize = intl.formatMessage((0, $dM7c5.messages).ai_summarize);
            const html_summarize = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_summarize, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                    label: label_summarize,
                    size: iconSize
                }),
                content: label_summarize,
                tooltipMessage: label_summarize,
                data: {
                    name: label_summarize,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_summarize),
                    mode: {
                        fastModeEnabled: true
                    }
                }
            };
        case "summarize-this-for-me":
            const label_summarize_this_for_me = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_summarize_this);
            const html_summarize_this_for_me = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_summarize, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
                    label: label_summarize_this_for_me
                }),
                content: label_summarize_this_for_me,
                tooltipMessage: label_summarize_this_for_me,
                data: {
                    name: label_summarize_this_for_me,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_summarize_this_for_me),
                    mode: {
                        fastModeEnabled: true
                    }
                }
            };
        case "highlight-relevant-content":
            const label_highlight_relevant_content = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_highlight_relevant_content);
            const html_highlight_relevant_content = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_highlight_relevant_content, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5d1eb2b6c0e657fd$export$2e2bcd8739ae039), null),
                content: label_highlight_relevant_content,
                tooltipMessage: label_highlight_relevant_content,
                data: {
                    name: label_highlight_relevant_content,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_highlight_relevant_content),
                    mode: {
                        fastModeEnabled: true
                    }
                }
            };
        case "ask-rovo-anything":
            const label_ask_rovo_anything = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_ask_rovo_anything);
            const prompt_ask_rovo_anything = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_ask_rovo_anything, {
                url: url
            });
            return {
                icon: cardAppearance === (0, $4yYAm.CardDisplay).Block && !!product && product === 'CONFLUENCE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
                    label: label_ask_rovo_anything,
                    size: 'xxsmall'
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $11b5a217c0474393$export$2e2bcd8739ae039), null),
                content: label_ask_rovo_anything,
                tooltipMessage: label_ask_rovo_anything,
                data: {
                    name: label_ask_rovo_anything,
                    dialogues: [],
                    prompt: prompt_ask_rovo_anything,
                    isPromptPlaceholder: true,
                    placeholderType: 'generic'
                }
            };
        case "ask-a-specific-question":
            const label_ask_a_specific_question = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_ask_a_specific_question);
            const prompt_ask_a_specific_question = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_ask_rovo_anything, {
                url: url
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bLfHG))), {
                    label: label_ask_a_specific_question
                }),
                content: label_ask_a_specific_question,
                tooltipMessage: label_ask_a_specific_question,
                data: {
                    name: label_ask_a_specific_question,
                    dialogues: [],
                    prompt: prompt_ask_a_specific_question,
                    isPromptPlaceholder: true,
                    placeholderType: 'generic'
                }
            };
        case "key-highlights":
            const label_key_highlights = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_key_highlights);
            const html_key_highlights = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_key_highlights, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                    label: label_key_highlights,
                    size: iconSize
                }),
                content: label_key_highlights,
                tooltipMessage: label_key_highlights,
                data: {
                    name: label_key_highlights,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_key_highlights)
                }
            };
        case "show-me-whats-relevant":
            const label_show_me_whats_relevant = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_show_me_whats_relevant);
            const html_show_me_whats_relevant = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_highlight_relevant_content, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9UcmI))), {
                    label: label_show_me_whats_relevant
                }),
                content: label_show_me_whats_relevant,
                tooltipMessage: label_show_me_whats_relevant,
                data: {
                    name: label_show_me_whats_relevant,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_show_me_whats_relevant)
                }
            };
        case "identify-key-trends":
            const label_identify_key_trends = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_identify_key_trends);
            const html_identify_key_trends = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_identify_key_trends, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                    label: label_identify_key_trends,
                    size: iconSize
                }),
                content: label_identify_key_trends,
                tooltipMessage: label_identify_key_trends,
                data: {
                    name: label_identify_key_trends,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_identify_key_trends)
                }
            };
        case "identify-key-points":
            const label_identify_key_points = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_identify_key_points);
            const html_identify_key_points = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_identify_key_points, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                    label: label_identify_key_points,
                    size: iconSize
                }),
                content: label_identify_key_points,
                tooltipMessage: label_identify_key_points,
                data: {
                    name: label_identify_key_points,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_identify_key_points)
                }
            };
        case "find-open-questions":
            const label_find_open_questions = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_find_open_questions);
            const html_find_open_questions = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_find_open_questions, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                    label: label_find_open_questions,
                    size: iconSize
                }),
                content: label_find_open_questions,
                tooltipMessage: label_find_open_questions,
                data: {
                    name: label_find_open_questions,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_find_open_questions)
                }
            };
        case "summarize-document":
            const label_summarize_document = intl.formatMessage((0, $dM7c5.messages).ai_summarize);
            const html_summarize_document = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_summarize_document, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_summarize_document,
                tooltipMessage: label_summarize_document,
                data: {
                    name: label_summarize_document,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_summarize_document)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
                    label: label_summarize_document,
                    size: iconSize
                })
            };
        case "summarize-presentation":
            const label_summarize_presentation = intl.formatMessage((0, $dM7c5.messages).ai_summarize);
            const html_summarize_presentation = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_summarize_presentation, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_summarize_presentation,
                tooltipMessage: label_summarize_presentation,
                data: {
                    name: label_summarize_presentation,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_summarize_presentation)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
                    label: label_summarize_presentation,
                    size: iconSize
                })
            };
        case "explain-code":
            const label_explain_code = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_explain_code);
            const html_explain_code = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_explain_code, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_explain_code,
                tooltipMessage: label_explain_code,
                data: {
                    name: label_explain_code,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_explain_code)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
                    label: label_explain_code,
                    size: iconSize
                })
            };
        case "catch-up":
            const label_catch_up = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_catch_up);
            const html_catch_up = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_catch_up, {
                url: url,
                provider: provider
            }, {
                ignoreTag: true
            });
            return {
                content: label_catch_up,
                tooltipMessage: label_catch_up,
                data: {
                    name: label_catch_up,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_catch_up)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
                    label: label_catch_up,
                    size: iconSize
                })
            };
        case "salesforce-prep":
            const label_overview = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_salesforce_prep);
            const html_overview = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_salesforce_prep, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_overview,
                tooltipMessage: label_overview,
                data: {
                    name: label_overview,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_overview)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
                    label: label_overview,
                    size: iconSize
                })
            };
    }
};
module.exports["RovoChatPromptKey"] = $77626c1968cfb017$export$a9f8723a23072cb8;
module.exports["getPromptAction"] = $77626c1968cfb017$export$35d7b8e732470f9f;

});

parcelRegister("751cc", function(module, exports) {

var $9udAq = parcelRequire("9udAq");

const $162dded746a4fc65$export$59ae2c325a998f89 = (maybeNode)=>(0, $9udAq.applyMark)({
        type: 'strong'
    }, maybeNode);
module.exports["strong"] = $162dded746a4fc65$export$59ae2c325a998f89;

});

parcelRegister("gxFDR", function(module, exports) {

var $9udAq = parcelRequire("9udAq");

const $6633d47e6c8a0c85$export$6565f9f03506010b = (maybeNode)=>(0, $9udAq.applyMark)({
        type: 'code'
    }, maybeNode);
module.exports["code"] = $6633d47e6c8a0c85$export$6565f9f03506010b;

});

parcelRegister("fGQsh", function(module, exports) {
const $857a268d3f29ba58$export$cbf8224b64e0d942 = (attrs)=>({
        type: 'inlineCard',
        attrs: attrs
    });
module.exports["inlineCard"] = $857a268d3f29ba58$export$cbf8224b64e0d942;

});

parcelRegister("bWF3R", function(module, exports) {
const $8a197a39985804ad$export$a140c94e5ea26bee = (...content)=>({
        type: 'bulletList',
        content: content
    });
module.exports["bulletList"] = $8a197a39985804ad$export$a140c94e5ea26bee;

});

parcelRegister("lOv7Z", function(module, exports) {

var $4yYAm = parcelRequire("4yYAm");

const $8a832de04ca367bd$export$adbd04236f07a7d8 = (items = [], context, product)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $4yYAm.ActionName).DeleteAction:
            case (0, $4yYAm.ActionName).EditAction:
            case (0, $4yYAm.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $4yYAm.ActionName)[item.name]);
            case (0, $4yYAm.ActionName).RovoChatAction:
                if (!!product && product === 'CONFLUENCE') return Boolean((0, $4yYAm.ActionName)[item.name]);
                // same as default case below
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
module.exports["filterActionItems"] = $8a832de04ca367bd$export$adbd04236f07a7d8;

});

parcelRegister("cOVCp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");

/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");





var $k12R1 = parcelRequire("k12R1");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $7WEaj = parcelRequire("7WEaj");


var $eKMV3 = parcelRequire("eKMV3");


var $vIR70 = parcelRequire("vIR70");


var $iMnC5 = parcelRequire("iMnC5");


var $lpNn5 = parcelRequire("lpNn5");





var $kjaz0 = parcelRequire("kjaz0");


var $it2N0 = parcelRequire("it2N0");


var $8QLAc = parcelRequire("8QLAc");


var $ckM0L = parcelRequire("ckM0L");




const $83ca216da4462ba1$export$9d642f65a919fb93 = {
    [(0, $4yYAm.SmartLinkSize).Small]: 'none',
    [(0, $4yYAm.SmartLinkSize).Medium]: 'compact',
    [(0, $4yYAm.SmartLinkSize).Large]: 'compact',
    [(0, $4yYAm.SmartLinkSize).XLarge]: 'default'
};


const $8532231a1a6a0a08$var$IconOnlyLarge = null;
const $8532231a1a6a0a08$var$SizeSmall = null;
const $8532231a1a6a0a08$var$styles = {
    textSmall: "_2AV1rB7NXe _46PhP8f7mX _4ceWemHnLE _0KyXRjDIqT"
};
const $8532231a1a6a0a08$var$SizeSmallIconOnly = null;
const $8532231a1a6a0a08$var$SizeSmallNotIconOnly = null;
const $8532231a1a6a0a08$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $8532231a1a6a0a08$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $8532231a1a6a0a08$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $8532231a1a6a0a08$var$ActionButtonRefresh = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    const iconOnly = !content;
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const { product: product } = (0, $8QLAc.default)();
    const isRovoSupported = !!context?.actions?.[(0, $4yYAm.ActionName).RovoChatAction] && !!product && product === 'CONFLUENCE';
    const onButtonClick = (0, $cozmU.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $cozmU.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $4yYAm.SmartLinkSize).Large || size === (0, $4yYAm.SmartLinkSize).XLarge ? 'default' : 'compact';
        const icon = iconBefore || iconAfter;
        const iconFn = icon ? ()=>icon : undefined;
        if (iconOnly && iconFn) {
            if (isLinkButton && iconFn) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
                appearance: $8532231a1a6a0a08$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $8532231a1a6a0a08$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                appearance: $8532231a1a6a0a08$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $8532231a1a6a0a08$var$tooltipOptions
            });
        }
        const iconBeforeFn = iconBefore ? ()=>iconBefore : undefined;
        const iconAfterFn = iconAfter ? ()=>iconAfter : undefined;
        if (isLinkButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            appearance: $8532231a1a6a0a08$var$ButtonAppearanceMap[appearance],
            "aria-label": ariaLabel,
            iconAfter: iconAfterFn,
            iconBefore: iconBeforeFn,
            isDisabled: isDisabled,
            href: href,
            onClick: onButtonClick(onClick),
            spacing: spacing,
            testId: testId
        }, content));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: $8532231a1a6a0a08$var$ButtonAppearanceMap[appearance],
            "aria-label": ariaLabel,
            iconAfter: iconAfterFn,
            iconBefore: iconBeforeFn,
            isDisabled: isDisabled,
            isLoading: isLoading,
            onClick: onButtonClick(onClick),
            spacing: spacing,
            testId: testId
        }, content));
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        xcss: (0, $k12R1.cx)(isRovoSupported && size === (0, $4yYAm.SmartLinkSize).Small && $8532231a1a6a0a08$var$styles.textSmall)
    }, button);
});
const $8532231a1a6a0a08$var$ActionButtonRefreshWithOverrideCss = (0, $ckM0L.withOverrideCss)($8532231a1a6a0a08$var$ActionButtonRefresh);
const $8532231a1a6a0a08$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $cozmU.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            size === (0, $4yYAm.SmartLinkSize).Large && iconOnly && "_3syKoKdnbC _1DhZAbdnbC _3g5xaLdnbC _3wQpz0dnbC _2h7MEPdnbC _07tuX1dnbC _3pYja6dnbC _4zLtGJdnbC _3tOQhEdnbC _47g3eodnbC _0SUtXsdnbC _1fXoeGdnbC _04h2sEdnbC _2YpdL1dnbC _24b4DjdnbC _28KjYAdnbC _3zlJk4dnbC _2BvQ3tdnbC _0k4xigdnbC _1O8dyrdnbC _1uShhVdnbC _1PeZETdnbC _3LkCxldnbC _38Yu2FdnbC _0eBsvxdnbC _1bZ7O8dnbC _0zG2z1dnbC _3iNqPKdnbC _4tzkdwdnbC _1dUVyqdnbC _1XCb4ZdnbC _33JUGNdnbC",
            size === (0, $4yYAm.SmartLinkSize).Small && "_2sNsIg7NXe _1kk5Tkf7mX",
            size === (0, $4yYAm.SmartLinkSize).Small && iconOnly && "_3syKoKFQfX _1DhZAbFQfX _3g5xaLFQfX _3wQpz0FQfX _2h7MEPFQfX _07tuX1FQfX _3pYja6FQfX _4zLtGJFQfX _3tOQhEFQfX _47g3eoFQfX _0SUtXsFQfX _1fXoeGFQfX _04h2sEFQfX _2YpdL1FQfX _24b4DjFQfX _28KjYAFQfX",
            size === (0, $4yYAm.SmartLinkSize).Small && !iconOnly && "_04h2sE1Y8M _2YpdL11Y8M _24b4Dj1Y8M _28KjYA1Y8M _2h7MEP1Y8M _07tuX11Y8M _3pYja61Y8M _4zLtGJ1Y8M",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: tooltipMessage,
        hideTooltipOnClick: true,
        testId: `${testId}-tooltip`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $vIR70.default), {
        appearance: appearance,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onButtonClick(onClick),
        spacing: (0, $83ca216da4462ba1$export$9d642f65a919fb93)[size],
        testId: testId,
        href: href,
        "aria-label": ariaLabel
    }, content)));
};
const $8532231a1a6a0a08$var$ActionButton = (props)=>{
    const ui = (0, $it2N0.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton || ui?.removeBlockRestriction) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8532231a1a6a0a08$var$ActionButtonRefreshWithOverrideCss, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8532231a1a6a0a08$var$ActionButtonNew, props);
};
var $8532231a1a6a0a08$export$2e2bcd8739ae039 = $8532231a1a6a0a08$var$ActionButton;






var $is1T6 = parcelRequire("is1T6");


var $jt5b6 = parcelRequire("jt5b6");

const $f6a96b6f05617437$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $jt5b6.handleOnClick)(onClick),
        testId: testId
    }, content);
var $f6a96b6f05617437$export$2e2bcd8739ae039 = $f6a96b6f05617437$var$ActionDropdownItem;


/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 





const $07bb28f8f9a17497$var$stackItemIconStylesCompiled = null;
const $07bb28f8f9a17497$var$ActionIcon = ({ testId: testId, icon: icon })=>{
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $hekY6.default)([
            "_3iDTPbccYA"
        ])
    }, icon);
};
var $07bb28f8f9a17497$export$2e2bcd8739ae039 = $07bb28f8f9a17497$var$ActionIcon;








/* action-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $w6R6I = parcelRequire("w6R6I");




var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");


var $lfoFx = parcelRequire("lfoFx");




const $58b8c8d2ace59b23$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $4yYAm.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $4yYAm.SmartLinkSize).Large:
            return 'space.200';
        case (0, $4yYAm.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $4yYAm.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};



const $b17373f47a070578$var$styles = {
    button: "_0KLXru66of _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _39xV02N91d _34b3D2Ll21 _1eOmH6o126 _3gzVzLN4oS",
    content: "_2sNsIg7NXe _1UtDYzy7kJ",
    spinner: "_39xV02oWWg _0jFU0VoWWg _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT"
};
const $b17373f47a070578$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style, ariaLabel: ariaLabel })=>{
    const space = spaceOption ?? (0, $58b8c8d2ace59b23$export$475c391af8171fec)(size);
    const onClick = (0, $cozmU.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]); // FIX-ME: This is required for ResolvedHoverCardFooterBlock action to show proper size
    // ResolvedHoverCardFooterBlock is currently not used but keeping inside the code base for
    // upcoming experiment to refresh HoverCard design
    // If ResolvedHoverCardFooterBlock is cleaned up, this code can be removed.
    const showSpinnerSize24 = false;
    const icon = iconOption && isLoading ? /*#__PURE__*/ $cozmU.createElement((0, $07bb28f8f9a17497$export$2e2bcd8739ae039), {
        icon: showSpinnerSize24 ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $b17373f47a070578$var$styles.spinner
        }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            size: 16,
            testId: `${testId}-loading`
        })) : /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            testId: `${testId}-loading`
        })
    }) : iconOption;
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($b17373f47a070578$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        style: style,
        "aria-label": ariaLabel
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        grow: "fill",
        space: space
    }, icon, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($b17373f47a070578$var$styles.content)
    }, content)));
};
var $b17373f47a070578$export$2e2bcd8739ae039 = $b17373f47a070578$var$ActionButton;


const $62d59e5b8825e398$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hasNewContentOnTriggerClick: hasNewContentOnTriggerClick, hideTooltip: hideTooltip, ...props })=>{
    return hideTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b17373f47a070578$export$2e2bcd8739ae039), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hasNewContentOnTriggerClick: hasNewContentOnTriggerClick
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b17373f47a070578$export$2e2bcd8739ae039), {
            ...props,
            content: content,
            tooltipProps: tooltipProps
        }));
};
var $62d59e5b8825e398$export$2e2bcd8739ae039 = $62d59e5b8825e398$var$ActionStackItem;


/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $d4ea2cbf7473627f$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $4yYAm.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hasNewContentOnTriggerClick: hasNewContentOnTriggerClick, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $07bb28f8f9a17497$export$2e2bcd8739ae039), {
        icon: icon,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $62d59e5b8825e398$export$2e2bcd8739ae039), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hasNewContentOnTriggerClick: hasNewContentOnTriggerClick,
        hideTooltip: hideTooltip,
        ariaLabel: ariaLabel
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f6a96b6f05617437$export$2e2bcd8739ae039), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8532231a1a6a0a08$export$2e2bcd8739ae039), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, null, button) : button;
};
var $d4ea2cbf7473627f$export$2e2bcd8739ae039 = $d4ea2cbf7473627f$var$Action;
module.exports["default"] = $d4ea2cbf7473627f$export$2e2bcd8739ae039;

});

parcelRegister("jt5b6", function(module, exports) {
parcelRequire("cozmU");

const $fa3082429122785f$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
module.exports["handleOnClick"] = $fa3082429122785f$export$ffccab2ae3d093ef;

});

parcelRegister("5Nciw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");





var $6cFsl = parcelRequire("6cFsl");


var $euBHF = parcelRequire("euBHF");





var $kSwu1 = parcelRequire("kSwu1");


var $gC0KQ = parcelRequire("gC0KQ");


var $6Vsq4 = parcelRequire("6Vsq4");


var $dM7c5 = parcelRequire("dM7c5");


var $cOVCp = parcelRequire("cOVCp");













const $1b0984aa4ce5b7c3$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $dM7c5.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $4yYAm.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $dM7c5.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $dM7c5.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $dM7c5.messages).ai_summary_error_generic_rebrand,
                url: (0, $4yYAm.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};








const $e73565c1b07bf983$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $e73565c1b07bf983$export$2e2bcd8739ae039 = $e73565c1b07bf983$var$AIEventErrorViewed;






var $i1t43 = parcelRequire("i1t43");




const $e209b8ee56caeb94$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: (0, $4yYAm.CONTENT_URL_ROVO),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props
    }, children);
var $e209b8ee56caeb94$export$2e2bcd8739ae039 = $e209b8ee56caeb94$var$AILearnMoreAnchor;


const $53a45ab7b94caa46$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $1b0984aa4ce5b7c3$export$cd2e891d7f87074d)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e73565c1b07bf983$export$2e2bcd8739ae039), {
            reason: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...message,
            values: {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e209b8ee56caeb94$export$2e2bcd8739ae039), {
                        href: url
                    }, chunks)
            }
        }))
    };
};


function $415dfd9ed8e9cb23$export$75a19de44af58722({ onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const onCompleted = (0, $cozmU.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $53a45ab7b94caa46$export$82f46aa4e6535a45)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).ai_summary_action_rebrand),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC0KQ))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            size: props.iconSize
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).ai_summary_action_description_rebrand),
        ...props
    });
}









var $fHs3z = parcelRequire("fHs3z");










function $0aa7654887d48ff1$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, summary: summary = '', testId: testId, ...props }) {
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $cozmU.useState)((0, $dM7c5.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $cozmU.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(summary);
        setTooltipMessage((0, $dM7c5.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        summary
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).copy_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary",
            size: props.iconSize
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $dM7c5.messages).copy_summary_action_description),
        hasNewContentOnTriggerClick: true,
        ...props
    });
}


const $ef162c0474978f45$export$8eed96bc6d982595 = (props)=>{
    (0, $6cFsl.di)((0, $euBHF.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $euBHF.default)(url);
    (0, $cozmU.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0aa7654887d48ff1$export$cfa1d3eed9a61059), {
        ...props,
        summary: content,
        testId: testId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $415dfd9ed8e9cb23$export$75a19de44af58722), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};


const $2e2681fee114ae51$var$AISummaryAction = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $4yYAm.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ef162c0474978f45$export$8eed96bc6d982595), {
        ...actionData,
        ...props
    }) : null;
};
var $2e2681fee114ae51$export$2e2bcd8739ae039 = $2e2681fee114ae51$var$AISummaryAction;
module.exports["default"] = $2e2681fee114ae51$export$2e2bcd8739ae039;

});

parcelRegister("euBHF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hiX3M = parcelRequire("hiX3M");


var $jMcHR = parcelRequire("jMcHR");


var $6Vsq4 = parcelRequire("6Vsq4");


var $12fG9 = parcelRequire("12fG9");


var $kSkO7 = parcelRequire("kSkO7");


var $ahcye = parcelRequire("ahcye");


var $9H66G = parcelRequire("9H66G");





var $kSwu1 = parcelRequire("kSwu1");

// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");


var $kzwaO = parcelRequire("kzwaO");

const $8a313ecc0905db1b$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};


/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $7f5a1c6c864b6857$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $7f5a1c6c864b6857$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $7f5a1c6c864b6857$export$ff2962de2b2c930f = (product)=>{
    if ($7f5a1c6c864b6857$var$isJiraProduct(product)) return $7f5a1c6c864b6857$var$AiMateJiraXProduct[product];
    return product;
};


const $50123147e90a63dd$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};


async function* $0cffe7e1a4751a42$export$e45226161c660403(response) {
    const reader = (0, $50123147e90a63dd$export$f6383c3ea1307da9)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}


class $69acbcf5fb261283$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $69acbcf5fb261283$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];


const $e542134bf344ced2$var$CONVO_AI_ENDPOINT = 'assist/api/ai/v2/ai-feature/smartlinksummary/stream';
class $e542134bf344ced2$export$73e4b807d5bd74b6 {
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const id = (0, $03RpJ.default)();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.content;
                if (chunk.type === 'ERROR') throw new (0, $69acbcf5fb261283$export$fcec967a4b7ebd84)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $69acbcf5fb261283$export$fcec967a4b7ebd84) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.config = void 0;
        this.url = void 0;
        this.ari = void 0;
        this.locale = void 0;
        this.subscribedStateSetters = new Set();
        this.onStart = void 0;
        this.onSuccess = void 0;
        this.onError = void 0;
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $kzwaO.getBaseUrl)(envKey);
                return (0, $8a313ecc0905db1b$export$4c25481b843feb0b)(baseUrl, $e542134bf344ced2$var$CONVO_AI_ENDPOINT);
            }
            return (0, $8a313ecc0905db1b$export$4c25481b843feb0b)('/gateway/api/', $e542134bf344ced2$var$CONVO_AI_ENDPOINT);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                },
                ai_feature_input: {
                    content_url: this.url,
                    content_ari: this.ari,
                    locale: this.locale
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $0cffe7e1a4751a42$export$e45226161c660403)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $7f5a1c6c864b6857$export$ff2962de2b2c930f)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
}



var $lPEt0 = parcelRequire("lPEt0");

const $423f9ef2c5e6a9fb$var$AI_SUMMARY_CACHE_SIZE = 100;
const $423f9ef2c5e6a9fb$export$6979339b6d41707e = new (0, $lPEt0.LRUMap)($423f9ef2c5e6a9fb$var$AI_SUMMARY_CACHE_SIZE);


const $a7221ae92bb029e9$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $cozmU.useState)((0, $423f9ef2c5e6a9fb$export$6979339b6d41707e).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $423f9ef2c5e6a9fb$export$6979339b6d41707e).get(url)) (0, $423f9ef2c5e6a9fb$export$6979339b6d41707e).set(url, new (0, $e542134bf344ced2$export$73e4b807d5bd74b6)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $423f9ef2c5e6a9fb$export$6979339b6d41707e).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $423f9ef2c5e6a9fb$export$6979339b6d41707e).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};



var $lBXKn = parcelRequire("lBXKn");

const $ef9452ea85dab480$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $ef9452ea85dab480$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $lBXKn.useAISummaryConfig)();
    const cardState = (0, $9H66G.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $hiX3M.extractAri)(data);
    const dataUrl = data && (0, $jMcHR.extractLink)(data) || '';
    const onStart = (0, $cozmU.useCallback)((id)=>{
        (0, $kSkO7.startUfoExperience)($ef9452ea85dab480$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $cozmU.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $ahcye.succeedUfoExperience)($ef9452ea85dab480$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $cozmU.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $12fG9.failUfoExperience)($ef9452ea85dab480$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $a7221ae92bb029e9$export$becd8f2eba1bbd96)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $ef9452ea85dab480$export$2e2bcd8739ae039 = $ef9452ea85dab480$var$useAISummaryAction;
module.exports["default"] = $ef9452ea85dab480$export$2e2bcd8739ae039;

});

parcelRegister("lBXKn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bI14T = parcelRequire("bI14T");

const $866680c7620d2426$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bI14T.useSmartLinkContext)();
    return (0, $cozmU.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};
module.exports["useAISummaryConfig"] = $866680c7620d2426$export$4480af2c00aa7ebe;

});

parcelRegister("5IFQc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hMcNB = parcelRequire("hMcNB");


var $4aRua = parcelRequire("4aRua");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $kjaz0 = parcelRequire("kjaz0");


var $d6Q9o = parcelRequire("d6Q9o");


var $cOVCp = parcelRequire("cOVCp");




const $1c7abd7b34efb0ba$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $dM7c5.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $dM7c5.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};



const $5c24e4c3132e9e87$var$AutomationModal = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("a8gZ1")));
const $5c24e4c3132e9e87$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const modal = (0, $d6Q9o.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $4yYAm.ActionName).AutomationAction];
    const automationActionOnClick = (0, $cozmU.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $1c7abd7b34efb0ba$export$93e707b363eaf5c8)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), modalTitle) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                        as: "strong"
                    }, chunks),
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null)
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5c24e4c3132e9e87$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).automation_action_title);
    const automationActionTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).automation_action_tooltip);
    const automationActionIconLabel = formatMessage((0, $dM7c5.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        content: automationActionTitle,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMcNB))), {
            spacing: "spacious",
            color: "currentColor",
            label: automationActionIconLabel,
            size: props.iconSize
        }),
        testId: "smart-action-automation-action",
        tooltipMessage: automationActionTooltip,
        ...props,
        onClick: ()=>automationActionOnClick(automationActionData)
    }));
};
var $5c24e4c3132e9e87$export$2e2bcd8739ae039 = $5c24e4c3132e9e87$var$AutomationAction;
module.exports["default"] = $5c24e4c3132e9e87$export$2e2bcd8739ae039;

});

parcelRegister("hsgLh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $d3ed0ddb142a7bfb$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $d3ed0ddb142a7bfb$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($d3ed0ddb142a7bfb$var$FALLBACK_API);
module.exports["SmartLinkModalContext"] = $d3ed0ddb142a7bfb$export$f4c0a0f23ba57f8c;

});

parcelRegister("a8gZ1", function(module, exports) {

let $7607d34509b87485$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7607d34509b87485$var$load("6wr18"),
    $7607d34509b87485$var$load("ffEVr"),
    $7607d34509b87485$var$load("kHXvF"),
    $7607d34509b87485$var$load("iWnyc"),
    $7607d34509b87485$var$load("hhss7"),
    $7607d34509b87485$var$load("Wowvf"),
    $7607d34509b87485$var$load("4g6rd"),
    $7607d34509b87485$var$load("7EorR"),
    $7607d34509b87485$var$load("9zzZg")
]).then(()=>parcelRequire('aoCnl'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("1FScK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kTb7m = parcelRequire("kTb7m");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $kjaz0 = parcelRequire("kjaz0");


var $kfxZm = parcelRequire("kfxZm");


var $cOVCp = parcelRequire("cOVCp");

const $36397dcac95c69a1$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const intl = (0, $kSwu1.useIntl)();
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const invoke = (0, $kfxZm.default)({});
    const data = context?.actions?.[(0, $4yYAm.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $cozmU.useState)((0, $dM7c5.messages).copy_url_to_clipboard);
    const onClick = (0, $cozmU.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $dM7c5.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        ariaLabel: intl.formatMessage((0, $dM7c5.messages).copy_url_to_clipboard),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).copy_url_to_clipboard),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            color: "currentColor",
            label: "",
            spacing: "spacious",
            size: props.iconSize
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $dM7c5.messages).copy_url_to_clipboard),
        hasNewContentOnTriggerClick: true,
        ...data,
        ...props
    }) : null;
};
var $36397dcac95c69a1$export$2e2bcd8739ae039 = $36397dcac95c69a1$var$CopyLinkAction;
module.exports["default"] = $36397dcac95c69a1$export$2e2bcd8739ae039;

});

parcelRegister("bHsBU", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a21383db9cb3b7a$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $wkC5u = parcelRequire("wkC5u");

var $5a21383db9cb3b7a$export$2e2bcd8739ae039 = (0, $wkC5u.CustomUnresolvedAction);

});

parcelRegister("wkC5u", function(module, exports) {
/* CustomUnresolvedAction.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");


var $4yYAm = parcelRequire("4yYAm");


var $3ec5J = parcelRequire("3ec5J");

const $891aa7c7950805e7$var$styles = {
    button: "_3iDTPbcK7c",
    message: "_4c065UPgdg _2Y7lL4Pgdg"
};
const $891aa7c7950805e7$var$validErrorStatuses = [
    (0, $4yYAm.SmartLinkStatus).Forbidden,
    (0, $4yYAm.SmartLinkStatus).Unauthorized
];
const $891aa7c7950805e7$var$validateErrorStatus = (status)=>{
    return status !== undefined && $891aa7c7950805e7$var$validErrorStatuses.includes(status);
};
const $891aa7c7950805e7$var$getMessageDescriptor = (status, accessType, props)=>{
    if (!$891aa7c7950805e7$var$validateErrorStatus(status)) return undefined;
    const message = props?.[status]?.[accessType ?? 'FALLBACK'];
    return message;
}; /**
    * Public API — exported externally. Do not add props without external support intent.
    */ 
const $891aa7c7950805e7$export$275b43513330d43b = ({ testId: testId = 'custom-unresolved-action', onlyShowIfAction: onlyShowIfAction = false, Container: Container, ...props })=>{
    const context = (0, $3ec5J.useFlexibleCardContext)();
    const data = context?.data?.actions?.[(0, $4yYAm.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const { status: status } = context;
    const accessType = context?.data?.meta?.accessType;
    const hasAction = onClick !== undefined;
    if (onlyShowIfAction && !hasAction) return null;
    const messageDescriptor = $891aa7c7950805e7$var$getMessageDescriptor(status, accessType, props) ?? descriptor;
    if (!messageDescriptor) return null;
    const message = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: $891aa7c7950805e7$var$styles.message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...messageDescriptor,
        values: values
    }));
    const component = hasAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $891aa7c7950805e7$var$styles.button
    }, message) : message;
    return Container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Container, null, component) : component;
};
module.exports["CustomUnresolvedAction"] = $891aa7c7950805e7$export$275b43513330d43b;

});

parcelRegister("fhinp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $l3wuH = parcelRequire("l3wuH");


var $dM7c5 = parcelRequire("dM7c5");


var $cOVCp = parcelRequire("cOVCp");

const $f88a7db3804e0f77$var$DeleteAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).delete),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).delete),
        ...props
    });
var $f88a7db3804e0f77$export$2e2bcd8739ae039 = $f88a7db3804e0f77$var$DeleteAction;
module.exports["default"] = $f88a7db3804e0f77$export$2e2bcd8739ae039;

});

parcelRegister("kD7T6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6Fmj3 = parcelRequire("6Fmj3");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $kjaz0 = parcelRequire("kjaz0");


var $kfxZm = parcelRequire("kfxZm");


var $cOVCp = parcelRequire("cOVCp");

const $dae9a0dddf9a7f28$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const invoke = (0, $kfxZm.default)({});
    const data = context?.actions?.[(0, $4yYAm.ActionName).DownloadAction];
    const onClick = (0, $cozmU.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $dM7c5.messages).download_file : (0, $dM7c5.messages).download;
    const tooltipMessage = isStackItem ? (0, $dM7c5.messages).download_description : (0, $dM7c5.messages).download;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Fmj3))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), tooltipMessage),
        ...data,
        ...props
    }) : null;
};
var $dae9a0dddf9a7f28$export$2e2bcd8739ae039 = $dae9a0dddf9a7f28$var$DownloadAction;
module.exports["default"] = $dae9a0dddf9a7f28$export$2e2bcd8739ae039;

});

parcelRegister("78OZj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $gC2EJ = parcelRequire("gC2EJ");


var $dM7c5 = parcelRequire("dM7c5");


var $cOVCp = parcelRequire("cOVCp");

const $e14a96ed4e7b2165$var$EditAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).edit),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).edit),
        ...props
    });
var $e14a96ed4e7b2165$export$2e2bcd8739ae039 = $e14a96ed4e7b2165$var$EditAction;
module.exports["default"] = $e14a96ed4e7b2165$export$2e2bcd8739ae039;

});

parcelRegister("1fKLY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cXtTj = parcelRequire("cXtTj");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $kjaz0 = parcelRequire("kjaz0");


var $4wH3g = parcelRequire("4wH3g");

const $6e48a94843c9ab3b$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "EzgQz",
        name: "importIcon",
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};






var $6Vsq4 = parcelRequire("6Vsq4");


var $bwJAe = parcelRequire("bwJAe");


var $6GOAK = parcelRequire("6GOAK");


var $aDH7j = parcelRequire("aDH7j");

const $3038b38463833894$export$65b3f792dff0bd60 = (err)=>{
    if (!(0, $aDH7j.isInvokeCustomError)(err)) return (0, $6GOAK.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $6GOAK.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $6GOAK.TrackQuickActionFailureReason).UnknownError;
    }
};



var $cEvdy = parcelRequire("cEvdy");

const $249c069e40bf5370$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $249c069e40bf5370$export$2e2bcd8739ae039 = $249c069e40bf5370$var$createInvokeRequest;



var $cOVCp = parcelRequire("cOVCp");

const $91b3cd2514901f8a$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const invoke = (0, $bwJAe.default)();
    const reload = (0, $cEvdy.default)();
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const handleClick = (0, $cozmU.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $249c069e40bf5370$export$2e2bcd8739ae039)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload({
                    url: action.reload.url,
                    isReloading: true,
                    id: action.reload.id
                });
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $3038b38463833894$export$65b3f792dff0bd60)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $91b3cd2514901f8a$export$2e2bcd8739ae039 = $91b3cd2514901f8a$var$ServerAction;








const $1fa8e2f128b6af29$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $cXtTj.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $dM7c5.messages).follow_project_errorGalaxia : (0, $dM7c5.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $cXtTj.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $dM7c5.messages).unfollow_project_errorGalaxia : (0, $dM7c5.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $dM7c5.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $dM7c5.messages).unfollow_goal_error;
    return (0, $dM7c5.messages).generic_error_message;
};




const $2f7ca412ccba39f5$var$importIconMapper = {
    goal: ()=>(parcelRequire("9U5KN")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("bC5Km")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $2f7ca412ccba39f5$var$getIcon = (stackIconType)=>{
    const importFn = $2f7ca412ccba39f5$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $6e48a94843c9ab3b$export$6dc831e1a0a7a851)(importFn);
};
const $2f7ca412ccba39f5$var$FollowAction = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const intl = (0, $kSwu1.useIntl)();
    const actionData = context?.actions?.[(0, $4yYAm.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $dM7c5.messages).follow : (0, $dM7c5.messages).unfollow;
    const projectMessage = value ? (0, $dM7c5.messages).follow_project : (0, $dM7c5.messages).unfollow_project;
    const goalMessage = value ? (0, $dM7c5.messages).follow_goal : (0, $dM7c5.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $cXtTj.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $dM7c5.messages).follow_project_descriptionGalaxia : (0, $dM7c5.messages).follow_project_description : (0, $cXtTj.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $dM7c5.messages).unfollow_project_descriptionGalaxia : (0, $dM7c5.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $dM7c5.messages).follow_goal_description : (0, $dM7c5.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $2f7ca412ccba39f5$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $1fa8e2f128b6af29$export$49248678d3914625)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), errorMessage),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91b3cd2514901f8a$export$2e2bcd8739ae039), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label),
        ariaLabel: intl.formatMessage(label),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), tooltipMessage),
        ...data,
        ...props,
        onError: handleError
    });
};
var $2f7ca412ccba39f5$export$2e2bcd8739ae039 = $2f7ca412ccba39f5$var$FollowAction;
module.exports["default"] = $2f7ca412ccba39f5$export$2e2bcd8739ae039;

});

parcelRegister("c7dFC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cXJjm = parcelRequire("cXJjm");

const $72eb3fb9792f1abd$export$d08617a365fbe694 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (cardClient)=>{
    const $ = (0, $bDgLe.c)(3);
    cardClient?.baseUrlOverride;
    cardClient?.envKey;
    const t0 = cardClient?.envKey;
    const t1 = cardClient?.baseUrlOverride;
    let t2;
    if ($[0] !== t0 || $[1] !== t1) {
        t2 = (0, $cXJjm.getResolverUrl)(t0, t1);
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : (cardClient)=>(0, $cozmU.useMemo)(()=>(0, $cXJjm.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);
module.exports["useResolverUrl"] = $72eb3fb9792f1abd$export$d08617a365fbe694;

});

parcelRegister("9U5KN", function(module, exports) {

let $735dce9471e245da$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $735dce9471e245da$var$load("6wr18"),
    $735dce9471e245da$var$load("ffEVr"),
    $735dce9471e245da$var$load("hTwYJ")
]).then(()=>parcelRequire('ez6j0'));

});

parcelRegister("bC5Km", function(module, exports) {

let $8747b37e82602029$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8747b37e82602029$var$load("6wr18"),
    $8747b37e82602029$var$load("ffEVr"),
    $8747b37e82602029$var$load("9PVXs")
]).then(()=>parcelRequire('kV5QU'));

});

parcelRegister("e8Ej5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $8VfSP = parcelRequire("8VfSP");


var $gDx2k = parcelRequire("gDx2k");


var $ieeJu = parcelRequire("ieeJu");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $kjaz0 = parcelRequire("kjaz0");


var $kfxZm = parcelRequire("kfxZm");


var $cOVCp = parcelRequire("cOVCp");

const $e5cd9fcfba897113$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const intl = (0, $kSwu1.useIntl)();
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const invoke = (0, $kfxZm.default)({});
    const data = context?.actions?.[(0, $4yYAm.ActionName).PreviewAction];
    const hasPreviewPanel = data?.hasPreviewPanel;
    const onClick = (0, $cozmU.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $dM7c5.messages).preview_description : (0, $dM7c5.messages).preview_improved;
    const actionIcon = (0, $cozmU.useCallback)(()=>{
        // Only use panel icon if experiment is enabled and hasPreviewPanel is true
        if ((0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))), {
            color: "currentColor",
            spacing: "spacious",
            label: "",
            size: props.iconSize
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))), {
            color: "currentColor",
            spacing: "spacious",
            label: "",
            size: props.iconSize
        });
    }, [
        hasPreviewPanel,
        props.iconSize
    ]);
    const actionLabel = (0, $cozmU.useMemo)(()=>{
        // Only use panel message if experiment is enabled and hasPreviewPanel is true
        if ((0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return (0, $dM7c5.messages).preview_panel;
        // Fall back to modal message if experiment is enabled, otherwise use original preview message
        if ((0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) return (0, $dM7c5.messages).preview_modal;
        return (0, $dM7c5.messages).preview_improved;
    }, [
        hasPreviewPanel
    ]);
    const actionMessage = intl.formatMessage(actionLabel);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        ariaLabel: actionMessage,
        content: actionMessage,
        icon: actionIcon(),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), tooltipMessage),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $e5cd9fcfba897113$export$2e2bcd8739ae039 = $e5cd9fcfba897113$var$PreviewAction;
module.exports["default"] = $e5cd9fcfba897113$export$2e2bcd8739ae039;

});

parcelRegister("kI1Tj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $kfxZm = parcelRequire("kfxZm");


var $4ZDKy = parcelRequire("4ZDKy");


var $edVsK = parcelRequire("edVsK");


var $cOVCp = parcelRequire("cOVCp");

const $270625602ddd6621$var$DEFAULT_PROMPTS = [];
const $270625602ddd6621$var$RovoChatAction = ({ onClick: onClickCallback, prompts: prompts, testId: testId = 'smart-action-rovo-chat-action', ...props })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { isRovoChatEnabled: isRovoChatEnabled, sendPromptMessage: sendPromptMessage } = (0, $4ZDKy.default)();
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $4yYAm.ActionName).RovoChatAction];
    const resolvedPrompts = (0, $cozmU.useMemo)(()=>{
        if (prompts) return prompts;
        return $270625602ddd6621$var$DEFAULT_PROMPTS;
    }, [
        prompts
    ]);
    const invoke = (0, $kfxZm.default)({});
    const onClick = (0, $cozmU.useCallback)((promptData, promptKey)=>{
        if (promptData && data?.invokeAction) {
            invoke({
                ...data?.invokeAction,
                actionFn: async ()=>sendPromptMessage(promptData),
                prompt: promptKey
            });
            onClickCallback?.();
        }
    }, [
        data?.invokeAction,
        invoke,
        onClickCallback,
        sendPromptMessage
    ]);
    const promptActions = (0, $cozmU.useMemo)(()=>{
        return resolvedPrompts.map((promptKey, idx)=>{
            const { icon: icon, content: content, tooltipMessage: tooltipMessage, data: promptData } = (0, $edVsK.getPromptAction)({
                promptKey: promptKey,
                intl: intl,
                url: data?.url,
                product: data?.product,
                iconSize: props.iconSize,
                cardAppearance: props.cardAppearance
            }) || {};
            return promptData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
                content: content,
                icon: icon,
                key: promptKey,
                onClick: ()=>onClick(promptData, promptKey),
                testId: `${testId}-${idx + 1}`,
                tooltipMessage: tooltipMessage,
                ...props
            }) : null;
        });
    }, [
        data,
        intl,
        onClick,
        resolvedPrompts,
        props,
        testId
    ]);
    return isRovoChatEnabled && data && promptActions?.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, promptActions) : null;
};
var $270625602ddd6621$export$2e2bcd8739ae039 = $270625602ddd6621$var$RovoChatAction;
module.exports["default"] = $270625602ddd6621$export$2e2bcd8739ae039;

});

parcelRegister("4ZDKy", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $130CJ = parcelRequire("130CJ");


var $aflIU = parcelRequire("aflIU");


var $8QLAc = parcelRequire("8QLAc");

const $3bcafe2f183f4da0$var$SMART_LINK_TO_ROVO_SOURCE = 'smart-link';
const $3bcafe2f183f4da0$var$useRovoChat = ()=>{
    const { rovoOptions: config } = (0, $8QLAc.default)();
    const { publishWithPostMessage: publishWithPostMessage } = (0, $130CJ.useRovoPostMessageToPubsub)();
    const isRovoChatEnabled = (0, $aflIU.getIsRovoChatEnabled)(config);
    const sendPromptMessage = (0, $cozmU.useCallback)((data)=>{
        publishWithPostMessage({
            targetWindow: window.parent ?? window,
            payload: {
                type: 'chat-new',
                source: $3bcafe2f183f4da0$var$SMART_LINK_TO_ROVO_SOURCE,
                data: {
                    dialogues: [],
                    ...data,
                    agentId: undefined
                },
                openChat: true,
                openChatMode: 'sidebar'
            },
            onAcknowledgeTimeout: ()=>{
            // NAVX-3599: Add analytics event
            }
        });
    }, [
        publishWithPostMessage
    ]);
    return (0, $cozmU.useMemo)(()=>({
            isRovoChatEnabled: isRovoChatEnabled,
            sendPromptMessage: sendPromptMessage
        }), [
        isRovoChatEnabled,
        sendPromptMessage
    ]);
};
var $3bcafe2f183f4da0$export$2e2bcd8739ae039 = $3bcafe2f183f4da0$var$useRovoChat;
module.exports["default"] = $3bcafe2f183f4da0$export$2e2bcd8739ae039;

});

parcelRegister("cpdvP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6Vsq4 = parcelRequire("6Vsq4");


var $dM7c5 = parcelRequire("dM7c5");


var $kjaz0 = parcelRequire("kjaz0");


var $d6Q9o = parcelRequire("d6Q9o");


var $cOVCp = parcelRequire("cOVCp");





var $5ZtfK = parcelRequire("5ZtfK");

const $0e88aae6564d7c8f$var$RelatedLinksActionIcon = ({ iconSize: iconSize })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
        color: "currentColor",
        spacing: "spacious",
        label: '',
        size: iconSize
    });
var $0e88aae6564d7c8f$export$2e2bcd8739ae039 = $0e88aae6564d7c8f$var$RelatedLinksActionIcon;



const $8383284991048575$var$RelatedLinksModal = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("65UxH")));
const $8383284991048575$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $d6Q9o.useSmartLinkModal)();
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const onClick = (0, $cozmU.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8383284991048575$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).related_links_view_related_links),
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).related_links_view_related_links),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e88aae6564d7c8f$export$2e2bcd8739ae039), {
            iconSize: props.iconSize
        }),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $8383284991048575$export$2e2bcd8739ae039 = $8383284991048575$var$ViewRelatedLinksAction;
module.exports["default"] = $8383284991048575$export$2e2bcd8739ae039;

});

parcelRegister("65UxH", function(module, exports) {

let $46ff11e416264e51$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $46ff11e416264e51$var$load("dhXIT"),
    $46ff11e416264e51$var$load("hhss7"),
    $46ff11e416264e51$var$load("ikMj1")
]).then(()=>parcelRequire('bvLmn'));

});

parcelRegister("8Mb1e", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");

const $8c688acf6816af13$var$styles = {
    button: "_3iDTPbcK7c",
    padding: "_2Y7lL48HPE",
    message: "_4c065UPgdg _2Y7lL4Pgdg"
};
const $8c688acf6816af13$var$UnresolvedAction = ({ testId: testId = 'unresolved-action', hasPadding: hasPadding = false })=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $4yYAm.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const hasAction = onClick !== undefined;
    const message = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: (0, $w6R6I.cx)($8c688acf6816af13$var$styles.message, hasPadding && $8c688acf6816af13$var$styles.padding)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...descriptor,
        values: values
    }));
    return hasAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $8c688acf6816af13$var$styles.button
    }, message) : message;
};
var $8c688acf6816af13$export$2e2bcd8739ae039 = $8c688acf6816af13$var$UnresolvedAction;
module.exports["default"] = $8c688acf6816af13$export$2e2bcd8739ae039;

});

parcelRegister("hsIfr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $bt1e6 = parcelRequire("bt1e6");
/* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gkfEh = parcelRequire("gkfEh");

const $2fe6d61cbd6c9581$export$6d33abd591a3f700 = (data, type)=>{
    const isDataLinkIcon = (_data)=>{
        return typeof _data === 'object' && _data !== null && ('icon' in _data || 'url' in _data);
    };
    if (!isDataLinkIcon(data)) return typeof data === 'object' ? data : undefined;
    const isImageRound = (0, $gkfEh.isProfileType)(type);
    return {
        ...data,
        appearance: isImageRound ? 'round' : 'square'
    };
};


const $21ed2e6b0c1568e5$var$excludedResourceTypes = [
    '0',
    'unknown',
    'unsupported',
    'REDACTED'
];
const $21ed2e6b0c1568e5$var$manualMapping = {
    jswBoard: 'Jira Software Board',
    calendarJsw: 'Jira Software Calendar',
    kbArticle: 'Knowledge Base Article',
    pull: 'Pull Request',
    repo: 'Repository'
};
/**
 * Splits a resolver `resourceType` token into human-oriented words.
 * Prefers kebab-case (`-`) when present; otherwise splits camelCase / PascalCase.
 */ function $21ed2e6b0c1568e5$var$splitIntoWords(resourceType) {
    if (resourceType.includes('-')) return resourceType.split('-').map((w)=>w.trim()).filter(Boolean);
    const spaced = resourceType.replace(/([a-z\d])([A-Z])/g, '$1 $2').replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2');
    return spaced.split(/\s+/).filter(Boolean);
}
function $21ed2e6b0c1568e5$var$titleCaseWord(word) {
    if (!word) return word;
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}
function $21ed2e6b0c1568e5$export$3422b5d26145468d(resourceType) {
    const trimmed = resourceType?.trim();
    if (!trimmed) return undefined;
    if ($21ed2e6b0c1568e5$var$excludedResourceTypes.includes(trimmed)) return undefined;
    const manual = $21ed2e6b0c1568e5$var$manualMapping[trimmed];
    if (manual !== undefined) return manual;
    const words = $21ed2e6b0c1568e5$var$splitIntoWords(trimmed);
    if (words.length === 0) return undefined;
    return words.map($21ed2e6b0c1568e5$var$titleCaseWord).join(' ');
} // Following are unique resourceType values for the past week (at the the time of writing) for reference:
 // page
 // issue
 // 0
 // (none)
 // unknown
 // file
 // space
 // message
 // jswBoard
 // video
 // card
 // project
 // board
 // repository
 // whiteboard
 // channel
 // pull-request
 // mergeRequest
 // database
 // pullRequest
 // singlePortalPage
 // folder
 // dashboard
 // requestCreateForm
 // commit
 // jql
 // blog
 // version
 // backlog
 // undefinedLink
 // branch
 // report
 // planTimeline
 // sharepointFile
 // comment
 // roadmap
 // idea
 // case
 // opportunity
 // account
 // list
 // issues
 // view
 // workItem
 // link
 // block
 // kbArticle
 // form
 // summary
 // task
 // search
 // visitor
 // public-link
 // user
 // playlist
 // prototype
 // deal
 // screen
 // pipeline
 // contact
 // incident
 // sheet
 // featureFlag
 // release
 // switcheroo-flag
 // single-calendar
 // repo
 // formBuilder
 // proformaForm
 // object
 // tiny
 // document
 // sharedFile
 // campaign
 // table
 // compassComponent
 // timeline
 // boardInvite
 // action
 // embed
 // objectType
 // calendar
 // calendarJsw
 // publishedView
 // template
 // gist
 // recording
 // plan
 // planDependencies
 // epic
 // oneDriveFile
 // chart
 // capability
 // artboard
 // planCalendar
 // planSummary
 // projectTeamTag
 // planProgram
 // compassComponentSearchQuery
 // feature
 // workspace
 // company
 // insight
 // customer
 // Page
 // schema
 // dependency
 // note
 // article
 // snippet
 // tag
 // goal
 // security
 // collaborationGroup
 // envelope
 // code
 // boardView
 // compassScorecard
 // invoice
 // theme
 // customWorkspaceView
 // risk
 // reel
 // deployments
 // objective
 // ask
 // compassMetricDefinition
 // compassComponentAnnouncement
 // portals
 // asks
 // breadcrumbChart
 // Chart
 // slide
 // unsupported
 // remote-link
 // pull
 // REDACTED
 // compassComponentScorecard
 // forms
 // sante
 // zoom


const $7d6821988c87783f$var$LinkIconElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    if (!context) return null;
    const linkIconProps = (0, $2fe6d61cbd6c9581$export$6d33abd591a3f700)(context?.linkIcon, context.type);
    if (!linkIconProps) return null;
    const jiraIssueTypeLabel = context.meta?.resourceType === 'issue' && context.type?.includes('atlassian:Task') ? linkIconProps.label?.trim() : undefined;
    const label = jiraIssueTypeLabel ?? (0, $21ed2e6b0c1568e5$export$3422b5d26145468d)(context.meta?.resourceType) ?? linkIconProps.label?.trim() ?? props.label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bt1e6.default), {
        ...linkIconProps,
        ...props,
        label: label,
        name: (0, $4yYAm.ElementName).LinkIcon
    });
};
var $7d6821988c87783f$export$2e2bcd8739ae039 = $7d6821988c87783f$var$LinkIconElement;
module.exports["default"] = $7d6821988c87783f$export$2e2bcd8739ae039;

});

parcelRegister("bt1e6", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kTb7m = parcelRequire("kTb7m");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $9NPFC = parcelRequire("9NPFC");


var $4yYAm = parcelRequire("4yYAm");


var $aGLwK = parcelRequire("aGLwK");


var $5IVlB = parcelRequire("5IVlB");


var $f3cl5 = parcelRequire("f3cl5");

const $4650c18fe752ae49$var$styles = {
    container: "_4ouGXIE6Kk",
    iconWrapperStyle: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
const $4650c18fe752ae49$var$positionStyleMap = {
    center: "_4xdlr0DIqT",
    top: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _4xdlr0chRC"
};
const $4650c18fe752ae49$var$customRenderStyleMap = {
    xlarge: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgxzFw _3iDTPbgJ9S _3W2Oc8wPeg _4Gn54R7dHp _2fwxA5DIqT _39HuIboWuR _1U1ZhbZqHV _3BSs0udnbC _3IFMqTdnbC _0eabI8dnbC _4uAkJCdnbC _3ZsYrqdnbC _0BXPwddnbC _3PFkzMdnbC _0DtnpGdnbC _0VOaqfQame _4ACwSfN91d _0VARMJN91d _2nBKY9GuX1",
    large: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgxzFw _3iDTPbgJ9S _3W2Oc8wPeg _4Gn54R7dHp _2fwxA5DIqT _39HuIboWuR _1U1ZhbZqHV _3BSs0udnbC _3IFMqTdnbC _0eabI8dnbC _4uAkJCdnbC _3ZsYrqdnbC _0BXPwddnbC _3PFkzMdnbC _0DtnpGdnbC _0VOaqfQame _4ACwSfN91d _0VARMJN91d _2nBKY9GuX1",
    medium: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIg1kXk _3iDTPbgJ9S _3W2Oc8wPeg _4Gn54R7dHp _2fwxA5DIqT _39HuIboWuR _1U1ZhbZqHV _3BSs0udnbC _3IFMqTdnbC _0eabI8dnbC _4uAkJCdnbC _3ZsYrqdnbC _0BXPwddnbC _3PFkzMdnbC _0DtnpGdnbC _0VOaqfQame _4ACwSfN91d _0VARMJN91d _2nBKY9HTUk",
    small: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIg1kXk _3iDTPbgJ9S _3W2Oc8wPeg _4Gn54R7dHp _2fwxA5DIqT _39HuIboWuR _1U1ZhbZqHV _3BSs0udnbC _3IFMqTdnbC _0eabI8dnbC _4uAkJCdnbC _3ZsYrqdnbC _0BXPwddnbC _3PFkzMdnbC _0DtnpGdnbC _0VOaqfQame _4ACwSfN91d _0VARMJN91d _2nBKY9HTUk"
};
const $4650c18fe752ae49$var$renderAtlaskitIcon = (icon, testId, size = (0, $4yYAm.SmartLinkSize).Medium, label, isTiledIcon)=>{
    if (icon) return /*#__PURE__*/ $cozmU.createElement((0, $5IVlB.default), {
        icon: icon,
        testId: `${testId}-icon`,
        label: label,
        size: size,
        isTiledIcon: isTiledIcon
    });
};
const $4650c18fe752ae49$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $4650c18fe752ae49$var$widthFromSize = (size, isTiledIcon)=>{
    switch(size){
        case (0, $4yYAm.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $4yYAm.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $4yYAm.SmartLinkSize).Medium:
            return isTiledIcon ? "var(--ds-space-250, 20px)" : "var(--ds-space-200, 16px)";
        case (0, $4yYAm.SmartLinkSize).Small:
            return "var(--ds-space-200, 16px)";
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $4650c18fe752ae49$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $4yYAm.SmartLinkSize).Medium, appearance, hideLoadingSkeleton, label)=>{
    const width = size === (0, $4yYAm.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ $cozmU.createElement((0, $aGLwK.default), {
        label: label,
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        appearance: appearance,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
const $4650c18fe752ae49$var$renderImageIconNew = (defaultIcon, url, testId, size = (0, $4yYAm.SmartLinkSize).Medium, appearance, hideLoadingSkeleton, label, isTiledIcon = false)=>{
    const width = $4650c18fe752ae49$var$widthFromSize(size, isTiledIcon);
    if (url) return /*#__PURE__*/ $cozmU.createElement((0, $aGLwK.default), {
        label: label,
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        appearance: appearance,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
}; /**
    * A base element that displays an Icon or favicon.
    * @internal
    * @param props - The props necessary for the Icon element.
    * @see LinkIcon
    */ 
const $4650c18fe752ae49$var$IconElement = ({ icon: icon, overrideIcon: overrideIcon, label: labelProp, name: name, position: position = (0, $4yYAm.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $4yYAm.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton, isTiledIcon: isTiledIcon })=>{
    const label = labelProp ?? '';
    const element = (0, $cozmU.useMemo)(()=>{
        const defaultIcon = $4650c18fe752ae49$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || ((0, $iDrrr.fg)('platform_sl_3p_preauth_better_hovercard_killswitch') ? $4650c18fe752ae49$var$renderImageIconNew(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton, label, isTiledIcon) : $4650c18fe752ae49$var$renderImageIcon(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton, label)) || $4650c18fe752ae49$var$renderAtlaskitIcon(icon, testId, size, label, isTiledIcon) || defaultIcon;
    }, [
        label,
        testId,
        overrideIcon,
        render,
        url,
        size,
        appearance,
        hideLoadingSkeleton,
        icon,
        isTiledIcon
    ]);
    const width = (0, $f3cl5.getIconWidth)(size);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $4650c18fe752ae49$var$styles.container,
            $4650c18fe752ae49$var$positionStyleMap[position],
            render && $4650c18fe752ae49$var$customRenderStyleMap[size],
            className
        ])
    }, isTiledIcon ? /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
        size: size,
        hasBorder: true,
        backgroundColor: "white",
        label: label,
        testId: `${testId}-tile`
    }, element) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4650c18fe752ae49$var$styles.iconWrapperStyle,
        testId: `${testId}-box`,
        style: {
            width: width,
            height: width
        }
    }, element));
};
var $4650c18fe752ae49$export$2e2bcd8739ae039 = $4650c18fe752ae49$var$IconElement;
module.exports["default"] = $4650c18fe752ae49$export$2e2bcd8739ae039;

});

parcelRegister("l4gLd", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


const $f95df04d50024a01$var$loadPriorityIcons = ()=>(parcelRequire("12WI4"));














































































const $f95df04d50024a01$export$92d31eb5326761b6 = ()=>{
    return {
        // IconTile wrappers (@atlaskit/icon/core/* wrapped in <IconTile> with color)
        [(0, $4yYAm.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("2jRrx")))
        },
        [(0, $4yYAm.IconType).Audio]: {
            default: ()=>(parcelRequire("bvcyI"))
        },
        [(0, $4yYAm.IconType).Code]: {
            default: ()=>(parcelRequire("hc68Z"))
        },
        [(0, $4yYAm.IconType).File]: {
            default: ()=>(parcelRequire("hCYYB"))
        },
        [(0, $4yYAm.IconType).Folder]: {
            default: ()=>(parcelRequire("b3Fnp"))
        },
        [(0, $4yYAm.IconType).Generic]: {
            default: ()=>(parcelRequire("hCYYB"))
        },
        [(0, $4yYAm.IconType).Image]: {
            default: ()=>(parcelRequire("iz1Wf"))
        },
        [(0, $4yYAm.IconType).Presentation]: {
            default: ()=>(parcelRequire("7aEvo"))
        },
        [(0, $4yYAm.IconType).Spreadsheet]: {
            default: ()=>(parcelRequire("in8Hx"))
        },
        [(0, $4yYAm.IconType).Video]: {
            default: ()=>(parcelRequire("ltObF"))
        },
        // @atlaskit/icon/core/* (plain monochrome icons)
        [(0, $4yYAm.IconType).Project]: {
            default: ()=>Promise.resolve((parcelRequire("fBqzD")))
        },
        [(0, $4yYAm.IconType).Template]: {
            default: ()=>Promise.resolve((parcelRequire("kkFbH")))
        },
        [(0, $4yYAm.IconType).Forbidden]: {
            default: ()=>Promise.resolve((parcelRequire("4efpo")))
        },
        [(0, $4yYAm.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("kTb7m")))
        },
        [(0, $4yYAm.IconType).Error]: {
            default: ()=>Promise.resolve((parcelRequire("24dy7")))
        },
        // @atlaskit/icon/core/* (badge icons)
        [(0, $4yYAm.IconType).Attachment]: {
            default: ()=>Promise.resolve((parcelRequire("gxI48")))
        },
        [(0, $4yYAm.IconType).CheckItem]: {
            default: ()=>Promise.resolve((parcelRequire("iAaYd")))
        },
        [(0, $4yYAm.IconType).Component]: {
            default: ()=>(parcelRequire("bOKLW"))
        },
        [(0, $4yYAm.IconType).Comment]: {
            default: ()=>Promise.resolve((parcelRequire("eDtFr")))
        },
        [(0, $4yYAm.IconType).View]: {
            default: ()=>Promise.resolve((parcelRequire("a79Sy")))
        },
        [(0, $4yYAm.IconType).React]: {
            default: ()=>Promise.resolve((parcelRequire("c8bBH")))
        },
        [(0, $4yYAm.IconType).Vote]: {
            default: ()=>Promise.resolve((parcelRequire("f6cdQ")))
        },
        [(0, $4yYAm.IconType).PriorityUndefined]: {
            default: ()=>Promise.resolve((parcelRequire("kyJuy")))
        },
        [(0, $4yYAm.IconType).ProgrammingLanguage]: {
            default: ()=>Promise.resolve((parcelRequire("6YkHb")))
        },
        [(0, $4yYAm.IconType).Subscriber]: {
            default: ()=>Promise.resolve((parcelRequire("fBqzD")))
        },
        [(0, $4yYAm.IconType).SubTasksProgress]: {
            default: ()=>Promise.resolve((parcelRequire("lSw2p")))
        },
        // @atlaskit/icon-file-type/glyph/* (file type icons with 16/24 size variants)
        [(0, $4yYAm.IconType).Archive]: {
            default: ()=>(parcelRequire("8KvsV")),
            large: ()=>(parcelRequire("infyS"))
        },
        [(0, $4yYAm.IconType).Executable]: {
            default: ()=>(parcelRequire("kKj89")),
            large: ()=>(parcelRequire("jH9Kl"))
        },
        [(0, $4yYAm.IconType).GIF]: {
            default: ()=>(parcelRequire("1N5Ke")),
            large: ()=>(parcelRequire("hNtm1"))
        },
        [(0, $4yYAm.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("7KlQ2")),
            large: ()=>(parcelRequire("h2ScA"))
        },
        [(0, $4yYAm.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("4D6tQ")),
            large: ()=>(parcelRequire("5t4l8"))
        },
        [(0, $4yYAm.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("30pMN")),
            large: ()=>(parcelRequire("22LPp"))
        },
        [(0, $4yYAm.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("hbVly")),
            large: ()=>(parcelRequire("4UzML"))
        },
        [(0, $4yYAm.IconType).MSExcel]: {
            default: ()=>(parcelRequire("5eRas")),
            large: ()=>(parcelRequire("7oGQO"))
        },
        [(0, $4yYAm.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("bmQsw")),
            large: ()=>(parcelRequire("8e6lY"))
        },
        [(0, $4yYAm.IconType).MSWord]: {
            default: ()=>(parcelRequire("3tCrI")),
            large: ()=>(parcelRequire("60b70"))
        },
        [(0, $4yYAm.IconType).PDF]: {
            default: ()=>(parcelRequire("eiZGU")),
            large: ()=>(parcelRequire("iBf9z"))
        },
        [(0, $4yYAm.IconType).Sketch]: {
            default: ()=>(parcelRequire("ldRXm")),
            large: ()=>(parcelRequire("dJIeK"))
        },
        // Keep blog/live-document out of the lazy map on purpose.
        // These icons should be present in SSR markup so hydration does not cause
        // a visible empty-state-then-pop-in transition in Smart Link consumers.
        [(0, $4yYAm.IconType).Branch]: {
            default: ()=>(parcelRequire("7t6Dm")),
            large: ()=>(parcelRequire("jsJnf")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).Commit]: {
            default: ()=>(parcelRequire("duHmw")),
            large: ()=>(parcelRequire("aQVr4")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).PullRequest]: {
            default: ()=>(parcelRequire("gXlTT")),
            large: ()=>(parcelRequire("1ChPv")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).Repo]: {
            default: ()=>(parcelRequire("5RVCA")),
            large: ()=>(parcelRequire("8CdxX")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).Bug]: {
            default: ()=>(parcelRequire("j55Vn")),
            large: ()=>(parcelRequire("99NnD")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).Change]: {
            default: ()=>(parcelRequire("eY8PF")),
            large: ()=>(parcelRequire("j2Hlo")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).Epic]: {
            default: ()=>(parcelRequire("f37yM")),
            large: ()=>(parcelRequire("a5N9p")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).Incident]: {
            default: ()=>(parcelRequire("ejH6V")),
            large: ()=>(parcelRequire("8TcgT")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).Problem]: {
            default: ()=>(parcelRequire("9moVO")),
            large: ()=>(parcelRequire("itIA9")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).ServiceRequest]: {
            default: ()=>(parcelRequire("7xZuu")),
            large: ()=>(parcelRequire("8T3P5")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).Story]: {
            default: ()=>(parcelRequire("jvfZM")),
            large: ()=>(parcelRequire("gSpIm")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).SubTask]: {
            default: ()=>(parcelRequire("f6nAm")),
            large: ()=>(parcelRequire("4Fqpf")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).Task]: {
            default: ()=>(parcelRequire("8myMn")),
            large: ()=>(parcelRequire("90g3C")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        // @atlaskit/logo/* (product logos)
        [(0, $4yYAm.IconType).Confluence]: {
            default: ()=>Promise.resolve((parcelRequire("5lkNm"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $4yYAm.IconType).Jira]: {
            default: ()=>Promise.resolve((parcelRequire("ldJ1U"))).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Priority icons stay lazy, but share one chunk to avoid a cold-cache request per icon type.
        [(0, $4yYAm.IconType).PriorityBlocker]: {
            default: ()=>$f95df04d50024a01$var$loadPriorityIcons().then(({ PriorityBlockerIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $4yYAm.IconType).PriorityCritical]: {
            default: ()=>$f95df04d50024a01$var$loadPriorityIcons().then(({ PriorityCriticalIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $4yYAm.IconType).PriorityHigh]: {
            default: ()=>$f95df04d50024a01$var$loadPriorityIcons().then(({ PriorityHighIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $4yYAm.IconType).PriorityHighest]: {
            default: ()=>$f95df04d50024a01$var$loadPriorityIcons().then(({ PriorityHighestIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $4yYAm.IconType).PriorityLow]: {
            default: ()=>$f95df04d50024a01$var$loadPriorityIcons().then(({ PriorityLowIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $4yYAm.IconType).PriorityLowest]: {
            default: ()=>$f95df04d50024a01$var$loadPriorityIcons().then(({ PriorityLowestIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $4yYAm.IconType).PriorityMajor]: {
            default: ()=>$f95df04d50024a01$var$loadPriorityIcons().then(({ PriorityMajorIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $4yYAm.IconType).PriorityMedium]: {
            default: ()=>$f95df04d50024a01$var$loadPriorityIcons().then(({ PriorityMediumIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $4yYAm.IconType).PriorityMinor]: {
            default: ()=>$f95df04d50024a01$var$loadPriorityIcons().then(({ PriorityMinorIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $4yYAm.IconType).PriorityTrivial]: {
            default: ()=>$f95df04d50024a01$var$loadPriorityIcons().then(({ PriorityTrivialIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        }
    };
};
module.exports["getLazyIcons"] = $f95df04d50024a01$export$92d31eb5326761b6;

});

parcelRegister("12WI4", function(module, exports) {

let $0c3384e8b36b359d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0c3384e8b36b359d$var$load("iehPx"),
    $0c3384e8b36b359d$var$load("fzYHf"),
    $0c3384e8b36b359d$var$load("d6ClG"),
    $0c3384e8b36b359d$var$load("4J6Or"),
    $0c3384e8b36b359d$var$load("jQMSx"),
    $0c3384e8b36b359d$var$load("d7uYo"),
    $0c3384e8b36b359d$var$load("02Zp4"),
    $0c3384e8b36b359d$var$load("exCSw"),
    $0c3384e8b36b359d$var$load("dtb6I"),
    $0c3384e8b36b359d$var$load("c4Al8"),
    $0c3384e8b36b359d$var$load("jrGyY")
]).then(()=>parcelRequire('kUUNW'));

});

parcelRegister("bvcyI", function(module, exports) {

let $85fc54e6b663bd09$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $85fc54e6b663bd09$var$load("gkVge"),
    $85fc54e6b663bd09$var$load("kGKln")
]).then(()=>parcelRequire('aKPSY'));

});

parcelRegister("hc68Z", function(module, exports) {

let $c84852b61c694686$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c84852b61c694686$var$load("6wr18"),
    $c84852b61c694686$var$load("ffEVr"),
    $c84852b61c694686$var$load("bAe4U")
]).then(()=>parcelRequire('h2YSA'));

});

parcelRegister("hCYYB", function(module, exports) {

let $cd5548ea4e420c5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cd5548ea4e420c5a$var$load("6wr18"),
    $cd5548ea4e420c5a$var$load("ffEVr"),
    $cd5548ea4e420c5a$var$load("1pJPT")
]).then(()=>parcelRequire('ipz0N'));

});

parcelRegister("b3Fnp", function(module, exports) {

let $80d0120e31aabe05$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $80d0120e31aabe05$var$load("6wr18"),
    $80d0120e31aabe05$var$load("ffEVr"),
    $80d0120e31aabe05$var$load("bsuUF")
]).then(()=>parcelRequire('6CIfi'));

});

parcelRegister("iz1Wf", function(module, exports) {

let $037cdad5f1808a44$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $037cdad5f1808a44$var$load("6wr18"),
    $037cdad5f1808a44$var$load("ffEVr"),
    $037cdad5f1808a44$var$load("g36gj")
]).then(()=>parcelRequire('ae0Qi'));

});

parcelRegister("7aEvo", function(module, exports) {

let $5388e315b58f69ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5388e315b58f69ad$var$load("6wr18"),
    $5388e315b58f69ad$var$load("ffEVr"),
    $5388e315b58f69ad$var$load("duEFL")
]).then(()=>parcelRequire('f49me'));

});

parcelRegister("in8Hx", function(module, exports) {

let $d6011fdf467654b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d6011fdf467654b7$var$load("6wr18"),
    $d6011fdf467654b7$var$load("ffEVr"),
    $d6011fdf467654b7$var$load("6fJCf")
]).then(()=>parcelRequire('jBJvN'));

});

parcelRegister("ltObF", function(module, exports) {

let $fa333c899ef52dd3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fa333c899ef52dd3$var$load("6wr18"),
    $fa333c899ef52dd3$var$load("ffEVr"),
    $fa333c899ef52dd3$var$load("14QdI")
]).then(()=>parcelRequire('8Lnna'));

});

parcelRegister("bOKLW", function(module, exports) {

let $89a8a5347591510c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $89a8a5347591510c$var$load("9ZAcQ").then(()=>parcelRequire('gF3RM'));

});

parcelRegister("8KvsV", function(module, exports) {

let $65eb06ff5571b2cc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $65eb06ff5571b2cc$var$load("5JWJI").then(()=>parcelRequire('iqehY'));

});

parcelRegister("infyS", function(module, exports) {

let $d606722c1dde4e4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d606722c1dde4e4e$var$load("5JWJI").then(()=>parcelRequire('9TA3F'));

});

parcelRegister("kKj89", function(module, exports) {

let $f1a6f16f6403b629$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1a6f16f6403b629$var$load("aQ5uu").then(()=>parcelRequire('3OVVx'));

});

parcelRegister("jH9Kl", function(module, exports) {

let $e56997ec3ac6dc2c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e56997ec3ac6dc2c$var$load("aQ5uu").then(()=>parcelRequire('jTyNF'));

});

parcelRegister("1N5Ke", function(module, exports) {

let $14ded2ce3ce05390$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $14ded2ce3ce05390$var$load("geXPZ").then(()=>parcelRequire('EhIdb'));

});

parcelRegister("hNtm1", function(module, exports) {

let $cf4dc864b8d1c362$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cf4dc864b8d1c362$var$load("geXPZ").then(()=>parcelRequire('gCL8n'));

});

parcelRegister("7KlQ2", function(module, exports) {

let $5a3dc4e9d091ba35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a3dc4e9d091ba35$var$load("b4nm1").then(()=>parcelRequire('hmd8r'));

});

parcelRegister("h2ScA", function(module, exports) {

let $c68caaf277d94ac1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c68caaf277d94ac1$var$load("b4nm1").then(()=>parcelRequire('l8FBD'));

});

parcelRegister("4D6tQ", function(module, exports) {

let $35efd4ccf002d2a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35efd4ccf002d2a8$var$load("jfYeU").then(()=>parcelRequire('lLxTI'));

});

parcelRegister("5t4l8", function(module, exports) {

let $3fb306fbb619c67f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3fb306fbb619c67f$var$load("jfYeU").then(()=>parcelRequire('cSPDT'));

});

parcelRegister("30pMN", function(module, exports) {

let $23055fbb4908668b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23055fbb4908668b$var$load("kYkz1").then(()=>parcelRequire('kUQwC'));

});

parcelRegister("22LPp", function(module, exports) {

let $17d0de54722123d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $17d0de54722123d7$var$load("kYkz1").then(()=>parcelRequire('lhYzt'));

});

parcelRegister("hbVly", function(module, exports) {

let $c83ff29c592bd62f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c83ff29c592bd62f$var$load("5kI0b").then(()=>parcelRequire('1G3Dq'));

});

parcelRegister("4UzML", function(module, exports) {

let $393826a85003934f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $393826a85003934f$var$load("5kI0b").then(()=>parcelRequire('3Ll8s'));

});

parcelRegister("5eRas", function(module, exports) {

let $3d078090de5174e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d078090de5174e1$var$load("3i44s").then(()=>parcelRequire('1kVaD'));

});

parcelRegister("7oGQO", function(module, exports) {

let $562c0391ce984de1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $562c0391ce984de1$var$load("3i44s").then(()=>parcelRequire('67SYT'));

});

parcelRegister("bmQsw", function(module, exports) {

let $846a710eb4b35adb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $846a710eb4b35adb$var$load("4QwAJ").then(()=>parcelRequire('aeJll'));

});

parcelRegister("8e6lY", function(module, exports) {

let $5fd48f2b4743c564$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5fd48f2b4743c564$var$load("4QwAJ").then(()=>parcelRequire('6lknI'));

});

parcelRegister("3tCrI", function(module, exports) {

let $2881e71a7d44971f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2881e71a7d44971f$var$load("fHlIz").then(()=>parcelRequire('8If3N'));

});

parcelRegister("60b70", function(module, exports) {

let $45eb5cc32d998b84$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $45eb5cc32d998b84$var$load("fHlIz").then(()=>parcelRequire('fGSwx'));

});

parcelRegister("eiZGU", function(module, exports) {

let $a6a299b1e4e47c5f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a6a299b1e4e47c5f$var$load("aaRXj").then(()=>parcelRequire('8B1YK'));

});

parcelRegister("iBf9z", function(module, exports) {

let $d8a76fd6b50df6a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d8a76fd6b50df6a9$var$load("aaRXj").then(()=>parcelRequire('90EXt'));

});

parcelRegister("ldRXm", function(module, exports) {

let $f734aa7c232eacf4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f734aa7c232eacf4$var$load("6OMo6").then(()=>parcelRequire('AzmWu'));

});

parcelRegister("dJIeK", function(module, exports) {

let $a001cad5375096fd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a001cad5375096fd$var$load("6OMo6").then(()=>parcelRequire('8BODT'));

});

parcelRegister("7t6Dm", function(module, exports) {

let $57006329b0bc9a93$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $57006329b0bc9a93$var$load("6wr18"),
    $57006329b0bc9a93$var$load("ffEVr"),
    $57006329b0bc9a93$var$load("aFLSJ")
]).then(()=>parcelRequire('iMQz5'));

});

parcelRegister("jsJnf", function(module, exports) {

let $e2b3d43217e721e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e2b3d43217e721e1$var$load("6wr18"),
    $e2b3d43217e721e1$var$load("ffEVr"),
    $e2b3d43217e721e1$var$load("aFLSJ")
]).then(()=>parcelRequire('f7FiQ'));

});

parcelRegister("duHmw", function(module, exports) {

let $9d2fb68e04e8e7a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9d2fb68e04e8e7a4$var$load("6wr18"),
    $9d2fb68e04e8e7a4$var$load("ffEVr"),
    $9d2fb68e04e8e7a4$var$load("3Cky6")
]).then(()=>parcelRequire('39Mwn'));

});

parcelRegister("aQVr4", function(module, exports) {

let $7e6b50379560811c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7e6b50379560811c$var$load("6wr18"),
    $7e6b50379560811c$var$load("ffEVr"),
    $7e6b50379560811c$var$load("3Cky6")
]).then(()=>parcelRequire('6gVpf'));

});

parcelRegister("gXlTT", function(module, exports) {

let $c58325007db064ed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c58325007db064ed$var$load("6wr18"),
    $c58325007db064ed$var$load("ffEVr"),
    $c58325007db064ed$var$load("39XCn")
]).then(()=>parcelRequire('gITbz'));

});

parcelRegister("1ChPv", function(module, exports) {

let $12d72bae2090e27c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $12d72bae2090e27c$var$load("6wr18"),
    $12d72bae2090e27c$var$load("ffEVr"),
    $12d72bae2090e27c$var$load("39XCn")
]).then(()=>parcelRequire('lvsY2'));

});

parcelRegister("5RVCA", function(module, exports) {

let $445e99693cc22e4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $445e99693cc22e4e$var$load("6wr18"),
    $445e99693cc22e4e$var$load("ffEVr"),
    $445e99693cc22e4e$var$load("kG5Ju")
]).then(()=>parcelRequire('3CYX0'));

});

parcelRegister("8CdxX", function(module, exports) {

let $645c616a73e875d0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $645c616a73e875d0$var$load("6wr18"),
    $645c616a73e875d0$var$load("ffEVr"),
    $645c616a73e875d0$var$load("kG5Ju")
]).then(()=>parcelRequire('2z1Cx'));

});

parcelRegister("j55Vn", function(module, exports) {

let $de431466ddbc1ea0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $de431466ddbc1ea0$var$load("6wr18"),
    $de431466ddbc1ea0$var$load("ffEVr"),
    $de431466ddbc1ea0$var$load("4N1MY")
]).then(()=>parcelRequire('fHe6f'));

});

parcelRegister("99NnD", function(module, exports) {

let $6aab422f6512c9dc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6aab422f6512c9dc$var$load("6wr18"),
    $6aab422f6512c9dc$var$load("ffEVr"),
    $6aab422f6512c9dc$var$load("4N1MY")
]).then(()=>parcelRequire('ix7Nw'));

});

parcelRegister("eY8PF", function(module, exports) {

let $ae5d8538e2b1e6a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ae5d8538e2b1e6a9$var$load("6wr18"),
    $ae5d8538e2b1e6a9$var$load("ffEVr"),
    $ae5d8538e2b1e6a9$var$load("il8bj")
]).then(()=>parcelRequire('ahlZa'));

});

parcelRegister("j2Hlo", function(module, exports) {

let $ddcfd373104ef90d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ddcfd373104ef90d$var$load("6wr18"),
    $ddcfd373104ef90d$var$load("ffEVr"),
    $ddcfd373104ef90d$var$load("il8bj")
]).then(()=>parcelRequire('lfmf4'));

});

parcelRegister("f37yM", function(module, exports) {

let $af4d001497becc1e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $af4d001497becc1e$var$load("6wr18"),
    $af4d001497becc1e$var$load("ffEVr"),
    $af4d001497becc1e$var$load("aIze1")
]).then(()=>parcelRequire('6MsAF'));

});

parcelRegister("a5N9p", function(module, exports) {

let $75907f57f5ec24c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $75907f57f5ec24c2$var$load("6wr18"),
    $75907f57f5ec24c2$var$load("ffEVr"),
    $75907f57f5ec24c2$var$load("aIze1")
]).then(()=>parcelRequire('bht3M'));

});

parcelRegister("ejH6V", function(module, exports) {

let $a6c447e90d918ccf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a6c447e90d918ccf$var$load("6wr18"),
    $a6c447e90d918ccf$var$load("ffEVr"),
    $a6c447e90d918ccf$var$load("7rqWx")
]).then(()=>parcelRequire('38zdI'));

});

parcelRegister("8TcgT", function(module, exports) {

let $678cfaa208640d00$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $678cfaa208640d00$var$load("6wr18"),
    $678cfaa208640d00$var$load("ffEVr"),
    $678cfaa208640d00$var$load("7rqWx")
]).then(()=>parcelRequire('tBrWH'));

});

parcelRegister("9moVO", function(module, exports) {

let $6d098204d7643aa5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6d098204d7643aa5$var$load("6wr18"),
    $6d098204d7643aa5$var$load("ffEVr"),
    $6d098204d7643aa5$var$load("jw3lv")
]).then(()=>parcelRequire('cVpj0'));

});

parcelRegister("itIA9", function(module, exports) {

let $d73d84854886bfaf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d73d84854886bfaf$var$load("6wr18"),
    $d73d84854886bfaf$var$load("ffEVr"),
    $d73d84854886bfaf$var$load("jw3lv")
]).then(()=>parcelRequire('e9ExL'));

});

parcelRegister("7xZuu", function(module, exports) {

let $57eb5042297dc78b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $57eb5042297dc78b$var$load("6wr18"),
    $57eb5042297dc78b$var$load("ffEVr"),
    $57eb5042297dc78b$var$load("cvcNg")
]).then(()=>parcelRequire('S7fVP'));

});

parcelRegister("8T3P5", function(module, exports) {

let $67866cf71443d7d2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $67866cf71443d7d2$var$load("6wr18"),
    $67866cf71443d7d2$var$load("ffEVr"),
    $67866cf71443d7d2$var$load("cvcNg")
]).then(()=>parcelRequire('2hwbE'));

});

parcelRegister("jvfZM", function(module, exports) {

let $e32d51ebd2ceaabd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e32d51ebd2ceaabd$var$load("6wr18"),
    $e32d51ebd2ceaabd$var$load("ffEVr"),
    $e32d51ebd2ceaabd$var$load("jXM1T")
]).then(()=>parcelRequire('bvjEB'));

});

parcelRegister("gSpIm", function(module, exports) {

let $c495a2de92f273d8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c495a2de92f273d8$var$load("6wr18"),
    $c495a2de92f273d8$var$load("ffEVr"),
    $c495a2de92f273d8$var$load("jXM1T")
]).then(()=>parcelRequire('bnm2b'));

});

parcelRegister("f6nAm", function(module, exports) {

let $afe9b61e1a0aa105$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $afe9b61e1a0aa105$var$load("6wr18"),
    $afe9b61e1a0aa105$var$load("ffEVr"),
    $afe9b61e1a0aa105$var$load("4zz48")
]).then(()=>parcelRequire('jMFOf'));

});

parcelRegister("4Fqpf", function(module, exports) {

let $365f7980cfa3706a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $365f7980cfa3706a$var$load("6wr18"),
    $365f7980cfa3706a$var$load("ffEVr"),
    $365f7980cfa3706a$var$load("4zz48")
]).then(()=>parcelRequire('h3uhG'));

});

parcelRegister("8myMn", function(module, exports) {

let $616b5b41539023df$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $616b5b41539023df$var$load("6wr18"),
    $616b5b41539023df$var$load("ffEVr"),
    $616b5b41539023df$var$load("iZR3N")
]).then(()=>parcelRequire('a5G9M'));

});

parcelRegister("90g3C", function(module, exports) {

let $68e091c9a3c7e630$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $68e091c9a3c7e630$var$load("6wr18"),
    $68e091c9a3c7e630$var$load("ffEVr"),
    $68e091c9a3c7e630$var$load("iZR3N")
]).then(()=>parcelRequire('glDuG'));

});

parcelRegister("lYcSC", function(module, exports) {

var $iW3KC = parcelRequire("iW3KC");


var $ai0Ge = parcelRequire("ai0Ge");


var $2wny6 = parcelRequire("2wny6");

const $e72e4900a096031d$var$BlogIconWithColor = (0, $2wny6.renderIconPerSize)((0, $iW3KC.default), (0, $ai0Ge.default));
$e72e4900a096031d$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $e72e4900a096031d$export$2e2bcd8739ae039 = $e72e4900a096031d$var$BlogIconWithColor;
module.exports["default"] = $e72e4900a096031d$export$2e2bcd8739ae039;

});

parcelRegister("2jRrx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $hMaHH = parcelRequire("hMaHH");


var $ebRBT = parcelRequire("ebRBT");

// `blueBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `blueBold` directly with `blue`.
const $1e952d673c6be6e0$var$PageIconWithColor = (0, $ebRBT.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), 'blueBold');
$1e952d673c6be6e0$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $1e952d673c6be6e0$export$2e2bcd8739ae039 = $1e952d673c6be6e0$var$PageIconWithColor;
module.exports["default"] = $1e952d673c6be6e0$export$2e2bcd8739ae039;

});

parcelRegister("ebRBT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lSQgn = parcelRequire("lSQgn");


var $iDrrr = parcelRequire("iDrrr");


var $eXfud = parcelRequire("eXfud");

/**
 * Maps IconTile appearance to the icon glyph color token to use when rendering
 * a standalone icon (without a tile background).
 * When cleaning up `platform_lp_non_bold_large_sl_icon` in NAVX-5752, remove the `*Bold`
 * entries. Nothing will pass a bold appearance into this map after that.
 */ const $284346a6badaef7b$var$appearanceToStandaloneIconColor = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
/**
 * Bold appearances are the gate-off values. Remove this map when cleaning up
 * `platform_lp_non_bold_large_sl_icon` in NAVX-5752:
 * https://hello.jira.atlassian.cloud/browse/NAVX-5752
 */ const $284346a6badaef7b$var$boldToNonBoldAppearance = {
    blueBold: 'blue',
    grayBold: 'gray',
    greenBold: 'green',
    limeBold: 'lime',
    magentaBold: 'magenta',
    orangeBold: 'orange',
    purpleBold: 'purple',
    redBold: 'red',
    tealBold: 'teal',
    yellowBold: 'yellow'
};
const $284346a6badaef7b$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, isTiledIcon: isTiledIcon, ...props })=>{
        const tileSize = (0, $eXfud.transformSmartLinkSizeToIconTileSize)(size);
        if (tileSize === undefined) {
            // size="16" has been removed — render the icon directly without a tile,
            // using the appearance-derived color so it still matches the intended style.
            const label = props.label ?? '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                role: label ? 'img' : undefined,
                "aria-label": label || undefined,
                "data-testid": props.testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                color: $284346a6badaef7b$var$appearanceToStandaloneIconColor[appearance],
                label: ""
            }));
        }
        const { ...tileProps } = props;
        const nonBoldAppearance = $284346a6badaef7b$var$boldToNonBoldAppearance[appearance];
        const tileAppearance = nonBoldAppearance !== undefined && (0, $iDrrr.fg)('platform_lp_non_bold_large_sl_icon') ? nonBoldAppearance : appearance;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            appearance: tileAppearance,
            icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                    ...iconProps,
                    spacing: "spacious"
                }) : Icon,
            size: tileSize,
            ...tileProps
        });
    };
};
module.exports["renderIconTile"] = $284346a6badaef7b$export$87c3646d0e299cfe;

});

parcelRegister("66hVV", function(module, exports) {

var $7pJjg = parcelRequire("7pJjg");


var $dipyx = parcelRequire("dipyx");


var $2wny6 = parcelRequire("2wny6");

const $ac3693948c0eb166$var$LiveDocumentIconWithColor = (0, $2wny6.renderIconPerSize)((0, $7pJjg.default), (0, $dipyx.default));
$ac3693948c0eb166$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $ac3693948c0eb166$export$2e2bcd8739ae039 = $ac3693948c0eb166$var$LiveDocumentIconWithColor;
module.exports["default"] = $ac3693948c0eb166$export$2e2bcd8739ae039;

});

parcelRegister("gkfEh", function(module, exports) {
const $39caeaab5a0529b2$export$6a4545d6b336c401 = (type)=>!!(type && type.includes('Profile'));
module.exports["isProfileType"] = $39caeaab5a0529b2$export$6a4545d6b336c401;

});

parcelRegister("3qg1D", function(module, exports) {
$parcel$export(module.exports, "default", () => $95a1d8811810ae49$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8oxOo = parcelRequire("8oxOo");

var $95a1d8811810ae49$export$2e2bcd8739ae039 = (0, $8oxOo.Block);

});

parcelRegister("8oxOo", function(module, exports) {
/* Block.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4yYAm = parcelRequire("4yYAm");


var $ggIq5 = parcelRequire("ggIq5");

const $9012cc12d5978135$var$baseBlockStyles = null;
const $9012cc12d5978135$var$highlightRemoveStyles = null;
const $9012cc12d5978135$var$gapStyles = {
    xlarge: "_2mHwu8kG2W _06xzsOkG2W",
    large: "_2mHwu85zaO _06xzsO5zaO",
    medium: "_2mHwu82ADO _06xzsO2ADO",
    small: "_2mHwu81Y8M _06xzsO1Y8M"
};
const $9012cc12d5978135$var$directionStyles = {
    vertical: "_0aFT5vbt8w _0hPCNLchRC",
    horizontal: "_0aFT5v1qpb _0hPCNLDIqT"
}; /**
    * A block represents a collection of elements and actions that are arranged
    * in a row. All elements and actions should be contained within a Block.
    * @internal
    * @param {ActionGroupProps} ActionGroupProps
    * @see Action
    */ 
const $9012cc12d5978135$export$d96a8827a60d6b69 = ({ children: children, direction: direction = (0, $4yYAm.SmartLinkDirection).Horizontal, size: size = (0, $4yYAm.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style, placeholderId: placeholderId })=>{
    (0, $cozmU.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0hPCNLDIqT _3iDTPbQ4SZ _4ouGXIdnbC _37wbyuchRC _11sDorYbGa _4q8qkJbQDk _0FDIDT9r67 _0VNGmmfPFO _3ucPdq4YkS _0lJBt5A97I _2R8PW44YkS",
            "_2xIroYxTF4 _497WNwOiJt _2zndICfKqY _2xIroYOLYo _1UtDYzOLYo _2X4BecjOvk _3AKos1YbGa _2UgkTUYbGa _4cb4toYbGa _1WgujfYbGa _20VacPYbGa",
            $9012cc12d5978135$var$directionStyles[direction],
            $9012cc12d5978135$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        style: style,
        "data-ssr-placeholder": placeholderId,
        "data-ssr-placeholder-replace": placeholderId
    }, (0, $ggIq5.renderChildren)(children, size));
};
module.exports["Block"] = $9012cc12d5978135$export$d96a8827a60d6b69;

});

parcelRegister("4cPhH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $kjaz0 = parcelRequire("kjaz0");


var $cZnAt = parcelRequire("cZnAt");

var $10jYv = parcelRequire("10jYv");

const $dab65d4e2e68d680$var$AssignedToElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $10jYv.toFormattedTextProps)((0, $dM7c5.messages).assigned_to, context.assignedTo) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).AssignedTo
    }) : null;
};
var $dab65d4e2e68d680$export$2e2bcd8739ae039 = $dab65d4e2e68d680$var$AssignedToElement;
module.exports["default"] = $dab65d4e2e68d680$export$2e2bcd8739ae039;

});

parcelRegister("cZnAt", function(module, exports) {
$parcel$export(module.exports, "default", () => $9dbbb345bb1a9bb1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* BaseTextElement.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $ULhqw = parcelRequire("ULhqw");

const $fe07dcec65d64f7f$var$baseStyle = null;
const $fe07dcec65d64f7f$var$fontOverrideStyleMap = {
    'font.body': "_2sNsIgmnOE",
    'font.body.large': "_2sNsIg20Hp",
    'font.body.small': "_2sNsIg7NXe"
}; /**
    * A base element that displays some Text.
    * @internal
    * @param {TextProps} TextProps - The props necessary for the Text element.
    * @see Title
    */ 
const $fe07dcec65d64f7f$export$79422073c7118b5b = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text', hideFormat: hideFormat = false, color: color, fontSize: fontSize })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    const formattedContent = hideFormat && content ? content : (0, $ULhqw.getFormattedMessage)(message) || content;
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzZpcK _1ANEUSzUZr _3iDTPbgJ9S _4ouGXIdnbC _39HuIbz8Lp _3W2Oc8wPeg _1U1ZhbbI28",
            fontSize !== undefined && $fe07dcec65d64f7f$var$fontOverrideStyleMap[fontSize],
            "_4Gn54RPFFO _2nBKY9XML9",
            className
        ]),
        style: {
            color: color,
            "--_1erfju8": (0, $9aYkv.default)(maxLines)
        }
    }, formattedContent);
};


var $9dbbb345bb1a9bb1$export$2e2bcd8739ae039 = (0, $fe07dcec65d64f7f$export$79422073c7118b5b);

});

parcelRegister("ktdgI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $le41x = parcelRequire("le41x");

var $f2zIB = parcelRequire("f2zIB");

const $9f1fdf181f083d55$var$AssignedToGroupElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $f2zIB.toAvatarGroupProps)(context.assignedToGroup, true) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $le41x.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).AssignedToGroup
    }) : null;
};
var $9f1fdf181f083d55$export$2e2bcd8739ae039 = $9f1fdf181f083d55$var$AssignedToGroupElement;
module.exports["default"] = $9f1fdf181f083d55$export$2e2bcd8739ae039;

});

parcelRegister("cA0ah", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $jJP7n = parcelRequire("jJP7n");

var $80uua = parcelRequire("80uua");

const $166e8b61b546e359$var$AttachmentCountElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $80uua.toBadgeProps)(context.attachmentCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).Attachment,
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).AttachmentCount
    }) : null;
};
var $166e8b61b546e359$export$2e2bcd8739ae039 = $166e8b61b546e359$var$AttachmentCountElement;
module.exports["default"] = $166e8b61b546e359$export$2e2bcd8739ae039;

});

parcelRegister("jqres", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $le41x = parcelRequire("le41x");

var $f2zIB = parcelRequire("f2zIB");

const $ddf90da8931b7d21$var$AuthorGroupElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $f2zIB.toAvatarGroupProps)(context.authorGroup, false) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $le41x.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).AuthorGroup
    }) : null;
};
var $ddf90da8931b7d21$export$2e2bcd8739ae039 = $ddf90da8931b7d21$var$AuthorGroupElement;
module.exports["default"] = $ddf90da8931b7d21$export$2e2bcd8739ae039;

});

parcelRegister("a8wJH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $jJP7n = parcelRequire("jJP7n");

var $80uua = parcelRequire("80uua");

const $ecfa86c6b4ffbff9$var$ChecklistProgressElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $80uua.toBadgeProps)(context.checklistProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).CheckItem,
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).ChecklistProgress
    }) : null;
};
var $ecfa86c6b4ffbff9$export$2e2bcd8739ae039 = $ecfa86c6b4ffbff9$var$ChecklistProgressElement;
module.exports["default"] = $ecfa86c6b4ffbff9$export$2e2bcd8739ae039;

});

parcelRegister("56DiX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $le41x = parcelRequire("le41x");

var $f2zIB = parcelRequire("f2zIB");

const $5a3d8a5264b2b296$var$CollaboratorGroupElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $f2zIB.toAvatarGroupProps)(context.collaboratorGroup, false) : undefined;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $le41x.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).CollaboratorGroup
    }) : null;
};
var $5a3d8a5264b2b296$export$2e2bcd8739ae039 = $5a3d8a5264b2b296$var$CollaboratorGroupElement;
module.exports["default"] = $5a3d8a5264b2b296$export$2e2bcd8739ae039;

});

parcelRegister("LvVJP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $jJP7n = parcelRequire("jJP7n");

var $80uua = parcelRequire("80uua");

const $738e3a2399fcd2d8$var$CommentCountElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $80uua.toBadgeProps)(context.commentCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $cozmU.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).Comment,
        ...data,
        ...restProps,
        name: (0, $4yYAm.ElementName).CommentCount
    }) : null;
};
var $738e3a2399fcd2d8$export$2e2bcd8739ae039 = $738e3a2399fcd2d8$var$CommentCountElement;
module.exports["default"] = $738e3a2399fcd2d8$export$2e2bcd8739ae039;

});

parcelRegister("gsQuB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $kjaz0 = parcelRequire("kjaz0");


var $cZnAt = parcelRequire("cZnAt");

var $10jYv = parcelRequire("10jYv");

const $201bd7de6b69c2e6$var$CreatedByElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $10jYv.toFormattedTextProps)((0, $dM7c5.messages).created_by, context.createdBy) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).CreatedBy
    }) : null;
};
var $201bd7de6b69c2e6$export$2e2bcd8739ae039 = $201bd7de6b69c2e6$var$CreatedByElement;
module.exports["default"] = $201bd7de6b69c2e6$export$2e2bcd8739ae039;

});

parcelRegister("ikX3P", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $9ox4X = parcelRequire("9ox4X");

var $8c7of = parcelRequire("8c7of");

const $6f0d5f807f040dda$var$CreatedOnElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $8c7of.toDateTimeProps)('created', context.createdOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ox4X.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).CreatedOn
    }) : null;
};
var $6f0d5f807f040dda$export$2e2bcd8739ae039 = $6f0d5f807f040dda$var$CreatedOnElement;
module.exports["default"] = $6f0d5f807f040dda$export$2e2bcd8739ae039;

});

parcelRegister("jUXZW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $bYlCi = parcelRequire("bYlCi");
/* toDateLozengeProps.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $kSwu1 = parcelRequire("kSwu1");

const $b7ccb1a0eb8ff11f$export$8f9f58f7bac50fbe = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};


const $060af5e2139ab2e7$var$DueOnElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $b7ccb1a0eb8ff11f$export$8f9f58f7bac50fbe)(context.dueOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bYlCi.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).DueOn,
        isDateTag: true
    }) : null;
};
var $060af5e2139ab2e7$export$2e2bcd8739ae039 = $060af5e2139ab2e7$var$DueOnElement;
module.exports["default"] = $060af5e2139ab2e7$export$2e2bcd8739ae039;

});

parcelRegister("2VRbJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $jJP7n = parcelRequire("jJP7n");

var $80uua = parcelRequire("80uua");

const $79f37e8a63c6e4c7$var$LatestCommitElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $80uua.toBadgeProps)(context.latestCommit?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).Commit,
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).LatestCommit
    }) : null;
};
var $79f37e8a63c6e4c7$export$2e2bcd8739ae039 = $79f37e8a63c6e4c7$var$LatestCommitElement;
module.exports["default"] = $79f37e8a63c6e4c7$export$2e2bcd8739ae039;

});

parcelRegister("8y6iW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $jdGU5 = parcelRequire("jdGU5");

const $43a900c32f2a690d$var$LocationElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context?.location ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdGU5.default), {
        theme: (0, $4yYAm.SmartLinkInternalTheme).Grey,
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).Location
    }) : null;
};
var $43a900c32f2a690d$export$2e2bcd8739ae039 = $43a900c32f2a690d$var$LocationElement;
module.exports["default"] = $43a900c32f2a690d$export$2e2bcd8739ae039;

});

parcelRegister("72lc5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $kjaz0 = parcelRequire("kjaz0");


var $cZnAt = parcelRequire("cZnAt");

var $10jYv = parcelRequire("10jYv");

const $2ebfb6cd7421d9a3$var$ModifiedByElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $10jYv.toFormattedTextProps)((0, $dM7c5.messages).modified_by, context.modifiedBy) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).ModifiedBy
    }) : null;
};
var $2ebfb6cd7421d9a3$export$2e2bcd8739ae039 = $2ebfb6cd7421d9a3$var$ModifiedByElement;
module.exports["default"] = $2ebfb6cd7421d9a3$export$2e2bcd8739ae039;

});

parcelRegister("7sCIj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $9ox4X = parcelRequire("9ox4X");

var $8c7of = parcelRequire("8c7of");

const $540439c5c0836204$var$ModifiedOnElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $8c7of.toDateTimeProps)('modified', context.modifiedOn) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $cozmU.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ox4X.default), {
        ...data,
        ...restProps,
        name: (0, $4yYAm.ElementName).ModifiedOn
    }) : null;
};
var $540439c5c0836204$export$2e2bcd8739ae039 = $540439c5c0836204$var$ModifiedOnElement;
module.exports["default"] = $540439c5c0836204$export$2e2bcd8739ae039;

});

parcelRegister("4GRqQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $kjaz0 = parcelRequire("kjaz0");


var $cZnAt = parcelRequire("cZnAt");

var $10jYv = parcelRequire("10jYv");

const $4e3bd94b37ff918f$var$OwnedByElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const { onRender: onRender, textPrefix: textPrefix = 'owned_by', ...restProps } = props || {};
    const data = context ? (0, $10jYv.toFormattedTextProps)((0, $dM7c5.messages)[textPrefix], context?.ownedBy) : null;
    (0, $cozmU.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        ...data,
        ...restProps,
        name: (0, $4yYAm.ElementName).OwnedBy
    }) : null;
};
var $4e3bd94b37ff918f$export$2e2bcd8739ae039 = $4e3bd94b37ff918f$var$OwnedByElement;
module.exports["default"] = $4e3bd94b37ff918f$export$2e2bcd8739ae039;

});

parcelRegister("cl3v4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $le41x = parcelRequire("le41x");

var $f2zIB = parcelRequire("f2zIB");

const $2fe0b095cba40ed1$var$OwnedByGroupElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $f2zIB.toAvatarGroupProps)(context.ownedByGroup, false) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $cozmU.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $le41x.default), {
        ...data,
        ...restProps,
        name: (0, $4yYAm.ElementName).OwnedByGroup
    }) : null;
};
var $2fe0b095cba40ed1$export$2e2bcd8739ae039 = $2fe0b095cba40ed1$var$OwnedByGroupElement;
module.exports["default"] = $2fe0b095cba40ed1$export$2e2bcd8739ae039;

});

parcelRegister("khRQO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");

/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $hekY6 = parcelRequire("hekY6");


var $it2N0 = parcelRequire("it2N0");


var $aGLwK = parcelRequire("aGLwK");

const $eb4553b3010e85ab$var$styles = null;
const $eb4553b3010e85ab$var$MediaElement = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    const ui = (0, $it2N0.useFlexibleUiOptionContext)();
    if (!type || !url) return null;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_3v5uP04flE _3iDTPbQ4SZ _39xV02N91d _0jFU0VE6Kk _1iKEQ3N91d _3N5HrcN91d _0rNQthN91d _2bdNiqN91d _3co5ZJN91d _4piunrN91d _0lPJ7RN91d _1p4bQvN91d _0riCIziObl _25VLNaiObl _2QkZjjXWGq _3VA16WXWGq _1UIY2pWVPG _4ov7MsWVPG _0MW9AFiDnZ _0ej9GniDnZ _3avySP715P _2JWBct715P _3WnT5j715P _05axL0715P _1wyBuMIZbP _47THVyIZbP _0i7hLsIZbP _2Vw2Y3IZbP _352YkPnQyn _3C2qY3nQyn _0qjCUirxnX _1nZKtqdnbC _2zzBA9RAKS",
            className
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $aGLwK.default), {
        hideLoadingSkeleton: ui?.hideLoadingSkeleton,
        testId: `${testId}-image`,
        url: url,
        onError: onError,
        onLoad: onLoad,
        defaultIcon: null
    }));
};
var $eb4553b3010e85ab$export$2e2bcd8739ae039 = $eb4553b3010e85ab$var$MediaElement;


const $dcb10cd4b057c2eb$var$PreviewElement = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $4yYAm.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eb4553b3010e85ab$export$2e2bcd8739ae039), {
        ...rest,
        ...data
    });
};
var $dcb10cd4b057c2eb$export$2e2bcd8739ae039 = $dcb10cd4b057c2eb$var$PreviewElement;
module.exports["default"] = $dcb10cd4b057c2eb$export$2e2bcd8739ae039;

});

parcelRegister("i64z9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $jJP7n = parcelRequire("jJP7n");

const $c1f965687d6e4984$var$PriorityElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context?.priority ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).Priority
    }) : null;
};
var $c1f965687d6e4984$export$2e2bcd8739ae039 = $c1f965687d6e4984$var$PriorityElement;
module.exports["default"] = $c1f965687d6e4984$export$2e2bcd8739ae039;

});

parcelRegister("7bJZv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $jJP7n = parcelRequire("jJP7n");

var $80uua = parcelRequire("80uua");

const $c107b1c1373e69fb$var$ProgrammingLanguageElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $80uua.toBadgeProps)(context.programmingLanguage) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).ProgrammingLanguage,
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).ProgrammingLanguage
    }) : null;
};
var $c107b1c1373e69fb$export$2e2bcd8739ae039 = $c107b1c1373e69fb$var$ProgrammingLanguageElement;
module.exports["default"] = $c107b1c1373e69fb$export$2e2bcd8739ae039;

});

parcelRegister("fCf6x", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $jJP7n = parcelRequire("jJP7n");

const $858b70b399909400$var$ProviderElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context?.provider ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).Provider
    }) : null;
};
var $858b70b399909400$export$2e2bcd8739ae039 = $858b70b399909400$var$ProviderElement;
module.exports["default"] = $858b70b399909400$export$2e2bcd8739ae039;

});

parcelRegister("eIk5O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $jJP7n = parcelRequire("jJP7n");

var $80uua = parcelRequire("80uua");

const $548f8e726ba13f87$var$ReactCountElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $80uua.toBadgeProps)(context.reactCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $cozmU.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).React,
        ...data,
        ...restProps,
        name: (0, $4yYAm.ElementName).ReactCount
    }) : null;
};
var $548f8e726ba13f87$export$2e2bcd8739ae039 = $548f8e726ba13f87$var$ReactCountElement;
module.exports["default"] = $548f8e726ba13f87$export$2e2bcd8739ae039;

});

parcelRegister("7Q48s", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $kjaz0 = parcelRequire("kjaz0");


var $cZnAt = parcelRequire("cZnAt");

var $10jYv = parcelRequire("10jYv");

const $6b917c9ea0468b0a$var$ReadTimeElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $10jYv.toFormattedTextProps)((0, $dM7c5.messages).read_time, context.readTime) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).ReadTime
    }) : null;
};
var $6b917c9ea0468b0a$export$2e2bcd8739ae039 = $6b917c9ea0468b0a$var$ReadTimeElement;
module.exports["default"] = $6b917c9ea0468b0a$export$2e2bcd8739ae039;

});

parcelRegister("9vYj2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $9ox4X = parcelRequire("9ox4X");

var $8c7of = parcelRequire("8c7of");

const $2650347969d1867f$var$SentOnElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $8c7of.toDateTimeProps)('sent', context.sentOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ox4X.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).SentOn
    }) : null;
};
var $2650347969d1867f$export$2e2bcd8739ae039 = $2650347969d1867f$var$SentOnElement;
module.exports["default"] = $2650347969d1867f$export$2e2bcd8739ae039;

});

parcelRegister("s4fzU", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kjaz0 = parcelRequire("kjaz0");


var $cZnAt = parcelRequire("cZnAt");

const $3ace4e57de674240$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $3ace4e57de674240$var$snippetBaseStyle = null;
const $3ace4e57de674240$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $3ace4e57de674240$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $kjaz0.useFlexibleUiContext)();
    return /*#__PURE__*/ $cozmU.createElement((0, $cZnAt.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        className: (0, $hekY6.default)([
            "_1UtDYzy7kJ _4ouGXIdnbC _2UgkTUJxkL _4cb4toJxkL _1WgujfJxkL _20VacPJxkL",
            className
        ]),
        ...restOfProps
    });
};
var $3ace4e57de674240$export$2e2bcd8739ae039 = $3ace4e57de674240$var$SnippetElement;
module.exports["default"] = $3ace4e57de674240$export$2e2bcd8739ae039;

});

parcelRegister("alGk9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $cZnAt = parcelRequire("cZnAt");

var $f6O9b = parcelRequire("f6O9b");

const $fe80467b8157e565$var$SourceBranchElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $f6O9b.toTextProps)(context.sourceBranch) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).SourceBranch
    }) : null;
};
var $fe80467b8157e565$export$2e2bcd8739ae039 = $fe80467b8157e565$var$SourceBranchElement;
module.exports["default"] = $fe80467b8157e565$export$2e2bcd8739ae039;

});

parcelRegister("ixgii", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $bYlCi = parcelRequire("bYlCi");

const $626942334d6c6fee$var$STATE_METRIC_REGEX = /^(.+?)\s+-\s+(\d+(?:\.\d+)?)$/;
const $626942334d6c6fee$var$StateElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context?.state ?? null;
    const metricProps = (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $cozmU.useMemo)(()=>{
        if (data && typeof data.text === 'string') {
            const match = data.text.match($626942334d6c6fee$var$STATE_METRIC_REGEX);
            if (match) return {
                text: match[1],
                trailingMetric: match[2]
            };
        }
        return null;
    }, [
        data
    ]) : undefined;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bYlCi.default), {
        ...data,
        ...props,
        ...metricProps,
        name: (0, $4yYAm.ElementName).State
    });
};
var $626942334d6c6fee$export$2e2bcd8739ae039 = $626942334d6c6fee$var$StateElement;
module.exports["default"] = $626942334d6c6fee$export$2e2bcd8739ae039;

});

parcelRegister("8CvOu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");

/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $hekY6 = parcelRequire("hekY6");


var $jLnA6 = parcelRequire("jLnA6");

const $e04abc48d41c7945$var$badgeStyles = null; /**
                           * A base element that displays a visual indicator for a numeric value
                           * @internal
                           * @see StoryPoints
                           * */ 
const $e04abc48d41c7945$var$BaseAtlaskitElementBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_0hPCNLDIqT _3iDTPbccYA _4ouGXIE6Kk",
            className
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $jLnA6.default), null, value));
};
var $e04abc48d41c7945$export$2e2bcd8739ae039 = $e04abc48d41c7945$var$BaseAtlaskitElementBadge;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $970cceb2204f026d$export$731812b93bd90554 = (value)=>{
    return value ? {
        value: value
    } : undefined;
};


const $a9b6966b9f844797$var$StoryPointsElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $970cceb2204f026d$export$731812b93bd90554)(context.storyPoints) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e04abc48d41c7945$export$2e2bcd8739ae039), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).StoryPoints
    }) : null;
};
var $a9b6966b9f844797$export$2e2bcd8739ae039 = $a9b6966b9f844797$var$StoryPointsElement;
module.exports["default"] = $a9b6966b9f844797$export$2e2bcd8739ae039;

});

parcelRegister("hKI6m", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $jJP7n = parcelRequire("jJP7n");

var $80uua = parcelRequire("80uua");

const $75719457775595b4$var$SubTasksProgressElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $80uua.toBadgeProps)(context.subTasksProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).SubTasksProgress,
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).SubTasksProgress
    }) : null;
};
var $75719457775595b4$export$2e2bcd8739ae039 = $75719457775595b4$var$SubTasksProgressElement;
module.exports["default"] = $75719457775595b4$export$2e2bcd8739ae039;

});

parcelRegister("kfBIC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $jJP7n = parcelRequire("jJP7n");

var $80uua = parcelRequire("80uua");

const $0c8068f0605185a4$var$SubscriberCountElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $80uua.toBadgeProps)(context.subscriberCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).Subscriber,
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).SubscriberCount
    }) : null;
};
var $0c8068f0605185a4$export$2e2bcd8739ae039 = $0c8068f0605185a4$var$SubscriberCountElement;
module.exports["default"] = $0c8068f0605185a4$export$2e2bcd8739ae039;

});

parcelRegister("gDO6D", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $cZnAt = parcelRequire("cZnAt");

var $f6O9b = parcelRequire("f6O9b");

const $0255f346a9fc2010$var$TargetBranchElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $f6O9b.toTextProps)(context.targetBranch) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).TargetBranch
    }) : null;
};
var $0255f346a9fc2010$export$2e2bcd8739ae039 = $0255f346a9fc2010$var$TargetBranchElement;
module.exports["default"] = $0255f346a9fc2010$export$2e2bcd8739ae039;

});

parcelRegister("415JS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $jJP7n = parcelRequire("jJP7n");

var $80uua = parcelRequire("80uua");

const $78c49f266ba351d0$var$ViewCountElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $80uua.toBadgeProps)(context.viewCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).View,
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).ViewCount
    }) : null;
};
var $78c49f266ba351d0$export$2e2bcd8739ae039 = $78c49f266ba351d0$var$ViewCountElement;
module.exports["default"] = $78c49f266ba351d0$export$2e2bcd8739ae039;

});

parcelRegister("emHHi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $jJP7n = parcelRequire("jJP7n");

var $80uua = parcelRequire("80uua");

const $27011927457b62cf$var$VoteCountElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const data = context ? (0, $80uua.toBadgeProps)(context.voteCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).Vote,
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).VoteCount
    }) : null;
};
var $27011927457b62cf$export$2e2bcd8739ae039 = $27011927457b62cf$var$VoteCountElement;
module.exports["default"] = $27011927457b62cf$export$2e2bcd8739ae039;

});

parcelRegister("lkhb1", function(module, exports) {
parcelRequire("cozmU");

const $0f4fabaf914a2ee4$export$14ff825bfe645006 = (node)=>{
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && node.type?.name === 'CC' && node.props.children) return true;
    return false;
};
module.exports["isStyleCacheProvider"] = $0f4fabaf914a2ee4$export$14ff825bfe645006;

});

parcelRegister("knKT4", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4yYAm = parcelRequire("4yYAm");


var $ggIq5 = parcelRequire("ggIq5");

const $e3640315f11416b3$var$alignmentStyleMap = {
    right: "_3hRCZuF05b _1MK24JF05b _37wbyuz9WS _2fwxA50dzo",
    left: "_3hRCZu7p2s _1MK24J7p2s _37wbyuchRC _2fwxA5ecOK"
};
const $e3640315f11416b3$var$baseStyleBySize = {
    xlarge: "_2mHwu8kG2W _4bt5LAnQyn _2WAcuGnQyn _0hPCNLDIqT _3iDTPbQ4SZ _4ouGXIdnbC",
    large: "_2mHwu85zaO _4bt5LAnQyn _2WAcuGnQyn _0hPCNLDIqT _3iDTPbQ4SZ _4ouGXIdnbC",
    medium: "_2mHwu82ADO _4bt5LAnQyn _2WAcuGnQyn _0hPCNLDIqT _3iDTPbQ4SZ _4ouGXIdnbC",
    small: "_2mHwu81Y8M _4bt5LAnQyn _2WAcuGnQyn _0hPCNLDIqT _3iDTPbQ4SZ _4ouGXIdnbC"
};
const $e3640315f11416b3$var$baseStyleByDirection = {
    horizontal: "_0aFT5v1qpb _0hPCNLDIqT",
    vertical: "_0aFT5vbt8w _0hPCNLchRC"
};
const $e3640315f11416b3$var$baseStyles = null;
const $e3640315f11416b3$var$widthStyle = {
    flexible: "_2O5Vij7dHp _3YEZNO7LI7 _1bHrqEAEMG",
    'fit-to-content': ""
};
const $e3640315f11416b3$var$positionStyle = {
    top: "_4xdlr0chRC",
    center: ""
};
const $e3640315f11416b3$var$horizontalStyleBase = null;
const $e3640315f11416b3$var$horizontalStyleByHeight = {
    xlarge: "_3iDTPbgJ9S _2nBKY9b4nN",
    large: "_3iDTPbgJ9S _2nBKY9b4nN",
    medium: "_3iDTPbgJ9S _2nBKY9GuX1",
    small: "_3iDTPbgJ9S _2nBKY9GuX1"
};
const $e3640315f11416b3$var$gapStylesLeft = {
    xlarge: "_0wyYyZkG2W _1sNT2fdnbC",
    large: "_0wyYyZ5zaO _1sNT2fdnbC",
    medium: "_0wyYyZ2ADO _1sNT2fdnbC",
    small: "_0wyYyZ1Y8M _1sNT2fdnbC"
};
const $e3640315f11416b3$var$gapStylesRight = {
    xlarge: "_08IXD0kG2W _0dQTBbdnbC",
    large: "_08IXD05zaO _0dQTBbdnbC",
    medium: "_08IXD02ADO _0dQTBbdnbC",
    small: "_08IXD01Y8M _0dQTBbdnbC"
};
const $e3640315f11416b3$var$minWidthStyle = null; /**
                             * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
                             * preferences.
                             * @internal
                             * @param {ActionGroupProps} ActionGroupProps
                             * @see Action
                             */ 
const $e3640315f11416b3$var$ElementGroup = ({ align: align = (0, $4yYAm.SmartLinkAlignment).Left, children: children, direction: direction = (0, $4yYAm.SmartLinkDirection).Horizontal, size: size = (0, $4yYAm.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $4yYAm.SmartLinkWidth).FitToContent, position: position = (0, $4yYAm.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $4yYAm.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $e3640315f11416b3$var$baseStyleBySize[size],
            $e3640315f11416b3$var$baseStyleByDirection[direction],
            "_11sDorYbGa",
            $e3640315f11416b3$var$alignmentStyleMap[align],
            "_4ouGXIbzpP",
            $e3640315f11416b3$var$widthStyle[width],
            isHorizontal && "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _1RrJLit2nV _39HuIbz8Lp _3W2Oc8wPeg _4Gn54R7dHp _1U1ZhbbI28 _33tXaUt2nV _2LbcETt2nV _3Cp5TsS8kF _2MC3vES8kF _3gERZGS8kF _0LyQPfS8kF",
            isHorizontal && $e3640315f11416b3$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $4yYAm.SmartLinkAlignment).Left && $e3640315f11416b3$var$gapStylesLeft[size],
            isHorizontal && align === (0, $4yYAm.SmartLinkAlignment).Right && $e3640315f11416b3$var$gapStylesRight[size],
            $e3640315f11416b3$var$positionStyle[position],
            className
        ])
    }, (0, $ggIq5.renderChildren)(children, size));
};
var $e3640315f11416b3$export$2e2bcd8739ae039 = $e3640315f11416b3$var$ElementGroup;
module.exports["default"] = $e3640315f11416b3$export$2e2bcd8739ae039;

});

parcelRegister("1NMtH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fj0wU = parcelRequire("fj0wU");


var $4cPhH = parcelRequire("4cPhH");


var $ktdgI = parcelRequire("ktdgI");


var $cA0ah = parcelRequire("cA0ah");


var $jqres = parcelRequire("jqres");


var $a8wJH = parcelRequire("a8wJH");


var $56DiX = parcelRequire("56DiX");


var $LvVJP = parcelRequire("LvVJP");


var $gsQuB = parcelRequire("gsQuB");


var $ikX3P = parcelRequire("ikX3P");


var $jUXZW = parcelRequire("jUXZW");


var $leiiU = parcelRequire("leiiU");


var $2VRbJ = parcelRequire("2VRbJ");


var $hsIfr = parcelRequire("hsIfr");


var $8y6iW = parcelRequire("8y6iW");


var $72lc5 = parcelRequire("72lc5");


var $7sCIj = parcelRequire("7sCIj");


var $4GRqQ = parcelRequire("4GRqQ");


var $cl3v4 = parcelRequire("cl3v4");


var $khRQO = parcelRequire("khRQO");


var $i64z9 = parcelRequire("i64z9");


var $7bJZv = parcelRequire("7bJZv");


var $fCf6x = parcelRequire("fCf6x");


var $eIk5O = parcelRequire("eIk5O");


var $7Q48s = parcelRequire("7Q48s");


var $9vYj2 = parcelRequire("9vYj2");


var $s4fzU = parcelRequire("s4fzU");


var $alGk9 = parcelRequire("alGk9");


var $ixgii = parcelRequire("ixgii");


var $8CvOu = parcelRequire("8CvOu");


var $hKI6m = parcelRequire("hKI6m");


var $kfBIC = parcelRequire("kfBIC");


var $gDO6D = parcelRequire("gDO6D");


var $8xQB8 = parcelRequire("8xQB8");


var $fIakH = parcelRequire("fIakH");


var $fO7nk = parcelRequire("fO7nk");


var $415JS = parcelRequire("415JS");


var $emHHi = parcelRequire("emHHi");

const $7f73ed524db99241$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};



var $4yYAm = parcelRequire("4yYAm");

const $44bad6257c01e35a$export$f942619ce67b1a41 = {
    [(0, $4yYAm.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).AppliedToComponentsCount]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).Location]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).Preview]: [
        'block'
    ],
    [(0, $4yYAm.ElementName).Priority]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).Provider]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).Snippet]: [
        'block'
    ],
    [(0, $4yYAm.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).State]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).TeamMemberCount]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).Title]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).UserAttributes]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).VoteCount]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).HostName]: [
        'inline'
    ]
};


const $529408ec64bddd8a$var$Elements = {
    AppliedToComponentsCount: $fj0wU.default,
    AssignedTo: $4cPhH.default,
    AssignedToGroup: $ktdgI.default,
    AttachmentCount: $cA0ah.default,
    AuthorGroup: $jqres.default,
    ChecklistProgress: $a8wJH.default,
    CollaboratorGroup: $56DiX.default,
    CommentCount: $LvVJP.default,
    CreatedBy: $gsQuB.default,
    CreatedOn: $ikX3P.default,
    DueOn: $jUXZW.default,
    HostName: $leiiU.default,
    LatestCommit: $2VRbJ.default,
    LinkIcon: $hsIfr.default,
    Location: $8y6iW.default,
    ModifiedBy: $72lc5.default,
    ModifiedOn: $7sCIj.default,
    OwnedBy: $4GRqQ.default,
    OwnedByGroup: $cl3v4.default,
    Preview: $khRQO.default,
    Priority: $i64z9.default,
    ProgrammingLanguage: $7bJZv.default,
    Provider: $fCf6x.default,
    ReactCount: $eIk5O.default,
    ReadTime: $7Q48s.default,
    SentOn: $9vYj2.default,
    Snippet: $s4fzU.default,
    SourceBranch: $alGk9.default,
    State: $ixgii.default,
    StoryPoints: $8CvOu.default,
    SubTasksProgress: $hKI6m.default,
    SubscriberCount: $kfBIC.default,
    TargetBranch: $gDO6D.default,
    TeamMemberCount: $8xQB8.default,
    Title: $fIakH.default,
    UserAttributes: $fO7nk.default,
    ViewCount: $415JS.default,
    VoteCount: $emHHi.default
};
const $529408ec64bddd8a$var$isElementDisplayValid = (name, display)=>{
    return (0, $44bad6257c01e35a$export$f942619ce67b1a41)[name]?.includes(display) ?? false;
};
const $529408ec64bddd8a$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $529408ec64bddd8a$var$Elements[name];
        const typedProps = props;
        if (Element && $529408ec64bddd8a$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Element, {
                key: idx,
                ...typedProps
            });
            if (!(0, $7f73ed524db99241$export$f2c7ad0961800b16)(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};
module.exports["renderElementItems"] = $529408ec64bddd8a$export$9678d3ca18bd7526;

});

parcelRegister("1384B", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bDFeF = parcelRequire("bDFeF");


var $h1uyX = parcelRequire("h1uyX");

const $39b024679e6e9750$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h1uyX.CardLinkView), {
        key: 'lazy-render-key',
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bDFeF.loadingPlaceholderClassName),
        placeholder: placeholder
    });
};
module.exports["LoadingCardLink"] = $39b024679e6e9750$export$1ca0544321134ad6;

});

parcelRegister("bDFeF", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $fhtb6 = parcelRequire("fhtb6");

const $9f0273b80d56b60e$export$889f1c7c5c7ba2f = 'smart-link-content-footer';
const $9f0273b80d56b60e$export$9747a645aa1216c7 = 'smart-link-metadata-list';
const $9f0273b80d56b60e$export$d4b64e3ae38899a3 = 'block-card-resolving-view';
const $9f0273b80d56b60e$export$7b62853ead5e547c = 'block-card-resolved-view';
const $9f0273b80d56b60e$export$3f9f9653bc75f33d = 'block-card-resolved-view-by';
const $9f0273b80d56b60e$export$a21bb776ab2c28b5 = 'block-card-forbidden-view';
const $9f0273b80d56b60e$export$e9fa69ca91e22a09 = 'block-card-forbidden-view-link';
const $9f0273b80d56b60e$export$d17e5383afeb158c = 'block-card-content';
const $9f0273b80d56b60e$export$8c59795ed52e92b3 = 'block-card-content-header';
const $9f0273b80d56b60e$export$a76ed4d75b5db5f = 'block-card-content-header-name';
const $9f0273b80d56b60e$export$7fbeca230aee4e1a = 'block-card-not-found-view';
const $9f0273b80d56b60e$export$38dcd9bf8c681d21 = 'block-card-errored-view';
const $9f0273b80d56b60e$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';
module.exports["contentFooterClassName"] = $9f0273b80d56b60e$export$889f1c7c5c7ba2f;
module.exports["metadataListClassName"] = $9f0273b80d56b60e$export$9747a645aa1216c7;
module.exports["blockCardResolvingViewClassName"] = $9f0273b80d56b60e$export$d4b64e3ae38899a3;
module.exports["blockCardResolvedViewClassName"] = $9f0273b80d56b60e$export$7b62853ead5e547c;
module.exports["blockCardResolvedViewByClassName"] = $9f0273b80d56b60e$export$3f9f9653bc75f33d;
module.exports["blockCardForbiddenViewClassName"] = $9f0273b80d56b60e$export$a21bb776ab2c28b5;
module.exports["blockCardForbiddenViewLinkClassName"] = $9f0273b80d56b60e$export$e9fa69ca91e22a09;
module.exports["blockCardContentClassName"] = $9f0273b80d56b60e$export$d17e5383afeb158c;
module.exports["blockCardContentHeaderClassName"] = $9f0273b80d56b60e$export$8c59795ed52e92b3;
module.exports["blockCardContentHeaderNameClassName"] = $9f0273b80d56b60e$export$a76ed4d75b5db5f;
module.exports["blockCardNotFoundViewClassName"] = $9f0273b80d56b60e$export$7fbeca230aee4e1a;
module.exports["blockCardErroredViewClassName"] = $9f0273b80d56b60e$export$38dcd9bf8c681d21;
module.exports["loadingPlaceholderClassName"] = $9f0273b80d56b60e$export$4b2b7d155f69aed4;

});

parcelRegister("fhtb6", function(module, exports) {
/* Icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $6Eovk = parcelRequire("6Eovk");


var $kTb7m = parcelRequire("kTb7m");

const $0a0338fd192c5f97$export$f3ef6db93b5dfd7a = 'block-card-icon-image';
const $0a0338fd192c5f97$var$imageStyles = null;
const $0a0338fd192c5f97$var$spanStyles = null;
const $0a0338fd192c5f97$export$f04a61298a47a40f = ({ url: url, icon: icon, defaultIcon: defaultIcon, testId: testId = 'block-card-icon', isFlexibleUi: isFlexibleUi = false })=>{
    const placeholder = defaultIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
        label: "link",
        testId: `${testId}-default`,
        color: "currentColor"
    });
    const image = url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Eovk.default), {
        src: url,
        loaded: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: url,
            alt: "",
            "data-testid": `${testId}-image`,
            className: (0, $hekY6.default)([
                isFlexibleUi && "_0jFU0Vey7F _39xV02ey7F"
            ])
        }),
        errored: placeholder
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            isFlexibleUi && "_0jFU0VSPN1 _39xV02ey7F _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
            $0a0338fd192c5f97$export$f3ef6db93b5dfd7a
        ])
    }, icon || image || placeholder);
};
module.exports["blockCardIconImageClassName"] = $0a0338fd192c5f97$export$f3ef6db93b5dfd7a;
module.exports["Icon"] = $0a0338fd192c5f97$export$f04a61298a47a40f;

});

parcelRegister("h1uyX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5HpbM = parcelRequire("5HpbM");

class $96d7254cc2f1d9b2$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HpbM.Frame), {
            withoutBackground: true,
            ...this.props
        }, this.props.placeholder || this.props.link);
    }
}
module.exports["CardLinkView"] = $96d7254cc2f1d9b2$export$ce508304ed2dd145;

});

parcelRegister("5HpbM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $eTTRx = parcelRequire("eTTRx");

/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");




const $37e477ca9cc27a20$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: _isInteractive, isSelected: isSelected, viewType: viewType, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ref: ref,
        ...props,
        className: (0, $hekY6.default)([
            "_4FKVYEUjnH _0bjKvD8mU2 _23rrnHwQNr _3iDTPbS8kF _2NnhnEXpc7 _1UtDYzM7Tp _4cb4toYbGa _0hPERGQvmT",
            truncateInline && "_4bt5LAnQyn _2WAcuGnQyn _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _39HuIbz8Lp _3W2Oc84hR5 _3iDTPbANGY _4Gn54R7dHp _1U1ZhbbI28 _1zdmX7vbI6 _4t0o8UFQfX _0eEwLBdnbC _1iKST2FQfX _0sb65SdnbC",
            truncateInline && viewType === 'unauthorised' && "_1UtDYze5R3",
            withoutBackground ? "_2Zuz6QdnbC _2XsHFMLl21" : "_30huDKOeNX _0KLXruqi9L _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8",
            isHovered && "_3vBAKHQvmT",
            isHovered && !withoutBackground && "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8",
            isSelected ? "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _0wOv4Q7zJH _2OUyjtAaAW _20VacPYbGa _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0KOPe2OeNX _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8" : "_20VacPJxkL"
        ])
    }, props.children);
});
const $37e477ca9cc27a20$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, viewType: viewType, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $hekY6.default)([
            "_4FKVYEUjnH _0bjKvD8mU2 _23rrnHwQNr _3iDTPbS8kF _2NnhnEXpc7 _1UtDYzM7Tp _4cb4toYbGa _0hPERGQvmT",
            truncateInline && "_4bt5LAnQyn _2WAcuGnQyn _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _39HuIbz8Lp _3W2Oc84hR5 _3iDTPbANGY _4Gn54R7dHp _1U1ZhbbI28 _1zdmX7vbI6 _4t0o8UFQfX _0eEwLBdnbC _1iKST2FQfX _0sb65SdnbC",
            truncateInline && viewType === 'unauthorised' && "_1UtDYze5R3",
            withoutBackground ? "_2Zuz6QdnbC _2XsHFMLl21" : "_30huDKOeNX _0KLXruqi9L _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8",
            isHovered && "_3vBAKHQvmT",
            isHovered && !withoutBackground && "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8",
            isSelected ? "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _0wOv4Q7zJH _2OUyjtAaAW _20VacPYbGa _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0KOPe2OeNX _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8" : "_20VacPJxkL",
            isInteractive && "_1zr6Dc98eZ _0htemXYbGa _067LceT6kp _2AowT47zJH _0ui43CAaAW _3DIml2YbGa _3gzVzLY9q9",
            viewType === 'errored' && "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8"
        ])
    }, props.children);
});
const $37e477ca9cc27a20$var$baseWrapperStyles = null; // if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $37e477ca9cc27a20$var$interactiveStyles = null;
const $37e477ca9cc27a20$var$hoveredStyles = null;
const $37e477ca9cc27a20$var$hoveredWithBackgroundStyles = null;
const $37e477ca9cc27a20$var$errorViewTypeStyles = null;
const $37e477ca9cc27a20$var$withoutBackgroundStyles = null;
const $37e477ca9cc27a20$var$withBackgroundStyles = null;
const $37e477ca9cc27a20$var$truncateStyles = null;
const $37e477ca9cc27a20$var$unauthorisedTruncateStyles = null;
const $37e477ca9cc27a20$var$notSelectedStyle = null;
const $37e477ca9cc27a20$var$selectedStyles = null;


const $302c4a7232ea4e89$export$b89a827e9254211a = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, link: link, viewType: viewType, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $cozmU.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $cozmU.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $eTTRx.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $37e477ca9cc27a20$export$6e4bde711df5c2ab) : (0, $37e477ca9cc27a20$export$8b5c95e985c4ec9a);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive && !link ? 0 : undefined,
        role: isInteractive && !link ? 'button' : undefined,
        onClick: handleClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        viewType: viewType
    }, children);
});
module.exports["Frame"] = $302c4a7232ea4e89$export$b89a827e9254211a;

});

parcelRegister("dZcIT", function(module, exports) {

let $a2ead76bfe74b45c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a2ead76bfe74b45c$var$load("dhXIT"),
    $a2ead76bfe74b45c$var$load("5gsbh"),
    $a2ead76bfe74b45c$var$load("8lMr1"),
    $a2ead76bfe74b45c$var$load("1vUE6"),
    $a2ead76bfe74b45c$var$load("h0X0x"),
    $a2ead76bfe74b45c$var$load("7l4Nc"),
    $a2ead76bfe74b45c$var$load("fEvpQ"),
    $a2ead76bfe74b45c$var$load("7A87G"),
    $a2ead76bfe74b45c$var$load("aCJpU"),
    $a2ead76bfe74b45c$var$load("aLwQm"),
    $a2ead76bfe74b45c$var$load("Xi5vc"),
    $a2ead76bfe74b45c$var$load("ekdqM"),
    $a2ead76bfe74b45c$var$load("iqLRv"),
    $a2ead76bfe74b45c$var$load("6vufR"),
    $a2ead76bfe74b45c$var$load("6fJCf"),
    $a2ead76bfe74b45c$var$load("duEFL"),
    $a2ead76bfe74b45c$var$load("1pJPT"),
    $a2ead76bfe74b45c$var$load("cvcNg"),
    $a2ead76bfe74b45c$var$load("iZR3N"),
    $a2ead76bfe74b45c$var$load("4zz48"),
    $a2ead76bfe74b45c$var$load("jXM1T"),
    $a2ead76bfe74b45c$var$load("39XCn"),
    $a2ead76bfe74b45c$var$load("jw3lv"),
    $a2ead76bfe74b45c$var$load("7rqWx"),
    $a2ead76bfe74b45c$var$load("aIze1"),
    $a2ead76bfe74b45c$var$load("3Cky6"),
    $a2ead76bfe74b45c$var$load("kG5Ju"),
    $a2ead76bfe74b45c$var$load("il8bj"),
    $a2ead76bfe74b45c$var$load("4N1MY"),
    $a2ead76bfe74b45c$var$load("6wr18"),
    $a2ead76bfe74b45c$var$load("aFLSJ"),
    $a2ead76bfe74b45c$var$load("ffEVr"),
    $a2ead76bfe74b45c$var$load("6bjEk"),
    $a2ead76bfe74b45c$var$load("cbF85")
]).then(()=>parcelRequire('9gHOR'));

});

parcelRegister("i1503", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9bb71ed919d2ffd$export$2e2bcd8739ae039);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("44bfd")).MetadataBlock);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $44bfd = parcelRequire("44bfd");

var $a9bb71ed919d2ffd$export$2e2bcd8739ae039 = (0, $44bfd.MetadataBlock);

});

parcelRegister("1dSeV", function(module, exports) {
// src/rovo/agent/types.ts
var $d60690bf70aab450$export$474f4563a5282a33 = "rovo", $d60690bf70aab450$export$541c04ced4758f83 = "agent";



var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/rovo/agent/manifest.ts
var $0e41143f0a0ebdce$var$rovoAgentAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $d60690bf70aab450$export$474f4563a5282a33),
    resourceType: (0, $d60690bf70aab450$export$541c04ced4758f83),
    resourceIdSlug: "activation/{activationId}/{agentId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        agentId: /[a-zA-Z0-9\-]+/
    }
};
// src/rovo/agent/index.ts
var $0e41143f0a0ebdce$export$eaa394a67f27c50 = class _RovoAgentAri extends (0, $9j37t.RegisteredAri) {
    get activationId() {
        return this._activationId;
    }
    get agentId() {
        return this._agentId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $0e41143f0a0ebdce$var$rovoAgentAriStaticOpts.qualifier,
            platformQualifier: $0e41143f0a0ebdce$var$rovoAgentAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $0e41143f0a0ebdce$var$rovoAgentAriStaticOpts.resourceOwner,
            resourceType: $0e41143f0a0ebdce$var$rovoAgentAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.agentId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                agentId: opts.agentId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $0e41143f0a0ebdce$var$rovoAgentAriStaticOpts);
        return new _RovoAgentAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $0e41143f0a0ebdce$var$rovoAgentAriStaticOpts);
        return new _RovoAgentAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            agentId: this.agentId
        };
    }
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._agentId = opts.resourceIdSegmentValues.agentId;
    }
};
module.exports["RovoAgentAri"] = $0e41143f0a0ebdce$export$eaa394a67f27c50;

});

parcelRegister("1koI0", function(module, exports) {

var $7qZTr = parcelRequire("7qZTr");


var $ONTtp = parcelRequire("ONTtp");


var $i70Es = parcelRequire("i70Es");


var $454YE = parcelRequire("454YE");

const $0a94c1ac318e85a1$var$fetchPolicy = 'store-or-network';

const $0a94c1ac318e85a1$export$6333901e831d7af0 = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("7lnAX")), {
        moduleId: "0e8b22f8",
        moduleName: "UserProfileCardEntryPoint",
        priority: "interaction",
        moduleId: 'user-profile-card-entrypoint'
    }),
    getPreloadProps: ({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, isReduced: isReduced })=>{
        const variables = (0, $i70Es.buildQueryVariables)({
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId,
            isReduced: isReduced
        });
        return {
            queries: {
                queryRef: {
                    parameters: $454YE.default,
                    variables: variables,
                    options: {
                        fetchPolicy: $0a94c1ac318e85a1$var$fetchPolicy
                    }
                }
            }
        };
    }
});
module.exports["entryPoint"] = $0a94c1ac318e85a1$export$6333901e831d7af0;

});

parcelRegister("i70Es", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

/**
 * @generated SignedSource<<060af1f7b3576087015198e072d23cec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fc0ddde612e6bc48$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    }, v2 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v3 = {
        "kind": "ScalarField",
        "name": "email"
    }, v4 = {
        "kind": "ScalarField",
        "name": "jobTitle"
    }, v5 = {
        "kind": "ScalarField",
        "name": "product"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluencePageLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v6 /*: any*/ 
            }
        ],
        "type": "ConfluencePage"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceBlogPostLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v6 /*: any*/ 
            }
        ],
        "type": "ConfluenceBlogPost"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v6 /*: any*/ 
            }
        ],
        "type": "ConfluenceWhiteboard"
    }, v10 = [
        {
            "concreteType": "ConfluenceCommentLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ]
        }
    ], v11 = [
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v13 = [
        v12 /*: any*/ 
    ], v14 = [
        v12 /*: any*/ ,
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": v13 /*: any*/ 
        }
    ], v15 = [
        {
            "alias": "trelloUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v16 = [
        {
            "alias": "webUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v17 = [
        {
            "concreteType": "AssetsLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "web"
                }
            ]
        }
    ], v18 = {
        "kind": "Variable",
        "name": "orgId",
        "variableName": "orgId"
    }, v19 = [
        {
            "kind": "ScalarField",
            "name": "accountIdentifier"
        },
        {
            "kind": "ScalarField",
            "name": "numberOfDirectReports"
        },
        {
            "kind": "ScalarField",
            "name": "numberOfTotalReports"
        },
        {
            "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
            "kind": "LinkedField",
            "name": "pii",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
                    "kind": "LinkedField",
                    "name": "extendedProfile",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": 50,
                "kind": "LocalArgument",
                "name": "activityFirst"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "collabContextId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "orgId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "siteAri"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "skipActivity"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "skipKnowledgeDiscovery"
            },
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "skipReportingLines"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "userAri"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "userId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "userIdString"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "viewerId"
            }
        ],
        "kind": "Fragment",
        "name": "UserProfileCardRelay_query",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "accountId",
                        "variableName": "userId"
                    }
                ],
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "accountStatus"
                    },
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "concreteType": "AtlassianAccountUserExtendedProfile",
                                "kind": "LinkedField",
                                "name": "extendedProfile",
                                "plural": false,
                                "selections": [
                                    v4 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "department"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "location"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "organization"
                                    }
                                ]
                            }
                        ],
                        "type": "AtlassianAccountUser"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v3 /*: any*/ 
                        ],
                        "type": "CustomerUser"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "appType"
                            }
                        ],
                        "type": "AppUser"
                    }
                ]
            },
            {
                "condition": "skipActivity",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "Activity",
                        "kind": "LinkedField",
                        "name": "activity",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "fields": [
                                            {
                                                "items": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "actors.0",
                                                        "variableName": "userAri"
                                                    }
                                                ],
                                                "kind": "ListValue",
                                                "name": "actors"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "collabContextId",
                                                "variableName": "collabContextId"
                                            }
                                        ],
                                        "kind": "ObjectValue",
                                        "name": "filter"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "first",
                                        "variableName": "activityFirst"
                                    }
                                ],
                                "concreteType": "ActivityConnection",
                                "kind": "LinkedField",
                                "name": "workedOn",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "ActivityItemEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "ActivityNode",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "ActivityObject",
                                                        "kind": "LinkedField",
                                                        "name": "object",
                                                        "plural": false,
                                                        "selections": [
                                                            v5 /*: any*/ ,
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "data",
                                                                "plural": false,
                                                                "selections": [
                                                                    v0 /*: any*/ ,
                                                                    v7 /*: any*/ ,
                                                                    v8 /*: any*/ ,
                                                                    v9 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "ConfluenceDatabaseLinks",
                                                                                "kind": "LinkedField",
                                                                                "name": "links",
                                                                                "plural": false,
                                                                                "selections": v6 /*: any*/ 
                                                                            }
                                                                        ],
                                                                        "type": "ConfluenceDatabase"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "ConfluenceEmbedLinks",
                                                                                "kind": "LinkedField",
                                                                                "name": "links",
                                                                                "plural": false,
                                                                                "selections": v6 /*: any*/ 
                                                                            }
                                                                        ],
                                                                        "type": "ConfluenceEmbed"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v10 /*: any*/ ,
                                                                        "type": "ConfluenceFooterComment"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v10 /*: any*/ ,
                                                                        "type": "ConfluenceInlineComment"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "TownsquareGoal"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "TownsquareProject"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "TownsquareComment"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v13 /*: any*/ ,
                                                                        "type": "JiraIssue"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v14 /*: any*/ ,
                                                                        "type": "JiraPlatformComment"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v14 /*: any*/ ,
                                                                        "type": "JiraServiceManagementComment"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v15 /*: any*/ ,
                                                                        "type": "TrelloBoard"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v15 /*: any*/ ,
                                                                        "type": "TrelloCard"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v16 /*: any*/ ,
                                                                        "type": "DevOpsDocument"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "ExternalDocument"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "DevOpsPullRequestDetails"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "ExternalPullRequest"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v16 /*: any*/ ,
                                                                        "type": "DevOpsDesign"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "ExternalRemoteLink"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "MercuryFocusArea"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "MercuryPortfolio"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "RadarPosition"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "RadarView"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "CompassComponent"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "href"
                                                                            }
                                                                        ],
                                                                        "type": "BitbucketPullRequest"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "alias": "loomUrl",
                                                                                "kind": "ScalarField",
                                                                                "name": "url"
                                                                            }
                                                                        ],
                                                                        "type": "LoomVideo"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v17 /*: any*/ ,
                                                                        "type": "AssetsObject"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v17 /*: any*/ ,
                                                                        "type": "AssetsObjectType"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v17 /*: any*/ ,
                                                                        "type": "AssetsSchema"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "skipKnowledgeDiscovery",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "KnowledgeDiscoveryQueryApi",
                        "kind": "LinkedField",
                        "name": "knowledgeDiscovery",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "accountId",
                                        "variableName": "userIdString"
                                    },
                                    v18 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "requestingUserId",
                                        "variableName": "viewerId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "tenantId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "singleUser",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "KnowledgeDiscoveryUserProfile",
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "KnowledgeDiscoveryUserManager",
                                                        "kind": "LinkedField",
                                                        "name": "manager",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "id"
                                                            },
                                                            v4 /*: any*/ ,
                                                            v2 /*: any*/ ,
                                                            v1 /*: any*/ 
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                                                        "kind": "LinkedField",
                                                        "name": "thirdPartyIntegrations",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "externalId"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "integrationId"
                                                            },
                                                            v5 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "KnowledgeDiscoverySingleUser"
                                    }
                                ]
                            },
                            {
                                "condition": "skipReportingLines",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "aaid",
                                                "variableName": "userIdString"
                                            },
                                            v18 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "siteId",
                                                "variableName": "siteAri"
                                            }
                                        ],
                                        "kind": "LinkedField",
                                        "name": "reportingLines",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                                        "kind": "LinkedField",
                                                        "name": "user",
                                                        "plural": false,
                                                        "selections": v19 /*: any*/ 
                                                    },
                                                    {
                                                        "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                                        "kind": "LinkedField",
                                                        "name": "managers",
                                                        "plural": true,
                                                        "selections": v19 /*: any*/ 
                                                    },
                                                    {
                                                        "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                                        "kind": "LinkedField",
                                                        "name": "reports",
                                                        "plural": true,
                                                        "selections": v19 /*: any*/ 
                                                    }
                                                ],
                                                "type": "KnowledgeDiscoveryReportingLines"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$fc0ddde612e6bc48$var$node.hash = "7629f0a0c1ec8ee2a6e8f6fe3702fc42";
var $fc0ddde612e6bc48$export$2e2bcd8739ae039 = $fc0ddde612e6bc48$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $dt88A = parcelRequire("dt88A");


var $2khPJ = parcelRequire("2khPJ");

var $5PJPG = parcelRequire("5PJPG");


var $3Z1Pc = parcelRequire("3Z1Pc");


var $d35qR = parcelRequire("d35qR");

/* UserProfileCard.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $9EOlJ = parcelRequire("9EOlJ");


var $arQY7 = parcelRequire("arQY7");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $2tuSz = parcelRequire("2tuSz");


var $lUcpS = parcelRequire("lUcpS");


var $eRfpr = parcelRequire("eRfpr");


var $kKnPE = parcelRequire("kKnPE");


var $hMCZS = parcelRequire("hMCZS");


var $aIlZA = parcelRequire("aIlZA");

const $95df3807650703a0$export$2b163c291f77b3f9 = (bridge, url, app)=>{
    const sourceApp = app ?? 'teams';
    const buildUrlWithAnalyticsParams = (0, $aIlZA.default)({
        bridge: bridge,
        product: 'townsquare',
        subProduct: sourceApp
    });
    return app !== undefined && app !== 'teams' ? buildUrlWithAnalyticsParams(url) : url;
};


const $583e2a6550f59f49$var$shouldOpenInSameTab = (townsquareApp)=>townsquareApp === 'teams' || townsquareApp === 'teams-isolated';
const $583e2a6550f59f49$export$a3989301a7f69ed7 = (userId, cloudId, townsquareApp)=>{
    const { href: rawHref, target: target, onNavigate: onNavigate } = (0, $hMCZS.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId
        },
        cloudId: cloudId,
        shouldOpenInSameTab: $583e2a6550f59f49$var$shouldOpenInSameTab(townsquareApp)
    });
    // When no townsquareApp is provided, fall back to `'teams'` for the bridge string so
    // the analytics tag is always a real app name, never the literal `"undefined-customLink"`.
    const bridgeApp = townsquareApp ?? 'teams';
    const wrappedHref = (0, $95df3807650703a0$export$2b163c291f77b3f9)(`${bridgeApp}-customLink`, rawHref, townsquareApp);
    const href = townsquareApp ? wrappedHref : rawHref;
    const isCrossAppMauEnabled = Boolean(townsquareApp) && href !== rawHref;
    return {
        href: href,
        target: target,
        onNavigate: onNavigate,
        isCrossAppMauEnabled: isCrossAppMauEnabled
    };
};



var $bIiaK = parcelRequire("bIiaK");


var $9gll8 = parcelRequire("9gll8");

/** Appends `/work` to a profile URL, preserving any querystring. */ function $45508ebbf47750c1$export$f339ec3b489d28e5(href) {
    if (!href) return href;
    const [pathPart, queryPart] = href.split('?');
    const normalisedPath = pathPart.endsWith('/') ? `${pathPart}work` : `${pathPart}/work`;
    return queryPart === undefined ? normalisedPath : `${normalisedPath}?${queryPart}`;
}



var $bXEsj = parcelRequire("bXEsj");



















function $f6a1f04ce64d6d23$export$2ebec9f03312245c({ testId: testId, errorType: errorType }) {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        fireEvent('ui.profilecard.rendered.error', {
            firedAt: (0, $eRfpr.firedAt)(),
            errorType: errorType,
            hasRetry: false
        });
    }, [
        fireEvent,
        errorType
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3Z1Pc.CardError), {
        testId: testId
    });
}



var $fxdou = parcelRequire("fxdou");








var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");




const $dc4ce11f77a04115$var$messages = (0, $kSwu1.defineMessages)({
    accountDeactivated: {
        id: "user-profile-card.DeactivatedStatus.accountDeactivated",
        defaultMessage: "Account deactivated"
    }
});
function $dc4ce11f77a04115$export$3b55902e173dd56e() {
    const intl = (0, $kSwu1.useIntl)();
    const { getTestId: getTestId } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
        appearance: "neutral",
        testId: getTestId('account-status'),
        children: intl.formatMessage($dc4ce11f77a04115$var$messages.accountDeactivated)
    });
}


/* EmailSection.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $w6R6I = parcelRequire("w6R6I");


var $fHs3z = parcelRequire("fHs3z");


var $chu6R = parcelRequire("chu6R");




var $hBYtq = parcelRequire("hBYtq");




var $lpNn5 = parcelRequire("lpNn5");




const $ee59531fc0307eed$var$TIMEOUT_DELAY = 2500;
const $ee59531fc0307eed$var$messages = (0, $kSwu1.defineMessages)({
    copyEmailTooltip: {
        id: "user-profile-card.EmailSection.copyEmailTooltip",
        defaultMessage: "Copy email"
    },
    copiedTooltip: {
        id: "user-profile-card.EmailSection.copiedTooltip",
        defaultMessage: "Copied"
    },
    copyEmailButtonLabel: {
        id: "user-profile-card.EmailSection.copyEmailButtonLabel",
        defaultMessage: "Copy email address"
    },
    successIconLabel: {
        id: "user-profile-card.EmailSection.successIconLabel",
        defaultMessage: "Email copied"
    }
});
const $ee59531fc0307eed$var$styles = {
    row: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    copyButton: "_0bjKvDKxmn _2V7sgOdnbC _3hxITiYbGa _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VSPN1 _39xV02SPN1 _1YKVNsdnbC _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0KLXru66of _0wOv4Q7zJH _3Tg68S7dHp _1eOmH6o126 _3gzVzLN4oS",
    copyButtonVisible: "_1YKVNs7dHp",
    copyButtonCopied: "_0wOv4Q18ZR"
};
function $ee59531fc0307eed$export$a46750d033a321b6({ email: email, hideCopyButton: hideCopyButton = false }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { getTestId: getTestId } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    const [isCopied, setIsCopied] = (0, $cozmU.useState)(false);
    const [isRowHovered, setIsRowHovered] = (0, $cozmU.useState)(false);
    const updateTooltip = (0, $cozmU.useRef)();
    const resetTimeout = (0, $cozmU.useRef)();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useLayoutEffect(()=>{
        updateTooltip.current?.();
    }, [
        isCopied
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>()=>{
            if (resetTimeout.current) clearTimeout(resetTimeout.current);
        }, []);
    const copyToClipboard = async ()=>{
        try {
            await navigator.clipboard.writeText(email);
        } catch  {
            return;
        }
        setIsCopied(true);
        resetTimeout.current = setTimeout(()=>{
            setIsCopied(false);
        }, $ee59531fc0307eed$var$TIMEOUT_DELAY);
    };
    const tooltipLabel = isCopied ? formatMessage($ee59531fc0307eed$var$messages.copiedTooltip) : formatMessage($ee59531fc0307eed$var$messages.copyEmailTooltip);
    const isButtonRevealed = isRowHovered || isCopied;
    if (hideCopyButton) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $ee59531fc0307eed$var$styles.row,
        testId: getTestId('email'),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            maxLines: 1,
            color: "color.text.subtlest",
            testId: getTestId('email-text'),
            children: email
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: $ee59531fc0307eed$var$styles.row,
        testId: getTestId('email'),
        onMouseEnter: ()=>setIsRowHovered(true),
        onMouseLeave: ()=>setIsRowHovered(false),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                maxLines: 1,
                color: "color.text.subtlest",
                testId: getTestId('email-text'),
                children: email
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                content: ({ update: update })=>{
                    updateTooltip.current = update;
                    return tooltipLabel;
                },
                position: "top",
                hasNewContentOnTriggerClick: true,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                    isDisabled: isCopied,
                    onClick: copyToClipboard,
                    testId: getTestId('email-copy-button'),
                    "aria-label": formatMessage($ee59531fc0307eed$var$messages.copyEmailButtonLabel),
                    xcss: (0, $w6R6I.cx)($ee59531fc0307eed$var$styles.copyButton, isButtonRevealed && $ee59531fc0307eed$var$styles.copyButtonVisible, isCopied && $ee59531fc0307eed$var$styles.copyButtonCopied),
                    children: isCopied ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                        label: formatMessage($ee59531fc0307eed$var$messages.successIconLabel),
                        color: "var(--ds-icon-success, #6A9A23)"
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)"
                    })
                })
            })
        ]
    });
}












var $7WEaj = parcelRequire("7WEaj");


var $eKMV3 = parcelRequire("eKMV3");











var $cP7Ln = parcelRequire("cP7Ln");








var $buHp0 = parcelRequire("buHp0");


var $9DHhW = parcelRequire("9DHhW");

const $2066a53fd7da0b8e$export$c7eac394c4a88aeb = (townsquareApp)=>{
    // `fireCustomCrossAppAnalytic` needs raw `createAnalyticsEvent`, so this hook
    // intentionally owns the `@atlaskit/analytics-next` dependency.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    return (0, $cozmU.useCallback)(()=>{
        if (!townsquareApp) return;
        (0, $buHp0.fireCustomCrossAppAnalytic)({
            tags: [
                'townsquare',
                'navigationExperiences'
            ],
            analyticsEventFireName: 'atlas',
            destinationApp: 'teams',
            bridge: `${townsquareApp}-customLink`,
            source: `townsquare-${townsquareApp}`,
            actionSubjectId: 'viewProfileLink',
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        townsquareApp,
        createAnalyticsEvent
    ]);
};












parcelRequire("cozmU");

function $5ed6cd0d2efefbfe$export$b33fb54b08bb6422() {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M7.71235 13.9487C7.71235 14.8109 7.0155 15.5078 6.15329 15.5078C5.29109 15.5078 4.59424 14.8109 4.59424 13.9487C4.59424 13.0865 5.29109 12.3896 6.15329 12.3896H7.71235V13.9487ZM8.49188 13.9487C8.49188 13.0865 9.18873 12.3896 10.0509 12.3896C10.9131 12.3896 11.61 13.0865 11.61 13.9487V17.8463C11.61 18.7085 10.9131 19.4054 10.0509 19.4054C9.18873 19.4054 8.49188 18.7085 8.49188 17.8463V13.9487Z",
                    fill: "#E01E5A"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M10.051 7.68879C9.18882 7.68879 8.49197 6.99194 8.49197 6.12973C8.49197 5.26753 9.18882 4.57068 10.051 4.57068C10.9132 4.57068 11.6101 5.26753 11.6101 6.12973V7.68879H10.051ZM10.051 8.48013C10.9132 8.48013 11.6101 9.17698 11.6101 10.0392C11.6101 10.9014 10.9132 11.5982 10.051 11.5982H6.14157C5.27937 11.5982 4.58252 10.9014 4.58252 10.0392C4.58252 9.17698 5.27937 8.48013 6.14157 8.48013H10.051Z",
                    fill: "#36C5F0"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M16.299 10.0392C16.299 9.17698 16.9959 8.48013 17.8581 8.48013C18.7203 8.48013 19.4171 9.17698 19.4171 10.0392C19.4171 10.9014 18.7203 11.5982 17.8581 11.5982H16.299V10.0392ZM15.5195 10.0392C15.5195 10.9014 14.8226 11.5982 13.9604 11.5982C13.0982 11.5982 12.4014 10.9014 12.4014 10.0392V6.12973C12.4014 5.26753 13.0982 4.57068 13.9604 4.57068C14.8226 4.57068 15.5195 5.26753 15.5195 6.12973V10.0392Z",
                    fill: "#2EB67D"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M13.9604 16.2873C14.8226 16.2873 15.5195 16.9841 15.5195 17.8463C15.5195 18.7085 14.8226 19.4054 13.9604 19.4054C13.0982 19.4054 12.4014 18.7085 12.4014 17.8463V16.2873H13.9604ZM13.9604 15.5078C13.0982 15.5078 12.4014 14.8109 12.4014 13.9487C12.4014 13.0865 13.0982 12.3896 13.9604 12.3896H17.8699C18.7321 12.3896 19.4289 13.0865 19.4289 13.9487C19.4289 14.8109 18.7321 15.5078 17.8699 15.5078H13.9604Z",
                    fill: "#ECB22E"
                })
            ]
        })
    });
}
function $5ed6cd0d2efefbfe$export$1bcbc9c337da86da() {
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M14.4626 10.3286H18.3371C18.7032 10.3286 18.9999 10.6308 18.9999 11.0036V14.5978C18.9999 15.9679 17.9093 17.0786 16.564 17.0786H16.5525C15.2072 17.0788 14.1164 15.9682 14.1162 14.5981C14.1162 14.598 14.1162 14.5979 14.1162 14.5978V10.6814C14.1162 10.4866 14.2713 10.3286 14.4626 10.3286Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M17.0815 9.61849C17.9484 9.61849 18.6512 8.90274 18.6512 8.01982C18.6512 7.13689 17.9484 6.42114 17.0815 6.42114C16.2145 6.42114 15.5117 7.13689 15.5117 8.01982C15.5117 8.90274 16.2145 9.61849 17.0815 9.61849Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M12.1976 9.61839C13.4499 9.61839 14.465 8.58453 14.465 7.3092C14.465 6.03386 13.4499 5 12.1976 5C10.9453 5 9.93018 6.03386 9.93018 7.3092C9.93018 8.58453 10.9453 9.61839 12.1976 9.61839Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M15.2211 10.3286H8.82556C8.46387 10.3377 8.17775 10.6434 8.18614 11.0118V15.1111C8.13564 17.3217 9.85286 19.156 12.0233 19.2101C14.1938 19.156 15.911 17.3217 15.8605 15.1111V11.0118C15.8689 10.6434 15.5828 10.3377 15.2211 10.3286Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                opacity: "0.1",
                d: "M12.3718 10.3286V16.0732C12.37 16.3366 12.2133 16.5733 11.9741 16.6736C11.8979 16.7064 11.8161 16.7233 11.7334 16.7233H8.49271C8.44736 16.6061 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.3718Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                opacity: "0.2",
                d: "M12.0229 10.3286V16.4284C12.0229 16.5127 12.0063 16.596 11.9741 16.6736C11.8756 16.9172 11.6432 17.0768 11.3846 17.0786H8.65666C8.59736 16.9613 8.54154 16.8441 8.49271 16.7233C8.44387 16.6025 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                opacity: "0.2",
                d: "M12.0229 10.3286V15.7179C12.0203 16.0759 11.736 16.3653 11.3845 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                opacity: "0.2",
                d: "M11.6741 10.3286V15.7179C11.6714 16.0759 11.3872 16.3653 11.0357 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H11.6741Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                opacity: "0.1",
                d: "M12.3722 8.49216V9.61123C12.3129 9.61478 12.2571 9.61834 12.1978 9.61834C12.1385 9.61834 12.0827 9.61479 12.0234 9.61123C11.9056 9.60328 11.7889 9.58425 11.6746 9.55439C10.9682 9.38403 10.3846 8.8795 10.1048 8.1973C10.0567 8.08274 10.0193 7.96378 9.99316 7.84204H11.7338C12.0859 7.8434 12.3709 8.13367 12.3722 8.49216Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                opacity: "0.2",
                d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                opacity: "0.2",
                d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                opacity: "0.2",
                d: "M11.6742 8.84739V9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.0359C11.3879 8.19863 11.6729 8.48891 11.6742 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M4.63941 8.19727H11.0349C11.3881 8.19727 11.6744 8.48882 11.6744 8.84846V15.3618C11.6744 15.7214 11.3881 16.013 11.0349 16.013H4.63941C4.28627 16.013 4 15.7214 4 15.3618V8.84846C4 8.48882 4.28628 8.19727 4.63941 8.19727Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M9.51986 10.6761H8.24137V14.2216H7.42685V10.6761H6.1543V9.98828H9.51986V10.6761Z",
                fill: "white"
            })
        ]
    });
}


const $aa9a50e7a58f2aaa$export$ebea5317ff1808bf = {
    slack: (0, $5ed6cd0d2efefbfe$export$b33fb54b08bb6422),
    teams: (0, $5ed6cd0d2efefbfe$export$1bcbc9c337da86da)
};
function $aa9a50e7a58f2aaa$export$5a867b7c6687d757(integration) {
    return $aa9a50e7a58f2aaa$export$ebea5317ff1808bf[integration];
}


const $9fb9b153af9bf64e$export$596e547f4ce626bc = (integrationId, user)=>{
    if (!integrationId || !user) return;
    const isSlack = integrationId === 'slack';
    const isMsTeams = integrationId === 'teams';
    if (isSlack) {
        const openDmUrl = $9fb9b153af9bf64e$export$9eb522d6e073fba0(user);
        if (openDmUrl) return {
            integration: 'slack',
            openDmUrl: openDmUrl
        };
    } else if (isMsTeams) {
        const openDmUrl = $9fb9b153af9bf64e$export$198aa8f5b10ebb27(user);
        if (openDmUrl) return {
            integration: 'teams',
            openDmUrl: openDmUrl
        };
    }
};
const $9fb9b153af9bf64e$export$9eb522d6e073fba0 = (user)=>{
    const externalId = user?.externalId;
    if (!externalId) return;
    return `https://slack.com/app_redirect?channel=${externalId}`;
};
const $9fb9b153af9bf64e$export$198aa8f5b10ebb27 = (user)=>{
    const email = user?.email;
    if (!email) return;
    return `https://teams.microsoft.com/l/chat/0/0?users=${email}`;
};


const $8b78f8e317e74b4e$var$normalizeProductKey = (product)=>product.trim().toLowerCase();
/**
 * Keeps the first row for each `product` (case-insensitive). Order matches the input array.
 */ function $8b78f8e317e74b4e$var$uniqueRowsByFirstOccurrence(integrations = []) {
    const seen = new Set();
    const out = [];
    for (const row of integrations){
        const key = $8b78f8e317e74b4e$var$normalizeProductKey(row.product);
        if (seen.has(key)) continue;
        seen.add(key);
        out.push(row);
    }
    return out;
}
const $8b78f8e317e74b4e$export$cf50127c50537c52 = [
    'slack',
    'teams'
];
function $8b78f8e317e74b4e$export$523ecfa1815bea06(integrations, email, integrationIdOrder = $8b78f8e317e74b4e$export$cf50127c50537c52) {
    const rows = $8b78f8e317e74b4e$var$uniqueRowsByFirstOccurrence(integrations ? [
        ...integrations
    ] : []);
    for (const id of integrationIdOrder){
        const row = rows.find((r)=>r.integrationId === id);
        if (!row) continue;
        const entry = {
            email: email,
            externalId: row.externalId,
            integrationId: row.integrationId,
            product: row.product
        };
        const dm = (0, $9fb9b153af9bf64e$export$596e547f4ce626bc)(row.integrationId, {
            email: entry.email,
            externalId: entry.externalId
        });
        if (dm) return {
            entry: entry,
            dm: dm
        };
    }
    return undefined;
}












var $1sCHt = parcelRequire("1sCHt");


var $6TaGl = parcelRequire("6TaGl");


var $9d7Pd = parcelRequire("9d7Pd");


var $8oBbn = parcelRequire("8oBbn");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");


var $4n1IT = parcelRequire("4n1IT");





var $jp2Q3 = parcelRequire("jp2Q3");










const $e73bf856672907cd$var$messages = (0, $kSwu1.defineMessages)({
    actionMenuLabel: {
        id: "user-profile-card.ActionMenu.actionMenuLabel",
        defaultMessage: "More actions for {name}"
    }
});
/** Assigns a node to either a callback ref or an object ref. */ function $e73bf856672907cd$var$assignRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if (ref && typeof ref === 'object') ref.current = node;
}
function $e73bf856672907cd$export$ed57a210b9d13bb6({ items: items, name: name, triggerRef: triggerRef }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setOpen] = (0, $cozmU.useState)(false);
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $bIiaK.useCardOpenTimer)();
    const { getTestId: getTestId } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    // Stable callbacks so the inner `Popup` and `IconButton` don't see prop churn each render.
    const handleClose = (0, $cozmU.useCallback)(()=>setOpen(false), []);
    const handleTriggerClick = (0, $cozmU.useCallback)(()=>setOpen((open)=>!open), []);
    const fireActionClick = (0, $cozmU.useCallback)((itemId, hasHref, hasOnClick, index)=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: hasHref,
            hasOnClick: hasOnClick,
            index: index,
            actionId: itemId
        });
    }, [
        fireEvent,
        getDurationSinceInteraction
    ]);
    if (items.length === 0) return null;
    const renderItem = (item, index)=>{
        if (item.kind === 'link') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8oBbn.default), {
            href: item.href,
            target: item.target,
            rel: item.target === '_blank' ? 'noopener noreferrer' : undefined,
            testId: getTestId(`menu-item-${item.id}`),
            onClick: (event)=>{
                fireActionClick(item.id, true, Boolean(item.onClick), index);
                item.onClick?.(event);
                setOpen(false);
            },
            children: item.label
        }, item.id);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9d7Pd.default), {
            testId: getTestId(`menu-item-${item.id}`),
            onClick: (event)=>{
                fireActionClick(item.id, false, true, index);
                item.onClick(event);
                setOpen(false);
            },
            children: item.label
        }, item.id);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
        isOpen: isOpen,
        onClose: handleClose,
        placement: "right-start",
        // The host card sits at `layers.modal()` (510) — use `layers.tooltip()` (700) so the
        // action-menu popup stacks above it. `tooltip()` is the conventional next-layer-up in
        // ADS and is forward-compatible with the upcoming top-layer popup mode.
        zIndex: (0, $jp2Q3.layers).tooltip(),
        testId: getTestId('action-menu'),
        content: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $6IL1T.default), {
                spacing: "cozy",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8FgJC.default), {
                    children: items.map(renderItem)
                })
            }),
        trigger: ({ ref: popupTriggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                ...triggerProps,
                ref: (node)=>{
                    $e73bf856672907cd$var$assignRef(popupTriggerRef, node);
                    // Skip `null`: Popup re-creates its ref on some renders, briefly passing null.
                    // Stale nodes are filtered by the consumer's `isConnected` check.
                    if (node && triggerRef) triggerRef.current = node;
                },
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                label: formatMessage($e73bf856672907cd$var$messages.actionMenuLabel, {
                    name: name
                }),
                onClick: handleTriggerClick,
                isSelected: isOpen,
                testId: getTestId('action-menu-trigger')
            })
    });
}












var $c4iAx = parcelRequire("c4iAx");


var $6nl31 = parcelRequire("6nl31");

var $as0eE = parcelRequire("as0eE");





var $2atIz = parcelRequire("2atIz");

const $4f68084afcb13ad1$var$messages = (0, $kSwu1.defineMessages)({
    giveKudosLabel: {
        id: "user-profile-card.useKudosMenuItem.giveKudosLabel",
        defaultMessage: "Give kudos"
    }
});
/**
 * Stable analytics source attributed to kudos drawer events fired from this card.
 */ const $4f68084afcb13ad1$var$ANALYTICS_SOURCE = 'user-profile-card';
function $4f68084afcb13ad1$export$e739febab83b2399({ accountId: accountId, cloudId: cloudId, viewerId: viewerId, actionMenuTriggerRef: actionMenuTriggerRef }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    // Getter so an unmounted trigger resolves to `null`; focusing a detached node drops focus
    // to `<body>`.
    const focusReturnRef = (0, $cozmU.useMemo)(()=>({
            get current () {
                const element = actionMenuTriggerRef?.current ?? null;
                return element && element.isConnected ? element : null;
            }
        }), [
        actionMenuTriggerRef
    ]);
    // Keep the card open while the drawer is up: clicks on the portalled drawer count as outside
    // clicks. Released on `onCloseComplete`, since trailing events can follow `onClose`.
    const cardCloseGuardRef = (0, $cozmU.useContext)((0, $2atIz.CardCloseGuardContext));
    const holdCardOpen = (0, $cozmU.useCallback)((held)=>{
        if (cardCloseGuardRef) cardCloseGuardRef.current = held;
    }, [
        cardCloseGuardRef
    ]);
    // Never leave the card stuck open if this unmounts mid-drawer.
    (0, $cozmU.useEffect)(()=>()=>holdCardOpen(false), [
        holdCardOpen
    ]);
    const onClose = (0, $cozmU.useCallback)(()=>setIsOpen(false), []);
    const onCloseComplete = (0, $cozmU.useCallback)(()=>holdCardOpen(false), [
        holdCardOpen
    ]);
    const onOpen = (0, $cozmU.useCallback)(()=>{
        if ((0, $iDrrr.fg)('teams_a11y_focus_high_priority')) holdCardOpen(true);
        setIsOpen(true);
    }, [
        holdCardOpen
    ]);
    const recipient = (0, $cozmU.useMemo)(()=>({
            type: (0, $as0eE.KudosType).INDIVIDUAL,
            recipientId: accountId
        }), [
        accountId
    ]);
    const label = formatMessage($4f68084afcb13ad1$var$messages.giveKudosLabel);
    const menuItem = (0, $cozmU.useMemo)(()=>({
            kind: 'button',
            id: 'give-kudos',
            label: label,
            onClick: onOpen
        }), [
        label,
        onOpen
    ]);
    const teamCentralBaseUrl = (0, $c4iAx.getATLContextUrl)('home');
    const suppressed = !teamCentralBaseUrl || !!viewerId && viewerId === accountId;
    if (suppressed) return {
        menuItem: null,
        launcher: null
    };
    const isFocusA11yEnabled = (0, $iDrrr.fg)('teams_a11y_focus_high_priority');
    const launcher = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6nl31.GiveKudosLauncherLazy), {
            isOpen: isOpen,
            onClose: onClose,
            recipient: recipient,
            analyticsSource: $4f68084afcb13ad1$var$ANALYTICS_SOURCE,
            teamCentralBaseUrl: teamCentralBaseUrl,
            cloudId: cloudId,
            triggerRef: isFocusA11yEnabled ? focusReturnRef : undefined,
            onCloseComplete: isFocusA11yEnabled ? onCloseComplete : undefined
        })
    });
    return {
        menuItem: menuItem,
        launcher: launcher
    };
}


const $d60be53616d0626a$var$messages = (0, $kSwu1.defineMessages)({
    viewProfile: {
        id: "user-profile-card.action-bar.view-profile",
        defaultMessage: "View profile"
    },
    sendMessageLabel: {
        id: "user-profile-card.action-bar.send-message-label",
        defaultMessage: "Message"
    }
});
function $d60be53616d0626a$export$223875819fd7cf93({ profileData: profileData, cloudId: cloudId, canViewProfile: canViewProfile = true, actions: actions, viewerId: viewerId, isDeactivated: isDeactivated = false }) {
    const intl = (0, $kSwu1.useIntl)();
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $bIiaK.useCardOpenTimer)();
    const { townsquareApp: townsquareApp, onProfileClick: onProfileClick, getTestId: getTestId, triggerMethod: triggerMethod } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    const setPopupInitialFocusRef = (0, $cP7Ln.usePopupInitialFocusRef)();
    const viewProfileInitialFocusRef = triggerMethod === 'click' && (0, $iDrrr.fg)('teams_a11y_focus_high_priority') ? setPopupInitialFocusRef : undefined;
    const { accountId: accountId, thirdPartyIntegrations: thirdPartyIntegrations, email: email } = profileData;
    const { href: href, target: target, onNavigate: onNavigate, isCrossAppMauEnabled: isCrossAppMauEnabled } = (0, $583e2a6550f59f49$export$a3989301a7f69ed7)(accountId, cloudId, townsquareApp);
    const fireCrossAppProfileAnalytic = (0, $2066a53fd7da0b8e$export$c7eac394c4a88aeb)(townsquareApp);
    const externalMessage = (0, $cozmU.useMemo)(()=>(0, $8b78f8e317e74b4e$export$523ecfa1815bea06)(thirdPartyIntegrations, email), [
        email,
        thirdPartyIntegrations
    ]);
    // We reuse the existing `@atlaskit/profilecard` clicked.action event so the SLO dashboards see a
    // single click-event surface for both profile-card packages. `index` and `hasOnClick` are
    // required by that schema but are not meaningful for user-profile-card actions, so we always
    // send `index: 0` and `hasOnClick: true`.
    const handleThirdPartyMessageClick = (0, $cozmU.useCallback)((event)=>{
        if (event.type === 'auxclick' && event.button !== 1) return;
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: Boolean(externalMessage?.dm.openDmUrl),
            hasOnClick: true,
            index: 0,
            actionId: 'thirdPartyMessage',
            isAuxClick: event.type === 'auxclick'
        });
    }, [
        fireEvent,
        getDurationSinceInteraction,
        externalMessage
    ]);
    const handleViewProfileClick = (0, $cozmU.useCallback)((event)=>{
        if (event.type === 'auxclick' && event.button !== 1) return;
        const auxClick = event.type === 'auxclick';
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: Boolean(href),
            hasOnClick: true,
            index: 0,
            actionId: 'viewProfile',
            isAuxClick: auxClick
        });
        if (isCrossAppMauEnabled) fireCrossAppProfileAnalytic();
        onProfileClick?.(accountId);
        // A middle-click on a link opens a new tab natively, so only run SPA navigation for
        // primary clicks.
        if (!auxClick) onNavigate?.(event);
    }, [
        fireEvent,
        getDurationSinceInteraction,
        href,
        onNavigate,
        onProfileClick,
        isCrossAppMauEnabled,
        fireCrossAppProfileAnalytic,
        accountId
    ]);
    const menuItems = (0, $cozmU.useMemo)(()=>{
        const visible = (actions ?? []).filter((action)=>!action.shouldRender || action.shouldRender(profileData));
        return visible.map((action, index)=>{
            const id = action.id ?? `action-${index}`;
            if (action.link) return {
                kind: 'link',
                id: id,
                label: action.label,
                href: action.link,
                target: action.target,
                onClick: action.callback ? (event, ...args)=>{
                    const isBasicClick = !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
                    if (isBasicClick) {
                        event.preventDefault();
                        action.callback?.(event, ...args);
                    }
                } : undefined
            };
            return {
                kind: 'button',
                id: id,
                label: action.label,
                onClick: (event, ...args)=>action.callback?.(event, ...args)
            };
        });
    }, [
        actions,
        profileData
    ]);
    // "More actions" button: the kudos drawer returns focus here, as the "Give kudos" item
    // unmounts when the menu closes.
    const actionMenuTriggerRef = (0, $cozmU.useRef)(null);
    const { menuItem: kudosMenuItem, launcher: kudosLauncher } = (0, $4f68084afcb13ad1$export$e739febab83b2399)({
        accountId: accountId,
        cloudId: cloudId,
        viewerId: viewerId,
        actionMenuTriggerRef: actionMenuTriggerRef
    });
    const allMenuItems = (0, $cozmU.useMemo)(// Deactivated accounts only surface the "View profile" button - no custom actions or kudos.
    ()=>isDeactivated ? [] : kudosMenuItem ? [
            ...menuItems,
            kudosMenuItem
        ] : menuItems, [
        isDeactivated,
        menuItems,
        kudosMenuItem
    ]);
    const hasActionMenu = allMenuItems.length > 0;
    const hasViewProfile = canViewProfile && Boolean(href);
    const hasExternalMessage = !isDeactivated && Boolean(externalMessage);
    if (!accountId || !hasViewProfile && !hasExternalMessage && !hasActionMenu) return null;
    const inline = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        children: [
            !isDeactivated && externalMessage && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7WEaj.default), {
                href: externalMessage.dm.openDmUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: handleThirdPartyMessageClick,
                onAuxClick: handleThirdPartyMessageClick,
                icon: (0, $aa9a50e7a58f2aaa$export$5a867b7c6687d757)(externalMessage.dm.integration),
                label: intl.formatMessage($d60be53616d0626a$var$messages.sendMessageLabel),
                isTooltipDisabled: false
            }),
            hasViewProfile && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eKMV3.default), {
                ref: viewProfileInitialFocusRef,
                href: href,
                appearance: "default",
                target: target,
                onClick: handleViewProfileClick,
                onAuxClick: handleViewProfileClick,
                rel: target === '_blank' ? 'noopener noreferrer' : undefined,
                testId: getTestId('view-profile-button'),
                children: intl.formatMessage($d60be53616d0626a$var$messages.viewProfile)
            }),
            hasActionMenu && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $e73bf856672907cd$export$ed57a210b9d13bb6), {
                items: allMenuItems,
                name: profileData.name,
                triggerRef: actionMenuTriggerRef
            })
        ]
    });
    // When there's no kudos launcher to portal-mount, return the bare `<Inline>` element so that
    // callers which expected the legacy single-element return tree continue to see one node (and
    // no extra fragment wrapper). The fragment form is only used when we actually need to render
    // the launcher sibling.
    if (isDeactivated || !kudosLauncher) return inline;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            inline,
            kudosLauncher
        ]
    });
}


/* ReportingLinePane.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");





var $ad7Ou = parcelRequire("ad7Ou");





var $kdlgT = parcelRequire("kdlgT");


var $4bg4c = parcelRequire("4bg4c");










/* MiniHierarchyList.tsx generated by @compiled/babel-plugin v3.0.2 */ 










/* MiniHierarchyMoreRow.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");











var $7vK9E = parcelRequire("7vK9E");







const $c1f76a0ca51cd8c3$var$MAX_STACKED_AVATARS = 3;
const $c1f76a0ca51cd8c3$var$messages = (0, $kSwu1.defineMessages)({
    seeMore: {
        id: "user-profile-card.MiniHierarchyMoreRow.seeMore",
        defaultMessage: "See {count} more"
    }
});
const $c1f76a0ca51cd8c3$var$styles = {
    row: "_0bjKvDKTcp _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3iDTPbvLZJ _39xV02N91d _0Of8r2gVvo _1Znuxb2ADO _1wydGWgVvo _2Zuz6Q2ADO _1UtDYzy7kJ",
    interactiveRow: "_0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _1eOmH6o126 _3gzVzLN4oS",
    stackedAvatar: "_0GTcwR4F84",
    firstAvatar: "_0GTcwRPgdg"
};
function $c1f76a0ca51cd8c3$export$becc079c0bfa72a({ people: people, href: href, target: target, onClick: onClick, onNavigate: onNavigate, testId: testId }) {
    const intl = (0, $kSwu1.useIntl)();
    const stacked = people.slice(0, $c1f76a0ca51cd8c3$var$MAX_STACKED_AVATARS);
    const content = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                alignBlock: "center",
                children: stacked.map((person, index)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: index === 0 ? $c1f76a0ca51cd8c3$var$styles.firstAvatar : $c1f76a0ca51cd8c3$var$styles.stackedAvatar,
                        "aria-hidden": true,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                            src: person.avatarUrl ?? undefined,
                            name: person.name
                        })
                    }, person.accountId))
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                weight: "medium",
                children: intl.formatMessage($c1f76a0ca51cd8c3$var$messages.seeMore, {
                    count: people.length
                })
            })
        ]
    });
    if (!href) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $c1f76a0ca51cd8c3$var$styles.row,
        testId: testId,
        children: content
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        onClick: (event)=>{
            onClick?.();
            onNavigate?.(event);
        },
        xcss: (0, $w6R6I.cx)($c1f76a0ca51cd8c3$var$styles.row, $c1f76a0ca51cd8c3$var$styles.interactiveRow),
        testId: testId,
        children: content
    });
}


/* MiniHierarchyRow.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");





var $jLnA6 = parcelRequire("jLnA6");













const $37a953e9ceb5bed0$var$styles = {
    row: "_0bjKvDKTcp _2V7sgONvrM _3hxITi6wH8 _3vBAKHjOvk _0Of8r2gVvo _1Znuxb2ADO _1wydGWgVvo _2Zuz6Q2ADO _0KLXruDMqu _39xV02N91d",
    selectedRow: "_3vBAKHrzt2 _0KLXrulfZc"
};
function $37a953e9ceb5bed0$export$e0eb144c897b990f({ person: person, selected: selected = false, rowRef: rowRef, testId: testId }) {
    const { name: name, avatarUrl: avatarUrl, jobTitle: jobTitle, numberOfTotalReports: numberOfTotalReports = 0, numberOfDirectReports: numberOfDirectReports = 0 } = person;
    const showBadge = numberOfTotalReports > 0 && numberOfDirectReports > 0;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        ref: rowRef,
        xcss: (0, $w6R6I.cx)($37a953e9ceb5bed0$var$styles.row, selected && $37a953e9ceb5bed0$var$styles.selectedRow),
        testId: testId,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                    space: "space.150",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                            src: avatarUrl ?? undefined,
                            name: name
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                    color: "color.text",
                                    weight: "medium",
                                    maxLines: 1,
                                    children: name
                                }),
                                jobTitle && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                    size: "small",
                                    color: "color.text.subtle",
                                    maxLines: 1,
                                    children: jobTitle
                                })
                            ]
                        })
                    ]
                }),
                showBadge && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jLnA6.default), {
                    appearance: selected ? 'primary' : 'default',
                    max: 99999,
                    children: numberOfTotalReports
                })
            ]
        })
    });
}


const $ce3e99e979c3bdb0$var$MAX_VISIBLE_REPORTS = 3; /** Levels of managers shown above the user when they have no direct reports (manager + skip). */ 
const $ce3e99e979c3bdb0$var$MAX_MANAGERS_NO_REPORTS = 2; /** Levels of managers shown above the user when they do have direct reports (immediate manager). */ 
const $ce3e99e979c3bdb0$var$MAX_MANAGERS_WITH_REPORTS = 1;
const $ce3e99e979c3bdb0$var$styles = {
    scrollArea: "_2O5Vij7dHp _3YEZNO7dHp _4kiQYAdnbC _2WAcuGIZbP _4bt5LAnQyn",
    connector: "_3SamIHFQfX _39xV024Y4b _0jFU0Vey7F _0KLXruKcZT",
    stack: "_4kiQYAN91d _0Of8r25zaO _1wydGW5zaO _1Znuxb5zaO _2Zuz6Q5zaO"
};
function $ce3e99e979c3bdb0$export$749b7901a1a4f14f({ data: data, scrollToken: scrollToken, moreHref: moreHref, moreTarget: moreTarget, onMoreClick: onMoreClick, onMoreNavigate: onMoreNavigate, testId: testId }) {
    const { managers: managers = [], user: user, reports: reports = [] } = data;
    const hasReports = reports.length > 0;
    const maxManagers = hasReports ? $ce3e99e979c3bdb0$var$MAX_MANAGERS_WITH_REPORTS : $ce3e99e979c3bdb0$var$MAX_MANAGERS_NO_REPORTS;
    const orderedManagers = managers.slice(0, maxManagers).reverse();
    const visibleReports = reports.slice(0, $ce3e99e979c3bdb0$var$MAX_VISIBLE_REPORTS);
    const overflowReports = reports.slice($ce3e99e979c3bdb0$var$MAX_VISIBLE_REPORTS);
    const showMoreRow = hasReports && overflowReports.length > 0;
    const connector = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $ce3e99e979c3bdb0$var$styles.connector,
        "aria-hidden": true,
        testId: "hierarchy-connector"
    });
    const scrollRef = (0, $cozmU.useRef)(null);
    const selectedRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useLayoutEffect)(()=>{
        const container = scrollRef.current;
        const selected = selectedRef.current;
        if (!container || !selected) return;
        const center = ()=>{
            const target = selected.offsetTop - (container.clientHeight - selected.offsetHeight) / 2;
            container.scrollTop = Math.max(0, target);
        };
        if (container.clientHeight === 0) {
            const frame = requestAnimationFrame(center);
            return ()=>cancelAnimationFrame(frame);
        }
        center();
    }, [
        user.accountId,
        scrollToken
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        ref: scrollRef,
        xcss: $ce3e99e979c3bdb0$var$styles.scrollArea,
        testId: testId,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
            space: "space.100",
            alignBlock: "center",
            alignInline: "center",
            xcss: $ce3e99e979c3bdb0$var$styles.stack,
            children: [
                orderedManagers.map((manager, index)=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                        children: [
                            index > 0 && connector,
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $37a953e9ceb5bed0$export$e0eb144c897b990f), {
                                person: manager,
                                testId: `hierarchy-row-manager-${manager.accountId}`
                            })
                        ]
                    }, manager.accountId)),
                orderedManagers.length > 0 && connector,
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $37a953e9ceb5bed0$export$e0eb144c897b990f), {
                    person: user,
                    selected: true,
                    rowRef: selectedRef,
                    testId: "hierarchy-row-selected"
                }),
                hasReports && connector,
                visibleReports.map((person)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $37a953e9ceb5bed0$export$e0eb144c897b990f), {
                        person: person,
                        testId: `hierarchy-row-report-${person.accountId}`
                    }, person.accountId)),
                showMoreRow && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c1f76a0ca51cd8c3$export$becc079c0bfa72a), {
                    people: overflowReports,
                    href: moreHref,
                    target: moreTarget,
                    onClick: onMoreClick,
                    onNavigate: onMoreNavigate,
                    testId: "hierarchy-row-more"
                })
            ]
        })
    });
}


const $640c1c7a91167409$var$styles = {
    focusReset: "_2xIroY98eZ _497WNwYbGa _2zndICT6kp",
    fill: "_2O5Vij7dHp _3YEZNO7dHp _4kiQYAdnbC _0jFU0VN91d _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    listRegion: "_2O5Vij7dHp _3YEZNO7dHp _4kiQYAdnbC _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $640c1c7a91167409$var$messages = (0, $kSwu1.defineMessages)({
    emptyState: {
        id: "user-profile-card.ReportingLinePane.emptyState",
        defaultMessage: "No reporting line information is available."
    },
    viewFullReportingLine: {
        id: "user-profile-card.ReportingLinePane.viewFullReportingLine",
        defaultMessage: "View full org chart"
    },
    heading: {
        id: "user-profile-card.ReportingLinePane.heading",
        defaultMessage: "Reporting line"
    },
    back: {
        id: "user-profile-card.ReportingLinePane.back",
        defaultMessage: "Back to profile"
    },
    backShort: {
        id: "user-profile-card.ReportingLinePane.backShort",
        defaultMessage: "Back"
    }
});
function $640c1c7a91167409$export$c0554440016547ea({ hierarchyData: hierarchyData, viewFullUrl: viewFullUrl, target: target, onNavigate: onNavigate, onViewFullClick: onViewFullClick, onBack: onBack, headingRef: headingRef, resetToken: resetToken, testId: testId }) {
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        space: "space.200",
        testId: testId,
        xcss: $640c1c7a91167409$var$styles.fill,
        children: [
            onBack && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                space: "space.100",
                alignBlock: "center",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    ref: headingRef,
                    tabIndex: -1,
                    xcss: $640c1c7a91167409$var$styles.focusReset,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
                        appearance: "default",
                        onClick: onBack,
                        testId: "hierarchy-back-button",
                        "aria-label": intl.formatMessage($640c1c7a91167409$var$messages.back),
                        children: intl.formatMessage($640c1c7a91167409$var$messages.backShort)
                    })
                })
            }),
            hierarchyData ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $640c1c7a91167409$var$styles.listRegion,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ce3e99e979c3bdb0$export$749b7901a1a4f14f), {
                    data: hierarchyData,
                    scrollToken: resetToken,
                    moreHref: viewFullUrl,
                    moreTarget: target,
                    onMoreClick: onViewFullClick,
                    onMoreNavigate: onNavigate,
                    testId: "hierarchy-list"
                })
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                paddingBlock: "space.100",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    size: "small",
                    color: "color.text.subtlest",
                    children: intl.formatMessage($640c1c7a91167409$var$messages.emptyState)
                })
            }),
            viewFullUrl && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                alignInline: "center",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eKMV3.default), {
                    href: viewFullUrl,
                    target: target,
                    rel: target === '_blank' ? 'noopener noreferrer' : undefined,
                    onClick: (event)=>{
                        onViewFullClick?.();
                        onNavigate?.(event);
                    },
                    appearance: "default",
                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($4bg4c))),
                    testId: "hierarchy-view-full-link",
                    children: intl.formatMessage($640c1c7a91167409$var$messages.viewFullReportingLine)
                })
            })
        ]
    });
}


/* ManagerSection.tsx generated by @compiled/babel-plugin v3.0.2 */ 



























const $edc2d3ea5f2e6444$export$1f2057e1ea6efa55 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
function $edc2d3ea5f2e6444$export$9219018d2db07e72() {
    return (0, $cozmU.useContext)($edc2d3ea5f2e6444$export$1f2057e1ea6efa55);
}





parcelRequire("cozmU");










const $1e8ff6c940adbec7$var$messages = (0, $kSwu1.defineMessages)({
    orgChart: {
        id: "user-profile-card.ViewReportingLineButton.orgChart",
        defaultMessage: "Org chart"
    }
});
function $1e8ff6c940adbec7$export$c6126cbbcc4238ee({ onClick: onClick, controls: controls, testId: testId }) {
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
        onClick: (event)=>{
            if ((0, $iDrrr.fg)('ptc_user_profile_card_stop_org_chart_bubble')) // Popup events cross React portals; do not let this secondary action activate an
            // ancestor control such as the Goals and Projects owner InlineEdit.
            event.stopPropagation();
            onClick();
        },
        "aria-controls": controls,
        testId: testId,
        spacing: "compact",
        appearance: "subtle",
        children: intl.formatMessage($1e8ff6c940adbec7$var$messages.orgChart)
    });
}


const $cd67a816341628e9$var$messages = (0, $kSwu1.defineMessages)({
    managerHeading: {
        id: "user-profile-card.ManagerSection.managerHeading",
        defaultMessage: "Manager"
    }
});
const $cd67a816341628e9$var$styles = {
    link: "_0bjKvDKTcp _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3iDTPbvLZJ _0Of8r2gVvo _1wydGWgVvo _2Zuz6Q2ADO _1Znuxb2ADO _1UtDYzy7kJ _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _1eOmH6o126 _3gzVzLN4oS"
};
function $cd67a816341628e9$export$2992b481dad9fb03({ manager: manager, nonInteractive: nonInteractive = false }) {
    const intl = (0, $kSwu1.useIntl)();
    const { getTestId: getTestId, cloudId: cloudId, townsquareApp: townsquareApp } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    const { id: id, name: name, avatarUrl: avatarUrl, jobTitle: jobTitle } = manager;
    const { href: href, target: target, onNavigate: onNavigate } = (0, $583e2a6550f59f49$export$a3989301a7f69ed7)(id, cloudId, townsquareApp);
    const slider = (0, $edc2d3ea5f2e6444$export$9219018d2db07e72)();
    const showOrgChartTrigger = Boolean(slider) && !nonInteractive;
    if (!name) return null;
    const managerDetails = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                src: avatarUrl ?? undefined,
                name: name
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        maxLines: 1,
                        children: name
                    }),
                    jobTitle && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        maxLines: 1,
                        size: "small",
                        children: jobTitle
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        space: "space.075",
        testId: getTestId('manager'),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                spread: "space-between",
                alignBlock: "start",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        as: "p",
                        weight: "medium",
                        color: "color.text",
                        children: intl.formatMessage($cd67a816341628e9$var$messages.managerHeading)
                    }),
                    showOrgChartTrigger && slider && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1e8ff6c940adbec7$export$c6126cbbcc4238ee), {
                        onClick: slider.onView,
                        controls: slider.backPaneId,
                        testId: getTestId('view-reporting-line')
                    })
                ]
            }),
            nonInteractive ? managerDetails : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                href: href,
                target: target,
                onClick: onNavigate,
                xcss: $cd67a816341628e9$var$styles.link,
                testId: getTestId('manager-link'),
                children: managerDetails
            })
        ]
    });
}


/* ProfileCardSlider.tsx generated by @compiled/babel-plugin v3.0.2 */ 












const $c676cd3726aaef40$var$SLIDE_DURATION = '0.35s';
const $c676cd3726aaef40$var$SLIDE_EASING = 'cubic-bezier(0.25, 0.1, 0.25, 1)';
const $c676cd3726aaef40$var$styles = {
    viewport: "_1mT5xdRAKS _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d",
    pane: "_1kOSYtC67X _3Z9K0wngV3 _0qk6IKUtCU _2Iz54kmrqn",
    frontShown: "_1VJPcalna5",
    frontHidden: "_1VJPcaIt9z",
    backPane: "_49OCfRPgdg _4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _3iDTPbQ4SZ _0aFT5vbt8w",
    backHidden: "_1VJPcaKthN",
    backShown: "_1VJPcalna5"
};
function $c676cd3726aaef40$var$useInert(active) {
    const ref = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const node = ref.current;
        if (!node) return;
        if (active) node.removeAttribute('inert');
        else node.setAttribute('inert', '');
    }, [
        active
    ]);
    return ref;
}
function $c676cd3726aaef40$export$da08d35d50ddd6ca({ children: children, onView: onView, onBack: onBack }) {
    const [showBack, setShowBack] = (0, $cozmU.useState)(false);
    const [resetToken, setResetToken] = (0, $cozmU.useState)(0);
    const backPaneId = (0, $cozmU.useId)();
    const handleView = (0, $cozmU.useCallback)(()=>{
        setShowBack(true);
        setResetToken((token)=>token + 1);
        onView?.();
    }, [
        onView
    ]);
    const handleBack = (0, $cozmU.useCallback)(()=>{
        setShowBack(false);
        onBack?.();
    }, [
        onBack
    ]);
    const value = (0, $cozmU.useMemo)(()=>({
            showBack: showBack,
            onView: handleView,
            onBack: handleBack,
            backPaneId: backPaneId,
            resetToken: resetToken
        }), [
        showBack,
        handleView,
        handleBack,
        backPaneId,
        resetToken
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $edc2d3ea5f2e6444$export$1f2057e1ea6efa55).Provider, {
        value: value,
        children: children
    });
}
function $c676cd3726aaef40$export$128359470049ac91({ front: front, back: back, showBack: showBack, onBack: onBack, backPaneId: backPaneId, testId: testId }) {
    const backHeadingRef = (0, $cozmU.useRef)(null);
    const viewportRef = (0, $cozmU.useRef)(null);
    const frontInertRef = $c676cd3726aaef40$var$useInert(!showBack);
    const backInertRef = $c676cd3726aaef40$var$useInert(showBack);
    (0, $cozmU.useEffect)(()=>{
        if (showBack) backHeadingRef.current?.focus({
            preventScroll: true
        });
    }, [
        showBack
    ]);
    (0, $cozmU.useEffect)(()=>{
        const viewport = viewportRef.current;
        if (!viewport) return;
        viewport.scrollLeft = 0;
        viewport.scrollTop = 0;
    }, [
        showBack
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        ref: viewportRef,
        xcss: $c676cd3726aaef40$var$styles.viewport,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                ref: frontInertRef,
                xcss: (0, $w6R6I.cx)($c676cd3726aaef40$var$styles.pane, showBack ? $c676cd3726aaef40$var$styles.frontHidden : $c676cd3726aaef40$var$styles.frontShown),
                children: front
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                ref: backInertRef,
                id: backPaneId,
                role: "group",
                xcss: (0, $w6R6I.cx)($c676cd3726aaef40$var$styles.pane, $c676cd3726aaef40$var$styles.backPane, showBack ? $c676cd3726aaef40$var$styles.backShown : $c676cd3726aaef40$var$styles.backHidden),
                children: back({
                    back: onBack,
                    headingRef: backHeadingRef
                })
            })
        ]
    });
}






parcelRequire("cozmU");



















parcelRequire("cozmU");


var $c2Doe = parcelRequire("c2Doe");




/* RecentWorkItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
















var $a9aSv = parcelRequire("a9aSv");


var $l8wPz = parcelRequire("l8wPz");


var $4yYAm = parcelRequire("4yYAm");

parcelRequire("i1503");
var $44bfd = parcelRequire("44bfd");

parcelRequire("jdA6O");
var $7n0A2 = parcelRequire("7n0A2");

/**
 * Module-level memory of which recent-work URLs have previously resolved via Smart Card.
 *
 * 1. Records URLs that have resolved successfully at least once.
 * 2. Lets a freshly mounted item initialise its `resolved` state to `true`, avoiding a
 *    skeleton flash when the profile card re-mounts (e.g. reopening the hover card).
 * 3. Is a no-op on the server so SSR never touches the shared set.
 */ const $64a1c98534950ad8$var$resolvedUrls = new Set();
const $64a1c98534950ad8$var$isBrowser = typeof window !== 'undefined';
function $64a1c98534950ad8$export$16ad849210e30509(url) {
    if (!$64a1c98534950ad8$var$isBrowser || !url) return false;
    return $64a1c98534950ad8$var$resolvedUrls.has(url);
}
function $64a1c98534950ad8$export$4221f35a82bb4741(url) {
    if (!$64a1c98534950ad8$var$isBrowser || !url) return;
    $64a1c98534950ad8$var$resolvedUrls.add(url);
}
function $64a1c98534950ad8$export$85e4c24706d1f5ed() {
    $64a1c98534950ad8$var$resolvedUrls.clear();
}


const $3382bf690af37aa1$var$styles = {
    root: "_0bjKvDKTcp _1mT5xdRAKS _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0KLXru66of _1eOmH6o126",
    unresolved: "_4kiQYAFwex",
    unresolvedSkeletonOverlay: "_0bjKvDKTcp _1mT5xdWVPG _2I62gzPgdg _1ZB6UyPgdg _3iC0zdPgdg _1OKFqYPgdg _0KLXrunmFW _0Of8r22ADO _2Zuz6Q2ADO _42Yu6B7dHp",
    skeletonRows: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC"
}; // These styles target Smart Card's internal DOM (icon, title link, element group), which requires
// nested selectors. `@atlaskit/css`'s `cssMap` disallows nested selectors, so we use
// `@compiled/react`'s `cssMap` here instead — the same approach used by the LinkList component in
// `@atlassian/smart-knowledge-cards`.
const $3382bf690af37aa1$var$unboundedStyles = {
    titleWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC",
    titleBlock: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _4bInUCPgdg _4hM5yg8fU6 _0yksiO2ADO _32GWj52ADO _2ztbEw2ADO _46UOc62ADO _3l7hjhDMqu _2XqGtx5UaJ _16yMdq98eZ _1jGVpLYbGa _3v4Fnm6wH8 _3F6Feu98eZ _4D1MCdYbGa _0ffBHJ6wH8 _013U0G98eZ _0i7M44YbGa _0XBv4M6wH8",
    stateSlot: "_3YEZNOdnbC _3iDTPbQ4SZ _37wbyuz9WS _2XsHFM8HPE"
};
function $3382bf690af37aa1$export$9adc0410c9970c44({ url: url, index: index, onLinkClick: onLinkClick, testId: testId }) {
    const [resolved, setResolved] = (0, $cozmU.useState)(()=>(0, $64a1c98534950ad8$export$16ad849210e30509)(url));
    const handleResolve = (0, $cozmU.useCallback)(()=>{
        (0, $64a1c98534950ad8$export$4221f35a82bb4741)(url);
        setResolved(true);
    }, [
        url
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3382bf690af37aa1$var$styles.root, !resolved && $3382bf690af37aa1$var$styles.unresolved),
        testId: testId ? `${testId}-item-${index}` : undefined,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l8wPz.Card), {
                appearance: "block",
                url: url,
                onClick: ()=>onLinkClick?.(url, index),
                ui: {
                    theme: (0, $4yYAm.SmartLinkTheme).Black,
                    clickableContainer: true,
                    hideBackground: true,
                    hideElevation: true,
                    hidePadding: true,
                    size: (0, $4yYAm.SmartLinkSize).Medium,
                    removeBlockRestriction: true
                },
                onResolve: handleResolve,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                    spread: "space-between",
                    alignBlock: "center",
                    children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        alignBlock: "center",
                        xcss: $3382bf690af37aa1$var$unboundedStyles.titleWrapper,
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $3382bf690af37aa1$var$unboundedStyles.titleBlock,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7n0A2.TitleBlock), {
                                    maxLines: 1,
                                    showActionOnHover: true,
                                    subtitle: [
                                        {
                                            name: (0, $4yYAm.ElementName).Provider,
                                            hideIcon: true
                                        },
                                        {
                                            name: (0, $4yYAm.ElementName).ModifiedOn
                                        }
                                    ],
                                    position: (0, $4yYAm.SmartLinkPosition).Center
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $3382bf690af37aa1$var$unboundedStyles.stateSlot,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $44bfd.MetadataBlock), {
                                    maxLines: 1,
                                    primary: [
                                        {
                                            name: (0, $4yYAm.ElementName).State
                                        }
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            !resolved && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $3382bf690af37aa1$var$styles.unresolvedSkeletonOverlay,
                testId: testId ? `${testId}-item-${index}-skeleton` : undefined,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                    space: "space.100",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                            width: "32px",
                            height: "32px",
                            borderRadius: "var(--ds-radius-small, 4px)"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                            xcss: $3382bf690af37aa1$var$styles.skeletonRows,
                            space: "space.100",
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: "40%",
                                    height: "12px",
                                    borderRadius: "var(--ds-radius-small, 4px)"
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: "70%",
                                    height: "12px",
                                    borderRadius: "var(--ds-radius-small, 4px)"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


const $8e18470dab2f6ca5$var$DEFAULT_MAX_SOURCES = 3;
function $8e18470dab2f6ca5$export$66aebd6b65f0e0cf({ urls: urls, maxSources: maxSources = $8e18470dab2f6ca5$var$DEFAULT_MAX_SOURCES, onLinkClick: onLinkClick, testId: testId }) {
    if (urls.length === 0) return null;
    const visibleUrls = urls.slice(0, maxSources);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c2Doe.SmartCardProvider), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dinVW.Stack), {
            space: "space.050",
            testId: testId,
            children: visibleUrls.map((url, index)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $3382bf690af37aa1$export$9adc0410c9970c44), {
                    url: url,
                    index: index,
                    onLinkClick: onLinkClick,
                    testId: testId
                }, `${url}-${index}`))
        })
    });
}


const $00b2d1a91d1fd509$var$messages = (0, $kSwu1.defineMessages)({
    recentWorkHeading: {
        id: "user-profile-card.recent-work.heading",
        defaultMessage: "Recent work"
    },
    viewAll: {
        id: "user-profile-card.RecentWorkSection.viewAll",
        defaultMessage: "View all"
    }
});
function $00b2d1a91d1fd509$export$5981f4ad4928b105({ recentWorkData: recentWorkData, testId: testId, viewAllUrl: viewAllUrl, onLinkClick: onLinkClick, onViewAllLinkClick: onViewAllLinkClick }) {
    const intl = (0, $kSwu1.useIntl)();
    if (recentWorkData.length === 0) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        space: "space.075",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                spread: "space-between",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        as: "p",
                        weight: "medium",
                        color: "color.text",
                        children: intl.formatMessage($00b2d1a91d1fd509$var$messages.recentWorkHeading)
                    }),
                    viewAllUrl && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eKMV3.default), {
                        href: viewAllUrl,
                        onClick: onViewAllLinkClick,
                        spacing: "compact",
                        appearance: "subtle",
                        testId: testId ? `${testId}-view-all` : undefined,
                        children: intl.formatMessage($00b2d1a91d1fd509$var$messages.viewAll)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                testId: testId,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8e18470dab2f6ca5$export$66aebd6b65f0e0cf), {
                    urls: recentWorkData,
                    maxSources: 3,
                    onLinkClick: onLinkClick
                })
            })
        ]
    });
}


const $ceb1b60f3799900e$var$styles = {
    root: "_39xV02wBC3 _4ouGXIe9dk _0wOv4Q18ZR _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _0KLXruqi9L",
    deactivatedAvatar: "_1llTr6MFyn"
}; /**
    * Presentational profile card displaying a user's core information and recent work.
    * Renders avatar, name, pronouns, job title, department, location, manager, and recent-work items.
    *
    * Shows a loading skeleton when `isLoading` is true or `profileData` is undefined.
    * Displays an error state when profile data is missing or `name` is not provided.
    *
    * Recent-work previews require a `SmartCardProvider` from `@atlaskit/link-provider`
    * in scope (already provided by every Atlassian product shell).
    */ 
function $ceb1b60f3799900e$export$7bf40cd2a197df2d({ profileData: profileData, recentWorkData: recentWorkData, hierarchyData: hierarchyData, isLoading: isLoading = false, testId: testId = 'user-profile-card', cloudId: cloudId, canViewProfile: canViewProfile = true, error: error, actions: actions, viewerId: viewerId, analyticsAttributes: analyticsAttributes, isReduced: isReduced }) {
    const outerContext = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    const userId = profileData?.accountId ?? '';
    const localGetTestId = (0, $cozmU.useMemo)(()=>(0, $bXEsj.makeGetTestId)(userId, testId), [
        userId,
        testId
    ]);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            ...outerContext,
            cloudId: cloudId,
            getTestId: outerContext.getTestId !== (0, $9gll8.defaultGetTestId) ? outerContext.getTestId : localGetTestId
        }), [
        cloudId,
        localGetTestId,
        outerContext
    ]);
    const analyticsData = {
        source: 'userProfileCard',
        attributes: {
            ...analyticsAttributes,
            cloudId: cloudId,
            userId: userId,
            hasManager: Boolean(profileData?.manager),
            hasRecentWork: Boolean(recentWorkData?.length),
            hasThirdPartyIntegrations: Boolean(profileData?.thirdPartyIntegrations?.length)
        }
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2tuSz.TeamsAppAnalyticsContext), {
        data: analyticsData,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9gll8.UserProfileCardContext).Provider, {
            value: contextValue,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bIiaK.CardOpenTimerProvider), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($ceb1b60f3799900e$var$UserProfileCardErrorBoundary, {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)($ceb1b60f3799900e$var$UserProfileCardContent, {
                        profileData: profileData,
                        recentWorkData: recentWorkData,
                        hierarchyData: hierarchyData,
                        isLoading: isLoading,
                        testId: testId,
                        cloudId: cloudId,
                        canViewProfile: canViewProfile,
                        error: error,
                        actions: actions,
                        viewerId: viewerId,
                        isReduced: isReduced
                    })
                })
            })
        })
    });
}
function $ceb1b60f3799900e$var$UserProfileCardErrorBoundary({ children: children, testId: testId }) {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const handleError = (0, $cozmU.useCallback)((_error)=>{
        // `default` (not `renderError`) - schema only allows `default | NotFound`.
        fireEvent('ui.profilecard.rendered.error', {
            firedAt: (0, $eRfpr.firedAt)(),
            errorType: 'default',
            hasRetry: false
        });
    }, [
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
        onError: handleError,
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3Z1Pc.CardError), {
            testId: testId
        }),
        children: children
    });
}
function $ceb1b60f3799900e$var$UserProfileCardContent({ profileData: profileData, recentWorkData: recentWorkData, hierarchyData: hierarchyData, isLoading: isLoading, testId: testId, cloudId: cloudId, canViewProfile: canViewProfile, error: error, actions: actions, viewerId: viewerId, isReduced: isReduced }) {
    const { getTestId: getTestId } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    const hasProfileData = Boolean(profileData && profileData.name);
    (0, $kKnPE.useFireRequestSucceeded)(!isLoading && hasProfileData);
    (0, $kKnPE.useFireRequestFailed)(!isLoading && !hasProfileData ? error ?? null : undefined);
    if (isLoading) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxdou.CardLoading), {
        testId: testId,
        profileData: profileData,
        isReduced: isReduced
    });
    if (!profileData || !profileData.name) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f6a1f04ce64d6d23$export$2ebec9f03312245c), {
        testId: testId,
        errorType: "NotFound"
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($ceb1b60f3799900e$var$UserProfileCardRenderedContent, {
        profileData: profileData,
        recentWorkData: recentWorkData,
        hierarchyData: hierarchyData,
        testId: testId,
        cloudId: cloudId,
        canViewProfile: canViewProfile,
        getTestId: getTestId,
        actions: actions,
        viewerId: viewerId,
        isReduced: isReduced
    });
} /**
   * Success-only render, split out so `useFireContentRendered` fires only when the content is shown
   * (not on the loading or error states).
   */ 
function $ceb1b60f3799900e$var$UserProfileCardRenderedContent({ profileData: profileData, recentWorkData: recentWorkData, hierarchyData: hierarchyData, testId: testId, cloudId: cloudId, canViewProfile: canViewProfile, getTestId: getTestId, actions: actions, viewerId: viewerId, isReduced: isReduced }) {
    (0, $kKnPE.useFireContentRendered)(profileData);
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $bIiaK.useCardOpenTimer)();
    const { townsquareApp: townsquareApp } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    const { href: profileHref, target: profileTarget, onNavigate: onProfileNavigate } = (0, $583e2a6550f59f49$export$a3989301a7f69ed7)(profileData.accountId, cloudId, townsquareApp);
    const viewAllUrl = (0, $45508ebbf47750c1$export$f339ec3b489d28e5)(profileHref);
    const handleRecentWorkViewAllClick = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: Boolean(viewAllUrl),
            hasOnClick: true,
            index: 0,
            actionId: 'recentWorkViewAll'
        });
    }, [
        fireEvent,
        getDurationSinceInteraction,
        viewAllUrl
    ]);
    const handleViewReportingLine = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: false,
            hasOnClick: true,
            index: 1,
            actionId: 'viewReportingLine'
        });
    }, [
        fireEvent,
        getDurationSinceInteraction
    ]);
    const handleBackToProfile = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: false,
            hasOnClick: true,
            index: 0,
            actionId: 'backToProfile'
        });
    }, [
        fireEvent,
        getDurationSinceInteraction
    ]);
    const handleViewFullReportingLineClick = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: Boolean(profileHref),
            hasOnClick: true,
            index: 0,
            actionId: 'viewFullReportingLine'
        });
    }, [
        fireEvent,
        getDurationSinceInteraction,
        profileHref
    ]);
    const handleRecentWorkLinkClick = (0, $cozmU.useCallback)((url, index)=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: Boolean(url),
            hasOnClick: true,
            index: index,
            actionId: 'recentWorkLink'
        });
    }, [
        fireEvent,
        getDurationSinceInteraction
    ]);
    const { name: name, pronouns: pronouns, avatarUrl: avatarUrl, jobTitle: jobTitle, department: department, location: location, localTime: localTime, manager: manager, email: email } = profileData; // Deactivated (inactive/closed) accounts get a reduced experience: greyed-out avatar, only the
    // "View profile" action, a status lozenge, and no manager / recent-work sections.
    const isDeactivated = profileData.accountStatus === 'inactive' || profileData.accountStatus === 'closed';
    const subtitleParts = [
        jobTitle,
        department
    ].filter(Boolean);
    const subtitle = subtitleParts.join(` \u2022 `);
    const locationLine = localTime && location ? `${location} \u2013 ${localTime}` : location ?? undefined;
    const hasRecentWork = Boolean(recentWorkData?.length);
    const hasHierarchy = Boolean(hierarchyData?.user?.accountId);
    const useSlider = !isDeactivated && hasHierarchy && !isReduced;
    const recentWorkPanel = hasRecentWork && recentWorkData ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $00b2d1a91d1fd509$export$5981f4ad4928b105), {
        recentWorkData: recentWorkData,
        testId: getTestId('recent-work'),
        viewAllUrl: viewAllUrl,
        onViewAllLinkClick: handleRecentWorkViewAllClick,
        onLinkClick: handleRecentWorkLinkClick
    }) : null;
    const profileHeader = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        space: "space.075",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                spread: "space-between",
                alignBlock: "start",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: isDeactivated ? $ceb1b60f3799900e$var$styles.deactivatedAvatar : undefined,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                            src: avatarUrl ?? undefined,
                            name: name,
                            size: "xlarge",
                            testId: getTestId('avatar')
                        })
                    }),
                    !isReduced && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d60be53616d0626a$export$223875819fd7cf93), {
                        profileData: profileData,
                        cloudId: cloudId,
                        canViewProfile: canViewProfile,
                        actions: actions,
                        viewerId: viewerId,
                        isDeactivated: isDeactivated
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        space: "space.100",
                        alignBlock: "end",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                                as: "h2",
                                size: "medium",
                                testId: getTestId('name'),
                                children: name
                            }),
                            pronouns && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                color: "color.text.subtlest",
                                testId: getTestId('pronouns'),
                                children: pronouns
                            })
                        ]
                    }),
                    subtitle && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        maxLines: 1,
                        color: "color.text.subtlest",
                        testId: getTestId('subtitle'),
                        children: subtitle
                    }),
                    locationLine && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        maxLines: 1,
                        color: "color.text.subtlest",
                        testId: getTestId('location'),
                        children: locationLine
                    }),
                    !isDeactivated && email && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ee59531fc0307eed$export$a46750d033a321b6), {
                        email: email,
                        hideCopyButton: isReduced
                    }),
                    isDeactivated && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dc4ce11f77a04115$export$3b55902e173dd56e), {})
                    })
                ]
            })
        ]
    });
    const managerSection = !isDeactivated && manager ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cd67a816341628e9$export$2992b481dad9fb03), {
        manager: manager,
        nonInteractive: isReduced
    }) : null;
    const mainColumn = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        space: "space.150",
        children: [
            profileHeader,
            managerSection,
            !isDeactivated && !isReduced && recentWorkPanel
        ]
    });
    const content = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $ceb1b60f3799900e$var$styles.root,
        testId: testId,
        role: "region",
        "aria-label": name,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dinVW.Stack), {
            space: "space.150",
            testId: "profilecard",
            children: useSlider ? /*#__PURE__*/ (0, $8aG6j.jsx)($ceb1b60f3799900e$var$ReportingLineSliderBody, {
                front: mainColumn,
                renderBack: ({ back: back, headingRef: headingRef, resetToken: resetToken })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $640c1c7a91167409$export$c0554440016547ea), {
                        hierarchyData: hierarchyData,
                        viewFullUrl: profileHref,
                        target: profileTarget,
                        onNavigate: onProfileNavigate,
                        onViewFullClick: handleViewFullReportingLineClick,
                        onBack: back,
                        headingRef: headingRef,
                        resetToken: resetToken,
                        testId: getTestId('reporting-line')
                    }),
                testId: getTestId('slider')
            }) : mainColumn
        })
    });
    if (!useSlider) return content;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c676cd3726aaef40$export$da08d35d50ddd6ca), {
        onView: handleViewReportingLine,
        onBack: handleBackToProfile,
        children: content
    });
}
/**
 * Renders the two-pane reporting-line viewport, reading the shared slide state (toggled by the
 * trigger on the Manager row) from {@link ProfileCardSliderContext}.
 */ function $ceb1b60f3799900e$var$ReportingLineSliderBody({ front: front, renderBack: renderBack, testId: testId }) {
    const slider = (0, $edc2d3ea5f2e6444$export$9219018d2db07e72)();
    if (!slider) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c676cd3726aaef40$export$128359470049ac91), {
        front: front,
        back: ({ back: back, headingRef: headingRef })=>renderBack({
                back: back,
                headingRef: headingRef,
                resetToken: slider.resetToken
            }),
        showBack: slider.showBack,
        onBack: slider.onBack,
        backPaneId: slider.backPaneId,
        testId: testId
    });
}


/**
 * Derives a canonical URL for a recent-activity object, covering every
 * URL-bearing activity type returned by the full profile-page query.
 * Returns a single-element array (for `flatMap`) or an empty array when the
 * object type has no resolvable URL.
 */ function $12851398953afe33$var$extractActivityUrl(objectData) {
    if (!objectData) return [];
    switch(objectData.__typename){
        case 'ConfluencePage':
        case 'ConfluenceBlogPost':
        case 'ConfluenceWhiteboard':
        case 'ConfluenceDatabase':
        case 'ConfluenceEmbed':
        case 'ConfluenceFooterComment':
        case 'ConfluenceInlineComment':
            return objectData.links?.base && objectData.links?.webUi ? [
                `${objectData.links.base}${objectData.links.webUi}`
            ] : [];
        case 'JiraIssue':
        case 'JiraPlatformComment':
        case 'JiraServiceManagementComment':
        case 'DevOpsDocument':
        case 'DevOpsDesign':
            return objectData.webUrl ? [
                objectData.webUrl
            ] : [];
        case 'TrelloBoard':
        case 'TrelloCard':
            return objectData.trelloUrl ? [
                objectData.trelloUrl
            ] : [];
        case 'TownsquareGoal':
        case 'TownsquareProject':
        case 'TownsquareComment':
        case 'ExternalDocument':
        case 'DevOpsPullRequestDetails':
        case 'ExternalPullRequest':
        case 'ExternalRemoteLink':
        case 'MercuryFocusArea':
        case 'MercuryPortfolio':
        case 'RadarPosition':
        case 'RadarView':
        case 'CompassComponent':
            return objectData.url ? [
                objectData.url
            ] : [];
        case 'BitbucketPullRequest':
            return objectData.href ? [
                objectData.href
            ] : [];
        case 'LoomVideo':
            return objectData.loomUrl ? [
                objectData.loomUrl
            ] : [];
        case 'AssetsObject':
        case 'AssetsObjectType':
        case 'AssetsSchema':
            return objectData.links?.web ? [
                objectData.links.web
            ] : [];
        default:
            return [];
    }
}
/**
 * Computes the de-duplication key for a recent-activity object, mirroring the
 * full profile page's `deduplicateId` behaviour:
 * - Confluence comments de-duplicate on their container (page/blog/whiteboard),
 *   so multiple comments on the same page collapse to a single entry
 *   (equivalent to `deduplicateId: ['container.id']`).
 * - Jira comments de-duplicate on their parent issue
 *   (equivalent to `deduplicateId: ['issue.id']`).
 * - Everything else de-duplicates on its own URL
 *   (equivalent to `deduplicateId: ['objectId']`).
 *
 * Falls back to the object's own URL when the container/issue is unavailable.
 */ function $12851398953afe33$var$getActivityDedupeKey(objectData) {
    const ownUrl = $12851398953afe33$var$extractActivityUrl(objectData)[0] ?? '';
    if (!objectData) return ownUrl;
    switch(objectData.__typename){
        case 'ConfluenceFooterComment':
        case 'ConfluenceInlineComment':
            {
                const container = objectData.container;
                const containerUrl = container && 'links' in container && container.links?.base && container.links?.webUi ? `${container.links.base}${container.links.webUi}` : '';
                return containerUrl || ownUrl;
            }
        case 'JiraPlatformComment':
        case 'JiraServiceManagementComment':
            return objectData.issue?.webUrl || ownUrl;
        default:
            return ownUrl;
    }
}
const $12851398953afe33$var$RECENT_WORK_LINK_LIMIT = 3;
/**
 * How many activity entries to request. The card shows at most three links, but entries are
 * dropped before that: types with no resolvable URL, and comments that collapse onto their
 * container. The default over-fetches heavily to survive that; the smaller size trades some of
 * that headroom for a much cheaper request on a surface that fires on hover.
 */ function $12851398953afe33$var$getRecentWorkPageSize() {
    return (0, $iDrrr.fg)('ptc_user_profile_card_reduce_activity_traffic') ? 15 : 50;
}
/**
 * Picks up to `limit` links spread across products instead of taking the most recent few, which a
 * single busy product (a Jira-heavy week, say) would otherwise fill on its own. Products are
 * visited in order of their most recent activity, taking one link each per pass, so the first pick
 * is still the single most recent item.
 */ function $12851398953afe33$var$pickDiverseLinks(candidates, limit) {
    const urlsByProduct = new Map();
    for (const candidate of candidates){
        const existing = urlsByProduct.get(candidate.product);
        if (existing) existing.push(candidate.url);
        else urlsByProduct.set(candidate.product, [
            candidate.url
        ]);
    }
    const queues = Array.from(urlsByProduct.values());
    const picked = [];
    while(picked.length < limit && queues.some((queue)=>queue.length > 0))for (const queue of queues){
        const url = queue.shift();
        if (url) picked.push(url);
        if (picked.length === limit) break;
    }
    return picked;
}
/**
 * Maps a knowledge-discovery reporting-line person into the card's `HierarchyPerson`, or `null` when
 * the entry has no account identifier (unusable for rendering/keys).
 */ function $12851398953afe33$var$mapHierarchyPerson(person) {
    if (!person?.accountIdentifier) return null;
    return {
        accountId: person.accountIdentifier,
        name: person.pii?.name ?? '',
        avatarUrl: person.pii?.picture ?? null,
        jobTitle: person.pii?.extendedProfile?.jobTitle ?? null,
        numberOfDirectReports: person.numberOfDirectReports ?? undefined,
        numberOfTotalReports: person.numberOfTotalReports ?? undefined
    };
}
/** Maps a reporting-line person list to `HierarchyPerson`, dropping entries without an account id. */ function $12851398953afe33$var$mapPeople(people) {
    return (people ?? []).map($12851398953afe33$var$mapHierarchyPerson).filter((person)=>person !== null);
}
/**
 * Builds the full site ARI that `reportingLines(siteId:)` requires (it needs an ARI, not the raw
 * cloudId). Returns `''` when the cloudId is missing.
 */ function $12851398953afe33$var$buildSiteAri(cloudId) {
    return cloudId ? (0, $5PJPG.PlatformSiteAri).create({
        siteId: cloudId
    }).toString() : '';
}
/**
 * Renders a user profile card from a Relay fragment.
 *
 * The fragment is colocated: it contains the user's base profile (name, avatar,
 * email, extendedProfile) and the supplemental data (manager, third-party
 * integrations, recent work) in one spread, so everything fetches in a single
 * round-trip.
 *
 * Recent-work previews need a `SmartCardProvider` from `@atlaskit/link-provider`
 * in scope. Atlassian product shells provide this by default.
 *
 * @example
 * ```tsx
 * const data = useLazyLoadQuery<MyQuery>(
 *   graphql`
 *     query MyQuery($userId: ID!, $cloudId: String!, $orgId: String!, $viewerId: String!) {
 *       ...UserProfileCardRelay_query @arguments(
 *         userId: $userId, cloudId: $cloudId, orgId: $orgId, viewerId: $viewerId
 *       )
 *     }
 *   `,
 *   buildQueryVariables({ userId, cloudId, orgId, viewerId }),
 * );
 * return <UserProfileCardRelay queryFragment={data} cloudId={cloudId} />;
 * ```
 */ function $12851398953afe33$export$8d4b90914bf8e85e({ queryFragment: queryFragment, cloudId: cloudId, testId: testId, isLoading: isLoading, agent: agent, actions: actions, viewerId: viewerId, prefilledProfileData: prefilledProfileData, customerCardDataLoader: customerCardDataLoader, isReduced: isReduced }) {
    const data = (0, $6SsN4.useFragment)((0, $fc0ddde612e6bc48$export$2e2bcd8739ae039), queryFragment);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($12851398953afe33$var$UserProfileCardRelayContent, {
        data: data,
        cloudId: cloudId,
        testId: testId,
        isLoading: isLoading,
        agent: agent,
        actions: actions,
        viewerId: viewerId,
        prefilledProfileData: prefilledProfileData,
        customerCardDataLoader: customerCardDataLoader,
        isReduced: isReduced
    });
}
function $12851398953afe33$var$UserProfileCardRelayContent({ data: data, cloudId: cloudId, testId: testId, isLoading: isLoading, agent: agent = {}, actions: actions, viewerId: viewerId, prefilledProfileData: prefilledProfileData, customerCardDataLoader: customerCardDataLoader, isReduced: isReduced }) {
    const user = data.user;
    const accountId = user?.accountId ?? '';
    const [customerProfileData, setCustomerProfileData] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!accountId || user?.__typename !== 'CustomerUser' || user.email || !customerCardDataLoader) return;
        let isCurrent = true;
        Promise.resolve().then(()=>customerCardDataLoader(cloudId, accountId)).then((profileData)=>{
            if (isCurrent) setCustomerProfileData({
                accountId: accountId,
                profileData: profileData
            });
        }).catch(()=>undefined);
        return ()=>{
            isCurrent = false;
        };
    }, [
        accountId,
        cloudId,
        customerCardDataLoader,
        user?.__typename,
        user?.email
    ]);
    const fallbackProfileData = customerProfileData?.accountId === accountId ? customerProfileData.profileData : undefined;
    const rawSingleUser = data.knowledgeDiscovery?.singleUser;
    const knowledgeSingleUser = rawSingleUser && 'user' in rawSingleUser ? rawSingleUser : null;
    const rawManager = knowledgeSingleUser?.user?.manager;
    const rawReportingLines = data.knowledgeDiscovery?.reportingLines;
    const hierarchyData = (0, $cozmU.useMemo)(()=>{
        if (!rawReportingLines || !('user' in rawReportingLines)) return undefined;
        const hierarchyUser = $12851398953afe33$var$mapHierarchyPerson(rawReportingLines.user);
        if (!hierarchyUser) return undefined;
        const managers = $12851398953afe33$var$mapPeople(rawReportingLines.managers);
        const reports = $12851398953afe33$var$mapPeople(rawReportingLines.reports);
        return {
            user: hierarchyUser,
            managers: managers.length ? managers : undefined,
            reports: reports.length ? reports : undefined
        };
    }, [
        rawReportingLines
    ]);
    const recentWorkData = (0, $cozmU.useMemo)(()=>{
        const edges = data.activity?.workedOn?.edges ?? [];
        // De-duplicate by the profile page's `deduplicateId` key (comments collapse
        // onto their container/issue), keeping the first occurrence, then resolve
        // each survivor to its display URL.
        const seenKeys = new Set();
        const candidates = [];
        for (const edge of edges){
            const activityObject = edge?.node?.object;
            const displayUrl = $12851398953afe33$var$extractActivityUrl(activityObject?.data)[0];
            if (!displayUrl) continue;
            const dedupeKey = $12851398953afe33$var$getActivityDedupeKey(activityObject?.data);
            if (seenKeys.has(dedupeKey)) continue;
            seenKeys.add(dedupeKey);
            candidates.push({
                product: activityObject?.product ?? '',
                url: displayUrl
            });
        }
        const urls = (0, $iDrrr.fg)('ptc_user_profile_card_reduce_activity_traffic') ? $12851398953afe33$var$pickDiverseLinks(candidates, $12851398953afe33$var$RECENT_WORK_LINK_LIMIT) : candidates.slice(0, $12851398953afe33$var$RECENT_WORK_LINK_LIMIT).map((candidate)=>candidate.url);
        return urls.length ? urls : undefined;
    }, [
        data.activity?.workedOn?.edges
    ]);
    const appType = user && 'appType' in user ? user.appType : null;
    const isAgent = typeof appType === 'string' && appType.toLowerCase() === 'agent';
    const profileData = (0, $cozmU.useMemo)(()=>{
        if (!user || isAgent) return null;
        const knowledge = knowledgeSingleUser?.user;
        const manager = rawManager?.id ? {
            id: rawManager.id,
            name: rawManager.name,
            avatarUrl: rawManager.picture,
            jobTitle: rawManager.jobTitle
        } : null;
        const thirdPartyIntegrations = knowledge?.thirdPartyIntegrations?.filter((integration)=>Boolean(integration?.externalId && integration?.integrationId && integration?.product)).map((integration)=>({
                externalId: integration.externalId,
                integrationId: integration.integrationId,
                product: integration.product
            }));
        return {
            accountId: user.accountId,
            accountStatus: user.accountStatus ?? fallbackProfileData?.accountStatus,
            name: user.name ?? fallbackProfileData?.name ?? '',
            pronouns: fallbackProfileData?.pronouns,
            avatarUrl: user.picture ?? fallbackProfileData?.avatarUrl,
            email: user.email || fallbackProfileData?.email,
            jobTitle: user.extendedProfile?.jobTitle ?? fallbackProfileData?.jobTitle,
            department: user.extendedProfile?.department ?? fallbackProfileData?.department,
            location: user.extendedProfile?.location ?? fallbackProfileData?.location,
            localTime: fallbackProfileData?.localTime,
            organization: user.extendedProfile?.organization ?? fallbackProfileData?.organization,
            manager: manager ?? fallbackProfileData?.manager ?? null,
            thirdPartyIntegrations: thirdPartyIntegrations?.length ? thirdPartyIntegrations : fallbackProfileData?.thirdPartyIntegrations ?? null
        };
    }, [
        user,
        isAgent,
        knowledgeSingleUser,
        rawManager,
        fallbackProfileData
    ]);
    if (!accountId) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3Z1Pc.CardError), {
        testId: testId
    });
    if (isAgent) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dt88A.AgentCard), {
        ...agent,
        accountId: accountId,
        cloudId: cloudId,
        resourceClient: agent.resourceClient
    });
    const displayedProfileData = isLoading && prefilledProfileData ? prefilledProfileData : profileData;
    if (!displayedProfileData) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3Z1Pc.CardError), {
        testId: testId
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d35qR.CardPopupWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ceb1b60f3799900e$export$7bf40cd2a197df2d), {
            cloudId: cloudId,
            testId: testId,
            isLoading: isLoading,
            profileData: displayedProfileData,
            canViewProfile: user?.__typename !== 'CustomerUser',
            recentWorkData: recentWorkData,
            hierarchyData: hierarchyData,
            actions: actions,
            viewerId: viewerId,
            isReduced: isReduced
        })
    });
}
function $12851398953afe33$export$9a3cee82e7cc08ff({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, isReduced: isReduced }) {
    const skipKnowledgeDiscovery = !cloudId || !orgId || !viewerId;
    const siteAri = $12851398953afe33$var$buildSiteAri(cloudId);
    const skipReportingLines = skipKnowledgeDiscovery || !siteAri;
    // The reduced card never renders the recent-activity panel, so don't fetch it.
    const skipActivity = !!isReduced;
    const isUserAri = (0, $2khPJ.IdentityUserAri).check(userId);
    const accountId = isUserAri && (0, $iDrrr.fg)('ptc_user_profile_card_normalize_user_ari') ? (0, $2khPJ.IdentityUserAri).parse(userId).userId : userId;
    return {
        userId: accountId,
        userIdString: accountId,
        cloudId: cloudId ?? '',
        orgId: orgId ?? '',
        viewerId: viewerId ?? '',
        siteAri: siteAri,
        userAri: isUserAri ? userId : (0, $2khPJ.IdentityUserAri).create({
            userId: userId
        }).toString(),
        skipKnowledgeDiscovery: skipKnowledgeDiscovery,
        skipReportingLines: skipReportingLines,
        skipActivity: skipActivity,
        collabContextId: cloudId ? (0, $5PJPG.PlatformSiteAri).create({
            siteId: cloudId
        }).toString() : null,
        activityFirst: $12851398953afe33$var$getRecentWorkPageSize()
    };
}
module.exports["UserProfileCardRelay"] = $12851398953afe33$export$8d4b90914bf8e85e;
module.exports["buildQueryVariables"] = $12851398953afe33$export$9a3cee82e7cc08ff;

});

parcelRegister("dt88A", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $9DHhW = parcelRequire("9DHhW");


var $iDrrr = parcelRequire("iDrrr");


var $4PAHv = parcelRequire("4PAHv");


var $3jT9F = parcelRequire("3jT9F");


var $bPFqZ = parcelRequire("bPFqZ");


var $c4fg0 = parcelRequire("c4fg0");


var $2bKeO = parcelRequire("2bKeO");

function $39b35634554d0ec8$var$AgentCardRelay({ accountId: accountId, cloudId: cloudId, hideStarButton: hideStarButton, hideConversationStarters: hideConversationStarters, onChatClick: onChatClick, onConversationStartersClick: onConversationStartersClick, onViewProfile: onViewProfile, onDuplicate: onDuplicate, onCopyLink: onCopyLink, onEdit: onEdit, onDeleteAgent: onDeleteAgent, renderCTA: renderCTA, slots: slots, renderMoreActions: renderMoreActions }) {
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const entryPoint = (0, $iDrrr.fg)('rovo_agent_profile_card_browse_kit') ? (0, $2bKeO.agentProfileCardEntryPoint) : (0, $3jT9F.agentProfileCardEntryPoint);
    const fallback = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c4fg0.AgentCardLoading), {});
    const entryPointReference = (0, $cozmU.useMemo)(()=>(0, $6SsN4.loadEntryPoint)({
            getEnvironment: ()=>environment
        }, entryPoint, {
            identityAccountId: accountId,
            cloudId: cloudId
        }), [
        accountId,
        cloudId,
        environment,
        entryPoint
    ]);
    const handleConversationStarterClick = (0, $cozmU.useMemo)(()=>(prompt)=>onConversationStartersClick?.({
                message: prompt,
                type: 'static'
            }), [
        onConversationStartersClick
    ]);
    const handleDelete = (0, $cozmU.useMemo)(()=>onDeleteAgent ? (agentId)=>{
            onDeleteAgent(agentId);
        } : undefined, [
        onDeleteAgent
    ]);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            action: 'mounted',
            actionSubject: 'agentCardRelay',
            eventType: 'operational',
            attributes: {
                source: 'agentCard'
            }
        }).fire();
        return ()=>{
            entryPointReference.dispose?.();
        };
    }, [
        entryPointReference,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: fallback,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bPFqZ.InternalEntryPointContainer), {
            id: "agent-profile-card",
            entryPointReference: entryPointReference,
            runtimeProps: {
                cloudId: cloudId,
                identityAccountId: accountId,
                hideStarButton: hideStarButton,
                hideConversationStarters: hideConversationStarters,
                onChatClick: onChatClick,
                onConversationStarterClick: handleConversationStarterClick,
                onViewProfile: onViewProfile,
                onDuplicate: onDuplicate,
                onCopyLink: onCopyLink,
                onEdit: onEdit,
                onDelete: handleDelete,
                renderCTA: renderCTA,
                slots: slots,
                renderMoreActions: renderMoreActions
            },
            fallback: fallback
        })
    });
}
function $39b35634554d0ec8$export$4bb3d93416a668a2(props) {
    if ((0, $iDrrr.fg)('rovo_agent_profile_card_browse_kit') || (0, $iDrrr.fg)('rovo_agent_profile_card_relay')) return /*#__PURE__*/ (0, $8aG6j.jsx)($39b35634554d0ec8$var$AgentCardRelay, {
        ...props
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4PAHv.AgentProfileCardResourced), {
        ...props
    });
}
module.exports["AgentCard"] = $39b35634554d0ec8$export$4bb3d93416a668a2;

});

parcelRegister("3jT9F", function(module, exports) {

var $1dSeV = parcelRequire("1dSeV");


var $7qZTr = parcelRequire("7qZTr");


var $ONTtp = parcelRequire("ONTtp");


var $3P7Ao = parcelRequire("3P7Ao");

function $13071ff81ef7f67c$var$resolveQueryVariables(params) {
    if ('identityAccountId' in params) {
        const identityAccountId = params.identityAccountId.startsWith('ari:cloud:identity::user/') ? params.identityAccountId : `ari:cloud:identity::user/${params.identityAccountId}`;
        return {
            agentAri: '',
            identityAccountId: identityAccountId,
            cloudId: params.cloudId,
            fetchByIdentity: true
        };
    }
    const agentAri = 'agentAri' in params ? params.agentAri : (0, $1dSeV.RovoAgentAri).create({
        activationId: params.activationId,
        agentId: params.agentId
    }).toString();
    return {
        agentAri: agentAri,
        identityAccountId: '',
        cloudId: '',
        fetchByIdentity: false
    };
}

const $13071ff81ef7f67c$export$cf39f5e5e131a6dd = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("67v39")), {
        moduleId: "dc6e5a58",
        moduleName: "AgentProfileCardContainer",
        priority: "interaction",
        moduleId: 'conversation-assistant-agent_agent-profile-card'
    }),
    getPreloadProps: (params)=>{
        const queryVariables = $13071ff81ef7f67c$var$resolveQueryVariables(params);
        return {
            queries: {
                agentProfileCardQuery: {
                    parameters: (0, $3P7Ao.default),
                    variables: queryVariables,
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});
module.exports["agentProfileCardEntryPoint"] = $13071ff81ef7f67c$export$cf39f5e5e131a6dd;

});

parcelRegister("3P7Ao", function(module, exports) {
/**
 * @generated SignedSource<<f06be0e373134095d73ae5809ea9549c>>
 * @relayHash ba360df9c813e3e6d558edc184fb409f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5bd439fe175f7e5700875f28bf1ecf25bf72ddba2d24d6f059da29f930c75cc2
const $cfa90136d687f07f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "agentAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fetchByIdentity"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "identityAccountId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "agentAri"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = [
        v5 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                {
                    "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "AgentProfileCard_agentRef"
                            }
                        ],
                        "type": "AgentStudioAssistant"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "AgentProfileCard_agentRef"
                }
            ],
            "type": "AgentStudioAssistant"
        }
    ], v9 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "identityAccountId"
        }
    ], v10 = [
        v5 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "description"
                },
                {
                    "kind": "ScalarField",
                    "name": "icon"
                },
                {
                    "kind": "ScalarField",
                    "name": "identityAccountId"
                },
                {
                    "kind": "LinkedField",
                    "name": "identityAccount",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "externalConfigReference"
                },
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                },
                {
                    "kind": "ScalarField",
                    "name": "conversationStarters"
                },
                {
                    "kind": "ScalarField",
                    "name": "creatorType"
                },
                {
                    "kind": "ScalarField",
                    "name": "forgeCreator"
                },
                {
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accountStatus"
                                }
                            ],
                            "type": "AtlassianAccountUser"
                        },
                        v6 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "authoringTeam",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "profileUrl"
                        },
                        v6 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "AgentStudioAgentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "canEdit"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canDelete"
                        }
                    ]
                }
            ],
            "type": "AgentStudioAssistant"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v6 /*: any*/ 
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AgentProfileCardContainerQuery",
            "selections": [
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentByIdentityAccountId",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "AgentProfileCardContainerQuery",
            "selections": [
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentByIdentityAccountId",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5bd439fe175f7e5700875f28bf1ecf25bf72ddba2d24d6f059da29f930c75cc2",
            "metadata": {},
            "name": "AgentProfileCardContainerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$cfa90136d687f07f$var$node.hash = "7f56b7d6645b9220c953a6792948a3ba";
var $cfa90136d687f07f$export$2e2bcd8739ae039 = $cfa90136d687f07f$var$node;
module.exports["default"] = $cfa90136d687f07f$export$2e2bcd8739ae039;

});

parcelRegister("67v39", function(module, exports) {

let $474b7b60676c31c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $474b7b60676c31c9$var$load("g2ITt"),
    $474b7b60676c31c9$var$load("cN2rp"),
    $474b7b60676c31c9$var$load("5gsbh"),
    $474b7b60676c31c9$var$load("fEvpQ"),
    $474b7b60676c31c9$var$load("6wr18"),
    $474b7b60676c31c9$var$load("1cQg7"),
    $474b7b60676c31c9$var$load("iYJZz"),
    $474b7b60676c31c9$var$load("7EorR"),
    $474b7b60676c31c9$var$load("jqoep"),
    $474b7b60676c31c9$var$load("VXbA1"),
    $474b7b60676c31c9$var$load("ffEVr"),
    $474b7b60676c31c9$var$load("hhss7"),
    $474b7b60676c31c9$var$load("8jBNC")
]).then(()=>parcelRequire('kzpDl'));

});

parcelRegister("fWkhK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");

const $fd925b40062fea78$var$styles = {
    cardDefiniteWidth: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _39xV029zBZ _0KLXruoI2d",
    body: "_0Of8r2Va5s _2Zuz6Q5zaO _1Znuxb5zaO _1wydGW5zaO"
};
const $fd925b40062fea78$export$406245d651cacfa7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "96px",
            borderRadius: 0
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fd925b40062fea78$var$styles.cardDefiniteWidth
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $fd925b40062fea78$var$styles.body,
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "160px",
            height: "20px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "120px",
            height: "16px"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "48px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "32px"
        })));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fd925b40062fea78$var$styles.cardDefiniteWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "96px",
        borderRadius: 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $fd925b40062fea78$var$styles.body,
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "160px",
        height: "20px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "120px",
        height: "16px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "48px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "32px"
    })));
};
module.exports["AgentProfileCardSkeleton"] = $fd925b40062fea78$export$406245d651cacfa7;

});

parcelRegister("jJ1KU", function(module, exports) {
/* AgentCardSkeleton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $eFbDl = parcelRequire("eFbDl");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $8bAf2 = parcelRequire("8bAf2");


var $dv8iP = parcelRequire("dv8iP");


var $4ACma = parcelRequire("4ACma");


var $jd7zX = parcelRequire("jd7zX");

const $82453c12379c0b8d$var$styles = {
    loadingContent: "_1xC2CJa6YE _4xdlr07p2s _4ouGXIdnbC",
    titleLine: "_3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VoWWg",
    textLine: "_3iDTPbQ4SZ _0hPCNLDIqT _0jFU0Vey7F",
    root: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDyzSk _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _24h04i2Njc _0jFU0VN91d _39xV02N91d _0KLXrulfZc _3iDTPbgBM8 _2iEGP28wUV _0ca6V7uqJ7 _3NN0tObcaY _42d1HA8HPE",
    cover: "_1xC2CJiObl _1mT5xdRAKS _39xV02N91d _0jFU0VmdCj",
    coverBackground: "_1mT5xdWVPG _2I62gzPgdg _1ZB6Uy5zaO _3iC0zdPgdg _1OKFqYPgdg",
    coverForeground: "_1mT5xdRAKS _42Yu6B7dHp _24h04i2Njc _3iDTPbgBM8 _39xV02N91d _0jFU0VN91d _2iEGP2cMcx _0GwItXDIqT _0hPCNLDIqT _0Of8r2kG2W _1Znuxb5zaO _2Zuz6Q5zaO",
    content: "_1xC2CJa6YE _4ouGXIdnbC _1Znuxb5zaO _2Zuz6Q5zaO",
    metadata: "_1xC2CJphCm _4ouGXIdnbC _313842IZbP _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO"
};
const $82453c12379c0b8d$var$LoadingAvatar = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $dv8iP.CardAvatarFrame), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eFbDl.default), {
            size: "xlarge",
            appearance: "hexagon",
            color: "var(--ds-text, #292A2E)"
        })
    });
const $82453c12379c0b8d$export$4f536719d096d4ec = ({ testId: testId })=>{
    if ((0, $iDrrr.fg)('rovo_agents_studio_browse_kit_uplift')) return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8bAf2.Card), {
        "aria-hidden": "true",
        hasCutout: true,
        isDisabled: true,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ACma.CardCover), {
                name: "",
                avatar: $82453c12379c0b8d$var$LoadingAvatar,
                coverStyle: "plain",
                testId: testId ? `${testId}--cover` : undefined
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                xcss: $82453c12379c0b8d$var$styles.loadingContent,
                space: "space.150",
                testId: testId ? `${testId}--content` : undefined,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $82453c12379c0b8d$var$styles.titleLine,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: "70%",
                                    height: 16
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $82453c12379c0b8d$var$styles.textLine,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: "45%",
                                    height: 12
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $82453c12379c0b8d$var$styles.textLine,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: "100%",
                                    height: 12
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $82453c12379c0b8d$var$styles.textLine,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: "80%",
                                    height: 12
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $jd7zX.CardFooter), {
                testId: testId ? `${testId}--footer` : undefined,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                        width: 24,
                        height: 24,
                        borderRadius: "var(--ds-radius-medium, 6px)"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                        width: 24,
                        height: 24,
                        borderRadius: "var(--ds-radius-medium, 6px)"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: $82453c12379c0b8d$var$styles.root,
        "aria-hidden": "true",
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                xcss: $82453c12379c0b8d$var$styles.cover,
                testId: testId ? `${testId}--cover` : undefined,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $82453c12379c0b8d$var$styles.coverBackground,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                            width: "100%",
                            height: "100%",
                            borderRadius: 0,
                            isShimmering: true
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $82453c12379c0b8d$var$styles.coverForeground,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                            width: 32,
                            height: 32,
                            isShimmering: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $82453c12379c0b8d$var$styles.content,
                testId: testId ? `${testId}--content` : undefined,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                    space: "space.075",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                            space: "space.075",
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: 112,
                                    height: 20,
                                    isShimmering: true
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: 16,
                                    height: 16,
                                    isShimmering: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dinVW.Stack), {
                            space: "space.025",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                width: "100%",
                                height: 16,
                                isShimmering: true
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $82453c12379c0b8d$var$styles.metadata,
                testId: testId ? `${testId}--metadata` : undefined,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                    space: "space.075",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                            width: 72,
                            height: 16,
                            isShimmering: true
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                            width: 16,
                            height: 16,
                            isShimmering: true
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                            width: 32,
                            height: 16,
                            isShimmering: true
                        })
                    ]
                })
            })
        ]
    });
};
module.exports["AgentCardSkeleton"] = $82453c12379c0b8d$export$4f536719d096d4ec;

});

parcelRegister("8bAf2", function(module, exports) {
/* Card.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");

/* Card.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $cozmU = parcelRequire("cozmU");









var $dinVW = parcelRequire("dinVW");

const $375f08866154a5dc$var$styles = {
    card: "_0bjKvDyzSk _23rrnHcvle _1mT5xdRAKS _0KLXrulfZc _0jFU0VN91d",
    interactive: "_3B9ZVQJNoT _2bmPrZzwhj _1eOmH6d1Zr _3fSdSTGk8v _3NJLv8TCo3",
    surface: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _24h04i2Njc _0jFU0VN91d",
    pressable: "_0bjKvDyzSk _1mT5xdWVPG _2I62gzPgdg _1ZB6UyPgdg _3iC0zdPgdg _1OKFqYPgdg _42Yu6BgtVO _0KLXrujOvk",
    content: "_1mT5xdRAKS _0jFU0VN91d _39xV02N91d _3iDTPbgBM8 _2iEGP2IZbP _0ca6V72ulg _3NN0tOmM0j _42d1HA8HPE"
};
const $375f08866154a5dc$export$60332b2344f7fe41 = ({ children: children, ariaLabel: ariaLabel, onClick: onClick, isDisabled: isDisabled = false, testId: testId, xcss: xcss, ...boxProps })=>{
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onClick?.();
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        ...boxProps,
        xcss: (0, $w6R6I.cx)($375f08866154a5dc$var$styles.card, Boolean(onClick) && !isDisabled && $375f08866154a5dc$var$styles.interactive, xcss),
        testId: testId,
        children: [
            onClick ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                xcss: $375f08866154a5dc$var$styles.pressable,
                onClick: handleClick,
                "aria-label": ariaLabel,
                isDisabled: isDisabled,
                "data-card-pressable": true
            }) : null,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $375f08866154a5dc$var$styles.surface,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dinVW.Stack), {
                    xcss: $375f08866154a5dc$var$styles.content,
                    space: "space.200",
                    children: children
                })
            })
        ]
    });
};


const $bf3abfcac1dc716b$var$styles = {
    card: "_0bjKvDyzSk _23rrnH0rAS _1mT5xdRAKS _0jFU0VN91d _4ouGXIPIoL _1EqgXlsz7G _1SdfoHYbGa",
    frame: "_1mT5xdRAKS _0jFU0VN91d",
    cutout: "_3X9j4qseFd _45s7WmbMq5 _4AZChJnPJF _3mXABNXSSG _0A6Iyfk2L1 _2Y5PIXHgVH",
    cutoutShadow: "_0bjKvDS5Zs _1mT5xdWVPG _2I62gz2ADO _3iC0zd715P _1VJPcajssS _39xV02R4us _0jFU0VZimw _2OUyjtKPGx _1pp6NdYbGa",
    interactive: "_3fSdSTGk8v _3NJLv8TCo3 _4eGeXtYbGa",
    pressable: "_0bjKvDyzSk _1mT5xdWVPG _2I62gzPgdg _1ZB6UyPgdg _3iC0zdPgdg _1OKFqYPgdg _42Yu6BgtVO _0KLXrujOvk",
    surface: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _24h04i2Njc _0KLXruqi9L _3iDTPbgBM8 _2iEGP20MSB _0ca6V792QF _3NN0tOO1EA _42d1HA8HPE _0hPCNLF05b _0jFU0VN91d _46hvQm5zaO _0xmtko5zaO _0LQT5E5zaO _03SyCP5zaO"
};
const $bf3abfcac1dc716b$export$60332b2344f7fe41 = ({ xcss: xcss, hasCutout: hasCutout = false, ...props })=>{
    if (!(0, $iDrrr.fg)('rovo_agents_studio_browse_kit_uplift')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $375f08866154a5dc$export$60332b2344f7fe41), {
        ...props,
        xcss: xcss
    });
    const { children: children, ariaLabel: ariaLabel, onClick: onClick, isDisabled: isDisabled = false, testId: testId, ...boxProps } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        ...boxProps,
        xcss: (0, $w6R6I.cx)($bf3abfcac1dc716b$var$styles.card, Boolean(onClick) && !isDisabled && $bf3abfcac1dc716b$var$styles.interactive, xcss),
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($bf3abfcac1dc716b$var$styles.frame, hasCutout && $bf3abfcac1dc716b$var$styles.cutout),
                children: [
                    onClick ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                        xcss: $bf3abfcac1dc716b$var$styles.pressable,
                        onClick: ()=>onClick(),
                        "aria-label": ariaLabel,
                        isDisabled: isDisabled,
                        "data-card-pressable": true
                    }) : null,
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $bf3abfcac1dc716b$var$styles.surface,
                        "data-card-surface": true,
                        children: children
                    })
                ]
            }),
            hasCutout ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $bf3abfcac1dc716b$var$styles.cutoutShadow,
                "aria-hidden": "true"
            }) : null
        ]
    });
};
module.exports["Card"] = $bf3abfcac1dc716b$export$60332b2344f7fe41;

});

parcelRegister("dv8iP", function(module, exports) {
/* CardAvatarFrame.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");

parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $iMnC5 = parcelRequire("iMnC5");

const $35a62c7d35ac3553$var$styles = {
    frame: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02pJKa _0jFU0VpJKa",
    avatar: "_3YEZNOdnbC _39xV02JgOI _0jFU0VJgOI _1VJPcaFzSL _0yKXXaDIqT",
    hexagon: "_1uo2ZfTcEg"
}; // Compiled supports the child selector needed to size consumer-provided images.
const $35a62c7d35ac3553$var$imageStyles = null;
const $35a62c7d35ac3553$export$34c21c6cf8773dae = ({ children: children, name: name, isHexagon: isHexagon = false })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $35a62c7d35ac3553$var$styles.frame,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                $35a62c7d35ac3553$var$styles.avatar,
                "_3Uxj39vLZJ _1f4A43N91d _2nmIiEN91d _3XtUJZiObl _0NjqGzDIqT",
                isHexagon && $35a62c7d35ac3553$var$styles.hexagon
            ]),
            children: children ?? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                name: name,
                appearance: isHexagon ? 'hexagon' : 'circle',
                size: "xlarge"
            })
        })
    });
module.exports["CardAvatarFrame"] = $35a62c7d35ac3553$export$34c21c6cf8773dae;

});

parcelRegister("4ACma", function(module, exports) {
/* CardCover.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $w6R6I = parcelRequire("w6R6I");


var $cJ0FD = parcelRequire("cJ0FD");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $dv8iP = parcelRequire("dv8iP");

/* CardCover.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");










const $73f1c039e15f14b8$var$DEFAULT_COVER_COLOR = "var(--ds-background-accent-green-subtlest, #DCFFF1)";
const $73f1c039e15f14b8$var$DEFAULT_GRID_LINE = "var(--ds-border, #0B120E24)";
const $73f1c039e15f14b8$var$DEFAULT_GRID_LINE_WIDTH = '0.3px';
const $73f1c039e15f14b8$var$BACKGROUND_STYLES = {
    grid: `linear-gradient(${$73f1c039e15f14b8$var$DEFAULT_GRID_LINE} ${$73f1c039e15f14b8$var$DEFAULT_GRID_LINE_WIDTH}, transparent ${$73f1c039e15f14b8$var$DEFAULT_GRID_LINE_WIDTH}), linear-gradient(90deg, ${$73f1c039e15f14b8$var$DEFAULT_GRID_LINE} ${$73f1c039e15f14b8$var$DEFAULT_GRID_LINE_WIDTH}, transparent ${$73f1c039e15f14b8$var$DEFAULT_GRID_LINE_WIDTH})`,
    gradient: 'linear-gradient(90deg, rgb(255 255 255 / 0.25) 0%, rgb(255 255 255 / 0) 70%)'
};
const $73f1c039e15f14b8$var$styles = {
    root: "_1xC2CJiObl _1mT5xdRAKS _39xV02N91d _0jFU0VmdCj",
    background: "_1mT5xdWVPG _2I62gzPgdg _1ZB6Uy5zaO _3iC0zdPgdg _1OKFqYPgdg _39xV02N91d _0jFU0VIZbP",
    gridBackground: "_3OqcjTWxuo _1DJ2rVphmj",
    plainRoot: "_0jFU0VIZbP",
    plainForeground: "_46hvQm5zaO",
    foreground: "_2Y7lL45zaO _24h04i2Njc _3iDTPbgBM8 _39xV02N91d _0jFU0VN91d _2iEGP2cMcx _0ca6V7IZbP _3NN0tO0GnG _0GwItXDIqT _0hPCNLDIqT _17lj8p2ADO _46hvQmkG2W",
    avatar: "_1xC2CJNoyG _4xdlr0DIqT _2p6ht9DIqT",
    content: "_1xC2CJa6YE _1mT5xdRAKS _42Yu6Bbhqd _2p6ht9F05b _4ouGXIdnbC",
    slot: "_3iDTPbgBM8 _0pI6nMF05b _0hPCNLDIqT",
    layer: "_1xC2CJYhv7"
};
const $73f1c039e15f14b8$var$DefaultAvatar = ({ name: name, iconUrl: iconUrl })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
        name: name,
        src: iconUrl,
        size: "small"
    });
const $73f1c039e15f14b8$export$1a2d6d8c98d2c941 = ({ name: name, avatar: AvatarComponent = $73f1c039e15f14b8$var$DefaultAvatar, coverStyle: coverStyle = 'grid', coverColor: coverColor, children: children, badge: badge, iconUrl: iconUrl, testId: testId })=>{
    const trailing = badge ?? children;
    const overlay = Boolean(badge && children);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($73f1c039e15f14b8$var$styles.root, coverStyle === 'plain' && $73f1c039e15f14b8$var$styles.plainRoot),
        testId: testId,
        children: [
            coverStyle === 'plain' ? null : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($73f1c039e15f14b8$var$styles.background, coverStyle === 'grid' && $73f1c039e15f14b8$var$styles.gridBackground),
                "aria-hidden": "true",
                style: {
                    backgroundColor: coverColor ?? $73f1c039e15f14b8$var$DEFAULT_COVER_COLOR,
                    backgroundImage: $73f1c039e15f14b8$var$BACKGROUND_STYLES[coverStyle]
                }
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($73f1c039e15f14b8$var$styles.foreground, coverStyle === 'plain' && $73f1c039e15f14b8$var$styles.plainForeground),
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $73f1c039e15f14b8$var$styles.avatar,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)(AvatarComponent, {
                            name: name,
                            iconUrl: iconUrl
                        })
                    }),
                    overlay ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                        xcss: (0, $w6R6I.cx)($73f1c039e15f14b8$var$styles.content, $73f1c039e15f14b8$var$styles.slot),
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $73f1c039e15f14b8$var$styles.layer,
                                children: badge
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $73f1c039e15f14b8$var$styles.layer,
                                children: children
                            })
                        ]
                    }) : trailing ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $73f1c039e15f14b8$var$styles.content,
                        children: trailing
                    }) : null
                ]
            })
        ]
    });
};



var $2SgeP = parcelRequire("2SgeP");

const $e26c08d1c8dff3bd$var$styles = {
    cover: "_1xC2CJiObl _0hPCNLDIqT _0pI6nMDIqT _1mT5xdRAKS _3iDTPbgBM8 _42d1HA5zaO _0xmtkoNHnM",
    background: "_1mT5xdWVPG _2I62gzUgYP _1ZB6UyPgdg _3iC0zdUgYP _1OKFqYUgYP _1pp6NdYbGa",
    neutral: "_0KLXrunmFW",
    image: "_1mT5xdWVPG _2I62gzPgdg _3iC0zdPgdg _39xV02N91d _0jFU0VN91d _00EA0eiObl",
    gradient: "_3X9j4qp3mJ",
    cutout: "_0bjKvDS5Zs _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _1mT5xdRAKS _24h04i2Njc _43nrzTB0rP _39xV02UF4f _0jFU0VJg58",
    avatar: "_1mT5xdRAKS _3iDTPbQ4SZ",
    trailing: "_1mT5xdWVPG _2I62gzPgdg _1OKFqYPgdg _42Yu6Bbhqd _3iDTPbgBM8 _0pI6nMF05b _0hPCNLDIqT _1EqgXlN91d",
    layer: "_1xC2CJYhv7"
};
const $e26c08d1c8dff3bd$var$DefaultAvatar = ({ name: name, iconUrl: iconUrl })=>iconUrl ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
        src: iconUrl,
        alt: name,
        width: 48,
        height: 48
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dv8iP.CardAvatarFrame), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
            name: name,
            size: "xlarge"
        })
    });
const $e26c08d1c8dff3bd$export$1a2d6d8c98d2c941 = (props)=>{
    if (!(0, $iDrrr.fg)('rovo_agents_studio_browse_kit_uplift')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $73f1c039e15f14b8$export$1a2d6d8c98d2c941), {
        ...props
    });
    const { name: name, avatar: AvatarComponent = $e26c08d1c8dff3bd$var$DefaultAvatar, coverStyle: coverStyle = 'grid', coverColor: coverColor, coverImageUrl: coverImageUrl, children: children, badge: badge, iconUrl: iconUrl, testId: testId } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: $e26c08d1c8dff3bd$var$styles.cover,
        testId: testId,
        children: [
            (0, $iDrrr.fg)('rovo_agents_studio_browse_kit_cover_image') && coverImageUrl ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($e26c08d1c8dff3bd$var$styles.background, $e26c08d1c8dff3bd$var$styles.neutral),
                style: {
                    backgroundColor: coverColor
                },
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    as: "img",
                    alt: "",
                    src: coverImageUrl,
                    xcss: $e26c08d1c8dff3bd$var$styles.image
                })
            }) : coverStyle !== 'gradient' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($e26c08d1c8dff3bd$var$styles.background, $e26c08d1c8dff3bd$var$styles.neutral),
                "aria-hidden": "true",
                children: coverStyle === 'grid' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2SgeP.CardCoverArtwork), {}) : null
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($e26c08d1c8dff3bd$var$styles.background, $e26c08d1c8dff3bd$var$styles.gradient),
                style: {
                    backgroundColor: coverColor
                },
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $e26c08d1c8dff3bd$var$styles.cutout,
                "data-card-cutout": true,
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $e26c08d1c8dff3bd$var$styles.avatar,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)(AvatarComponent, {
                    name: name,
                    iconUrl: iconUrl
                })
            }),
            badge || children ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                xcss: $e26c08d1c8dff3bd$var$styles.trailing,
                children: [
                    badge ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $e26c08d1c8dff3bd$var$styles.layer,
                        children: badge
                    }) : null,
                    children ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $e26c08d1c8dff3bd$var$styles.layer,
                        children: children
                    }) : null
                ]
            }) : null
        ]
    });
};
module.exports["CardCover"] = $e26c08d1c8dff3bd$export$1a2d6d8c98d2c941;

});

parcelRegister("2SgeP", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $6ebb9aacbc91d412$export$c8a30effa66534ce = ({ appearance: appearance = 'default' })=>{
    const id = (0, $cozmU.useId)();
    const gridId = `${id}-grid`;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: "100%",
        height: "100%",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("defs", {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("pattern", {
                    id: gridId,
                    width: "20",
                    height: "20",
                    patternUnits: "userSpaceOnUse",
                    x: "50%",
                    y: "9",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M 0 1 H 20 M 0 1 V 21",
                        fill: "none",
                        stroke: appearance === 'inverse' ? "var(--ds-border-inverse, #FFFFFF)" : "var(--ds-border-bold, #7D818A)",
                        strokeOpacity: 0.5,
                        strokeWidth: 1.25,
                        strokeDasharray: "0 4",
                        strokeLinecap: "round"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                width: "100%",
                height: "100%",
                fill: `url(#${gridId})`
            })
        ]
    });
};
module.exports["CardCoverArtwork"] = $6ebb9aacbc91d412$export$c8a30effa66534ce;

});

parcelRegister("jd7zX", function(module, exports) {
/* CardFooter.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $1l0kj = parcelRequire("1l0kj");

/* CardFooter.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $b626f27198f7c7ef$var$styles = {
    footer: "_1xC2CJtr1Z _2Y7lL45zaO _1mT5xdRAKS _42Yu6Bbhqd _1pp6NdIZbP _4ouGXIdnbC _1wydGW5zaO"
};
const $b626f27198f7c7ef$export$e9897d434e0741ee = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $b626f27198f7c7ef$var$styles.footer,
        testId: testId,
        children: children
    });


const $bd7467a63557867b$var$styles = {
    footer: "_1xC2CJtr1Z _1mT5xdRAKS _42Yu6Bbhqd _4ouGXIdnbC"
};
const $bd7467a63557867b$export$e9897d434e0741ee = (props)=>{
    if (!(0, $iDrrr.fg)('rovo_agents_studio_browse_kit_uplift')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b626f27198f7c7ef$export$e9897d434e0741ee), {
        ...props
    });
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
        xcss: $bd7467a63557867b$var$styles.footer,
        space: "space.100",
        alignInline: "start",
        alignBlock: "center",
        shouldWrap: true,
        testId: testId,
        children: children
    });
};
module.exports["CardFooter"] = $bd7467a63557867b$export$e9897d434e0741ee;

});

parcelRegister("2bKeO", function(module, exports) {

var $1dSeV = parcelRequire("1dSeV");


var $7qZTr = parcelRequire("7qZTr");


var $ONTtp = parcelRequire("ONTtp");


var $1EUnE = parcelRequire("1EUnE");


const $3a7ad12ffbd4d935$export$cf39f5e5e131a6dd = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("loRSi")).then((module)=>module.AgentProfileCard), {
        moduleId: "a0ccb7dd",
        moduleName: "AgentProfileCard",
        priority: "interaction",
        moduleId: 'agent-profile-card_browse-kit'
    }),
    getPreloadProps: (params)=>{
        const fetchByIdentity = 'identityAccountId' in params;
        const identityAccountId = fetchByIdentity ? params.identityAccountId.startsWith('ari:cloud:identity::user/') ? params.identityAccountId : `ari:cloud:identity::user/${params.identityAccountId}` : '';
        const agentAri = fetchByIdentity ? '' : 'agentAri' in params ? params.agentAri : (0, $1dSeV.RovoAgentAri).create({
            agentId: params.agentId,
            activationId: params.activationId
        }).toString();
        return {
            queries: {
                agentProfileCardQuery: {
                    parameters: (0, $1EUnE.default),
                    variables: {
                        agentAri: agentAri,
                        identityAccountId: identityAccountId,
                        cloudId: fetchByIdentity ? params.cloudId : '',
                        fetchByIdentity: fetchByIdentity
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});
module.exports["agentProfileCardEntryPoint"] = $3a7ad12ffbd4d935$export$cf39f5e5e131a6dd;

});

parcelRegister("1EUnE", function(module, exports) {
/**
 * @generated SignedSource<<84bf4ba09639db99237d89137a02477f>>
 * @relayHash a927de0ec765e23dba1d543e24965073
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 64e256d56df5d7c2723d7002d8836219f0e795e080d865d9e8a8b8724d659c0c
const $eb82cffce767a44e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "agentAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fetchByIdentity"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "identityAccountId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "agentAri"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = [
        {
            "fragment": {
                "kind": "InlineFragment",
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "FragmentSpread",
                        "name": "AgentCardRelay_StudioBrowseKit"
                    }
                ],
                "type": "AgentStudioAssistant"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "agent"
        }
    ], v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "identityAccountId"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = [
        v8 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v5 /*: any*/ ,
                v9 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "description"
                },
                {
                    "kind": "ScalarField",
                    "name": "isVerified"
                },
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                },
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__id"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "icon"
                },
                {
                    "kind": "ScalarField",
                    "name": "externalConfigReference"
                },
                {
                    "kind": "ScalarField",
                    "name": "identityAccountId"
                },
                {
                    "kind": "LinkedField",
                    "name": "identityAccount",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isUser"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appType"
                                }
                            ],
                            "type": "AppUser"
                        },
                        v9 /*: any*/ 
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "creatorType"
                },
                {
                    "kind": "ScalarField",
                    "name": "forgeCreator"
                },
                {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "authoringTeam",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        },
                        v9 /*: any*/ 
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "accountStatus"
                        },
                        v9 /*: any*/ 
                    ]
                }
            ],
            "type": "AgentStudioAssistant"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v9 /*: any*/ 
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AgentProfileCardQuery",
            "selections": [
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": v6 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentByIdentityAccountId",
                            "plural": false,
                            "selections": v6 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "AgentProfileCardQuery",
            "selections": [
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentByIdentityAccountId",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "64e256d56df5d7c2723d7002d8836219f0e795e080d865d9e8a8b8724d659c0c",
            "metadata": {},
            "name": "AgentProfileCardQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$eb82cffce767a44e$var$node.hash = "6bb49a428565993244c38618367b96d4";
var $eb82cffce767a44e$export$2e2bcd8739ae039 = $eb82cffce767a44e$var$node;
module.exports["default"] = $eb82cffce767a44e$export$2e2bcd8739ae039;

});

parcelRegister("loRSi", function(module, exports) {

let $f945a1450aa46c03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f945a1450aa46c03$var$load("g2ITt"),
    $f945a1450aa46c03$var$load("8cMMl"),
    $f945a1450aa46c03$var$load("cN2rp"),
    $f945a1450aa46c03$var$load("6wr18"),
    $f945a1450aa46c03$var$load("cY1aV"),
    $f945a1450aa46c03$var$load("1cQg7"),
    $f945a1450aa46c03$var$load("4aKct"),
    $f945a1450aa46c03$var$load("i10Rb"),
    $f945a1450aa46c03$var$load("ffEVr"),
    $f945a1450aa46c03$var$load("hhss7"),
    $f945a1450aa46c03$var$load("c7hX7")
]).then(()=>parcelRequire('hf1Z9'));

});

parcelRegister("3Z1Pc", function(module, exports) {
/* CardError.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $d35qR = parcelRequire("d35qR");

const $fd4a3a1c380784ee$var$messages = (0, $kSwu1.defineMessages)({
    errorTitle: {
        id: "user-profile-card.error.title",
        defaultMessage: "Something went wrong and we couldn't load this profile."
    },
    errorDescription: {
        id: "user-profile-card.error.description",
        defaultMessage: "Try again in a few moments."
    }
});
const $fd4a3a1c380784ee$var$styles = {
    body: "_0Of8r2NHnM _1wydGWNHnM _2Zuz6QNHnM _1ZnuxbNHnM _2fwxA5DIqT"
}; /**
    * Error fallback when the entry point fails to render or profile data is missing.
    */ 
function $fd4a3a1c380784ee$export$f7f7efdefcc02999({ testId: testId }) {
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d35qR.CardPopupWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            testId: testId,
            role: "alert",
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                space: "space.100",
                xcss: $fd4a3a1c380784ee$var$styles.body,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        weight: "semibold",
                        color: "color.text.subtlest",
                        children: intl.formatMessage($fd4a3a1c380784ee$var$messages.errorTitle)
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        size: "small",
                        color: "color.text.subtlest",
                        children: intl.formatMessage($fd4a3a1c380784ee$var$messages.errorDescription)
                    })
                ]
            })
        })
    });
}
module.exports["CardError"] = $fd4a3a1c380784ee$export$f7f7efdefcc02999;

});

parcelRegister("g0RaX", function(module, exports) {
const $d415e99ed33e2323$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $d415e99ed33e2323$var$performanceAvailable = $d415e99ed33e2323$var$isPerformanceAvailable();
const $d415e99ed33e2323$var$initialPageTime = Date.now();
const $d415e99ed33e2323$export$e9faea7c41053334 = ()=>{
    if ($d415e99ed33e2323$var$performanceAvailable) return performance.now();
    return Date.now() - $d415e99ed33e2323$var$initialPageTime;
};
module.exports["getPageTime"] = $d415e99ed33e2323$export$e9faea7c41053334;

});

parcelRegister("fxdou", function(module, exports) {
/* CardLoading.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $arQY7 = parcelRequire("arQY7");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $a9aSv = parcelRequire("a9aSv");


var $c4fg0 = parcelRequire("c4fg0");


var $kKnPE = parcelRequire("kKnPE");


var $d35qR = parcelRequire("d35qR");

const $c8358ec2650d268a$var$messages = (0, $kSwu1.defineMessages)({
    managerHeading: {
        id: "user-profile-card.CardLoading.managerHeading",
        defaultMessage: "Manager"
    }
});
const $c8358ec2650d268a$var$styles = {
    inner: "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    fill: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
    linkRow: "_0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO",
    managerRow: "_0Of8r2gVvo _1wydGWgVvo _2Zuz6Q2ADO _1Znuxb2ADO"
};
function $c8358ec2650d268a$var$HeaderLoading({ profileData: profileData, isReduced: isReduced = false }) {
    const subtitle = [
        profileData?.jobTitle,
        profileData?.department
    ].filter(Boolean).join(" \u2022 ");
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        space: "space.075",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                spread: "space-between",
                alignBlock: "start",
                children: [
                    profileData?.avatarUrl || profileData?.name ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                        src: profileData.avatarUrl ?? undefined,
                        name: profileData.name,
                        size: "xlarge"
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                        width: "96px",
                        height: "96px",
                        borderRadius: "var(--ds-radius-full, 9999px)"
                    }),
                    !isReduced && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        space: "space.100",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                width: "32px",
                                height: "32px",
                                borderRadius: "var(--ds-radius-medium, 6px)"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                width: "96px",
                                height: "32px",
                                borderRadius: "var(--ds-radius-medium, 6px)"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                width: "32px",
                                height: "32px",
                                borderRadius: "var(--ds-radius-medium, 6px)"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                space: "space.050",
                children: [
                    profileData?.name ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                        as: "h2",
                        size: "medium",
                        children: profileData.name
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                        width: "45%",
                        height: "24px",
                        borderRadius: "var(--ds-radius-small, 4px)"
                    }),
                    subtitle ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        children: subtitle
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                        width: "80%",
                        height: "20px",
                        borderRadius: "var(--ds-radius-small, 4px)"
                    }),
                    profileData?.location ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        children: profileData.location
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                        width: "50%",
                        height: "20px",
                        borderRadius: "var(--ds-radius-small, 4px)"
                    }),
                    profileData?.email ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        children: profileData.email
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                        width: "80%",
                        height: "20px",
                        borderRadius: "var(--ds-radius-small, 4px)"
                    })
                ]
            })
        ]
    });
}
function $c8358ec2650d268a$var$ManagerSectionLoading({ profileData: profileData }) {
    const intl = (0, $kSwu1.useIntl)();
    const manager = profileData?.manager;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        space: "space.075",
        children: [
            manager?.name ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                as: "p",
                weight: "medium",
                children: intl.formatMessage($c8358ec2650d268a$var$messages.managerHeading)
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                width: "60px",
                height: "24px",
                borderRadius: "var(--ds-radius-small, 4px)"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                space: "space.100",
                alignBlock: "center",
                xcss: $c8358ec2650d268a$var$styles.managerRow,
                children: [
                    manager?.avatarUrl || manager?.name ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                        src: manager.avatarUrl ?? undefined,
                        name: manager.name ?? undefined
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                        width: "36px",
                        height: "36px",
                        borderRadius: "var(--ds-radius-full, 9999px)"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                        space: "space.050",
                        xcss: $c8358ec2650d268a$var$styles.fill,
                        children: [
                            manager?.name ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                children: manager.name
                            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                width: "45%",
                                height: "14px",
                                borderRadius: "var(--ds-radius-small, 4px)"
                            }),
                            manager?.jobTitle ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                color: "color.text.subtlest",
                                size: "small",
                                children: manager.jobTitle
                            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                width: "65%",
                                height: "14px",
                                borderRadius: "var(--ds-radius-small, 4px)"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $c8358ec2650d268a$var$LinkRowSkeleton() {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $c8358ec2650d268a$var$styles.linkRow,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                    space: "space.100",
                    alignBlock: "center",
                    xcss: $c8358ec2650d268a$var$styles.fill,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                            width: "36px",
                            height: "36px",
                            borderRadius: "var(--ds-radius-large, 8px)"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                            xcss: $c8358ec2650d268a$var$styles.fill,
                            space: "space.050",
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: "40%",
                                    height: "16px",
                                    borderRadius: "var(--ds-radius-small, 4px)"
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: "70%",
                                    height: "16px",
                                    borderRadius: "var(--ds-radius-small, 4px)"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                    width: "32px",
                    height: "16px",
                    borderRadius: "var(--ds-radius-small, 4px)"
                })
            ]
        })
    });
}
function $c8358ec2650d268a$var$RecentWorkSectionSkeleton() {
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        space: "space.075",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                width: "90px",
                height: "24px",
                borderRadius: "var(--ds-radius-small, 4px)"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)($c8358ec2650d268a$var$LinkRowSkeleton, {}),
                    /*#__PURE__*/ (0, $8aG6j.jsx)($c8358ec2650d268a$var$LinkRowSkeleton, {}),
                    /*#__PURE__*/ (0, $8aG6j.jsx)($c8358ec2650d268a$var$LinkRowSkeleton, {})
                ]
            })
        ]
    });
} /**
   * Loading state shown while the profile card entry chunk resolves. Mirrors the
   * populated card layout:
   *
   * - Header: 96px avatar + action buttons (icon + "View profile") above the
   *   name + pronouns, subtitle (up to 2 lines), and location.
   * - Manager: heading + 24px avatar with name and job title lines.
   * - Recent work: heading + 3 bordered link rows that mirror the compact
   *   `LinkList` rendering used in `RecentWorkSection`
   *
   * Keeping the skeleton shape close to the populated layout minimises the
   * perceived layout jump when data resolves. Fires `rendered.spinner` on mount
   * so the event only emits when the spinner is actually on screen.
   */ 
function $c8358ec2650d268a$export$5d25853fd6bdf402({ testId: testId, profileData: profileData, isReduced: isReduced = false, isAgent: isAgent = false }) {
    (0, $kKnPE.useFireRenderedSpinner)();
    if (isAgent) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        testId: testId,
        role: "status",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c4fg0.AgentCardLoading), {})
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d35qR.CardPopupWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            testId: testId,
            role: "status",
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                space: "space.150",
                xcss: $c8358ec2650d268a$var$styles.inner,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)($c8358ec2650d268a$var$HeaderLoading, {
                        profileData: profileData,
                        isReduced: isReduced
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)($c8358ec2650d268a$var$ManagerSectionLoading, {
                        profileData: profileData
                    }),
                    !isReduced && /*#__PURE__*/ (0, $8aG6j.jsx)($c8358ec2650d268a$var$RecentWorkSectionSkeleton, {})
                ]
            })
        })
    });
}
module.exports["CardLoading"] = $c8358ec2650d268a$export$5d25853fd6bdf402;

});

parcelRegister("454YE", function(module, exports) {
/**
 * @generated SignedSource<<2519dbf4f984912154dfc507593f3717>>
 * @relayHash fecac1223d0ae7cacb4cff7f7a02672b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3412d565a789fe8ad831df0c4c20783567b02aa6784cb67786107136db6d3b13
const $3b461e95a816e67a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "activityFirst"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collabContextId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "siteAri"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipActivity"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipKnowledgeDiscovery"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipReportingLines"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userAri"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userId"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userIdString"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewerId"
    }, v12 = {
        "kind": "Variable",
        "name": "collabContextId",
        "variableName": "collabContextId"
    }, v13 = {
        "kind": "Variable",
        "name": "orgId",
        "variableName": "orgId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v17 = {
        "kind": "ScalarField",
        "name": "email"
    }, v18 = {
        "kind": "ScalarField",
        "name": "jobTitle"
    }, v19 = {
        "kind": "ScalarField",
        "name": "id"
    }, v20 = {
        "kind": "ScalarField",
        "name": "product"
    }, v21 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v22 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluencePageLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v21 /*: any*/ 
            }
        ],
        "type": "ConfluencePage"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceBlogPostLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v21 /*: any*/ 
            }
        ],
        "type": "ConfluenceBlogPost"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v21 /*: any*/ 
            }
        ],
        "type": "ConfluenceWhiteboard"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            v19 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v26 = [
        {
            "concreteType": "ConfluenceCommentLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": v21 /*: any*/ 
        },
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v14 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ 
            ]
        }
    ], v27 = {
        "kind": "ScalarField",
        "name": "url"
    }, v28 = [
        v27 /*: any*/ 
    ], v29 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v30 = [
        v29 /*: any*/ ,
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
                v29 /*: any*/ ,
                v19 /*: any*/ 
            ]
        }
    ], v31 = [
        {
            "alias": "trelloUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v32 = [
        {
            "alias": "webUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v33 = [
        v27 /*: any*/ ,
        v19 /*: any*/ 
    ], v34 = [
        {
            "concreteType": "AssetsLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "web"
                }
            ]
        }
    ], v35 = [
        {
            "kind": "ScalarField",
            "name": "accountIdentifier"
        },
        {
            "kind": "ScalarField",
            "name": "numberOfDirectReports"
        },
        {
            "kind": "ScalarField",
            "name": "numberOfTotalReports"
        },
        {
            "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
            "kind": "LinkedField",
            "name": "pii",
            "plural": false,
            "selections": [
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
                    "kind": "LinkedField",
                    "name": "extendedProfile",
                    "plural": false,
                    "selections": [
                        v18 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "UserProfileCardEntryPointQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "activityFirst",
                            "variableName": "activityFirst"
                        },
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "siteAri",
                            "variableName": "siteAri"
                        },
                        {
                            "kind": "Variable",
                            "name": "skipActivity",
                            "variableName": "skipActivity"
                        },
                        {
                            "kind": "Variable",
                            "name": "skipKnowledgeDiscovery",
                            "variableName": "skipKnowledgeDiscovery"
                        },
                        {
                            "kind": "Variable",
                            "name": "skipReportingLines",
                            "variableName": "skipReportingLines"
                        },
                        {
                            "kind": "Variable",
                            "name": "userAri",
                            "variableName": "userAri"
                        },
                        {
                            "kind": "Variable",
                            "name": "userId",
                            "variableName": "userId"
                        },
                        {
                            "kind": "Variable",
                            "name": "userIdString",
                            "variableName": "userIdString"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewerId",
                            "variableName": "viewerId"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "UserProfileCardRelay_query"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v11 /*: any*/ ,
                v4 /*: any*/ ,
                v8 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "UserProfileCardEntryPointQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "accountId",
                            "variableName": "userId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accountStatus"
                        },
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "concreteType": "AtlassianAccountUserExtendedProfile",
                                    "kind": "LinkedField",
                                    "name": "extendedProfile",
                                    "plural": false,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "department"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "location"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "organization"
                                        }
                                    ]
                                }
                            ],
                            "type": "AtlassianAccountUser"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v17 /*: any*/ 
                            ],
                            "type": "CustomerUser"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appType"
                                }
                            ],
                            "type": "AppUser"
                        },
                        v19 /*: any*/ 
                    ]
                },
                {
                    "condition": "skipActivity",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "Activity",
                            "kind": "LinkedField",
                            "name": "activity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "fields": [
                                                {
                                                    "items": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "actors.0",
                                                            "variableName": "userAri"
                                                        }
                                                    ],
                                                    "kind": "ListValue",
                                                    "name": "actors"
                                                },
                                                v12 /*: any*/ 
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filter"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "first",
                                            "variableName": "activityFirst"
                                        }
                                    ],
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "workedOn",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v14 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ConfluenceDatabaseLinks",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": false,
                                                                                    "selections": v21 /*: any*/ 
                                                                                }
                                                                            ],
                                                                            "type": "ConfluenceDatabase"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ConfluenceEmbedLinks",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": false,
                                                                                    "selections": v21 /*: any*/ 
                                                                                }
                                                                            ],
                                                                            "type": "ConfluenceEmbed"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v26 /*: any*/ ,
                                                                            "type": "ConfluenceFooterComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v26 /*: any*/ ,
                                                                            "type": "ConfluenceInlineComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v28 /*: any*/ ,
                                                                            "type": "TownsquareGoal"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v28 /*: any*/ ,
                                                                            "type": "TownsquareProject"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v28 /*: any*/ ,
                                                                            "type": "TownsquareComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v29 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraIssue"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v30 /*: any*/ ,
                                                                            "type": "JiraPlatformComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v30 /*: any*/ ,
                                                                            "type": "JiraServiceManagementComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v31 /*: any*/ ,
                                                                            "type": "TrelloBoard"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v31 /*: any*/ ,
                                                                            "type": "TrelloCard"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v32 /*: any*/ ,
                                                                            "type": "DevOpsDocument"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v28 /*: any*/ ,
                                                                            "type": "ExternalDocument"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v33 /*: any*/ ,
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v28 /*: any*/ ,
                                                                            "type": "ExternalPullRequest"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v32 /*: any*/ ,
                                                                            "type": "DevOpsDesign"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v28 /*: any*/ ,
                                                                            "type": "ExternalRemoteLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v28 /*: any*/ ,
                                                                            "type": "MercuryFocusArea"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v33 /*: any*/ ,
                                                                            "type": "MercuryPortfolio"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v28 /*: any*/ ,
                                                                            "type": "RadarPosition"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v28 /*: any*/ ,
                                                                            "type": "RadarView"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v28 /*: any*/ ,
                                                                            "type": "CompassComponent"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "href"
                                                                                }
                                                                            ],
                                                                            "type": "BitbucketPullRequest"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": "loomUrl",
                                                                                    "kind": "ScalarField",
                                                                                    "name": "url"
                                                                                }
                                                                            ],
                                                                            "type": "LoomVideo"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v34 /*: any*/ ,
                                                                            "type": "AssetsObject"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v34 /*: any*/ ,
                                                                            "type": "AssetsObjectType"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v34 /*: any*/ ,
                                                                            "type": "AssetsSchema"
                                                                        },
                                                                        v25 /*: any*/ 
                                                                    ]
                                                                },
                                                                v19 /*: any*/ 
                                                            ]
                                                        },
                                                        v19 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "skipKnowledgeDiscovery",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "KnowledgeDiscoveryQueryApi",
                            "kind": "LinkedField",
                            "name": "knowledgeDiscovery",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "accountId",
                                            "variableName": "userIdString"
                                        },
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "requestingUserId",
                                            "variableName": "viewerId"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "tenantId",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "singleUser",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "KnowledgeDiscoveryUserProfile",
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "KnowledgeDiscoveryUserManager",
                                                            "kind": "LinkedField",
                                                            "name": "manager",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v18 /*: any*/ ,
                                                                v16 /*: any*/ ,
                                                                v15 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                                                            "kind": "LinkedField",
                                                            "name": "thirdPartyIntegrations",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "externalId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "integrationId"
                                                                },
                                                                v20 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "KnowledgeDiscoverySingleUser"
                                        }
                                    ]
                                },
                                {
                                    "condition": "skipReportingLines",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "aaid",
                                                    "variableName": "userIdString"
                                                },
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "Variable",
                                                    "name": "siteId",
                                                    "variableName": "siteAri"
                                                }
                                            ],
                                            "kind": "LinkedField",
                                            "name": "reportingLines",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": v35 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                                            "kind": "LinkedField",
                                                            "name": "managers",
                                                            "plural": true,
                                                            "selections": v35 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                                            "kind": "LinkedField",
                                                            "name": "reports",
                                                            "plural": true,
                                                            "selections": v35 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "KnowledgeDiscoveryReportingLines"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3412d565a789fe8ad831df0c4c20783567b02aa6784cb67786107136db6d3b13",
            "metadata": {},
            "name": "UserProfileCardEntryPointQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3b461e95a816e67a$var$node.hash = "0f548ed921a2de7c914a8feb3cef9648";
var $3b461e95a816e67a$export$2e2bcd8739ae039 = $3b461e95a816e67a$var$node;
module.exports["default"] = $3b461e95a816e67a$export$2e2bcd8739ae039;

});

parcelRegister("7lnAX", function(module, exports) {

let $558ccc12ee09af34$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $558ccc12ee09af34$var$load("fGYoU").then(()=>parcelRequire('9tb7H'));

});

parcelRegister("9zU5G", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $2tuSz = parcelRequire("2tuSz");


var $lUcpS = parcelRequire("lUcpS");


var $cP7Ln = parcelRequire("cP7Ln");


var $jp2Q3 = parcelRequire("jp2Q3");


var $d5gEx = parcelRequire("d5gEx");


var $eRfpr = parcelRequire("eRfpr");


var $kKnPE = parcelRequire("kKnPE");


var $1koI0 = parcelRequire("1koI0");


var $2atIz = parcelRequire("2atIz");


var $bIiaK = parcelRequire("bIiaK");


var $9gll8 = parcelRequire("9gll8");


var $bXEsj = parcelRequire("bXEsj");


var $3Z1Pc = parcelRequire("3Z1Pc");


var $fxdou = parcelRequire("fxdou");

/* UserProfileCardTrigger.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");





var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");

const $e5738d39a9fd0a96$var$styles = {
    trigger: "_1mb4UnZqHV _3iDTPbS8kF",
    fullWidthTrigger: "_1mb4UnZqHV _3iDTPbvLZJ _39xV02N91d"
};
const $e5738d39a9fd0a96$var$messages = (0, $kSwu1.defineMessages)({
    fallbackAriaLabel: {
        id: "user-profile-card.UserProfileCardTrigger.fallbackAriaLabel",
        defaultMessage: "More information about this user"
    }
});
const $e5738d39a9fd0a96$export$d5e867b0afea0b23 = ({ trigger: trigger, triggerProps: triggerProps, children: children, ariaHideProfileTrigger: ariaHideProfileTrigger, ariaLabel: ariaLabel, fullWidthTrigger: fullWidthTrigger = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const hoverOnlyTrigger = Array.isArray(trigger) ? trigger.every((mode)=>mode === 'hover') : trigger === 'hover';
    const useNonInteractiveHoverTrigger = hoverOnlyTrigger;
    const accessibleName = ariaHideProfileTrigger ? undefined : ariaLabel ?? formatMessage($e5738d39a9fd0a96$var$messages.fallbackAriaLabel);
    if (useNonInteractiveHoverTrigger) {
        const { 'aria-expanded': _ariaExpanded, 'aria-haspopup': _ariaHasPopup, ...nonInteractiveTriggerProps } = triggerProps;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "span",
            ...nonInteractiveTriggerProps,
            testId: "user-profile-card-trigger-wrapper",
            xcss: fullWidthTrigger ? $e5738d39a9fd0a96$var$styles.fullWidthTrigger : $e5738d39a9fd0a96$var$styles.trigger,
            "aria-hidden": ariaHideProfileTrigger ? true : undefined,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
        ...triggerProps,
        testId: "user-profile-card-trigger-wrapper",
        xcss: fullWidthTrigger ? $e5738d39a9fd0a96$var$styles.fullWidthTrigger : $e5738d39a9fd0a96$var$styles.trigger,
        "aria-label": accessibleName,
        "aria-hidden": ariaHideProfileTrigger ? true : undefined,
        tabIndex: ariaHideProfileTrigger ? -1 : undefined,
        children: children
    });
};


/**
 * Pointer rest time (ms) before a hover preloads the card. The adaptor default (200ms) is short
 * enough that incidental pointer transit over a mention or avatar preloads the card, and every
 * preload costs an AGG request that reaches Worklens for the recent-activity section.
 */ const $b98ac5af1bd78598$var$PRELOAD_INTENT_DELAY = 750;
const $b98ac5af1bd78598$var$EARLY_PRELOAD_INTENT_DELAY = 650;
const $b98ac5af1bd78598$var$messages = (0, $kSwu1.defineMessages)({
    profileAriaLabel: {
        id: "user-profile-card.UserProfileCardWithTrigger.profileAriaLabel",
        defaultMessage: "More information about {name}"
    }
});
function $b98ac5af1bd78598$export$74fa5d03ff375804({ isVisible: isVisible, ...props }) {
    const hostRelayEnvironment = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext))?.environment;
    if (isVisible === false) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: props.children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d5gEx.AtlassianRelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($b98ac5af1bd78598$var$UserProfileCardWithTriggerInner, {
            ...props,
            hostRelayEnvironment: hostRelayEnvironment
        })
    });
}
/** Inner implementation of {@link UserProfileCardWithTrigger}. */ function $b98ac5af1bd78598$var$UserProfileCardWithTriggerInner({ hostRelayEnvironment: hostRelayEnvironment, userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, trigger: trigger, placement: placement = 'bottom-start', offset: offset, shouldRenderToParent: shouldRenderToParent = false, children: children, testId: testId, townsquareApp: townsquareApp, onOpen: onOpen, onProfileClick: onProfileClick, agent: agent, isAgent: isAgent, actions: actions, ariaHideProfileTrigger: ariaHideProfileTrigger, ariaLabel: ariaLabel, analyticsAttributes: analyticsAttributes, fullWidthTrigger: fullWidthTrigger, prefilledProfileData: prefilledProfileData, customerCardDataLoader: customerCardDataLoader, isReduced: isReduced }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const resolvedTriggerMode = trigger ?? 'click';
    const resolvedAriaLabel = ariaLabel ?? (prefilledProfileData?.name ? formatMessage($b98ac5af1bd78598$var$messages.profileAriaLabel, {
        name: prefilledProfileData.name
    }) : undefined);
    const relayWrappedChildren = hostRelayEnvironment ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6SsN4.RelayEnvironmentProvider), {
        environment: hostRelayEnvironment,
        children: children
    }) : children;
    const entryPointErrorFallback = (0, $cozmU.useCallback)((_props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $3Z1Pc.CardError), {
            testId: testId
        }), [
        testId
    ]);
    const getTestId = (0, $cozmU.useMemo)(()=>(0, $bXEsj.makeGetTestId)(userId, testId), [
        userId,
        testId
    ]);
    // `triggerMethod` is the actual open method ('click' | 'hover') reported by the popup
    // adapter. It stays `undefined` until the first open so we never report a trigger-mode
    // value (e.g. 'preload-on-hover') as if it were an open method. This is hoisted onto
    // `TeamsAppAnalyticsContext.attributes` below so every analytics event fired beneath
    // the popup picks it up automatically without each event having to attach it manually.
    const [triggerMethod, setTriggerMethod] = (0, $cozmU.useState)(undefined);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            cloudId: cloudId ?? '',
            townsquareApp: townsquareApp,
            onProfileClick: onProfileClick,
            getTestId: getTestId,
            triggerMethod: triggerMethod
        }), [
        cloudId,
        townsquareApp,
        onProfileClick,
        getTestId,
        triggerMethod
    ]);
    const analyticsContextData = (0, $cozmU.useMemo)(()=>({
            source: 'userProfileCard',
            attributes: {
                ...analyticsAttributes,
                cloudId: cloudId ?? '',
                userId: userId,
                viewerId: viewerId ?? '',
                // Only attach `method` once an actual open has occurred so SLO dashboards never
                // see a synthetic method on pre-open events (e.g. preload).
                ...triggerMethod !== undefined ? {
                    method: triggerMethod
                } : {}
            }
        }), [
        cloudId,
        viewerId,
        userId,
        triggerMethod,
        analyticsAttributes
    ]);
    if (!userId) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: relayWrappedChildren
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: relayWrappedChildren
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9gll8.UserProfileCardContext).Provider, {
            value: contextValue,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2tuSz.TeamsAppAnalyticsContext), {
                data: analyticsContextData,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bIiaK.CardOpenTimerProvider), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)($b98ac5af1bd78598$var$UserProfileCardPopupWithAnalytics, {
                        entryPointParams: {
                            userId: userId,
                            cloudId: cloudId,
                            orgId: orgId,
                            viewerId: viewerId,
                            // `isReduced` never reached the entry point, so the reduced card's
                            // `skipActivity` optimisation has never taken effect.
                            ...(0, $iDrrr.fg)('ptc_user_profile_card_reduce_activity_traffic') ? {
                                isReduced: isReduced
                            } : {}
                        },
                        entryPointProps: {
                            cloudId: cloudId ?? '',
                            viewerId: viewerId,
                            testId: testId,
                            agent: agent,
                            isAgent: isAgent,
                            actions: actions,
                            isReduced: isReduced,
                            ...prefilledProfileData ? {
                                prefilledProfileData: prefilledProfileData
                            } : {},
                            ...customerCardDataLoader ? {
                                customerCardDataLoader: customerCardDataLoader
                            } : {}
                        },
                        placement: placement,
                        offset: offset,
                        shouldRenderToParent: shouldRenderToParent,
                        triggerMode: resolvedTriggerMode,
                        errorFallback: entryPointErrorFallback,
                        autoFocus: triggerMethod === 'click',
                        onTriggerMethodChange: setTriggerMethod,
                        onOpen: onOpen,
                        trigger: (triggerProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $e5738d39a9fd0a96$export$d5e867b0afea0b23), {
                                trigger: resolvedTriggerMode,
                                triggerProps: triggerProps,
                                ariaHideProfileTrigger: ariaHideProfileTrigger,
                                ariaLabel: resolvedAriaLabel,
                                fullWidthTrigger: fullWidthTrigger,
                                children: relayWrappedChildren
                            })
                    })
                })
            })
        })
    });
}
const $b98ac5af1bd78598$var$REFERENCE_HIDDEN_STYLE = {
    visibility: 'hidden',
    pointerEvents: 'none'
};
/**
 * Replaces `@atlaskit/popup`'s default popup component, so it re-applies the `z-index` that
 * component would otherwise provide.
 */ const $b98ac5af1bd78598$var$ReferenceHidingPopupComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ children: children, style: style, isReferenceHidden: isReferenceHidden, ...rest }, ref)=>{
    const mergedStyle = {
        ...style,
        zIndex: (0, $jp2Q3.layers).modal(),
        ...isReferenceHidden ? $b98ac5af1bd78598$var$REFERENCE_HIDDEN_STYLE : undefined
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ref: ref,
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- popper controls positioning dynamically; reference-hidden visibility mirrors Smart Link hover-card scroll behaviour
        style: mergedStyle,
        children: children
    });
});
function $b98ac5af1bd78598$var$UserProfileCardPopupWithAnalytics({ entryPointParams: entryPointParams, entryPointProps: entryPointProps, placement: placement, offset: offset, shouldRenderToParent: shouldRenderToParent, triggerMode: triggerMode, errorFallback: errorFallback, autoFocus: autoFocus, onTriggerMethodChange: onTriggerMethodChange, onOpen: onOpen, trigger: trigger }) {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { markInteractionStart: markInteractionStart } = (0, $bIiaK.useCardOpenTimer)();
    const fireTriggeredRequest = (0, $kKnPE.useFireTriggeredRequest)();
    const handleOpen = (0, $cozmU.useCallback)((method, { preloaded: preloaded })=>{
        // t=0 for all downstream `duration` measurements.
        markInteractionStart();
        onTriggerMethodChange(method);
        // `method` is attached inline because the context update from
        // `onTriggerMethodChange` has not propagated yet at this exact moment.
        fireEvent('ui.profilecard.triggered', {
            firedAt: (0, $eRfpr.firedAt)(),
            method: method,
            preloaded: preloaded
        });
        fireTriggeredRequest();
        onOpen?.(method);
    }, [
        fireEvent,
        fireTriggeredRequest,
        markInteractionStart,
        onOpen,
        onTriggerMethodChange
    ]);
    const handlePreload = (0, $cozmU.useCallback)(()=>{
        fireEvent('operational.profilecard.preloaded.request', {
            firedAt: (0, $eRfpr.firedAt)()
        });
    }, [
        fireEvent
    ]);
    // Lets card content hold the card open; see `CardCloseGuardContext`.
    const closeGuardRef = (0, $cozmU.useRef)(false);
    const shouldPreventClose = (0, $cozmU.useCallback)(()=>closeGuardRef.current, []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2atIz.CardCloseGuardContext).Provider, {
        value: closeGuardRef,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cP7Ln.PopupTriggerWithHover), {
            entryPoint: (0, $1koI0.entryPoint),
            placement: placement,
            offset: offset,
            fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxdou.CardLoading), {
                testId: entryPointProps.testId ?? '',
                profileData: entryPointProps.prefilledProfileData,
                isReduced: entryPointProps.isReduced,
                isAgent: entryPointProps.isAgent
            }),
            errorFallback: errorFallback,
            delays: (0, $iDrrr.fg)('ptc_user_profile_card_reduce_activity_traffic') ? {
                preloadIntent: (0, $iDrrr.fg)('ptc_user_profile_card_preload_tuning') ? $b98ac5af1bd78598$var$EARLY_PRELOAD_INTENT_DELAY : $b98ac5af1bd78598$var$PRELOAD_INTENT_DELAY
            } : undefined,
            keepPreloadOnLeave: (0, $iDrrr.fg)('ptc_user_profile_card_preload_tuning'),
            entryPointParams: entryPointParams,
            entryPointProps: entryPointProps,
            shouldRenderToParent: shouldRenderToParent,
            autoFocus: autoFocus,
            shouldUseCaptureOnOutsideClick: true,
            triggerMode: triggerMode,
            onOpen: handleOpen,
            onPreload: handlePreload,
            trigger: trigger,
            zIndex: (0, $jp2Q3.layers).modal(),
            popupComponent: $b98ac5af1bd78598$var$ReferenceHidingPopupComponent,
            shouldPreventClose: shouldPreventClose
        })
    });
}
module.exports["UserProfileCardWithTrigger"] = $b98ac5af1bd78598$export$74fa5d03ff375804;

});

parcelRegister("d6Q9o", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hsgLh = parcelRequire("hsgLh");

const $cada95658fe82fcc$export$1fd7f5f21a6d6cb8 = ()=>(0, $cozmU.useContext)((0, $hsgLh.SmartLinkModalContext));
module.exports["useSmartLinkModal"] = $cada95658fe82fcc$export$1fd7f5f21a6d6cb8;

});

parcelRegister("f3cl5", function(module, exports) {

var $4yYAm = parcelRequire("4yYAm");

const $4e8a3954cc804de2$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $4yYAm.SmartLinkSize).XLarge:
        case (0, $4yYAm.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $4yYAm.SmartLinkSize).Medium:
        case (0, $4yYAm.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
module.exports["getIconWidth"] = $4e8a3954cc804de2$export$fb10bc5609c6347e;

});

parcelRegister("kaqe6", function(module, exports) {

var $4yYAm = parcelRequire("4yYAm");

const $7685ea5c6a9d6b5a$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $4yYAm.SmartLinkSize).Large,
        (0, $4yYAm.SmartLinkSize).XLarge
    ].includes(size);
module.exports["isIconSizeLarge"] = $7685ea5c6a9d6b5a$export$d2b8fb9e780e17e7;

});

parcelRegister("eXfud", function(module, exports) {

var $4yYAm = parcelRequire("4yYAm");

const $704e045b7ca2090c$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $4yYAm.SmartLinkSize).Small:
        case (0, $4yYAm.SmartLinkSize).Medium:
            return undefined;
        case (0, $4yYAm.SmartLinkSize).XLarge:
        case (0, $4yYAm.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
};
module.exports["transformSmartLinkSizeToIconTileSize"] = $704e045b7ca2090c$export$3acc3fb10995f020;

});

parcelRegister("2wny6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kaqe6 = parcelRequire("kaqe6");

const $36b8e854d74ea3eb$export$28dd5ad82647c000 = (ObjectIcon, ObjectTileIcon)=>{
    return ({ size: size, ...props })=>{
        if ((0, $kaqe6.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ObjectTileIcon, {
            ...props,
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ObjectIcon, props);
    };
};
module.exports["renderIconPerSize"] = $36b8e854d74ea3eb$export$28dd5ad82647c000;

});

parcelRegister("5IVlB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $lSQgn = parcelRequire("lSQgn");


var $5lkNm = parcelRequire("5lkNm");

var $ldJ1U = parcelRequire("ldJ1U");


var $iDrrr = parcelRequire("iDrrr");


var $eXfud = parcelRequire("eXfud");


var $4yYAm = parcelRequire("4yYAm");


var $l4gLd = parcelRequire("l4gLd");


var $kaqe6 = parcelRequire("kaqe6");

const $5025f0bf7c5e18db$var$getIconImportFn = (icon, size)=>{
    const item = (0, $l4gLd.getLazyIcons)()[icon];
    if ((0, $kaqe6.isIconSizeLarge)(size) && item?.large) return item.large;
    return item?.default;
};
const $5025f0bf7c5e18db$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "rynap",
        name: "importIcon",
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};

const $5025f0bf7c5e18db$var$getBlogIcon = ()=>(parcelRequire("lYcSC")).default;

const $5025f0bf7c5e18db$var$getDocumentIcon = ()=>(parcelRequire("2jRrx")).default;

const $5025f0bf7c5e18db$var$getLiveDocumentIcon = ()=>(parcelRequire("66hVV")).default;
const $5025f0bf7c5e18db$var$PRIORITY_ICONS = [
    (0, $4yYAm.IconType).PriorityBlocker,
    (0, $4yYAm.IconType).PriorityCritical,
    (0, $4yYAm.IconType).PriorityHigh,
    (0, $4yYAm.IconType).PriorityHighest,
    (0, $4yYAm.IconType).PriorityLow,
    (0, $4yYAm.IconType).PriorityLowest,
    (0, $4yYAm.IconType).PriorityMajor,
    (0, $4yYAm.IconType).PriorityMedium,
    (0, $4yYAm.IconType).PriorityMinor,
    (0, $4yYAm.IconType).PriorityTrivial
];
const $5025f0bf7c5e18db$var$isCoreIcon = (icon)=>{
    return [
        (0, $4yYAm.IconType).Project,
        (0, $4yYAm.IconType).Template,
        (0, $4yYAm.IconType).Forbidden,
        (0, $4yYAm.IconType).Default,
        (0, $4yYAm.IconType).Error,
        (0, $4yYAm.IconType).Attachment,
        (0, $4yYAm.IconType).CheckItem,
        (0, $4yYAm.IconType).Component,
        (0, $4yYAm.IconType).Comment,
        (0, $4yYAm.IconType).View,
        (0, $4yYAm.IconType).React,
        (0, $4yYAm.IconType).Vote,
        (0, $4yYAm.IconType).PriorityUndefined,
        (0, $4yYAm.IconType).ProgrammingLanguage,
        (0, $4yYAm.IconType).Subscriber,
        (0, $4yYAm.IconType).SubTasksProgress,
        ...$5025f0bf7c5e18db$var$PRIORITY_ICONS
    ].includes(icon);
};
const $5025f0bf7c5e18db$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $4yYAm.SmartLinkSize).Medium, isTiledIcon: isTiledIcon })=>{
    // Intentionally keep these three icon types synchronous and outside lazy imports.
    // These icons should be present in SSR markup so hydration does not cause a
    // visible empty-state-then-pop-in transition in Smart Link consumers.
    switch(icon){
        case (0, $4yYAm.IconType).Document:
            {
                const DocumentIcon = $5025f0bf7c5e18db$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: label ?? 'document',
                    testId: testId,
                    size: size,
                    isTiledIcon: isTiledIcon
                });
            }
        case (0, $4yYAm.IconType).Blog:
            {
                const BlogIcon = $5025f0bf7c5e18db$var$getBlogIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BlogIcon, {
                    label: label ?? 'blog',
                    testId: testId,
                    size: size,
                    isTiledIcon: isTiledIcon
                });
            }
        case (0, $4yYAm.IconType).LiveDocument:
            {
                const LiveDocumentIcon = $5025f0bf7c5e18db$var$getLiveDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LiveDocumentIcon, {
                    label: label ?? 'live-doc',
                    testId: testId,
                    size: size,
                    isTiledIcon: isTiledIcon
                });
            }
    }
    const importFn = $5025f0bf7c5e18db$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $5025f0bf7c5e18db$var$importIcon(importFn);
    if ($5025f0bf7c5e18db$var$isCoreIcon(icon)) {
        let color;
        if (icon === (0, $4yYAm.IconType).Error || icon === (0, $4yYAm.IconType).Forbidden) color = "var(--ds-icon-danger, #C9372C)";
        switch(size){
            case (0, $4yYAm.SmartLinkSize).Small:
            case (0, $4yYAm.SmartLinkSize).Medium:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId,
                    color: color
                });
            case (0, $4yYAm.SmartLinkSize).Large:
            case (0, $4yYAm.SmartLinkSize).XLarge:
                if ($5025f0bf7c5e18db$var$PRIORITY_ICONS.includes(icon)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId,
                    color: color
                });
                let appearance;
                if (icon === (0, $4yYAm.IconType).Error || icon === (0, $4yYAm.IconType).Forbidden) appearance = 'redBold';
                else if ((0, $iDrrr.fg)('platform_lp_non_bold_large_sl_icon')) appearance = 'gray';
                else appearance = 'grayBold';
                const iconTileSize = (0, $eXfud.transformSmartLinkSizeToIconTileSize)(size);
                if (iconTileSize) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
                    appearance: appearance,
                    icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ImportedIcon, {
                            ...iconProps,
                            spacing: "spacious"
                        }) : ImportedIcon,
                    size: iconTileSize,
                    label: label ?? ''
                });
                else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId,
                    color: color
                });
        }
    }
    switch(icon){
        case (0, $4yYAm.IconType).Confluence:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5lkNm.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                ...(0, $iDrrr.fg)('billplat_a11y_icon_label_fix') ? {
                    label: ''
                } : undefined,
                size: size === (0, $4yYAm.SmartLinkSize).Large || size === (0, $4yYAm.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $4yYAm.IconType).Jira:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldJ1U.JiraIcon), {
                appearance: "brand",
                testId: testId,
                ...(0, $iDrrr.fg)('billplat_a11y_icon_label_fix') ? {
                    label: ''
                } : undefined,
                size: size === (0, $4yYAm.SmartLinkSize).Large || size === (0, $4yYAm.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $4yYAm.IconType).Error:
        case (0, $4yYAm.IconType).Forbidden:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                size: size,
                isTiledIcon: isTiledIcon
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                size: size,
                isTiledIcon: isTiledIcon
            });
    }
};
var $5025f0bf7c5e18db$export$2e2bcd8739ae039 = $5025f0bf7c5e18db$var$AtlaskitIcon;
module.exports["default"] = $5025f0bf7c5e18db$export$2e2bcd8739ae039;

});

parcelRegister("ckM0L", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $c764d7c8e3c7c13d$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $cozmU.useRef)(null);
        (0, $cozmU.useEffect)(()=>{
            if (props?.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props?.className
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...props,
            ref: ref
        });
    };
}
module.exports["withOverrideCss"] = $c764d7c8e3c7c13d$export$e0bdcacb944f1da6;

});

parcelRegister("10jYv", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $5bcce00f9e68cb32$export$b9738bf28fb14829 = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        },
        content: context
    } : undefined;
};
module.exports["toFormattedTextProps"] = $5bcce00f9e68cb32$export$b9738bf28fb14829;

});

parcelRegister("ULhqw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $228b1b7b89f6b832$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...descriptor,
            values: values
        });
    }
};
module.exports["getFormattedMessage"] = $228b1b7b89f6b832$export$f1aa79f2218fb713;

});

parcelRegister("jJP7n", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $it2N0 = parcelRequire("it2N0");


var $8QLAc = parcelRequire("8QLAc");


var $aGLwK = parcelRequire("aGLwK");


var $5IVlB = parcelRequire("5IVlB");


var $ckM0L = parcelRequire("ckM0L");


var $ULhqw = parcelRequire("ULhqw");

const $85c0dffca2d5c229$var$styles = {
    container: "_2mHwu81Y8M _3iDTPbccYA _0hPCNLDIqT _4ouGXIE6Kk",
    icon: "_3iDTPbccYA _23odCiccYA _37mLE4ccYA _3B2Ea7ccYA _0jFU0Vey7F _0LETLXey7F _4ACwSfey7F _2Qxi4ney7F _0Of8r2Pgdg _2F15zaPgdg _3ZsYrqPgdg _1bWpQpPgdg _1ZnuxbPgdg _0fBW2MPgdg _0BXPwdPgdg _20JdpsPgdg _1wydGWPgdg _4EY69QPgdg _3PFkzMPgdg _0mILL2Pgdg _2Zuz6QPgdg _4BqEoIPgdg _0DtnpGPgdg _0woc9oPgdg _39xV02ey7F _1tJeXfey7F _0VARMJey7F _27VeLCey7F _1RrJLit2nV _1PRH53t2nV _0VOaqft2nV _2jszTzt2nV",
    text: "_2sNsIg7NXe"
};
const $85c0dffca2d5c229$var$colorMap = {
    subtle: "_1UtDYzKGUX",
    default: "_1UtDYzZpcK"
};
const $85c0dffca2d5c229$var$messageMapper = {
    [(0, $4yYAm.IconType).PriorityBlocker]: (0, $dM7c5.messages).priority_blocker,
    [(0, $4yYAm.IconType).PriorityCritical]: (0, $dM7c5.messages).priority_critical,
    [(0, $4yYAm.IconType).PriorityHigh]: (0, $dM7c5.messages).priority_high,
    [(0, $4yYAm.IconType).PriorityHighest]: (0, $dM7c5.messages).priority_highest,
    [(0, $4yYAm.IconType).PriorityLow]: (0, $dM7c5.messages).priority_low,
    [(0, $4yYAm.IconType).PriorityLowest]: (0, $dM7c5.messages).priority_lowest,
    [(0, $4yYAm.IconType).PriorityMajor]: (0, $dM7c5.messages).priority_major,
    [(0, $4yYAm.IconType).PriorityMedium]: (0, $dM7c5.messages).priority_medium,
    [(0, $4yYAm.IconType).PriorityMinor]: (0, $dM7c5.messages).priority_minor,
    [(0, $4yYAm.IconType).PriorityTrivial]: (0, $dM7c5.messages).priority_trivial,
    [(0, $4yYAm.IconType).PriorityUndefined]: (0, $dM7c5.messages).priority_undefined
};
const $85c0dffca2d5c229$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $85c0dffca2d5c229$var$messageMapper[icon];
        if (descriptor) return (0, $ULhqw.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $85c0dffca2d5c229$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5IVlB.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $85c0dffca2d5c229$var$renderImageIcon = (url, testId, hideLoadingSkeleton)=>{
    if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aGLwK.default), {
        testId: testId,
        url: url,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
const $85c0dffca2d5c229$var$BaseBadgeRefreshNew = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url, color: color, hideLabel: hideLabel = false }, ref)=>{
    const ui = (0, $it2N0.useFlexibleUiOptionContext)();
    const { product: product } = (0, $8QLAc.default)();
    const formattedMessageOrLabel = $85c0dffca2d5c229$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $85c0dffca2d5c229$var$renderAtlaskitIcon(icon, testId) || $85c0dffca2d5c229$var$renderImageIcon(url, testId, ui?.hideLoadingSkeleton);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    const shouldHideLabel = hideLabel && !!product && product === 'CONFLUENCE';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        style: {
            color: color
        },
        className: (0, $hekY6.default)([
            $85c0dffca2d5c229$var$styles.container,
            $85c0dffca2d5c229$var$colorMap[appearance]
        ])
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $85c0dffca2d5c229$var$styles.icon
    }, badgeIcon), !shouldHideLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        testId: `${testId}-label`,
        xcss: $85c0dffca2d5c229$var$styles.text
    }, formattedMessageOrLabel));
});
const $85c0dffca2d5c229$var$_default_1 = (0, $ckM0L.withOverrideCss)($85c0dffca2d5c229$var$BaseBadgeRefreshNew);
var $85c0dffca2d5c229$export$2e2bcd8739ae039 = $85c0dffca2d5c229$var$_default_1;
module.exports["default"] = $85c0dffca2d5c229$export$2e2bcd8739ae039;

});

parcelRegister("le41x", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $bcDqz = parcelRequire("bcDqz");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $9iuN4 = parcelRequire("9iuN4");

const $2ec34253a6b00462$var$styles = null;
const $2ec34253a6b00462$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $4yYAm.ElementName).AssignedToGroup:
            return (0, $9iuN4.getFormattedMessageAsString)(intl, (0, $dM7c5.messages).assigned_to, personName);
        case (0, $4yYAm.ElementName).OwnedByGroup:
            return (0, $9iuN4.getFormattedMessageAsString)(intl, (0, $dM7c5.messages).owned_by, personName);
        case (0, $4yYAm.ElementName).AuthorGroup:
            return (0, $9iuN4.getFormattedMessageAsString)(intl, (0, $dM7c5.messages).created_by, personName);
        default:
            return personName;
    }
};
const $2ec34253a6b00462$var$BaseAvatarGroup = ({ items: items = [], maxCount: maxCount = 4, name: name, className: className, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $kSwu1.useIntl)();
    const data = (0, $cozmU.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $4yYAm.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $9iuN4.getFormattedMessageAsString)(intl, (0, $dM7c5.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
         //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $2ec34253a6b00462$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ $cozmU.createElement("span" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    , {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_4ouGXIE6Kk _3iDTPbccYA _3KMNLz2ADO _2nCqgUdnbC",
            className
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $bcDqz.default), {
        maxCount: maxCount,
        appearance: "stack",
        size: "small",
        data: data,
        testId: testId
    }));
};
var $2ec34253a6b00462$export$2e2bcd8739ae039 = $2ec34253a6b00462$var$BaseAvatarGroup;
module.exports["default"] = $2ec34253a6b00462$export$2e2bcd8739ae039;

});

parcelRegister("f2zIB", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $aa634c30824f2fbb$export$91ba8651475968bd = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};
module.exports["toAvatarGroupProps"] = $aa634c30824f2fbb$export$91ba8651475968bd;

});

parcelRegister("80uua", function(module, exports) {
/* eslint-disable @atlaskit/design-system/use-tokens-typography */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $29d10a6d9d915edc$export$a2fb457791942ba4 = (label)=>{
    // Don't render the element if its 0
    return label !== '0' && label ? {
        label: label
    } : undefined;
};
module.exports["toBadgeProps"] = $29d10a6d9d915edc$export$a2fb457791942ba4;

});

parcelRegister("bwJAe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $j2eru = parcelRequire("j2eru");


var $bI14T = parcelRequire("bI14T");

const $21355f4f099ffb95$var$useInvoke = ()=>{
    const { connections: connections } = (0, $bI14T.useSmartLinkContext)();
    const clientExt = (0, $j2eru.useSmartLinkClientExtension)(connections.client);
    return (0, $cozmU.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $21355f4f099ffb95$export$2e2bcd8739ae039 = $21355f4f099ffb95$var$useInvoke;
module.exports["default"] = $21355f4f099ffb95$export$2e2bcd8739ae039;

});

parcelRegister("aDH7j", function(module, exports) {
const $8856be0a6885344d$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;
module.exports["isInvokeCustomError"] = $8856be0a6885344d$export$1694272377fa07d8;

});

parcelRegister("jdGU5", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $lpNn5 = parcelRequire("lpNn5");


var $4yYAm = parcelRequire("4yYAm");


var $eTTRx = parcelRequire("eTTRx");


var $2nc6N = parcelRequire("2nc6N");

const $0233df0f75012bd0$var$DEFAULT_MAX_LINES = 2;
const $0233df0f75012bd0$var$MAXIMUM_MAX_LINES = 2;
const $0233df0f75012bd0$var$MINIMUM_MAX_LINES = 1;
const $0233df0f75012bd0$var$containerStyles = null;
const $0233df0f75012bd0$var$getMaxLines = (maxLines)=>{
    if (maxLines > $0233df0f75012bd0$var$MAXIMUM_MAX_LINES) return $0233df0f75012bd0$var$DEFAULT_MAX_LINES;
    if (maxLines < $0233df0f75012bd0$var$MINIMUM_MAX_LINES) return $0233df0f75012bd0$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $0233df0f75012bd0$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span"
    }, trigger);
const $0233df0f75012bd0$var$linkStyleSizeMap = {
    xlarge: "_2sNsIgWSk4 _1kk5Tku7m9 _26BoRw9DVM",
    large: "_2sNsIgmnOE _1kk5Tku7m9 _26BoRwQAma",
    medium: "_2sNsIgmnOE _1kk5Tku7m9 _26BoRwQAma",
    small: "_2sNsIg7NXe _1kk5Tku7m9 _26BoRwQAma"
};
const $0233df0f75012bd0$var$baseAnchorStyle = null;
const $0233df0f75012bd0$var$workBreakStyleMap = {
    true: "_3W2Oc8wPeg",
    false: "_3W2Oc84hR5"
};
const $0233df0f75012bd0$var$anchorConstantsStyles = null;
const $0233df0f75012bd0$var$anchorLineClampMap = {
    1: "_4Gn54R7dHp",
    2: "_4Gn54RiZR3"
};
const $0233df0f75012bd0$var$anchorLinkLineHeight1Map = {
    xlarge: "_2nBKY99DVM",
    large: "_2nBKY9QAma",
    medium: "_2nBKY9QAma",
    small: "_2nBKY9QAma"
};
const $0233df0f75012bd0$var$anchorLinkLineHeight2Map = {
    xlarge: "_2nBKY9DuDI",
    large: "_2nBKY9Z49V",
    medium: "_2nBKY9Z49V",
    small: "_2nBKY9Z49V"
};
const $0233df0f75012bd0$var$themeStyleMap = {
    grey: "_11DEw798eZ _0BgsrW98eZ _13LFQp98eZ _1H1Mfr98eZ _1a3ty90Rl6 _3iTTW20Rl6 _3LJZxF0Rl6 _20nBlz0Rl6 _2hNNnT6wH8 _38pcgl6wH8 _0Belvf6wH8 _0p4Zmw6wH8 _4b2ZeMKGUX _0TCqaoKGUX _1PcSDPKGUX _3vnqniKGUX _2qLPYU7NXe _2gIZZIKGUX",
    black: "_1UtDYzZpcK _3WzCGi98eZ _32C2rk98eZ _0DCa9D98eZ _4DXJrK98eZ _0NqVRt0Rl6 _0i9AWA0Rl6 _3932vv0Rl6 _4yBLMO0Rl6 _3BKYwu6wH8 _0mm6KQ6wH8 _02cRtH6wH8 _2QcX5c6wH8 _0CMRbkZpcK _10n1R5ZpcK _0clgaMZpcK _2nTuUYZpcK",
    link: "_1UtDYzM7Tp _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMM7Tp _0CMRbkAwSC"
};
const $0233df0f75012bd0$var$BaseLinkElement = ({ hideTooltip: hideTooltip, maxLines: maxLines = $0233df0f75012bd0$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $4yYAm.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $4yYAm.SmartLinkTheme).Link, url: url, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, target: target = '_blank', anchorRef: anchorRef })=>{
    const onMouseDown = (0, $eTTRx.useMouseDownEvent)();
    const hasSpace = (0, $cozmU.useMemo)(()=>text ? (0, $2nc6N.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onMouseDown: onMouseDown,
        href: url,
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP",
            $0233df0f75012bd0$var$linkStyleSizeMap[size],
            $0233df0f75012bd0$var$anchorLineClampMap[$0233df0f75012bd0$var$getMaxLines(maxLines)],
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbgJ9S _39HuIbz8Lp _1U1ZhbbI28",
            $0233df0f75012bd0$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $0233df0f75012bd0$var$getMaxLines(maxLines) === 1 && $0233df0f75012bd0$var$anchorLinkLineHeight1Map[size],
            $0233df0f75012bd0$var$getMaxLines(maxLines) === 2 && $0233df0f75012bd0$var$anchorLinkLineHeight2Map[size],
            $0233df0f75012bd0$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        ref: anchorRef
    }, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP"
        ])
    }, hideTooltip || text === undefined ? anchor : $0233df0f75012bd0$var$withTooltip(anchor, url?.includes(text) ? url : text, testId));
};
var $0233df0f75012bd0$export$2e2bcd8739ae039 = $0233df0f75012bd0$var$BaseLinkElement;
module.exports["default"] = $0233df0f75012bd0$export$2e2bcd8739ae039;

});

parcelRegister("9ox4X", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $2Pib0 = parcelRequire("2Pib0");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $dM7c5 = parcelRequire("dM7c5");

const $c6488c9b7bc1f612$var$styles = null;
const $c6488c9b7bc1f612$var$ABSOLUTE_DATE_FORMAT = {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
};
const $c6488c9b7bc1f612$var$isValidTimeZone = (timeZone)=>{
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZone
        });
        return true;
    } catch  {
        return false;
    }
};
const $c6488c9b7bc1f612$var$formatAbsoluteDateWithOptionalTimeZone = ({ date: date, formatDate: formatDate, timeZone: timeZone })=>{
    if (!timeZone || !$c6488c9b7bc1f612$var$isValidTimeZone(timeZone)) return formatDate(date, $c6488c9b7bc1f612$var$ABSOLUTE_DATE_FORMAT);
    return formatDate(date, {
        ...$c6488c9b7bc1f612$var$ABSOLUTE_DATE_FORMAT,
        timeZone: timeZone
    });
};
const $c6488c9b7bc1f612$var$typeToDescriptorMap = {
    created: {
        relative: (0, $dM7c5.messages).created_on_relative,
        absolute: (0, $dM7c5.messages).created_on_absolute
    },
    modified: {
        relative: (0, $dM7c5.messages).modified_on_relative,
        absolute: (0, $dM7c5.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $dM7c5.messages).sent_on_relative,
        absolute: (0, $dM7c5.messages).sent_on_absolute
    }
};
const $c6488c9b7bc1f612$var$fontOverrideStyleMap = {
    'font.body': "_2sNsIgmnOE",
    'font.body.large': "_2sNsIg20Hp",
    'font.body.small': "_2sNsIg7NXe"
};
const $c6488c9b7bc1f612$var$BaseDateTimeElement = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text, hideDatePrefix: hideDatePrefix = false, color: color, fontSize: fontSize, timeZone: timeZone })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = (0, $iDrrr.fg)('dfo_issue_view_remote_data_srr_group') ? $c6488c9b7bc1f612$var$formatAbsoluteDateWithOptionalTimeZone({
            date: date,
            formatDate: formatDate,
            timeZone: timeZone
        }) : formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $2Pib0.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    let content;
    if (hideDatePrefix) content = context;
    else if (text) content = `${text} ${context}`;
    else content = /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...$c6488c9b7bc1f612$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    });
    return /*#__PURE__*/ $cozmU.createElement("span", {
        style: {
            color: color
        },
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzZpcK _3iDTPbgJ9S _4ouGXIdnbC _39HuIbz8Lp _3W2Oc8wPeg _4Gn54R7dHp _1U1ZhbbI28 _2nBKY9ey7F",
            fontSize !== undefined && $c6488c9b7bc1f612$var$fontOverrideStyleMap[fontSize],
            className
        ])
    }, content);
};
var $c6488c9b7bc1f612$export$2e2bcd8739ae039 = $c6488c9b7bc1f612$var$BaseDateTimeElement;
module.exports["default"] = $c6488c9b7bc1f612$export$2e2bcd8739ae039;

});

parcelRegister("8c7of", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $3a528e8d5cdd7a30$export$2d4384e6b150cbe3 = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};
module.exports["toDateTimeProps"] = $3a528e8d5cdd7a30$export$2d4384e6b150cbe3;

});

parcelRegister("bYlCi", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9KSWX = parcelRequire("9KSWX");


var $iDrrr = parcelRequire("iDrrr");


var $eY4uS = parcelRequire("eY4uS");


var $it2N0 = parcelRequire("it2N0");


var $fjPbo = parcelRequire("fjPbo");

const $cd825829ae2f70d5$var$styles = null;
const $cd825829ae2f70d5$var$dueOnStyles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {BaseLozengeElementProps} BaseLozengeElementProps - The props necessary for the Lozenge element.
 * @see State
 */ const $cd825829ae2f70d5$var$BaseLozengeElement = ({ action: action, appearance: appearance = 'default', className: className, maxWidth: maxWidth, name: name, onAfterChanged: onAfterChanged, style: style, text: text, testId: testId = 'smart-element-lozenge', isDateTag: isDateTag, trailingMetric: trailingMetric })=>{
    const ui = (0, $it2N0.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ $cozmU.createElement((0, $fjPbo.default), {
        action: action,
        appearance: appearance,
        maxWidth: maxWidth,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex,
        onAfterChanged: onAfterChanged,
        ...trailingMetric && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? {
            trailingMetric: trailingMetric
        } : undefined
    }) : isDateTag ? /*#__PURE__*/ $cozmU.createElement((0, $eY4uS.default), {
        text: text,
        migration_fallback: "lozenge"
    }) : /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: true,
        maxWidth: maxWidth,
        style: style,
        testId: `${testId}-lozenge`,
        ...trailingMetric && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? {
            trailingMetric: trailingMetric
        } : undefined
    }, text);
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_3iDTPbccYA _4ouGXIE6Kk",
            isDateTag && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && "_3138425UaJ _0adFHs5UaJ _1DCdHi5UaJ _2XsHFM5UaJ",
            className
        ])
    }, lozenge);
};
var $cd825829ae2f70d5$export$2e2bcd8739ae039 = $cd825829ae2f70d5$var$BaseLozengeElement;
module.exports["default"] = $cd825829ae2f70d5$export$2e2bcd8739ae039;

});

parcelRegister("f6O9b", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $1b1108bb5e7b7d91$export$f12aecc78be3c7bb = (content)=>{
    return content ? {
        content: content
    } : undefined;
};
module.exports["toTextProps"] = $1b1108bb5e7b7d91$export$f12aecc78be3c7bb;

});

parcelRegister("ggIq5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $k8i0T = parcelRequire("k8i0T");


var $3M4EV = parcelRequire("3M4EV");


var $knKT4 = parcelRequire("knKT4");

const $d9743902edbc2b34$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node) && node.type === (0, $3M4EV.default);
const $d9743902edbc2b34$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node) && ((0, $k8i0T.isFlexibleUiElement)(node) || node.type === (0, $knKT4.default));
const $d9743902edbc2b34$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (child)=>{
        if ($d9743902edbc2b34$var$isElementOrElementGroup(child) || $d9743902edbc2b34$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
module.exports["renderChildren"] = $d9743902edbc2b34$export$cd762ccf1a583d69;

});

parcelRegister("fj0wU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $kjaz0 = parcelRequire("kjaz0");


var $jJP7n = parcelRequire("jJP7n");

const $d5f7874bbde1d059$var$AppliedToComponentsCountElement = (props)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const context = (0, $kjaz0.useFlexibleUiContext)();
    if (// Check for null and undefined, render if it's 0.
    context?.appliedToComponentsCount === null || context?.appliedToComponentsCount === undefined) return null;
    const label = formatMessage((0, $dM7c5.messages).compass_applied_components_count, {
        numberOfComponents: context.appliedToComponentsCount
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).Component,
        label: label,
        ...props
    });
};
var $d5f7874bbde1d059$export$2e2bcd8739ae039 = $d5f7874bbde1d059$var$AppliedToComponentsCountElement;
module.exports["default"] = $d5f7874bbde1d059$export$2e2bcd8739ae039;

});

parcelRegister("leiiU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $3ec5J = parcelRequire("3ec5J");


var $cZnAt = parcelRequire("cZnAt");

const $fba2805a8ad6b102$var$HostNameElement = (props)=>{
    const context = (0, $3ec5J.useFlexibleCardContext)();
    const hostName = context?.data?.hostName;
    return hostName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        content: hostName,
        ...props,
        name: (0, $4yYAm.ElementName).HostName
    }) : null;
};
var $fba2805a8ad6b102$export$2e2bcd8739ae039 = $fba2805a8ad6b102$var$HostNameElement;
module.exports["default"] = $fba2805a8ad6b102$export$2e2bcd8739ae039;

});

parcelRegister("8xQB8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $kjaz0 = parcelRequire("kjaz0");


var $cZnAt = parcelRequire("cZnAt");

var $10jYv = parcelRequire("10jYv");

const $b36f8cfb192a5fc3$var$MAX_TEAM_MEMBER_LIMIT = 50;
const $b36f8cfb192a5fc3$var$TeamMemberCountElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    if (!context?.teamMemberCount) return null;
    const count = context?.teamMemberCount && context?.teamMemberCount > $b36f8cfb192a5fc3$var$MAX_TEAM_MEMBER_LIMIT ? `${$b36f8cfb192a5fc3$var$MAX_TEAM_MEMBER_LIMIT}+` : context?.teamMemberCount?.toString();
    const data = count ? (0, $10jYv.toFormattedTextProps)((0, $dM7c5.messages).team_members_count, count) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).TeamMemberCount
    }) : null;
};
var $b36f8cfb192a5fc3$export$2e2bcd8739ae039 = $b36f8cfb192a5fc3$var$TeamMemberCountElement;
module.exports["default"] = $b36f8cfb192a5fc3$export$2e2bcd8739ae039;

});

parcelRegister("fO7nk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $kjaz0 = parcelRequire("kjaz0");


var $cZnAt = parcelRequire("cZnAt");

var $10jYv = parcelRequire("10jYv");

const $f6b6d2f50b462776$var$UserAttributesElement = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const renderUserAttributes = (userAttributes)=>{
        if (!userAttributes) return null;
        const attributeKeys = [
            'pronouns',
            'role',
            'department',
            'location'
        ];
        const attributes = [];
        attributeKeys.forEach((key)=>{
            if (userAttributes[key]) {
                const data = (0, $10jYv.toFormattedTextProps)((0, $dM7c5.messages).user_attributes, userAttributes[key]);
                if (data) attributes.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
                    key: key,
                    ...data,
                    testId: `smart-element-text-${key}`,
                    ...props,
                    name: (0, $4yYAm.ElementName).UserAttributes
                }));
            }
        });
        return attributes.length > 0 ? attributes : null;
    };
    const elements = context ? renderUserAttributes(context.userAttributes) : null;
    return elements ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, elements) : null;
};
var $f6b6d2f50b462776$export$2e2bcd8739ae039 = $f6b6d2f50b462776$var$UserAttributesElement;
module.exports["default"] = $f6b6d2f50b462776$export$2e2bcd8739ae039;

});

parcelRegister("44bfd", function(module, exports) {
/* MetadataBlock.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4yYAm = parcelRequire("4yYAm");


var $3ec5J = parcelRequire("3ec5J");


var $3qg1D = parcelRequire("3qg1D");


var $knKT4 = parcelRequire("knKT4");


var $1NMtH = parcelRequire("1NMtH");

const $a9cc91f0c122b2f8$export$13bf823ad4713393 = {
    DEFAULT_MAX_LINES: 2,
    MAXIMUM_MAX_LINES: 2,
    MINIMUM_MAX_LINES: 1
};


const $088677278b9466c9$var$truncateStyles = {
    '1': "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbgJ9S _39HuIbz8Lp _3W2Oc8wPeg _4Gn54R7dHp _1U1ZhbbI28",
    '2': "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbgJ9S _39HuIbz8Lp _3W2Oc8wPeg _4Gn54RiZR3 _1U1ZhbbI28"
};
const $088677278b9466c9$var$sizeStyles = {
    xlarge: "_2nBKY9mdCj",
    large: "_2nBKY9mdCj",
    medium: "_2nBKY9pJKa",
    small: "_2nBKY9pJKa"
};
const $088677278b9466c9$var$getMaxLines = (maxLines)=>{
    if (maxLines > (0, $a9cc91f0c122b2f8$export$13bf823ad4713393).MAXIMUM_MAX_LINES) return (0, $a9cc91f0c122b2f8$export$13bf823ad4713393).DEFAULT_MAX_LINES;
    if (maxLines < (0, $a9cc91f0c122b2f8$export$13bf823ad4713393).MINIMUM_MAX_LINES) return (0, $a9cc91f0c122b2f8$export$13bf823ad4713393).MINIMUM_MAX_LINES;
    return maxLines;
};
const $088677278b9466c9$var$ElementItemRenderer = ({ align: align = (0, $4yYAm.SmartLinkAlignment).Left, items: items = [], display: display = 'inline', size: size = (0, $4yYAm.SmartLinkSize).Medium, maxLines: maxLines = (0, $a9cc91f0c122b2f8$export$13bf823ad4713393).DEFAULT_MAX_LINES })=>{
    const elements = (0, $1NMtH.renderElementItems)(items, display);
    return elements && /*#__PURE__*/ $cozmU.createElement((0, $knKT4.default), {
        align: align,
        direction: (0, $4yYAm.SmartLinkDirection).Horizontal,
        width: (0, $4yYAm.SmartLinkWidth).Flexible,
        size: size,
        className: (0, $hekY6.default)([
            $088677278b9466c9$var$truncateStyles[maxLines],
            $088677278b9466c9$var$sizeStyles[size]
        ])
    }, elements);
}; /**
    * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
    * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
    * @public
    * @param {MetadataBlockProps} MetadataBlockProps
    * @see Block
    */ 
const $088677278b9466c9$export$2e4ce4ce734f69e1 = ({ maxLines: maxLines = (0, $a9cc91f0c122b2f8$export$13bf823ad4713393).DEFAULT_MAX_LINES, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    const cardContext = (0, $3ec5J.useFlexibleCardContext)();
    if (primary.length === 0 && secondary.length === 0 || cardContext?.status !== (0, $4yYAm.SmartLinkStatus).Resolved) return null;
    const size = blockProps?.size ?? cardContext?.ui?.size ?? (0, $4yYAm.SmartLinkSize).Medium;
    const maxLinesTotal = $088677278b9466c9$var$getMaxLines(maxLines);
    return /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        ...blockProps,
        size: size,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ $cozmU.createElement($088677278b9466c9$var$ElementItemRenderer, {
        items: primary,
        size: size,
        maxLines: maxLinesTotal
    }), /*#__PURE__*/ $cozmU.createElement($088677278b9466c9$var$ElementItemRenderer, {
        align: (0, $4yYAm.SmartLinkAlignment).Right,
        items: secondary,
        size: size,
        maxLines: maxLinesTotal
    }));
};
module.exports["MetadataBlock"] = $088677278b9466c9$export$2e4ce4ce734f69e1;

});

parcelRegister("d35qR", function(module, exports) {
/* CardPopupWrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $03ac0dbc50e02241$var$styles = {
    wrapper: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _39xV02wBC3 _2OUyjtFYNq"
};
function $03ac0dbc50e02241$export$aefd550f0f72fff8({ children: children }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $03ac0dbc50e02241$var$styles.wrapper,
        backgroundColor: "elevation.surface.overlay",
        children: children
    });
}
module.exports["CardPopupWrapper"] = $03ac0dbc50e02241$export$aefd550f0f72fff8;

});

parcelRegister("c4fg0", function(module, exports) {
/* AgentCardLoading.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $fWkhK = parcelRequire("fWkhK");


var $jJ1KU = parcelRequire("jJ1KU");

const $c38eaf812f6ce80f$var$styles = {
    card: "_39xV02PIoL"
};
function $c38eaf812f6ce80f$export$54489a2dfb0679c2() {
    return (0, $iDrrr.fg)('rovo_agent_profile_card_browse_kit') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $c38eaf812f6ce80f$var$styles.card,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jJ1KU.AgentCardSkeleton), {})
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fWkhK.AgentProfileCardSkeleton), {});
}
module.exports["AgentCardLoading"] = $c38eaf812f6ce80f$export$54489a2dfb0679c2;

});

parcelRegister("kKnPE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lUcpS = parcelRequire("lUcpS");


var $eRfpr = parcelRequire("eRfpr");


var $bIiaK = parcelRequire("bIiaK");

// Cast payload superset to `never` so `fireEvent` accepts extra SLO fields.
const $5204e5464349947f$var$asExtendedPayload = (payload)=>payload;
function $5204e5464349947f$export$97ec6f6769110fe4() {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    return ()=>{
        fireEvent('operational.profilecard.triggered.request', {
            firedAt: (0, $eRfpr.firedAt)()
        });
    };
}
function $5204e5464349947f$export$f7831696c122c106() {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const firedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (firedRef.current) return;
        firedRef.current = true;
        fireEvent('ui.profilecard.rendered.spinner', {
            firedAt: (0, $eRfpr.firedAt)()
        });
    }, [
        fireEvent
    ]);
}
function $5204e5464349947f$export$38eb2c63ddf3e3a3(hasProfileData) {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $bIiaK.useCardOpenTimer)();
    const firedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!hasProfileData || firedRef.current) return;
        firedRef.current = true;
        fireEvent('operational.profilecard.succeeded.request', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0
        });
    }, [
        hasProfileData,
        fireEvent,
        getDurationSinceInteraction
    ]);
}
function $5204e5464349947f$export$20c24f03e0a7c8fc(profileData) {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $bIiaK.useCardOpenTimer)();
    const firedRef = (0, $cozmU.useRef)(false);
    const profileDataRef = (0, $cozmU.useRef)(profileData);
    profileDataRef.current = profileData;
    (0, $cozmU.useEffect)(()=>{
        if (firedRef.current) return;
        firedRef.current = true;
        fireEvent('ui.profilecard.rendered.content', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            numActions: (0, $eRfpr.countRenderedActions)(profileDataRef.current)
        });
    }, [
        fireEvent,
        getDurationSinceInteraction
    ]);
}
function $5204e5464349947f$export$5fc91356da713d06(error) {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $bIiaK.useCardOpenTimer)();
    const firedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (error === undefined || firedRef.current) return;
        firedRef.current = true;
        const attributes = error === null ? {
            errorType: 'NotFound'
        } : (0, $eRfpr.getErrorAttributes)(error);
        if (attributes.errorType === 'NotFound') {
            fireEvent('operational.profilecard.succeeded.request', {
                firedAt: (0, $eRfpr.firedAt)(),
                duration: getDurationSinceInteraction() ?? 0
            });
            return;
        }
        fireEvent('operational.profilecard.failed.request', $5204e5464349947f$var$asExtendedPayload({
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            // schema requires `errorMessage`; send the classified type to avoid PII.
            errorMessage: attributes.errorType,
            errorType: attributes.errorType,
            ...attributes.statusCode !== undefined ? {
                errorStatusCode: attributes.statusCode
            } : {}
        }));
    }, [
        error,
        fireEvent,
        getDurationSinceInteraction
    ]);
}
module.exports["useFireTriggeredRequest"] = $5204e5464349947f$export$97ec6f6769110fe4;
module.exports["useFireRenderedSpinner"] = $5204e5464349947f$export$f7831696c122c106;
module.exports["useFireRequestSucceeded"] = $5204e5464349947f$export$38eb2c63ddf3e3a3;
module.exports["useFireContentRendered"] = $5204e5464349947f$export$20c24f03e0a7c8fc;
module.exports["useFireRequestFailed"] = $5204e5464349947f$export$5fc91356da713d06;

});

parcelRegister("eRfpr", function(module, exports) {

var $g0RaX = parcelRequire("g0RaX");

function $c6281ea988ae57a1$export$935a1f551ec13075(profileData) {
    if (!profileData) return 0;
    let count = 0;
    if (profileData.accountId) count += 1;
    const isDeactivated = profileData.accountStatus === 'inactive' || profileData.accountStatus === 'closed';
    if (!isDeactivated && profileData.thirdPartyIntegrations && profileData.thirdPartyIntegrations.length > 0) count += 1;
    return count;
}
const $c6281ea988ae57a1$export$feb180212387929b = ()=>Math.round((0, $g0RaX.getPageTime)());
const $c6281ea988ae57a1$export$6ad9e7706a4ee0f8 = (error)=>{
    const statusCode = $c6281ea988ae57a1$var$readNumericField(error, 'statusCode') ?? $c6281ea988ae57a1$var$readNumericField(error, 'status') ?? $c6281ea988ae57a1$var$readRelayExtensionsStatusCode(error);
    if (statusCode === 404 || $c6281ea988ae57a1$var$isNotFoundLikeError(error, statusCode)) return statusCode !== undefined ? {
        errorType: 'NotFound',
        statusCode: statusCode
    } : {
        errorType: 'NotFound'
    };
    return statusCode !== undefined ? {
        errorType: 'default',
        statusCode: statusCode
    } : {
        errorType: 'default'
    };
};
/**
 * Relay surfaces network errors as `{ errors: [{ extensions: { statusCode, errorType, ... } }] }`.
 * Reads the first error's `extensions.statusCode` so the SLO classification works against the
 * common Relay error envelope, not just hand-rolled `{ statusCode }` objects.
 */ const $c6281ea988ae57a1$var$readRelayExtensionsStatusCode = (error)=>{
    if (!error || typeof error !== 'object' || !('errors' in error)) return undefined;
    const errors = error.errors;
    if (!Array.isArray(errors) || errors.length === 0) return undefined;
    const first = errors[0];
    if (!first || typeof first !== 'object' || !('extensions' in first)) return undefined;
    const extensions = first.extensions;
    if (!extensions || typeof extensions !== 'object') return undefined;
    return $c6281ea988ae57a1$var$readNumericField(extensions, 'statusCode') ?? $c6281ea988ae57a1$var$readNumericField(extensions, 'status');
};
const $c6281ea988ae57a1$var$readNumericField = (error, field)=>{
    if (error && typeof error === 'object' && field in error) {
        const value = error[field];
        if (typeof value === 'number' && Number.isFinite(value)) return value;
    }
    return undefined;
};
/** Returns true for unambiguous not-found signals. Message-pattern matching is last-resort — only used when statusCode is absent to avoid misclassifying generic errors (e.g. a 500 whose message contains "not found"). */ const $c6281ea988ae57a1$var$isNotFoundLikeError = (error, statusCode)=>{
    if (!error || typeof error !== 'object') return false;
    const code = $c6281ea988ae57a1$var$readStringField(error, 'code');
    if (code && /NOT_FOUND/i.test(code)) return true;
    // Only match message patterns when there is no statusCode — a 500 with "not found" in its message must not be misclassified as NotFound.
    if (statusCode === undefined) {
        const message = $c6281ea988ae57a1$var$readStringField(error, 'message');
        if (message && /\bnot\s*found\b/i.test(message)) return true;
    }
    return false;
};
const $c6281ea988ae57a1$var$readStringField = (error, field)=>{
    if (field in error) {
        const value = error[field];
        if (typeof value === 'string') return value;
    }
    return undefined;
};
module.exports["countRenderedActions"] = $c6281ea988ae57a1$export$935a1f551ec13075;
module.exports["firedAt"] = $c6281ea988ae57a1$export$feb180212387929b;
module.exports["getErrorAttributes"] = $c6281ea988ae57a1$export$6ad9e7706a4ee0f8;

});

parcelRegister("2atIz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $50c6c751a4eda4dc$export$cd42012d8c9757c9 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
module.exports["CardCloseGuardContext"] = $50c6c751a4eda4dc$export$cd42012d8c9757c9;

});

parcelRegister("bIiaK", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $g0RaX = parcelRequire("g0RaX");

const $1aeaee3bd13c0f7b$var$noopContext = {
    markInteractionStart: ()=>{},
    getDurationSinceInteraction: ()=>undefined
};
const $1aeaee3bd13c0f7b$var$CardOpenTimerContext = /*#__PURE__*/ (0, $cozmU.createContext)($1aeaee3bd13c0f7b$var$noopContext);
function $1aeaee3bd13c0f7b$export$8f61ff484d9ed897({ children: children }) {
    const outer = (0, $cozmU.useContext)($1aeaee3bd13c0f7b$var$CardOpenTimerContext);
    const interactionStartRef = (0, $cozmU.useRef)(null);
    const markInteractionStart = (0, $cozmU.useCallback)(()=>{
        // Re-arm per interaction so successive opens each measure from their own t=0.
        interactionStartRef.current = (0, $g0RaX.getPageTime)();
    }, []);
    const getDurationSinceInteraction = (0, $cozmU.useCallback)(()=>{
        if (interactionStartRef.current === null) return undefined;
        return Math.max(0, (0, $g0RaX.getPageTime)() - interactionStartRef.current);
    }, []);
    const value = (0, $cozmU.useMemo)(()=>({
            markInteractionStart: markInteractionStart,
            getDurationSinceInteraction: getDurationSinceInteraction
        }), [
        markInteractionStart,
        getDurationSinceInteraction
    ]);
    if (outer !== $1aeaee3bd13c0f7b$var$noopContext) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($1aeaee3bd13c0f7b$var$CardOpenTimerContext.Provider, {
        value: value,
        children: children
    });
}
function $1aeaee3bd13c0f7b$export$d0c3a3e820a371d6() {
    return (0, $cozmU.useContext)($1aeaee3bd13c0f7b$var$CardOpenTimerContext);
}
module.exports["CardOpenTimerProvider"] = $1aeaee3bd13c0f7b$export$8f61ff484d9ed897;
module.exports["useCardOpenTimer"] = $1aeaee3bd13c0f7b$export$d0c3a3e820a371d6;

});

parcelRegister("9gll8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/** Sentinel identity used to detect "no outer provider" without an explicit flag. */ const $c070228ab88c7aa0$export$ff993edec5f1dba3 = ()=>undefined;
const $c070228ab88c7aa0$export$24fd9e960a1a443b = /*#__PURE__*/ (0, $cozmU.createContext)({
    cloudId: '',
    townsquareApp: undefined,
    onProfileClick: undefined,
    getTestId: $c070228ab88c7aa0$export$ff993edec5f1dba3
});
module.exports["defaultGetTestId"] = $c070228ab88c7aa0$export$ff993edec5f1dba3;
module.exports["UserProfileCardContext"] = $c070228ab88c7aa0$export$24fd9e960a1a443b;

});

parcelRegister("bXEsj", function(module, exports) {
/**
 * Default testId used by the user profile card when the consumer does not pass one.
 * Centralised so the `getTestId` factory in `UserProfileCard` and
 * `UserProfileCardWithTrigger` agrees on what counts as "default".
 */ const $a9a5f85cd687888c$export$d0c64eda5f53987e = 'user-profile-card';
const $a9a5f85cd687888c$export$51b2da6fcb5ae549 = (userId, testId)=>{
    const baseTestId = `user-profile-card-${userId}`;
    const isDefaultTestId = !testId || testId === $a9a5f85cd687888c$export$d0c64eda5f53987e;
    const suffixModifier = isDefaultTestId ? '' : `--${testId}`;
    return (suffix)=>userId ? `${baseTestId}-${suffix}${suffixModifier}` : undefined;
};
module.exports["makeGetTestId"] = $a9a5f85cd687888c$export$51b2da6fcb5ae549;

});

parcelRegister("9iuN4", function(module, exports) {
const $da2f097720522834$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
module.exports["getFormattedMessageAsString"] = $da2f097720522834$export$66ecb50a9dd1768;

});

parcelRegister("j2eru", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $j39Hd = parcelRequire("j39Hd");


var $eWtDJ = parcelRequire("eWtDJ");


var $c7dFC = parcelRequire("c7dFC");

const $f0965a811968f271$export$303ede4eed148855 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (cardClient)=>{
    const $ = (0, $bDgLe.c)(4);
    const resolverUrl = (0, $c7dFC.useResolverUrl)(cardClient);
    let t0;
    if ($[0] !== resolverUrl) {
        t0 = async (data)=>{
            try {
                return await (0, $j39Hd.request)("post", `${resolverUrl}/invoke`, data, undefined, [
                    200,
                    201,
                    202,
                    203,
                    204
                ]);
            } catch (t1) {
                const err = t1;
                if (err && err.json && typeof err.json === "function") {
                    const errorBody = await err.json();
                    if (errorBody) throw new (0, $eWtDJ.InvokeError)(errorBody?.error.message, errorBody?.error.status);
                }
                throw err;
            }
        };
        $[0] = resolverUrl;
        $[1] = t0;
    } else t0 = $[1];
    const invoke = t0;
    let t1;
    if ($[2] !== invoke) {
        t1 = {
            invoke: invoke
        };
        $[2] = invoke;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (cardClient)=>{
    const resolverUrl = (0, $c7dFC.useResolverUrl)(cardClient);
    const invoke = (0, $cozmU.useCallback)(async (data)=>{
        try {
            return await (0, $j39Hd.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $eWtDJ.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $cozmU.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};
module.exports["useSmartLinkClientExtension"] = $f0965a811968f271$export$303ede4eed148855;

});

parcelRegister("2nc6N", function(module, exports) {
const $24ff3ad88a36baf4$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};
module.exports["hasWhiteSpace"] = $24ff3ad88a36baf4$export$619e376a425cb759;

});

parcelRegister("2Pib0", function(module, exports) {
var $20ee71a6d547a2a3$var$__assign = undefined && undefined.__assign || function() {
    $20ee71a6d547a2a3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $20ee71a6d547a2a3$var$__assign.apply(this, arguments);
};
var $20ee71a6d547a2a3$var$MS_PER_SECOND = 1e3;
var $20ee71a6d547a2a3$var$SECS_PER_MIN = 60;
var $20ee71a6d547a2a3$var$SECS_PER_HOUR = $20ee71a6d547a2a3$var$SECS_PER_MIN * 60;
var $20ee71a6d547a2a3$var$SECS_PER_DAY = $20ee71a6d547a2a3$var$SECS_PER_HOUR * 24;
var $20ee71a6d547a2a3$var$SECS_PER_WEEK = $20ee71a6d547a2a3$var$SECS_PER_DAY * 7;
function $20ee71a6d547a2a3$export$b8f7189986dd5395(from, to, thresholds) {
    if (to === void 0) to = Date.now();
    if (thresholds === void 0) thresholds = {};
    var resolvedThresholds = $20ee71a6d547a2a3$var$__assign($20ee71a6d547a2a3$var$__assign({}, $20ee71a6d547a2a3$export$f4fd60e41371f80d), thresholds || {});
    var secs = (+from - +to) / $20ee71a6d547a2a3$var$MS_PER_SECOND;
    if (Math.abs(secs) < resolvedThresholds.second) return {
        value: Math.round(secs),
        unit: 'second'
    };
    var mins = secs / $20ee71a6d547a2a3$var$SECS_PER_MIN;
    if (Math.abs(mins) < resolvedThresholds.minute) return {
        value: Math.round(mins),
        unit: 'minute'
    };
    var hours = secs / $20ee71a6d547a2a3$var$SECS_PER_HOUR;
    if (Math.abs(hours) < resolvedThresholds.hour) return {
        value: Math.round(hours),
        unit: 'hour'
    };
    var days = secs / $20ee71a6d547a2a3$var$SECS_PER_DAY;
    if (Math.abs(days) < resolvedThresholds.day) return {
        value: Math.round(days),
        unit: 'day'
    };
    var fromDate = new Date(from);
    var toDate = new Date(to);
    var years = fromDate.getFullYear() - toDate.getFullYear();
    if (Math.round(Math.abs(years)) > 0) return {
        value: Math.round(years),
        unit: 'year'
    };
    var months = years * 12 + fromDate.getMonth() - toDate.getMonth();
    if (Math.round(Math.abs(months)) > 0) return {
        value: Math.round(months),
        unit: 'month'
    };
    var weeks = secs / $20ee71a6d547a2a3$var$SECS_PER_WEEK;
    return {
        value: Math.round(weeks),
        unit: 'week'
    };
}
var $20ee71a6d547a2a3$export$f4fd60e41371f80d = {
    second: 45,
    minute: 45,
    hour: 22,
    day: 5
};
module.exports["selectUnit"] = $20ee71a6d547a2a3$export$b8f7189986dd5395;

});

parcelRegister("fjPbo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3vgx3 = parcelRequire("3vgx3");


var $iDrrr = parcelRequire("iDrrr");


var $6Vsq4 = parcelRequire("6Vsq4");


var $f92oS = parcelRequire("f92oS");


var $bwJAe = parcelRequire("bwJAe");


var $aDH7j = parcelRequire("aDH7j");


var $cEvdy = parcelRequire("cEvdy");


var $iaxrH = parcelRequire("iaxrH");


var $6GOAK = parcelRequire("6GOAK");


var $dKFXD = parcelRequire("dKFXD");


var $4oSKE = parcelRequire("4oSKE");


var $iM6Ch = parcelRequire("iM6Ch");


var $84UG4 = parcelRequire("84UG4");


var $8dbeV = parcelRequire("8dbeV");


var $3vexH = parcelRequire("3vexH");

const $9cbbde11c9060b49$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $9cbbde11c9060b49$var$LozengeAction = ({ action: action, appearance: appearance, maxWidth: maxWidth, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex, onAfterChanged: onAfterChanged, trailingMetric: trailingMetric, shouldRenderToParent: shouldRenderToParent = false })=>{
    const [selected, setSelected] = (0, $cozmU.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $cozmU.useState)(false);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [items, setItems] = (0, $cozmU.useState)();
    const [errorMessage, setErrorMessage] = (0, $cozmU.useState)();
    const reload = (0, $cEvdy.default)();
    const invoke = (0, $bwJAe.default)();
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $cozmU.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $6GOAK.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $f92oS.default));
                const validItems = typeof text === 'string' ? $9cbbde11c9060b49$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $4oSKE.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $iDrrr.fg)('confluence-issue-terminology-refresh') ? (0, $84UG4.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $84UG4.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch  {
                setErrorMessage((0, $84UG4.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $4oSKE.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $cozmU.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vexH.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            maxWidth: maxWidth,
            testId: testId,
            text: selected.text,
            trailingMetric: trailingMetric
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        maxWidth,
        testId,
        trailingMetric
    ]);
    const handleItemClick = (0, $cozmU.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $iaxrH.default)(updateAction, id);
                await invoke(request);
                onAfterChanged?.();
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $6GOAK.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload({
                    url: url,
                    isReloading: true,
                    id: linkId
                });
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $aDH7j.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $4oSKE.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $84UG4.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $4oSKE.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent,
        onAfterChanged
    ]);
    const dropdownItemGroup = (0, $cozmU.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iM6Ch.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8dbeV.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        shouldRenderToParent: shouldRenderToParent
    }, dropdownItemGroup);
};
const $9cbbde11c9060b49$var$_default_1 = (0, $dKFXD.default)($9cbbde11c9060b49$var$LozengeAction);
var $9cbbde11c9060b49$export$2e2bcd8739ae039 = $9cbbde11c9060b49$var$_default_1;
module.exports["default"] = $9cbbde11c9060b49$export$2e2bcd8739ae039;

});

parcelRegister("k8i0T", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fj0wU = parcelRequire("fj0wU");


var $4cPhH = parcelRequire("4cPhH");


var $ktdgI = parcelRequire("ktdgI");


var $cA0ah = parcelRequire("cA0ah");


var $jqres = parcelRequire("jqres");


var $a8wJH = parcelRequire("a8wJH");


var $56DiX = parcelRequire("56DiX");


var $LvVJP = parcelRequire("LvVJP");


var $gsQuB = parcelRequire("gsQuB");


var $ikX3P = parcelRequire("ikX3P");


var $jUXZW = parcelRequire("jUXZW");


var $leiiU = parcelRequire("leiiU");


var $2VRbJ = parcelRequire("2VRbJ");


var $hsIfr = parcelRequire("hsIfr");


var $8y6iW = parcelRequire("8y6iW");


var $72lc5 = parcelRequire("72lc5");


var $7sCIj = parcelRequire("7sCIj");


var $4GRqQ = parcelRequire("4GRqQ");


var $cl3v4 = parcelRequire("cl3v4");


var $khRQO = parcelRequire("khRQO");


var $i64z9 = parcelRequire("i64z9");


var $7bJZv = parcelRequire("7bJZv");


var $fCf6x = parcelRequire("fCf6x");


var $eIk5O = parcelRequire("eIk5O");


var $7Q48s = parcelRequire("7Q48s");


var $9vYj2 = parcelRequire("9vYj2");


var $s4fzU = parcelRequire("s4fzU");


var $alGk9 = parcelRequire("alGk9");


var $ixgii = parcelRequire("ixgii");


var $8CvOu = parcelRequire("8CvOu");


var $hKI6m = parcelRequire("hKI6m");


var $kfBIC = parcelRequire("kfBIC");


var $gDO6D = parcelRequire("gDO6D");


var $8xQB8 = parcelRequire("8xQB8");


var $fIakH = parcelRequire("fIakH");


var $fO7nk = parcelRequire("fO7nk");


var $415JS = parcelRequire("415JS");


var $emHHi = parcelRequire("emHHi");


var $lkhb1 = parcelRequire("lkhb1");

const $9749396efc9da845$var$Elements = {
    AppliedToComponentsCount: $fj0wU.default,
    AssignedTo: $4cPhH.default,
    AssignedToGroup: $ktdgI.default,
    AttachmentCount: $cA0ah.default,
    AuthorGroup: $jqres.default,
    ChecklistProgress: $a8wJH.default,
    CollaboratorGroup: $56DiX.default,
    CommentCount: $LvVJP.default,
    CreatedBy: $gsQuB.default,
    CreatedOn: $ikX3P.default,
    DueOn: $jUXZW.default,
    HostName: $leiiU.default,
    LatestCommit: $2VRbJ.default,
    LinkIcon: $hsIfr.default,
    Location: $8y6iW.default,
    ModifiedBy: $72lc5.default,
    ModifiedOn: $7sCIj.default,
    OwnedBy: $4GRqQ.default,
    OwnedByGroup: $cl3v4.default,
    Preview: $khRQO.default,
    Priority: $i64z9.default,
    ProgrammingLanguage: $7bJZv.default,
    Provider: $fCf6x.default,
    ReactCount: $eIk5O.default,
    ReadTime: $7Q48s.default,
    SentOn: $9vYj2.default,
    Snippet: $s4fzU.default,
    SourceBranch: $alGk9.default,
    State: $ixgii.default,
    StoryPoints: $8CvOu.default,
    SubTasksProgress: $hKI6m.default,
    SubscriberCount: $kfBIC.default,
    TargetBranch: $gDO6D.default,
    TeamMemberCount: $8xQB8.default,
    Title: $fIakH.default,
    UserAttributes: $fO7nk.default,
    ViewCount: $415JS.default,
    VoteCount: $emHHi.default
};
const $9749396efc9da845$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node)) return false;
    if (Object.values($9749396efc9da845$var$Elements).some((type)=>type === node.type)) return true;
    if ((0, $lkhb1.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $9749396efc9da845$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
module.exports["isFlexibleUiElement"] = $9749396efc9da845$export$d7fc505bb0bd5756;

});

parcelRegister("f92oS", function(module, exports) {
const $f0be3113a19fee73$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $f0be3113a19fee73$export$2e2bcd8739ae039 = $f0be3113a19fee73$var$extractLozengeActionItems;
module.exports["default"] = $f0be3113a19fee73$export$2e2bcd8739ae039;

});

parcelRegister("iaxrH", function(module, exports) {
const $12322a86b2d18f7a$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $12322a86b2d18f7a$export$2e2bcd8739ae039 = $12322a86b2d18f7a$var$createStatusUpdateRequest;
module.exports["default"] = $12322a86b2d18f7a$export$2e2bcd8739ae039;

});

parcelRegister("dKFXD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $9KSWX = parcelRequire("9KSWX");

const $e5c8e130a6b36b08$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
                appearance: props?.appearance,
                isBold: true,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`,
                trailingMetric: props?.trailingMetric
            }, props?.text), [
            props?.appearance,
            props?.testId,
            props?.text,
            props?.trailingMetric
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props));
    };
var $e5c8e130a6b36b08$export$2e2bcd8739ae039 = $e5c8e130a6b36b08$var$withErrorBoundary;
module.exports["default"] = $e5c8e130a6b36b08$export$2e2bcd8739ae039;

});

parcelRegister("4oSKE", function(module, exports) {
const $7a40eaa9d3d6b29e$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $7a40eaa9d3d6b29e$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $7a40eaa9d3d6b29e$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $7a40eaa9d3d6b29e$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};
module.exports["unknownLoadErrorAnalyticsPayload"] = $7a40eaa9d3d6b29e$export$2a568ff99500df53;
module.exports["permissionLoadErrorAnalyticsPayload"] = $7a40eaa9d3d6b29e$export$2de2d0ccc17b915f;
module.exports["unknownUpdateErrorAnalyticsPayload"] = $7a40eaa9d3d6b29e$export$c1c05f9d51f7c467;
module.exports["validationUpdateErrorAnalyticsPayload"] = $7a40eaa9d3d6b29e$export$618660b8f2aa87e2;

});

parcelRegister("iM6Ch", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $kSwu1 = parcelRequire("kSwu1");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $24dy7 = parcelRequire("24dy7");


var $iDrrr = parcelRequire("iDrrr");


var $hBYtq = parcelRequire("hBYtq");


var $6Vsq4 = parcelRequire("6Vsq4");


var $dM7c5 = parcelRequire("dM7c5");


var $kfxZm = parcelRequire("kfxZm");


var $ULhqw = parcelRequire("ULhqw");

const $13a1bb7803caef18$var$MAX_LINE_NUMBER = 8;
const $13a1bb7803caef18$var$styles = {
    contentStyles: "_2mHwu82ADO _2sNsIg20Hp _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _4ouGXIdnbC _0aFT5v1qpb _313842FQfX _0hPCNLchRC _1HkmYgmnOE _2nAzZYmnOE _1xYrcmy7kJ _4iwgQuy7kJ",
    linkStyles: "_2mHwu82ADO _4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _3iDTPbQ4SZ _4ouGXIdnbC _0aFT5v1qpb _0hPCNLDIqT _0wOv4Q7zJH _3138422ADO _2XsHFMVa5s _1DCdHiFQfX",
    textStylesBase: "_2sNsIg20Hp _4bt5LAnQyn _2WAcuGnQyn _1ANEUSzUZr _3iDTPbgJ9S _39HuIbz8Lp _3W2Oc8wPeg _1U1ZhbbI28",
    dropdownItemGroupStyles: "_2FH9z4PIoL _0rushMOLYo _3lkMW918ZR",
    openIssueInJiraStyles: "_2sNsIgmnOE _23rrnHyKLB _0KLXrujOvk _37wbyuecOK _3iDTPbOLYo _1UtDYzM7Tp _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMAwSC"
};
const $13a1bb7803caef18$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $13a1bb7803caef18$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const invoke = (0, $kfxZm.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $cozmU.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $cozmU.useMemo)(()=>{
        return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $13a1bb7803caef18$var$styles.contentStyles
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            testId: `${testId}-icon`,
            color: "var(--ds-icon-danger, #C9372C)",
            label: 'error',
            spacing: "spacious"
        }), /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": `${testId}-error-message`,
            className: (0, $hekY6.default)([
                $13a1bb7803caef18$var$styles.textStylesBase,
                "_4Gn54Rc671 _2nBKY9PZbg"
            ]),
            style: {
                "--_t4prqe": (0, $9aYkv.default)(maxLineNumber)
            }
        }, typeof errorMessage === 'string' ? errorMessage : (0, $ULhqw.getFormattedMessage)(errorMessage))), isPreviewAvailable ? /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $13a1bb7803caef18$var$styles.linkStyles
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            testId: `${testId}-open-embed`,
            onClick: handlePreviewOpen,
            xcss: $13a1bb7803caef18$var$styles.openIssueInJiraStyles
        }, (0, $iDrrr.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).open_issue_in_jiraIssueTermRefresh) : /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).open_issue_in_jira))) : null);
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $hekY6.default)([
            $13a1bb7803caef18$var$styles.dropdownItemGroupStyles
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9erVg.default), null, /*#__PURE__*/ $cozmU.createElement((0, $is1T6.default), {
        testId: `${testId}-error`
    }, content)));
};
var $13a1bb7803caef18$export$2e2bcd8739ae039 = $13a1bb7803caef18$var$LozengeActionError;
module.exports["default"] = $13a1bb7803caef18$export$2e2bcd8739ae039;

});

parcelRegister("84UG4", function(module, exports) {

var $dM7c5 = parcelRequire("dM7c5");

const $ab784d52386de0cb$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $dM7c5.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $dM7c5.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $dM7c5.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $dM7c5.messages)['status_change_update_error']
    }
};
module.exports["LozengeActionErrorMessages"] = $ab784d52386de0cb$export$4f2e371a667ad688;

});

parcelRegister("8dbeV", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9erVg = parcelRequire("9erVg");


var $jgAjn = parcelRequire("jgAjn");

const $c576d9384b193cdf$var$dropdownItemGroupStyles = null;
const $c576d9384b193cdf$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $hekY6.default)([
            "_0NUa3rBfNa _2WAcuGIZbP _458OYC98eZ _3Put9R98eZ _1KlgPIYbGa _1reJrkYbGa _1GffKIT6kp _07uqNfT6kp _3NEQHQo126 _1Lk0Y4o126 _1wUjul2Njc _2oodiG2Njc _2jtNHusKwa _29rjtVsKwa _3syKoKgVvo _2h7MEP8HPE _3tOQhEgVvo _04h2sE8HPE _0RIC7ScM5X _2FH9z4PIoL _0rushMOLYo"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9erVg.default), null, items.map((item, idx)=>/*#__PURE__*/ $cozmU.createElement((0, $jgAjn.default), {
            ...item,
            key: idx,
            onClick: onClick,
            testId: `${testId}-item-${idx}`
        }))));
var $c576d9384b193cdf$export$2e2bcd8739ae039 = $c576d9384b193cdf$var$LozengeActionItemsGroup;
module.exports["default"] = $c576d9384b193cdf$export$2e2bcd8739ae039;

});

parcelRegister("3vexH", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $9KSWX = parcelRequire("9KSWX");


var $1glfF = parcelRequire("1glfF");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $dM7c5 = parcelRequire("dM7c5");

const $2588de3e72138c31$var$styles = {
    chevronDown: "_2XsHFMgVvo _3iDTPbQ4SZ",
    lozengeContainer: "_1mb4UnZqHV _0bjKvDKxmn _3hxITi6wH8 _2V7sgONvrM _3vBAKHjOvk _0KLXrujOvk _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0Vey7F",
    lozengeContainerSelected: "_4bt5LAnQyn _2WAcuGnQyn _3vBAKHnXvL",
    lozengeDropdownContainer: "_0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M"
};
const $2588de3e72138c31$var$textStyles = null;
const $2588de3e72138c31$var$triggerLozengeStyles = null;
const $2588de3e72138c31$var$triggerButtonStyles = null;
const $2588de3e72138c31$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, maxWidth: maxWidth, testId: testId, text: text, triggerRef: triggerRef, trailingMetric: trailingMetric, ...props })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isPressing, setIsPressing] = (0, $cozmU.useState)(false);
    const [lozengeBackgroundColor, setLozengeBackgroundColor] = (0, $cozmU.useState)(undefined);
    const [lozengeForegroundColor, setLozengeForegroundColor] = (0, $cozmU.useState)(undefined);
    const onMouseOrKeyDown = (0, $cozmU.useCallback)(()=>setIsPressing(true), []);
    const onMouseOrKeyUp = (0, $cozmU.useCallback)(()=>setIsPressing(false), []);
    (0, $cozmU.useEffect)(()=>{
        if (isPressing) {
            setLozengeBackgroundColor("var(--ds-background-selected-pressed, #8FB8F6)");
            setLozengeForegroundColor("var(--ds-text-selected, #1868DB)");
        } else if (isOpen) {
            setLozengeBackgroundColor("var(--ds-background-selected, #E9F2FE)");
            setLozengeForegroundColor("var(--ds-text-selected, #1868DB)");
        } else {
            setLozengeBackgroundColor(undefined);
            setLozengeForegroundColor(undefined);
        }
    }, [
        isPressing,
        isOpen
    ]);
    const lozenge = (0, $cozmU.useMemo)(()=>{
        return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $k12R1.cx)($2588de3e72138c31$var$styles.lozengeContainer, (isOpen || isPressing) && $2588de3e72138c31$var$styles.lozengeContainerSelected),
            as: "span"
        }, /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
            appearance: appearance,
            isBold: true,
            maxWidth: maxWidth,
            style: {
                backgroundColor: lozengeBackgroundColor,
                color: lozengeForegroundColor
            }
        }, /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                "_0hPCNLDIqT _3iDTPbQ4SZ"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7"
            ])
        }, text), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $2588de3e72138c31$var$styles.chevronDown
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            color: "currentColor",
            label: "options",
            size: "small",
            "aria-hidden": true
        })))));
    }, [
        appearance,
        isPressing,
        text,
        isOpen,
        lozengeBackgroundColor,
        lozengeForegroundColor,
        maxWidth
    ]);
    return (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $2588de3e72138c31$var$styles.lozengeDropdownContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $1glfF.default), {
        ...props,
        appearance: appearance,
        trailingMetric: trailingMetric,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        maxWidth: maxWidth,
        testId: testId,
        ref: triggerRef,
        "aria-label": // The `as unknown` type cast is needed for react-intl v7 upgrade
        intl.formatMessage((0, $dM7c5.messages).change_status, {
            status: text
        })
    }, text)) : /*#__PURE__*/ $cozmU.createElement("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        style: {
            maxWidth: maxWidth
        },
        onMouseDown: onMouseOrKeyDown,
        onMouseUp: onMouseOrKeyUp,
        onKeyDown: onMouseOrKeyDown,
        onKeyUp: onMouseOrKeyUp,
        ref: triggerRef,
        "aria-label": // The `as unknown` type cast is needed for react-intl v7 upgrade
        intl.formatMessage((0, $dM7c5.messages).change_status, {
            status: text
        }),
        className: (0, $hekY6.default)([
            "_1mb4UnZqHV _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _2Lm0GhZqHV _3hxITi6wH8 _2V7sgO2M4S _3vBAKHjOvk _0KLXrujOvk _1UtDYzZqHV _0wOv4Q7zJH _0WKd3GZqHV _4ya3eEZqHV _2l4i3rZqHV _1kk5TkZqHV _26BoRwdnbC _41LZZBZqHV _313842FQfX _0adFHsFQfX _1DCdHiFQfX _2XsHFMFQfX _1ubuxo98eZ _3ug7X598eZ _1FiV8B98eZ _1NDpvbYbGa _1FBEATYbGa _462dWnYbGa _2wtOC9T6kp _2ueIPVT6kp _02bwPNT6kp _37yqvNKTcp _30638CKTcp _05zY0AKTcp _3kPd401O6y _4mPnyf1O6y _0rPas41O6y"
        ])
    }, lozenge);
};
var $2588de3e72138c31$export$2e2bcd8739ae039 = $2588de3e72138c31$var$LozengeActionTrigger;
module.exports["default"] = $2588de3e72138c31$export$2e2bcd8739ae039;

});

parcelRegister("jgAjn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $is1T6 = parcelRequire("is1T6");


var $9KSWX = parcelRequire("9KSWX");

const $a1691ad9902b975e$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $cozmU.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        onFocus: handleMouseEnter,
        onMouseEnter: handleMouseEnter,
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: handleClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: true
    }, text)));
};
var $a1691ad9902b975e$export$2e2bcd8739ae039 = $a1691ad9902b975e$var$LozengeActionItem;
module.exports["default"] = $a1691ad9902b975e$export$2e2bcd8739ae039;

});


$parcel$global.rlb("dhXIT")
//# sourceMappingURL=RelatedLinksModal.ed769dc5.js.map
